webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Global_vue__);







var utils = {
  sType: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
  sTypeIcon: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
  categoryList: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
  getRC4Hex: function getRC4Hex(message, key) {
    var keys = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Utf8.parse(key);

    var encode = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.RC4.encrypt(message, keys);

    var base64code = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Base64.parse(encode.toString());

    var encryptedHexStr = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Hex.stringify(base64code);

    var hexsStr = encryptedHexStr.toString(__WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Utf8);

    return hexsStr;
  },
  stringToByte: function stringToByte(str) {
    var bytes = [];
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(c >> 18 & 0x07 | 0xf0);
        bytes.push(c >> 12 & 0x3f | 0x80);
        bytes.push(c >> 6 & 0x3f | 0x80);
        bytes.push(c & 0x3f | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(c >> 12 & 0x0f | 0xe0);
        bytes.push(c >> 6 & 0x3f | 0x80);
        bytes.push(c & 0x3f | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(c >> 6 & 0x1f | 0xc0);
        bytes.push(c & 0x3f | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }
    return bytes;
  },
  hextoString: function hextoString(hex) {
    var arr = hex.split("");
    var out = "";
    for (var i = 0; i < arr.length / 2; i++) {
      var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
      var charValue = String.fromCharCode(tmp);
      out += charValue;
    }
    return out;
  },
  stringtoHex: function stringtoHex(str) {
    var hextable = "0123456789abcdef";
    var strbyte = this.stringToByte(str);
    var dst = [];
    for (var i = 0; i < strbyte.length; i++) {
      dst[i * 2] = hextable[strbyte[i] >> 4];
      dst[i * 2 + 1] = hextable[strbyte[i] & 0x0f];
    }
    var result = "";
    for (var index = 0; index < dst.length; index++) {
      result = result + dst[index];
    }
    return result;
  },
  getDecodeRC4Hex: function getDecodeRC4Hex(encrypted, key) {
    var keys = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Utf8.parse(key);

    var encryptedHexStr = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Hex.parse(encrypted);

    var srcs = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Base64.stringify(encryptedHexStr);

    var decrypteds = __WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.RC4.decrypt(srcs, keys);

    return decrypteds.toString(__WEBPACK_IMPORTED_MODULE_2_crypto_js___default.a.enc.Utf8);
  },
  showMsg: function showMsg(messge) {
    alert(messge);
  },
  goUri: function goUri(apiUrl) {
    window.location.href = apiUrl;
  },
  log: function log(message) {
    console.log(message);
  },
  checkIsNeedToGoBurg: function checkIsNeedToGoBurg(to) {
    return to.query.appid === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].burgAppid && (to.path === "/agent" || to.path === "/device" || to.path === "/accessory" || to.path === "/deviceuser" || to.path === "/aboutdevice" || to.path === "/parametersetting" || to.path === "/feedback" || to.path === "/eventlist" || to.path === "/problemdevicelist");
  },
  checkIsNeedToGoCN: function checkIsNeedToGoCN(to) {
    return to.query.appid === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].cnAppid && (to.path === "/agent" || to.path === "/device" || to.path === "/accessory" || to.path === "/deviceuser" || to.path === "/aboutdevice" || to.path === "/parametersetting" || to.path === "/feedback" || to.path === "/eventlist" || to.path === "/problemdevicelist");
  },
  checkIsNeedToGoBlackhole: function checkIsNeedToGoBlackhole(to) {
    return !utils.checkIsNeedToGoBurg(to) && !utils.checkIsNeedToGoCN(to);
  },
  login: function login(username, password, callback) {
    var _this = this;

    var params = new URLSearchParams();
    var jsons = {
      uid: username,
      password: password
    };
    params.append("json", this.getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_5__components_Global_vue___default.a.APP_SECRET));
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request("post", "/login?_type=json", params).then(function (response) {
      var data = response.data;
      if (data.Status !== 1) {
        callback(false, "");
        return;
      }

      if (data.Result) {
        var decodeResult = _this.getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_5__components_Global_vue___default.a.APP_SECRET);

        var myJson = JSON.parse(decodeResult);
        myJson.pw = _this.getRC4Hex(myJson.pw, __WEBPACK_IMPORTED_MODULE_5__components_Global_vue___default.a.APP_SECRET);
        callback(true, myJson);
      }
    });
  },
  checkIsSuperAdmin: function checkIsSuperAdmin() {
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem("user") || "null";
      var localUser = JSON.parse(localUserString);

      if (localUser.pm > 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAdmin: function checkIsAdmin() {
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem("user") || "null";
      var localUser = JSON.parse(localUserString);

      if (localUser.pm >= 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAppSuperAdmin: function checkIsAppSuperAdmin() {
    if (window.localStorage) {
      var localUser = window.localStorage.getItem("appper") || "null";

      if (localUser > 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAppAdmin: function checkIsAppAdmin() {
    if (window.localStorage) {
      var localUser = window.localStorage.getItem("appper") || "null";
      if (localUser >= 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsNeedToLogin: function checkIsNeedToLogin(to) {
    if (this.isEmpty(to.query.u) || this.isEmpty(to.query.p)) {
      return false;
    }
    return true;
  },
  formatDate: function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        var str = o[k] + "";
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },
  padLeftZero: function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  },
  getRandomString: function getRandomString(length) {
    var str = "";
    for (; str.length < length; str += Math.random().toString(36).substr(2)) {}
    return str.substr(0, length);
  },
  getMessageId: function getMessageId() {
    return this.getRandomString(12);
  },
  isHasKey: function isHasKey(target, key) {
    return target.hasOwnProperty(key);
  },
  isEmpty: function isEmpty(target) {
    if (!target) {
      return true;
    }
    return false;
  },
  checkIsURL: function checkIsURL(url) {
    return (/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(url)
    );
  },
  initPluginDataMap: function initPluginDataMap() {
    var m = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
    m.set("13", "Smart Light");
    m.set("14", "Wireless Siren");
    m.set("15", "Smart Plug");
    m.set("17", "Distance Sensor");
    m.set("19", "Window Sensor");
    m.set("1B", "Wireless Keypad");
    m.set("1F", "IP Camera");
    m.set("0B", "Door Window Sensor");
    m.set("09", "PIR Sensor");
    m.set("0A", "Gas Sensor");
    m.set("05", "Smoke Sensor");
    m.set("02", "Remote Controller");
    m.set("08", "Remote Controller");
    m.set("01", "Remote Controller");
    m.set("04", "Remote Controller");
    m.set("07", "Panic Button");
    m.set("30", "Panic Button");
    m.set("0D", "Remote Controller");
    m.set("0E", "Liquid Sensor");
    m.set("06", "Vibration Sensor");
    m.set("CC", "Vibration Sensor");
    m.set("31", "CO Detector");
    m.set("32", "Outdoor PIR");
    m.set("33", "Outdoor Beam");
    m.set("37", "RFID Tag");
    this.sType = m;

    var im = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
    im.set("13", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set("14", "../../../static/img/accessoryicon/icon_eventlist_wireless_siren.svg");
    im.set("15", "../../../static/img/accessoryicon/icon_eventlist_switch.svg");
    im.set("17", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set("19", "../../../static/img/accessoryicon/icon_eventlist_doorwindow_sensor.svg");
    im.set("1B", "../../../static/img/accessoryicon/icon_eventlist_keypad.svg");
    im.set("1F", "../../../static/img/accessoryicon/icon_eventlist_ipc.svg");
    im.set("0B", "../../../static/img/accessoryicon/icon_eventlist_doorwindow_sensor.svg");
    im.set("09", "../../../static/img/accessoryicon/icon_eventlist_pir.svg");
    im.set("0A", "../../../static/img/accessoryicon/icon_eventlist_gas_sensor.svg");
    im.set("05", "../../../static/img/accessoryicon/icon_eventlist_smoke_sensor.svg");
    im.set("02", "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg");
    im.set("08", "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg");
    im.set("01", "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg");
    im.set("04", "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg");
    im.set("07", "../../../static/img/accessoryicon/icon_eventlist_urgentbtn_sensor.svg");
    im.set("30", "../../../static/img/accessoryicon/icon_eventlist_urgentbtn_sensor.svg");
    im.set("0D", "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg");
    im.set("0E", "../../../static/img/accessoryicon/icon_eventlist_water_sensor.svg");
    im.set("06", "../../../static/img/accessoryicon/icon_eventlist_shake_sensor.svg");
    im.set("CC", "../../../static/img/accessoryicon/icon_eventlist_shake_sensor.svg");
    im.set("31", "../../../static/img/accessoryicon/icon_eventlist_cosensor.svg");
    im.set("32", "../../../static/img/accessoryicon/icon_eventlist_pir.svg");
    im.set("33", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set("37", "../../../static/img/accessoryicon/icon_eventlist_rfid.svg");
    this.sTypeIcon = im;

    this.categoryList = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
    this.categoryList.set("0B", 0);
    this.categoryList.set("09", 0);
    this.categoryList.set("05", 0);
    this.categoryList.set("07", 0);
    this.categoryList.set("02", 1);
    this.categoryList.set("14", 4);
    this.categoryList.set("1B", 1);
    this.categoryList.set("0E", 0);
    this.categoryList.set("06", 0);
    this.categoryList.set("15", 3);
    this.categoryList.set("37", 1);
  },
  getNameByCatAndSub: function getNameByCatAndSub(cat, sub) {
    if (cat === 10) {
      if (sub === "17") {
        return this.sType.get("09");
      } else if (sub === "16") {
        return this.sType.get("0B");
      } else if (sub === "18") {
        return this.sType.get("0E");
      } else if (sub === "19") {
        return this.sType.get("06");
      } else if (sub === "21") {
        return this.sType.get("14");
      } else if (sub === "22") {
        return this.sType.get("14");
      } else if (sub === "11") {
        return this.sType.get("0B");
      }
    }
    return this.sType.get(sub);
  },
  getPluginIconByCatAndSub: function getPluginIconByCatAndSub(cat, sub) {
    if (cat === 10) {
      if (sub === "17") {
        return this.sTypeIcon.get("09");
      } else if (sub === "16") {
        return this.sTypeIcon.get("0B");
      } else if (sub === "18") {
        return this.sTypeIcon.get("0E");
      } else if (sub === "19") {
        return this.sTypeIcon.get("06");
      } else if (sub === "21") {
        return this.sTypeIcon.get("14");
      } else if (sub === "22") {
        return this.sTypeIcon.get("14");
      } else if (sub === "11") {
        return this.sTypeIcon.get("0B");
      }
    }
    return this.sTypeIcon.get(sub);
  },
  getCategory: function getCategory(sub) {
    return this.categoryList.get(sub);
  },
  capitalize: function capitalize(str) {
    return str.toLowerCase().replace(/(^\w)|(_\w)/g, function (match) {
      return match.toUpperCase();
    }).replace(/_+/g, " ");
  }
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Global_vue__);












__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.timeout = 10 * 60 * 1000;
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencode";

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(error.response);
});

var CancelToken = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.CancelToken;
var source = CancelToken.source();

function checkCode(res) {
  if (res && res.data && res.data.Status === -12) {
    __WEBPACK_IMPORTED_MODULE_7__main__["default"].logout();
  }
  return res;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error("API function call requires method argument");
      return;
    }

    if (!uri) {
      console.error("API function call requires uri argument");
      return;
    }

    var url = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].serverURI + uri;
    return __WEBPACK_IMPORTED_MODULE_5_axios___default()({ method: method, url: url, data: data }).then(checkCode);
  },
  requestWithServerUrl: function requestWithServerUrl(method, serverurl, uri) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!method) {
      console.error("API function call requires method argument");
      return;
    }

    if (!uri) {
      console.error("API function call requires uri argument");
      return;
    }

    var url = serverurl + uri;
    return __WEBPACK_IMPORTED_MODULE_5_axios___default()({ method: method, url: url, data: data }).then(checkCode);
  },
  uploadFile: function uploadFile(file, token, progress, finish) {
    var that = this;

    var params = new URLSearchParams();
    params.append("token", token);
    this.requestWithServerUrl("post", __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, "/uploader/getuptokenv2", params).then(function (response) {
      var data = response.data;
      if (data.Status !== 1) {
        finish("", false);
        return;
      }
      if (data.Result) {
        that.toDoUploadFile(data.Result, file, progress, finish);
      } else {
        finish("", false);
      }
    });
  },
  toDoUploadFile: function toDoUploadFile(token, file, progress, finish) {
    var param = new FormData();

    param.append("file", file, file.name);

    param.append("chunk", "0");
    param.append("token", token);

    var config = {
      headers: { "Content-Type": "multipart/form-data" },
      cancelToken: source.token,
      onUploadProgress: function onUploadProgress(e) {
        var p = Math.round(e.loaded * 100 / e.total) || 0;
        progress(p);
      }
    };
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://upload.qiniu.com/", param, config).then(function (response) {
      var data = response.data;
      if (data) {
        finish(data.key, true, false);
      } else {
        finish("", false, false);
      }
      progress(0);
    }).catch(function (thrown) {
      progress(0);
      finish("", false, true);
    });
  },
  cancelUpload: function cancelUpload() {
    source.cancel("");
  },
  post: function post(_ref) {
    var _this = this;

    var path = _ref.path,
        data = _ref.data,
        withLoading = _ref.withLoading,
        noError = _ref.noError;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, url, res, _res$data, Status, Result, ErrorMessage, respData;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (false) {
                console.log("--> [" + path + "]:", data);
              }

              params = new URLSearchParams();

              params.append("json", __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data), __WEBPACK_IMPORTED_MODULE_10__components_Global_vue___default.a.APP_SECRET));
              if (window.localStorage) {
                params.append("token", window.localStorage.getItem("token"));
              }

              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_FULLSCREEN_LOADING");
              url = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].serverURI + path;
              _context.prev = 6;
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default()({ method: "post", url: url, data: params }).then(checkCode);

            case 9:
              res = _context.sent;


              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("UNSET_FULLSCREEN_LOADING");

              _res$data = res.data, Status = _res$data.Status, Result = _res$data.Result, ErrorMessage = _res$data.ErrorMessage;

              if (!(Status === 1 && Result)) {
                _context.next = 18;
                break;
              }

              respData = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getDecodeRC4Hex(Result, __WEBPACK_IMPORTED_MODULE_10__components_Global_vue___default.a.APP_SECRET));

              if (false) {
                console.log("<-- [" + path + "]:", respData);
              }
              return _context.abrupt("return", respData);

            case 18:
              throw new Error(ErrorMessage || "Unkonwn Error");

            case 19:
              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](6);

              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("UNSET_FULLSCREEN_LOADING");
              if (!noError) __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_ERROR", _context.t0.message);
              throw _context.t0;

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 21]]);
    }))();
  },
  post_blackhole: function post_blackhole(_ref2) {
    var _this2 = this;

    var path = _ref2.path,
        appid = _ref2.appid,
        cmd = _ref2.cmd,
        data = _ref2.data,
        withLoading = _ref2.withLoading,
        noError = _ref2.noError,
        _ref2$host = _ref2.host,
        host = _ref2$host === undefined ? __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI : _ref2$host;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var params, url, res, _data, Status, ErrorMessage;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = new URLSearchParams();

              params.append("json", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { messageid: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getMessageId(), cmd: cmd })));
              if (window.localStorage) {
                params.append("token", window.localStorage.getItem("token"));
              }

              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_FULLSCREEN_LOADING");
              url = host + path + "/" + appid;
              _context2.prev = 5;
              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default()({ method: "post", url: url, data: params });

            case 8:
              res = _context2.sent;

              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("UNSET_FULLSCREEN_LOADING");
              _data = res.data || {};
              Status = _data.Status, ErrorMessage = _data.ErrorMessage;

              if (!(Status !== 1)) {
                _context2.next = 14;
                break;
              }

              throw new Error(ErrorMessage || "Unknown Error");

            case 14:
              return _context2.abrupt("return", _data);

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](5);

              withLoading && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("UNSET_FULLSCREEN_LOADING");
              if (!noError) __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_ERROR", _context2.t0.message);
              throw _context2.t0;

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[5, 17]]);
    }))();
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/Global.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dc62d44", Component.options)
  } else {
    hotAPI.reload("data-v-2dc62d44", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var config = {
  burgAppid: "88d79c29c7ce1bfd07f7afb7897511a7",
  userAddDevice: "/device/adddevicebyadmin/",
  addDeviceuser: "/auth/regist/",
  fixedLayout: true,
  hideLogoOnMobile: false,
  isAdminInApp: false
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config,  false ? {
  serverURI: "https://mysystemapi.burg.dinsafer.com",

  blackholeURI: "https://mysystem.dinsafer.com",

  blackholeServerURI: "https://api.burg.dinsafer.com"
} : {
  serverURI: "https://mysystemapi.dinsafer.com",
  asServerURI: "https://myapi-as01.dinsafer.com",

  burgURI: "https://mysystem.burg.dinsafer.com",
  burgAppid: "88d79c29c7ce1bfd07f7afb7897511a7",

  cnURI: 'https://m-zero.dinsafer.com',
  cnAppid: '67fb585f2ac4f032c1bf38e85f680afc',

  blackholeServerURI: "https://api.dinsafer.com",
  buildVersion: "1.3.2",
  buildSHA: "74ec6d0"
});

if (true) {
  if (location.host === 'my-test.dinsafer.com') {
    config.serverURI = "https://myapi-test.dinsafer.com";
    config.asServerURI = "https://myapi-test.dinsafer.com";
  } else {
    config.serverURI = "https://testadminapi.dinsafer.com";
    config.asServerURI = "https://testadminapi.dinsafer.com";
  }
  config.blackholeServerURI = "https://test.dinsafer.com";
} else if (process.env.NODE_ENV === "development") {
  if (process.env.SERVER_URI) {
    config.serverURI = process.env.SERVER_URI;
    config.asServerURI = process.env.SERVER_URI;
  } else {
    config.serverURI = "http://localhost:7792";
    config.asServerURI = "http://localhost:7792";
  }
  config.blackholeServerURI = "https://test.dinsafer.com";
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(234);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return servers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stats; });
/* unused harmony export timeline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var servers = [{
  name: 'www01',
  status: 'success',
  icon: 'globe',
  description: 'Web server that runs our sites'
}, {
  name: 'sql01',
  status: 'danger',
  icon: 'database',
  description: 'mySQL server used for reporting'
}, {
  name: 'mongoDB01',
  status: 'info',
  icon: 'file-code-o',
  description: 'Main DB server'
}, {
  name: 'ldap01',
  status: 'success',
  icon: 'key',
  description: 'Authentication server'
}, {
  name: 'mgmt01',
  status: 'success',
  icon: 'home',
  description: 'Management server with all tools'
}, {
  name: 'bkup01',
  status: 'warning',
  icon: 'backward',
  description: 'Backup server'
}];

var stats = [{
  header: '8390',
  text: 'Visitors'
}, {
  header: '30%',
  text: 'Referrals'
}, {
  header: '70%',
  text: 'Organic'
}];

var timeline = [{
  icon: 'fa-envelope',
  color: 'blue',
  title: 'Write short novel',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').fromNow(),
  body: 'Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle quora plaxo ideeli hulu weebly balihoo...',
  buttons: [{
    type: 'primary',
    message: 'Read more',
    href: 'https://github.com/misterGF/CoPilot',
    target: '_blank'
  }]
}, {
  icon: 'fa-user',
  color: 'yellow',
  title: 'Sarah Young accepted your friend request',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()('20150620', 'MMM Do YY').fromNow()
}, {
  icon: 'fa-camera',
  color: 'purple',
  title: 'Watch a youTube video',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()('20130620', 'YYYYMMDD').fromNow(),
  body: '<div class="embed-responsive embed-responsive-16by9"><iframe width="560" height="315" src="https://www.youtube.com/embed/8aGhZQkoFbQ" frameborder="0" allowfullscreen></iframe></div>'
}];

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bus__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chenfengyuan_vue_qrcode__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_App_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_App_vue__);


















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_11__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_11__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_11__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_11__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_bus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_10__chenfengyuan_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__chenfengyuan_vue_qrcode__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (true) {
    if (__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].checkIsNeedToGoBurg(to)) {
      if (!router.app.$store.state.user.uid || router.app.$store.state.user.uid === 'null') {
        var urlstr = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].burgURI + to.fullPath;
        __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].goUri(urlstr);
      } else {
        var urlstrs = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].burgURI + to.fullPath + '&u=' + router.app.$store.state.user.uid + '&p=' + router.app.$store.state.user.pw + '&apr=' + window.localStorage.getItem('appper');
        __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].goUri(urlstrs);
      }
      return;
    }

    if (__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].checkIsNeedToGoCN(to)) {
      if (!router.app.$store.state.user.uid || router.app.$store.state.user.uid === 'null') {
        var _urlstr = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].cnURI + to.fullPath;
        __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].goUri(_urlstr);
      } else {
        var _urlstrs = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].cnURI + to.fullPath + '&u=' + router.app.$store.state.user.uid + '&p=' + router.app.$store.state.user.pw + '&apr=' + window.localStorage.getItem('appper');
        __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].goUri(_urlstrs);
      }
      return;
    }

    if (__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].checkIsNeedToLogin(to)) {
      __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].login(to.query.u, __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].getDecodeRC4Hex(to.query.p, __WEBPACK_IMPORTED_MODULE_9__components_Global_vue___default.a.APP_SECRET), function (isSuccess, myJson) {
        if (isSuccess) {
          router.app.$store.commit('SET_USER', myJson);
          router.app.$store.commit('SET_TOKEN', myJson.token);

          if (window.localStorage) {
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myJson));
            window.localStorage.setItem('token', myJson.token);
            window.localStorage.setItem('appper', to.query.apr);
          }
          var _urlstr2 = to.path + '?';
          for (var key in to.query) {
            if (key === 'u' || key === 'p') {
              continue;
            }
            __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].log(key);
            _urlstr2 = _urlstr2 + key + '=' + to.query[key] + '&';
          }
          next({
            path: _urlstr2
          });
        } else {
          next({
            path: '/login'
          });
        }
      });
      return;
    }

    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
      window.console.log('Not authenticated');
      next({
        path: '/login'
      });
    } else {
      next();
    }
  } else {
    if (utils.checkIsNeedToGoBlackhole(to)) {
      var _urlstr3 = config.blackholeURI + to.fullPath;
      if (!(!router.app.$store.state.user.uid || router.app.$store.state.user.uid === 'null')) {
        if (to.fullPath === '/') {
          _urlstr3 = _urlstr3 + '?' + 'u=' + router.app.$store.state.user.uid + '&p=' + router.app.$store.state.user.pw + '&apr=' + window.localStorage.getItem('appper');
        } else {
          _urlstr3 = _urlstr3 + '&u=' + router.app.$store.state.user.uid + '&p=' + router.app.$store.state.user.pw + '&apr=' + window.localStorage.getItem('appper');
        }
      }
      utils.goUri(_urlstr3);
    } else if (utils.checkIsNeedToLogin(to)) {
      utils.login(to.query.u, utils.getDecodeRC4Hex(to.query.p, global.APP_SECRET), function (isSuccess, myJson) {
        if (isSuccess) {
          router.app.$store.commit('SET_USER', myJson);
          router.app.$store.commit('SET_TOKEN', myJson.token);

          if (window.localStorage) {
            window.localStorage.setItem('user', _JSON$stringify(myJson));
            window.localStorage.setItem('token', myJson.token);
            window.localStorage.setItem('appper', to.query.apr);
          }
          next({
            path: to.path + '?appid=' + to.query.appid + '&appname=' + to.query.appname
          });
        } else {
          next({
            path: '/login'
          });
        }
      });
    } else if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
      window.console.log('Not authenticated');
      next({
        path: '/login'
      });
    } else {
      next();
    }
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].initPluginDataMap();

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_12__components_App_vue___default.a);
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_USER', null);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_TOKEN', null);

    if (window.localStorage) {
      window.localStorage.setItem('user', null);
      window.localStorage.setItem('token', null);
    }

    router.push('/login');
  }
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-968f34c8",
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/AppDataForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AppDataForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-968f34c8", Component.options)
  } else {
    hotAPI.reload("data-v-968f34c8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/UpdateLogs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UpdateLogs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c6b36f4a", Component.options)
  } else {
    hotAPI.reload("data-v-c6b36f4a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 1.0.2
 *
 * Copyright 2015 Nick Downie
 * Released under the MIT license
 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
 */

(function () {
  'use strict'

	// Declare root variable - window in the browser, global on the server
  var root = this,
  previous = root.Chart

	// Occupy the global variable of Chart, and create a simple base class
  var Chart = function (context) {
  var chart = this
  this.canvas = context.canvas

  this.ctx = context

		// Variables global to the chart
  var computeDimension = function (element, dimension) {
  if (element['offset' + dimension]) {
  return element['offset' + dimension]
} else {
  return document.defaultView.getComputedStyle(element).getPropertyValue(dimension)
}
}

  var width = this.width = computeDimension(context.canvas, 'Width')
  var height = this.height = computeDimension(context.canvas, 'Height')

		// Firefox requires this to work correctly
  context.canvas.width = width
  context.canvas.height = height

  var width = this.width = context.canvas.width
  var height = this.height = context.canvas.height
  this.aspectRatio = this.width / this.height
		// High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
  helpers.retinaScale(this)

  return this
}
	// Globally expose the defaults to allow for user updating/changing
  Chart.defaults = {
  global: {
			// Boolean - Whether to animate the chart
  animation: true,

			// Number - Number of animation steps
  animationSteps: 60,

			// String - Animation easing effect
  animationEasing: 'easeOutQuart',

			// Boolean - If we should show the scale at all
  showScale: true,

			// Boolean - If we want to override with a hard coded scale
  scaleOverride: false,

			// ** Required if scaleOverride is true **
			// Number - The number of steps in a hard coded scale
  scaleSteps: null,
			// Number - The value jump in the hard coded scale
  scaleStepWidth: null,
			// Number - The scale starting value
  scaleStartValue: null,

			// String - Colour of the scale line
  scaleLineColor: 'rgba(0,0,0,.1)',

			// Number - Pixel width of the scale line
  scaleLineWidth: 1,

			// Boolean - Whether to show labels on the scale
  scaleShowLabels: true,

			// Interpolated JS string - can access value
  scaleLabel: '<%=value%>',

			// Boolean - Whether the scale should stick to integers, and not show any floats even if drawing space is there
  scaleIntegersOnly: true,

			// Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
  scaleBeginAtZero: false,

			// String - Scale label font declaration for the scale label
  scaleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Scale label font size in pixels
  scaleFontSize: 12,

			// String - Scale label font weight style
  scaleFontStyle: 'normal',

			// String - Scale label font colour
  scaleFontColor: '#666',

			// Boolean - whether or not the chart should be responsive and resize when the browser does.
  responsive: false,

			// Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
  maintainAspectRatio: true,

			// Boolean - Determines whether to draw tooltips on the canvas or not - attaches events to touchmove & mousemove
  showTooltips: true,

			// Boolean - Determines whether to draw built-in tooltip or call custom tooltip function
  customTooltips: false,

			// Array - Array of string names to attach tooltip events
  tooltipEvents: ['mousemove', 'touchstart', 'touchmove', 'mouseout'],

			// String - Tooltip background colour
  tooltipFillColor: 'rgba(0,0,0,0.8)',

			// String - Tooltip label font declaration for the scale label
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Tooltip label font size in pixels
  tooltipFontSize: 14,

			// String - Tooltip font weight style
  tooltipFontStyle: 'normal',

			// String - Tooltip label font colour
  tooltipFontColor: '#fff',

			// String - Tooltip title font declaration for the scale label
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Tooltip title font size in pixels
  tooltipTitleFontSize: 14,

			// String - Tooltip title font weight style
  tooltipTitleFontStyle: 'bold',

			// String - Tooltip title font colour
  tooltipTitleFontColor: '#fff',

			// Number - pixel width of padding around tooltip text
  tooltipYPadding: 6,

			// Number - pixel width of padding around tooltip text
  tooltipXPadding: 6,

			// Number - Size of the caret on the tooltip
  tooltipCaretSize: 8,

			// Number - Pixel radius of the tooltip border
  tooltipCornerRadius: 6,

			// Number - Pixel offset from point x to tooltip edge
  tooltipXOffset: 10,

			// String - Template string for single tooltips
  tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= value %>',

			// String - Template string for single tooltips
  multiTooltipTemplate: '<%= value %>',

			// String - Colour behind the legend colour block
  multiTooltipKeyBackground: '#fff',

			// Function - Will fire on animation progression.
  onAnimationProgress: function () { },

			// Function - Will fire on animation completion.
  onAnimationComplete: function () { }

}
}

	// Create a dictionary of chart types, to allow for extension of existing types
  Chart.types = {}

	// Global Chart helpers object for utility methods and classes
  var helpers = Chart.helpers = {}

	// -- Basic js utility methods
  var each = helpers.each = function (loopable, callback, self) {
    var additionalArgs = Array.prototype.slice.call(arguments, 3)
		// Check to see if null or undefined firstly.
    if (loopable) {
  if (loopable.length === +loopable.length) {
  var i
  for (i = 0; i < loopable.length; i++) {
  callback.apply(self, [loopable[i], i].concat(additionalArgs))
}
} else {
  for (var item in loopable) {
  callback.apply(self, [loopable[item], item].concat(additionalArgs))
}
}
}
  },
  clone = helpers.clone = function (obj) {
  var objClone = {}
  each(obj, function (value, key) {
  if (obj.hasOwnProperty(key)) objClone[key] = value
})
  return objClone
},
  extend = helpers.extend = function (base) {
  each(Array.prototype.slice.call(arguments, 1), function (extensionObject) {
  each(extensionObject, function (value, key) {
  if (extensionObject.hasOwnProperty(key)) base[key] = value
})
})
  return base
},
  merge = helpers.merge = function (base, master) {
			// Merge properties in left object over to a shallow clone of object right.
  var args = Array.prototype.slice.call(arguments, 0)
  args.unshift({})
  return extend.apply(null, args)
},
  indexOf = helpers.indexOf = function (arrayToSearch, item) {
  if (Array.prototype.indexOf) {
  return arrayToSearch.indexOf(item)
} else {
  for (var i = 0; i < arrayToSearch.length; i++) {
  if (arrayToSearch[i] === item) return i
}
  return -1
}
},
  where = helpers.where = function (collection, filterCallback) {
  var filtered = []

  helpers.each(collection, function (item) {
  if (filterCallback(item)) {
  filtered.push(item)
}
})

  return filtered
},
  findNextWhere = helpers.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
  if (!startIndex) {
  startIndex = -1
}
  for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
  var currentItem = arrayToSearch[i]
  if (filterCallback(currentItem)) {
  return currentItem
}
}
},
  findPreviousWhere = helpers.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
  if (!startIndex) {
  startIndex = arrayToSearch.length
}
  for (var i = startIndex - 1; i >= 0; i--) {
  var currentItem = arrayToSearch[i]
  if (filterCallback(currentItem)) {
  return currentItem
}
}
},
  inherits = helpers.inherits = function (extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
  var parent = this
  var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function () { return parent.apply(this, arguments) }

  var Surrogate = function () { this.constructor = ChartElement }
  Surrogate.prototype = parent.prototype
  ChartElement.prototype = new Surrogate()

  ChartElement.extend = inherits

  if (extensions) extend(ChartElement.prototype, extensions)

  ChartElement.__super__ = parent.prototype

  return ChartElement
},
  noop = helpers.noop = function () { },
  uid = helpers.uid = (function () {
  var id = 0
  return function () {
  return 'chart-' + id++
}
})(),
  warn = helpers.warn = function (str) {
			// Method for warning of errors
  if (window.console && typeof window.console.warn === 'function') console.warn(str)
},
  amd = helpers.amd = ("function" === 'function' && __webpack_require__(206)),
		// -- Math methods
  isNumber = helpers.isNumber = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
},
  max = helpers.max = function (array) {
  return Math.max.apply(Math, array)
},
  min = helpers.min = function (array) {
  return Math.min.apply(Math, array)
},
  cap = helpers.cap = function (valueToCap, maxValue, minValue) {
  if (isNumber(maxValue)) {
  if (valueToCap > maxValue) {
  return maxValue
}
} else if (isNumber(minValue)) {
  if (valueToCap < minValue) {
  return minValue
}
}
  return valueToCap
},
  getDecimalPlaces = helpers.getDecimalPlaces = function (num) {
  if (num % 1 !== 0 && isNumber(num)) {
  return num.toString().split('.')[1].length
} else {
  return 0
}
},
  toRadians = helpers.radians = function (degrees) {
  return degrees * (Math.PI / 180)
},
		// Gets the angle from vertical upright to the point about a centre.
  getAngleFromPoint = helpers.getAngleFromPoint = function (centrePoint, anglePoint) {
  var distanceFromXCenter = anglePoint.x - centrePoint.x,
  distanceFromYCenter = anglePoint.y - centrePoint.y,
  radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter)

  var angle = Math.PI * 2 + Math.atan2(distanceFromYCenter, distanceFromXCenter)

			// If the segment is in the top left quadrant, we need to add another rotation to the angle
  if (distanceFromXCenter < 0 && distanceFromYCenter < 0) {
  angle += Math.PI * 2
}

return {
  angle: angle,
  distance: radialDistanceFromCenter
}
},
  aliasPixel = helpers.aliasPixel = function (pixelWidth) {
  return (pixelWidth % 2 === 0) ? 0 : 0.5
},
  splineCurve = helpers.splineCurve = function (FirstPoint, MiddlePoint, AfterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
  var d01 = Math.sqrt(Math.pow(MiddlePoint.x - FirstPoint.x, 2) + Math.pow(MiddlePoint.y - FirstPoint.y, 2)),
  d12 = Math.sqrt(Math.pow(AfterPoint.x - MiddlePoint.x, 2) + Math.pow(AfterPoint.y - MiddlePoint.y, 2)),
  fa = t * d01 / (d01 + d12), // scaling factor for triangle Ta
  fb = t * d12 / (d01 + d12)
return {
  inner: {
  x: MiddlePoint.x - fa * (AfterPoint.x - FirstPoint.x),
  y: MiddlePoint.y - fa * (AfterPoint.y - FirstPoint.y)
},
  outer: {
  x: MiddlePoint.x + fb * (AfterPoint.x - FirstPoint.x),
  y: MiddlePoint.y + fb * (AfterPoint.y - FirstPoint.y)
}
}
},
  calculateOrderOfMagnitude = helpers.calculateOrderOfMagnitude = function (val) {
  return Math.floor(Math.log(val) / Math.LN10)
},
  calculateScaleRange = helpers.calculateScaleRange = function (valuesArray, drawingSize, textSize, startFromZero, integersOnly) {
			// Set a minimum step of two - a point at the top of the graph, and a point at the base
  var minSteps = 2,
  maxSteps = Math.floor(drawingSize / (textSize * 1.5)),
  skipFitting = (minSteps >= maxSteps)

  var maxValue = max(valuesArray),
  minValue = min(valuesArray)

			// We need some degree of seperation here to calculate the scales if all the values are the same
			// Adding/minusing 0.5 will give us a range of 1.
  if (maxValue === minValue) {
  maxValue += 0.5
				// So we don't end up with a graph with a negative start value if we've said always start from zero
  if (minValue >= 0.5 && !startFromZero) {
  minValue -= 0.5
} else {
					// Make up a whole number above the values
  maxValue += 0.5
}
}

  var valueRange = Math.abs(maxValue - minValue),
  rangeOrderOfMagnitude = calculateOrderOfMagnitude(valueRange),
  graphMax = Math.ceil(maxValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
  graphMin = (startFromZero) ? 0 : Math.floor(minValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
  graphRange = graphMax - graphMin,
  stepValue = Math.pow(10, rangeOrderOfMagnitude),
  numberOfSteps = Math.round(graphRange / stepValue)

			// If we have more space on the graph we'll use it to give more definition to the data
  while ((numberOfSteps > maxSteps || (numberOfSteps * 2) < maxSteps) && !skipFitting) {
  if (numberOfSteps > maxSteps) {
  stepValue *= 2
  numberOfSteps = Math.round(graphRange / stepValue)
					// Don't ever deal with a decimal number of steps - cancel fitting and just use the minimum number of steps.
  if (numberOfSteps % 1 !== 0) {
  skipFitting = true
}
}
				// We can fit in double the amount of scale points on the scale
  else {
					// If user has declared ints only, and the step value isn't a decimal
  if (integersOnly && rangeOrderOfMagnitude >= 0) {
						// If the user has said integers only, we need to check that making the scale more granular wouldn't make it a float
  if (stepValue / 2 % 1 === 0) {
  stepValue /= 2
  numberOfSteps = Math.round(graphRange / stepValue)
}
						// If it would make it a float break out of the loop
  else {
  break
}
}
					// If the scale doesn't have to be an int, make the scale more granular anyway.
  else {
  stepValue /= 2
  numberOfSteps = Math.round(graphRange / stepValue)
}
}
}

  if (skipFitting) {
  numberOfSteps = minSteps
  stepValue = graphRange / numberOfSteps
}

  return {
  steps: numberOfSteps,
  stepValue: stepValue,
  min: graphMin,
  max: graphMin + (numberOfSteps * stepValue)
}
},
		/* jshint ignore:start */
		// Blows up jshint errors based on the new Function constructor
		// Templating methods
		// Javascript micro templating by John Resig - source at http://ejohn.org/blog/javascript-micro-templating/
  template = helpers.template = function (templateString, valuesObject) {
			// If templateString is function rather than string-template - call the function for valuesObject

  if (templateString instanceof Function) {
  return templateString(valuesObject)
}

  var cache = {}
  function tmpl (str, data) {
				// Figure out if we're getting a template, or if we need to
				// load the template - and be sure to cache the result.
  var fn = !/\W/.test(str)
					? cache[str] = cache[str]

					// Generate a reusable function that will serve as a template
					// generator (and which will be cached).
					: new Function('obj',
						'var p=[],print=function(){p.push.apply(p,arguments);};' +

						// Introduce the data as local variables using with(){}
						"with(obj){p.push('" +

						// Convert the template into pure JavaScript
						str
							.replace(/[\r\t\n]/g, ' ')
							.split('<%').join('\t')
							.replace(/((^|%>)[^\t]*)'/g, '$1\r')
							.replace(/\t=(.*?)%>/g, "',$1,'")
							.split('\t').join("');")
							.split('%>').join("p.push('")
							.split('\r').join("\\'") +
						"');}return p.join('');"
					)

				// Provide some basic currying to the user
  return data ? fn(data) : fn
}
  return tmpl(templateString, valuesObject)
},
		/* jshint ignore:end */
  generateLabels = helpers.generateLabels = function (templateString, numberOfSteps, graphMin, stepValue) {
  var labelsArray = new Array(numberOfSteps)
  if (labelTemplateString) {
  each(labelsArray, function (val, index) {
  labelsArray[index] = template(templateString, { value: (graphMin + (stepValue * (index + 1))) })
})
}
  return labelsArray
},
		// --Animation methods
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
  easingEffects = helpers.easingEffects = {
  linear: function (t) {
  return t
},
  easeInQuad: function (t) {
  return t * t
},
  easeOutQuad: function (t) {
  return -1 * t * (t - 2)
},
  easeInOutQuad: function (t) {
  if ((t /= 1 / 2) < 1) return 1 / 2 * t * t
  return -1 / 2 * ((--t) * (t - 2) - 1)
},
  easeInCubic: function (t) {
  return t * t * t
},
  easeOutCubic: function (t) {
  return 1 * ((t = t / 1 - 1) * t * t + 1)
},
  easeInOutCubic: function (t) {
  if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t
  return 1 / 2 * ((t -= 2) * t * t + 2)
},
  easeInQuart: function (t) {
  return t * t * t * t
},
  easeOutQuart: function (t) {
  return -1 * ((t = t / 1 - 1) * t * t * t - 1)
},
  easeInOutQuart: function (t) {
  if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t
  return -1 / 2 * ((t -= 2) * t * t * t - 2)
},
  easeInQuint: function (t) {
  return 1 * (t /= 1) * t * t * t * t
},
  easeOutQuint: function (t) {
  return 1 * ((t = t / 1 - 1) * t * t * t * t + 1)
},
  easeInOutQuint: function (t) {
  if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t * t
  return 1 / 2 * ((t -= 2) * t * t * t * t + 2)
},
  easeInSine: function (t) {
  return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1
},
  easeOutSine: function (t) {
  return 1 * Math.sin(t / 1 * (Math.PI / 2))
},
  easeInOutSine: function (t) {
  return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1)
},
  easeInExpo: function (t) {
  return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1))
},
  easeOutExpo: function (t) {
  return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1)
},
  easeInOutExpo: function (t) {
  if (t === 0) return 0
  if (t === 1) return 1
  if ((t /= 1 / 2) < 1) return 1 / 2 * Math.pow(2, 10 * (t - 1))
  return 1 / 2 * (-Math.pow(2, -10 * --t) + 2)
},
  easeInCirc: function (t) {
  if (t >= 1) return t
  return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1)
},
  easeOutCirc: function (t) {
  return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t)
},
  easeInOutCirc: function (t) {
  if ((t /= 1 / 2) < 1) return -1 / 2 * (Math.sqrt(1 - t * t) - 1)
  return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1)
},
  easeInElastic: function (t) {
  var s = 1.70158
  var p = 0
  var a = 1
  if (t === 0) return 0
  if ((t /= 1) == 1) return 1
  if (!p) p = 1 * 0.3
  if (a < Math.abs(1)) {
  a = 1
  s = p / 4
} else s = p / (2 * Math.PI) * Math.asin(1 / a)
  return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p))
},
  easeOutElastic: function (t) {
  var s = 1.70158
  var p = 0
  var a = 1
  if (t === 0) return 0
  if ((t /= 1) == 1) return 1
  if (!p) p = 1 * 0.3
  if (a < Math.abs(1)) {
  a = 1
  s = p / 4
} else s = p / (2 * Math.PI) * Math.asin(1 / a)
  return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1
},
  easeInOutElastic: function (t) {
  var s = 1.70158
  var p = 0
  var a = 1
  if (t === 0) return 0
  if ((t /= 1 / 2) == 2) return 1
  if (!p) p = 1 * (0.3 * 1.5)
  if (a < Math.abs(1)) {
  a = 1
  s = p / 4
} else s = p / (2 * Math.PI) * Math.asin(1 / a)
  if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p))
  return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1
},
  easeInBack: function (t) {
  var s = 1.70158
  return 1 * (t /= 1) * t * ((s + 1) * t - s)
},
  easeOutBack: function (t) {
  var s = 1.70158
  return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1)
},
  easeInOutBack: function (t) {
  var s = 1.70158
  if ((t /= 1 / 2) < 1) return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s))
  return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2)
},
  easeInBounce: function (t) {
  return 1 - easingEffects.easeOutBounce(1 - t)
},
  easeOutBounce: function (t) {
  if ((t /= 1) < (1 / 2.75)) {
  return 1 * (7.5625 * t * t)
} else if (t < (2 / 2.75)) {
  return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75)
} else if (t < (2.5 / 2.75)) {
  return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375)
} else {
  return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375)
}
},
  easeInOutBounce: function (t) {
  if (t < 1 / 2) return easingEffects.easeInBounce(t * 2) * 0.5
  return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5
}
},
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
  requestAnimFrame = helpers.requestAnimFrame = (function () {
return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function (callback) {
  return window.setTimeout(callback, 1000 / 60)
}
})(),
  cancelAnimFrame = helpers.cancelAnimFrame = (function () {
  return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function (callback) {
  return window.clearTimeout(callback, 1000 / 60)
}
})(),
  animationLoop = helpers.animationLoop = function (callback, totalSteps, easingString, onProgress, onComplete, chartInstance) {
  var currentStep = 0,
  easingFunction = easingEffects[easingString] || easingEffects.linear

  var animationFrame = function () {
  currentStep++
  var stepDecimal = currentStep / totalSteps
  var easeDecimal = easingFunction(stepDecimal)

  callback.call(chartInstance, easeDecimal, stepDecimal, currentStep)
  onProgress.call(chartInstance, easeDecimal, stepDecimal)
  if (currentStep < totalSteps) {
  chartInstance.animationFrame = requestAnimFrame(animationFrame)
} else {
  onComplete.apply(chartInstance)
}
}
  requestAnimFrame(animationFrame)
},
		// -- DOM methods
  getRelativePosition = helpers.getRelativePosition = function (evt) {
  var mouseX, mouseY
  var e = evt.originalEvent || evt,
  canvas = evt.currentTarget || evt.srcElement,
  boundingRect = canvas.getBoundingClientRect()

  if (e.touches) {
  mouseX = e.touches[0].clientX - boundingRect.left
  mouseY = e.touches[0].clientY - boundingRect.top
} else {
  mouseX = e.clientX - boundingRect.left
  mouseY = e.clientY - boundingRect.top
}

return {
  x: mouseX,
  y: mouseY
}
},
  addEvent = helpers.addEvent = function (node, eventType, method) {
  if (node.addEventListener) {
  node.addEventListener(eventType, method)
} else if (node.attachEvent) {
  node.attachEvent('on' + eventType, method)
} else {
  node['on' + eventType] = method
}
},
  removeEvent = helpers.removeEvent = function (node, eventType, handler) {
  if (node.removeEventListener) {
  node.removeEventListener(eventType, handler, false)
} else if (node.detachEvent) {
  node.detachEvent('on' + eventType, handler)
} else {
  node['on' + eventType] = noop
}
},
  bindEvents = helpers.bindEvents = function (chartInstance, arrayOfEvents, handler) {
			// Create the events object if it's not already present
  if (!chartInstance.events) chartInstance.events = {}

  each(arrayOfEvents, function (eventName) {
  chartInstance.events[eventName] = function () {
  handler.apply(chartInstance, arguments)
}
  addEvent(chartInstance.chart.canvas, eventName, chartInstance.events[eventName])
})
},
  unbindEvents = helpers.unbindEvents = function (chartInstance, arrayOfEvents) {
  each(arrayOfEvents, function (handler, eventName) {
  removeEvent(chartInstance.chart.canvas, eventName, handler)
})
},
  getMaximumWidth = helpers.getMaximumWidth = function (domNode) {
  var container = domNode.parentNode
			// TODO = check cross browser stuff with this.
  return container.clientWidth
},
  getMaximumHeight = helpers.getMaximumHeight = function (domNode) {
  var container = domNode.parentNode
			// TODO = check cross browser stuff with this.
  return container.clientHeight
},
  getMaximumSize = helpers.getMaximumSize = helpers.getMaximumWidth, // legacy support
  retinaScale = helpers.retinaScale = function (chart) {
  var ctx = chart.ctx,
  width = chart.canvas.width,
  height = chart.canvas.height

  if (window.devicePixelRatio) {
  ctx.canvas.style.width = width + 'px'
  ctx.canvas.style.height = height + 'px'
  ctx.canvas.height = height * window.devicePixelRatio
  ctx.canvas.width = width * window.devicePixelRatio
  ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
}
},
		// -- Canvas methods
  clear = helpers.clear = function (chart) {
  chart.ctx.clearRect(0, 0, chart.width, chart.height)
},
  fontString = helpers.fontString = function (pixelSize, fontStyle, fontFamily) {
  return fontStyle + ' ' + pixelSize + 'px ' + fontFamily
},
  longestText = helpers.longestText = function (ctx, font, arrayOfStrings) {
  ctx.font = font
  var longest = 0
  each(arrayOfStrings, function (string) {
  var textWidth = ctx.measureText(string).width
  longest = (textWidth > longest) ? textWidth : longest
})
  return longest
},
  drawRoundedRectangle = helpers.drawRoundedRectangle = function (ctx, x, y, width, height, radius) {
  ctx.beginPath()
  ctx.moveTo(x + radius, y)
  ctx.lineTo(x + width - radius, y)
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
  ctx.lineTo(x + width, y + height - radius)
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
  ctx.lineTo(x + radius, y + height)
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
  ctx.lineTo(x, y + radius)
  ctx.quadraticCurveTo(x, y, x + radius, y)
  ctx.closePath()
}

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
  Chart.instances = {}

  Chart.Type = function (data, options, chart) {
  this.options = options
  this.chart = chart
  this.id = uid()
		// Add the chart instance to the global namespace
  Chart.instances[this.id] = this

		// Initialize is always called when a chart type is created
		// By default it is a no op, but it should be extended
  if (options.responsive) {
  this.resize()
}
  this.initialize.call(this, data)
}

	// Core methods that'll be a part of every chart type
  extend(Chart.Type.prototype, {
  initialize: function () { return this },
  clear: function () {
  clear(this.chart)
  return this
},
  stop: function () {
			// Stops any current animation loop occuring
  cancelAnimFrame(this.animationFrame)
  return this
},
  resize: function (callback) {
  this.stop()
  var canvas = this.chart.canvas,
  newWidth = getMaximumWidth(this.chart.canvas),
  newHeight = this.options.maintainAspectRatio ? newWidth / this.chart.aspectRatio : getMaximumHeight(this.chart.canvas)

  canvas.width = this.chart.width = newWidth
  canvas.height = this.chart.height = newHeight

  retinaScale(this.chart)

  if (typeof callback === 'function') {
  callback.apply(this, Array.prototype.slice.call(arguments, 1))
}
  return this
},
  reflow: noop,
  render: function (reflow) {
  if (reflow) {
  this.reflow()
}
  if (this.options.animation && !reflow) {
  helpers.animationLoop(
					this.draw,
					this.options.animationSteps,
					this.options.animationEasing,
					this.options.onAnimationProgress,
					this.options.onAnimationComplete,
					this
				)
} else {
  this.draw()
  this.options.onAnimationComplete.call(this)
}
  return this
},
  generateLegend: function () {
  return template(this.options.legendTemplate, this)
},
  destroy: function () {
  this.clear()
  unbindEvents(this, this.events)
  var canvas = this.chart.canvas

			// Reset canvas height/width attributes starts a fresh with the canvas context
  canvas.width = this.chart.width
  canvas.height = this.chart.height

			// < IE9 doesn't support removeProperty
  if (canvas.style.removeProperty) {
  canvas.style.removeProperty('width')
  canvas.style.removeProperty('height')
} else {
  canvas.style.removeAttribute('width')
  canvas.style.removeAttribute('height')
}

  delete Chart.instances[this.id]
},
  showTooltip: function (ChartElements, forceRedraw) {
			// Only redraw the chart if we've actually changed what we're hovering on.
  if (typeof this.activeElements === 'undefined') this.activeElements = []

  var isChanged = (function (Elements) {
  var changed = false

				if (Elements.length !== this.activeElements.length) {
  changed = true
					return changed
				}

  each(Elements, function (element, index) {
  if (element !== this.activeElements[index]) {
  changed = true
					}
}, this)
				return changed
			}.call(this, ChartElements))

  if (!isChanged && !forceRedraw) {
  return
} else {
  this.activeElements = ChartElements
}
  this.draw()
  if (this.options.customTooltips) {
  this.options.customTooltips(false)
}
  if (ChartElements.length > 0) {
				// If we have multiple datasets, show a MultiTooltip for all of the data points at that index
  if (this.datasets && this.datasets.length > 1) {
  var dataArray,
  dataIndex

  for (var i = this.datasets.length - 1; i >= 0; i--) {
  dataArray = this.datasets[i].points || this.datasets[i].bars || this.datasets[i].segments
  dataIndex = indexOf(dataArray, ChartElements[0])
  if (dataIndex !== -1) {
  break
}
}
  var tooltipLabels = [],
  tooltipColors = [],
  medianPosition = (function (index) {
							// Get all the points at that particular index
  var Elements = [],
  dataCollection,
  xPositions = [],
  yPositions = [],
  xMax,
  yMax,
  xMin,
  yMin
							helpers.each(this.datasets, function (dataset) {
  dataCollection = dataset.points || dataset.bars || dataset.segments
								if (dataCollection[dataIndex] && dataCollection[dataIndex].hasValue()) {
  Elements.push(dataCollection[dataIndex])
								}
})

							helpers.each(Elements, function (element) {
  xPositions.push(element.x)
								yPositions.push(element.y)


								//Include any colour information about the element
								tooltipLabels.push(helpers.template(this.options.multiTooltipTemplate, element))
								tooltipColors.push({
  fill: element._saved.fillColor || element.fillColor,
  stroke: element._saved.strokeColor || element.strokeColor
})

							}, this)

							yMin = min(yPositions)
							yMax = max(yPositions)

							xMin = min(xPositions)
							xMax = max(xPositions)

							return {
  x: (xMin > this.chart.width / 2) ? xMin : xMax,
  y: (yMin + yMax) / 2
}
						}.call(this, dataIndex))

  new Chart.MultiTooltip({
  x: medianPosition.x,
  y: medianPosition.y,
  xPadding: this.options.tooltipXPadding,
  yPadding: this.options.tooltipYPadding,
  xOffset: this.options.tooltipXOffset,
  fillColor: this.options.tooltipFillColor,
  textColor: this.options.tooltipFontColor,
  fontFamily: this.options.tooltipFontFamily,
  fontStyle: this.options.tooltipFontStyle,
  fontSize: this.options.tooltipFontSize,
  titleTextColor: this.options.tooltipTitleFontColor,
  titleFontFamily: this.options.tooltipTitleFontFamily,
  titleFontStyle: this.options.tooltipTitleFontStyle,
  titleFontSize: this.options.tooltipTitleFontSize,
  cornerRadius: this.options.tooltipCornerRadius,
  labels: tooltipLabels,
  legendColors: tooltipColors,
  legendColorBackground: this.options.multiTooltipKeyBackground,
  title: ChartElements[0].label,
  chart: this.chart,
  ctx: this.chart.ctx,
  custom: this.options.customTooltips
}).draw()
} else {
  each(ChartElements, function (Element) {
  var tooltipPosition = Element.tooltipPosition()
  new Chart.Tooltip({
  x: Math.round(tooltipPosition.x),
  y: Math.round(tooltipPosition.y),
  xPadding: this.options.tooltipXPadding,
  yPadding: this.options.tooltipYPadding,
  fillColor: this.options.tooltipFillColor,
  textColor: this.options.tooltipFontColor,
  fontFamily: this.options.tooltipFontFamily,
  fontStyle: this.options.tooltipFontStyle,
  fontSize: this.options.tooltipFontSize,
  caretHeight: this.options.tooltipCaretSize,
  cornerRadius: this.options.tooltipCornerRadius,
  text: template(this.options.tooltipTemplate, Element),
  chart: this.chart,
  custom: this.options.customTooltips
}).draw()
}, this)
}
}
  return this
},
  toBase64Image: function () {
  return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments)
}
})

  Chart.Type.extend = function (extensions) {
  var parent = this

  var ChartType = function () {
  return parent.apply(this, arguments)
}

		// Copy the prototype object of the this class
  ChartType.prototype = clone(parent.prototype)
		// Now overwrite some of the properties in the base class with the new extensions
  extend(ChartType.prototype, extensions)

  ChartType.extend = Chart.Type.extend

  if (extensions.name || parent.prototype.name) {
  var chartName = extensions.name || parent.prototype.name
			// Assign any potential default values of the new chart type

			// If none are defined, we'll use a clone of the chart type this is being extended from.
			// I.e. if we extend a line chart, we'll use the defaults from the line chart if our new chart
			// doesn't define some defaults of their own.

  var baseDefaults = (Chart.defaults[parent.prototype.name]) ? clone(Chart.defaults[parent.prototype.name]) : {}

  Chart.defaults[chartName] = extend(baseDefaults, extensions.defaults)

  Chart.types[chartName] = ChartType

			// Register this new chart type in the Chart prototype
  Chart.prototype[chartName] = function (data, options) {
  var config = merge(Chart.defaults.global, Chart.defaults[chartName], options || {})
  return new ChartType(data, config, this)
}
} else {
  warn("Name not provided for this chart, so it hasn't been registered")
}
  return parent
}

  Chart.Element = function (configuration) {
  extend(this, configuration)
  this.initialize.apply(this, arguments)
  this.save()
}
  extend(Chart.Element.prototype, {
  initialize: function () { },
  restore: function (props) {
  if (!props) {
  extend(this, this._saved)
} else {
  each(props, function (key) {
  this[key] = this._saved[key]
}, this)
}
  return this
},
  save: function () {
  this._saved = clone(this)
  delete this._saved._saved
  return this
},
  update: function (newProps) {
  each(newProps, function (value, key) {
  this._saved[key] = this[key]
  this[key] = value
}, this)
  return this
},
  transition: function (props, ease) {
  each(props, function (value, key) {
  this[key] = ((value - this._saved[key]) * ease) + this._saved[key]
}, this)
  return this
},
  tooltipPosition: function () {
  return {
  x: this.x,
  y: this.y
}
},
  hasValue: function () {
  return isNumber(this.value)
}
})

  Chart.Element.extend = inherits

  Chart.Point = Chart.Element.extend({
  display: true,
  inRange: function (chartX, chartY) {
  var hitDetectionRange = this.hitDetectionRadius + this.radius
  return ((Math.pow(chartX - this.x, 2) + Math.pow(chartY - this.y, 2)) < Math.pow(hitDetectionRange, 2))
},
  draw: function () {
  if (this.display) {
  var ctx = this.ctx
  ctx.beginPath()

  ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2)
  ctx.closePath()

  ctx.strokeStyle = this.strokeColor
  ctx.lineWidth = this.strokeWidth

  ctx.fillStyle = this.fillColor

  ctx.fill()
  ctx.stroke()
}

			// Quick debug for bezier curve splining
			// Highlights control points and the line between them.
			// Handy for dev - stripped in the min version.

			// ctx.save();
			// ctx.fillStyle = "black";
			// ctx.strokeStyle = "black"
			// ctx.beginPath();
			// ctx.arc(this.controlPoints.inner.x,this.controlPoints.inner.y, 2, 0, Math.PI*2);
			// ctx.fill();

			// ctx.beginPath();
			// ctx.arc(this.controlPoints.outer.x,this.controlPoints.outer.y, 2, 0, Math.PI*2);
			// ctx.fill();

			// ctx.moveTo(this.controlPoints.inner.x,this.controlPoints.inner.y);
			// ctx.lineTo(this.x, this.y);
			// ctx.lineTo(this.controlPoints.outer.x,this.controlPoints.outer.y);
			// ctx.stroke();

			// ctx.restore();
}
})

  Chart.Arc = Chart.Element.extend({
  inRange: function (chartX, chartY) {
  var pointRelativePosition = helpers.getAngleFromPoint(this, {
  x: chartX,
  y: chartY
})

			// Check if within the range of the open/close angle
  var betweenAngles = (pointRelativePosition.angle >= this.startAngle && pointRelativePosition.angle <= this.endAngle),
  withinRadius = (pointRelativePosition.distance >= this.innerRadius && pointRelativePosition.distance <= this.outerRadius)

  return (betweenAngles && withinRadius)
			// Ensure within the outside of the arc centre, but inside arc outer
},
  tooltipPosition: function () {
  var centreAngle = this.startAngle + ((this.endAngle - this.startAngle) / 2),
  rangeFromCentre = (this.outerRadius - this.innerRadius) / 2 + this.innerRadius
  return {
  x: this.x + (Math.cos(centreAngle) * rangeFromCentre),
  y: this.y + (Math.sin(centreAngle) * rangeFromCentre)
}
},
  draw: function (animationPercent) {
  var easingDecimal = animationPercent || 1

  var ctx = this.ctx

  ctx.beginPath()

  ctx.arc(this.x, this.y, this.outerRadius, this.startAngle, this.endAngle)

  ctx.arc(this.x, this.y, this.innerRadius, this.endAngle, this.startAngle, true)

  ctx.closePath()
  ctx.strokeStyle = this.strokeColor
  ctx.lineWidth = this.strokeWidth

  ctx.fillStyle = this.fillColor

  ctx.fill()
  ctx.lineJoin = 'bevel'

  if (this.showStroke) {
  ctx.stroke()
}
}
})

  Chart.Rectangle = Chart.Element.extend({
  draw: function () {
  var ctx = this.ctx,
  halfWidth = this.width / 2,
  leftX = this.x - halfWidth,
  rightX = this.x + halfWidth,
  top = this.base - (this.base - this.y),
  halfStroke = this.strokeWidth / 2

			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
  if (this.showStroke) {
  leftX += halfStroke
  rightX -= halfStroke
  top += halfStroke
}

  ctx.beginPath()

  ctx.fillStyle = this.fillColor
  ctx.strokeStyle = this.strokeColor
  ctx.lineWidth = this.strokeWidth

			// It'd be nice to keep this class totally generic to any rectangle
			// and simply specify which border to miss out.
  ctx.moveTo(leftX, this.base)
  ctx.lineTo(leftX, top)
  ctx.lineTo(rightX, top)
  ctx.lineTo(rightX, this.base)
  ctx.fill()
  if (this.showStroke) {
  ctx.stroke()
}
},
  height: function () {
  return this.base - this.y
},
  inRange: function (chartX, chartY) {
  return (chartX >= this.x - this.width / 2 && chartX <= this.x + this.width / 2) && (chartY >= this.y && chartY <= this.base)
}
})

  Chart.Tooltip = Chart.Element.extend({
  draw: function () {
  var ctx = this.chart.ctx

  ctx.font = fontString(this.fontSize, this.fontStyle, this.fontFamily)

  this.xAlign = 'center'
  this.yAlign = 'above'

			// Distance between the actual element.y position and the start of the tooltip caret
  var caretPadding = this.caretPadding = 2

  var tooltipWidth = ctx.measureText(this.text).width + 2 * this.xPadding,
  tooltipRectHeight = this.fontSize + 2 * this.yPadding,
  tooltipHeight = tooltipRectHeight + this.caretHeight + caretPadding

  if (this.x + tooltipWidth / 2 > this.chart.width) {
  this.xAlign = 'left'
} else if (this.x - tooltipWidth / 2 < 0) {
  this.xAlign = 'right'
}

  if (this.y - tooltipHeight < 0) {
  this.yAlign = 'below'
}

  var tooltipX = this.x - tooltipWidth / 2,
  tooltipY = this.y - tooltipHeight

  ctx.fillStyle = this.fillColor

			// Custom Tooltips
  if (this.custom) {
  this.custom(this)
} else {
  switch (this.yAlign) {
  case 'above':
						// Draw a caret above the x/y
    ctx.beginPath()
    ctx.moveTo(this.x, this.y - caretPadding)
    ctx.lineTo(this.x + this.caretHeight, this.y - (caretPadding + this.caretHeight))
    ctx.lineTo(this.x - this.caretHeight, this.y - (caretPadding + this.caretHeight))
    ctx.closePath()
    ctx.fill()
    break
  case 'below':
    tooltipY = this.y + caretPadding + this.caretHeight
						// Draw a caret below the x/y
    ctx.beginPath()
    ctx.moveTo(this.x, this.y + caretPadding)
    ctx.lineTo(this.x + this.caretHeight, this.y + caretPadding + this.caretHeight)
    ctx.lineTo(this.x - this.caretHeight, this.y + caretPadding + this.caretHeight)
    ctx.closePath()
    ctx.fill()
    break
}

  switch (this.xAlign) {
  case 'left':
    tooltipX = this.x - tooltipWidth + (this.cornerRadius + this.caretHeight)
    break
  case 'right':
    tooltipX = this.x - (this.cornerRadius + this.caretHeight)
    break
}

  drawRoundedRectangle(ctx, tooltipX, tooltipY, tooltipWidth, tooltipRectHeight, this.cornerRadius)

  ctx.fill()

  ctx.fillStyle = this.textColor
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillText(this.text, tooltipX + tooltipWidth / 2, tooltipY + tooltipRectHeight / 2)
}
}
})

  Chart.MultiTooltip = Chart.Element.extend({
  initialize: function () {
  this.font = fontString(this.fontSize, this.fontStyle, this.fontFamily)

  this.titleFont = fontString(this.titleFontSize, this.titleFontStyle, this.titleFontFamily)

  this.height = (this.labels.length * this.fontSize) + ((this.labels.length - 1) * (this.fontSize / 2)) + (this.yPadding * 2) + this.titleFontSize * 1.5

  this.ctx.font = this.titleFont

  var titleWidth = this.ctx.measureText(this.title).width,
				// Label has a legend square as well so account for this.
  labelWidth = longestText(this.ctx, this.font, this.labels) + this.fontSize + 3,
  longestTextWidth = max([labelWidth, titleWidth])

  this.width = longestTextWidth + (this.xPadding * 2)

  var halfHeight = this.height / 2

			// Check to ensure the height will fit on the canvas
  if (this.y - halfHeight < 0) {
  this.y = halfHeight
} else if (this.y + halfHeight > this.chart.height) {
  this.y = this.chart.height - halfHeight
}

			// Decide whether to align left or right based on position on canvas
  if (this.x > this.chart.width / 2) {
  this.x -= this.xOffset + this.width
} else {
  this.x += this.xOffset
}
},
  getLineHeight: function (index) {
  var baseLineHeight = this.y - (this.height / 2) + this.yPadding,
  afterTitleIndex = index - 1

			// If the index is zero, we're getting the title
  if (index === 0) {
  return baseLineHeight + this.titleFontSize / 2
} else {
  return baseLineHeight + ((this.fontSize * 1.5 * afterTitleIndex) + this.fontSize / 2) + this.titleFontSize * 1.5
}
},
  draw: function () {
			// Custom Tooltips
  if (this.custom) {
  this.custom(this)
} else {
  drawRoundedRectangle(this.ctx, this.x, this.y - this.height / 2, this.width, this.height, this.cornerRadius)
  var ctx = this.ctx
  ctx.fillStyle = this.fillColor
  ctx.fill()
  ctx.closePath()

  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = this.titleTextColor
  ctx.font = this.titleFont

  ctx.fillText(this.title, this.x + this.xPadding, this.getLineHeight(0))

  ctx.font = this.font
  helpers.each(this.labels, function (label, index) {
  ctx.fillStyle = this.textColor
  ctx.fillText(label, this.x + this.xPadding + this.fontSize + 3, this.getLineHeight(index + 1))

					// A bit gnarly, but clearing this rectangle breaks when using explorercanvas (clears whole canvas)
					// ctx.clearRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
					// Instead we'll make a white filled block to put the legendColour palette over.

  ctx.fillStyle = this.legendColorBackground
  ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize / 2, this.fontSize, this.fontSize)

  ctx.fillStyle = this.legendColors[index].fill
  ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize / 2, this.fontSize, this.fontSize)
}, this)
}
}
})

  Chart.Scale = Chart.Element.extend({
  initialize: function () {
  this.fit()
},
  buildYLabels: function () {
  this.yLabels = []

  var stepDecimalPlaces = getDecimalPlaces(this.stepValue)

  for (var i = 0; i <= this.steps; i++) {
  this.yLabels.push(template(this.templateString, { value: (this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces) }))
}
  this.yLabelWidth = (this.display && this.showLabels) ? longestText(this.ctx, this.font, this.yLabels) : 0
},
  addXLabel: function (label) {
  this.xLabels.push(label)
  this.valuesCount++
  this.fit()
},
  removeXLabel: function () {
  this.xLabels.shift()
  this.valuesCount--
  this.fit()
},
		// Fitting loop to rotate x Labels and figure out what fits there, and also calculate how many Y steps to use
  fit: function () {
			// First we need the width of the yLabels, assuming the xLabels aren't rotated

			// To do that we need the base line at the top and base of the chart, assuming there is no x label rotation
  this.startPoint = (this.display) ? this.fontSize : 0
  this.endPoint = (this.display) ? this.height - (this.fontSize * 1.5) - 5 : this.height // -5 to pad labels

			// Apply padding settings to the start and end point.
  this.startPoint += this.padding
  this.endPoint -= this.padding

			// Cache the starting height, so can determine if we need to recalculate the scale yAxis
  var cachedHeight = this.endPoint - this.startPoint,
  cachedYLabelWidth

			// Build the current yLabels so we have an idea of what size they'll be to start
			/*
			 *	This sets what is returned from calculateScaleRange as static properties of this class:
			 *
				this.steps;
				this.stepValue;
				this.min;
				this.max;
			 *
			 */
  this.calculateYRange(cachedHeight)

			// With these properties set we can now build the array of yLabels
			// and also the width of the largest yLabel
  this.buildYLabels()

  this.calculateXLabelRotation()

  while ((cachedHeight > this.endPoint - this.startPoint)) {
  cachedHeight = this.endPoint - this.startPoint
  cachedYLabelWidth = this.yLabelWidth

  this.calculateYRange(cachedHeight)
  this.buildYLabels()

				// Only go through the xLabel loop again if the yLabel width has changed
  if (cachedYLabelWidth < this.yLabelWidth) {
  this.calculateXLabelRotation()
}
}
},
  calculateXLabelRotation: function () {
			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.

  this.ctx.font = this.font

  var firstWidth = this.ctx.measureText(this.xLabels[0]).width,
  lastWidth = this.ctx.measureText(this.xLabels[this.xLabels.length - 1]).width,
  firstRotated,
  lastRotated

  this.xScalePaddingRight = lastWidth / 2 + 3
  this.xScalePaddingLeft = (firstWidth / 2 > this.yLabelWidth + 10) ? firstWidth / 2 : this.yLabelWidth + 10

  this.xLabelRotation = 0
  if (this.display) {
  var originalLabelWidth = longestText(this.ctx, this.font, this.xLabels),
  cosRotation,
  firstRotatedWidth
  this.xLabelWidth = originalLabelWidth
				// Allow 3 pixels x2 padding either side for label readability
  var xGridWidth = Math.floor(this.calculateX(1) - this.calculateX(0)) - 6

				// Max label rotate should be 90 - also act as a loop counter
  while ((this.xLabelWidth > xGridWidth && this.xLabelRotation === 0) || (this.xLabelWidth > xGridWidth && this.xLabelRotation <= 90 && this.xLabelRotation > 0)) {
  cosRotation = Math.cos(toRadians(this.xLabelRotation))

  firstRotated = cosRotation * firstWidth
  lastRotated = cosRotation * lastWidth

					// We're right aligning the text now.
  if (firstRotated + this.fontSize / 2 > this.yLabelWidth + 8) {
  this.xScalePaddingLeft = firstRotated + this.fontSize / 2
}
  this.xScalePaddingRight = this.fontSize / 2

  this.xLabelRotation++
  this.xLabelWidth = cosRotation * originalLabelWidth
}
  if (this.xLabelRotation > 0) {
  this.endPoint -= Math.sin(toRadians(this.xLabelRotation)) * originalLabelWidth + 3
}
} else {
  this.xLabelWidth = 0
  this.xScalePaddingRight = this.padding
  this.xScalePaddingLeft = this.padding
}
},
		// Needs to be overidden in each Chart type
		// Otherwise we need to pass all the data into the scale class
  calculateYRange: noop,
  drawingArea: function () {
  return this.startPoint - this.endPoint
},
  calculateY: function (value) {
  var scalingFactor = this.drawingArea() / (this.min - this.max)
  return this.endPoint - (scalingFactor * (value - this.min))
},
  calculateX: function (index) {
  var isRotated = (this.xLabelRotation > 0),
				// innerWidth = (this.offsetGridLines) ? this.width - offsetLeft - this.padding : this.width - (offsetLeft + halfLabelWidth * 2) - this.padding,
  innerWidth = this.width - (this.xScalePaddingLeft + this.xScalePaddingRight),
  valueWidth = innerWidth / Math.max((this.valuesCount - ((this.offsetGridLines) ? 0 : 1)), 1),
  valueOffset = (valueWidth * index) + this.xScalePaddingLeft

  if (this.offsetGridLines) {
  valueOffset += (valueWidth / 2)
}

  return Math.round(valueOffset)
},
  update: function (newProps) {
  helpers.extend(this, newProps)
  this.fit()
},
  draw: function () {
  var ctx = this.ctx,
  yLabelGap = (this.endPoint - this.startPoint) / this.steps,
  xStart = Math.round(this.xScalePaddingLeft)
  if (this.display) {
  ctx.fillStyle = this.textColor
  ctx.font = this.font
  each(this.yLabels, function (labelString, index) {
  var yLabelCenter = this.endPoint - (yLabelGap * index),
  linePositionY = Math.round(yLabelCenter),
  drawHorizontalLine = this.showHorizontalLines

  ctx.textAlign = 'right'
  ctx.textBaseline = 'middle'
  if (this.showLabels) {
  ctx.fillText(labelString, xStart - 10, yLabelCenter)
}

					// This is X axis, so draw it
  if (index === 0 && !drawHorizontalLine) {
  drawHorizontalLine = true
}

  if (drawHorizontalLine) {
  ctx.beginPath()
}

  if (index > 0) {
						// This is a grid line in the centre, so drop that
  ctx.lineWidth = this.gridLineWidth
  ctx.strokeStyle = this.gridLineColor
} else {
						// This is the first line on the scale
  ctx.lineWidth = this.lineWidth
  ctx.strokeStyle = this.lineColor
}

  linePositionY += helpers.aliasPixel(ctx.lineWidth)

  if (drawHorizontalLine) {
  ctx.moveTo(xStart, linePositionY)
  ctx.lineTo(this.width, linePositionY)
  ctx.stroke()
  ctx.closePath()
}

  ctx.lineWidth = this.lineWidth
  ctx.strokeStyle = this.lineColor
  ctx.beginPath()
  ctx.moveTo(xStart - 5, linePositionY)
  ctx.lineTo(xStart, linePositionY)
  ctx.stroke()
  ctx.closePath()
}, this)

  each(this.xLabels, function (label, index) {
  var xPos = this.calculateX(index) + aliasPixel(this.lineWidth),
						// Check to see if line/bar here and decide where to place the line
  linePos = this.calculateX(index - (this.offsetGridLines ? 0.5 : 0)) + aliasPixel(this.lineWidth),
  isRotated = (this.xLabelRotation > 0),
  drawVerticalLine = this.showVerticalLines

					// This is Y axis, so draw it
  if (index === 0 && !drawVerticalLine) {
  drawVerticalLine = true
}

  if (drawVerticalLine) {
  ctx.beginPath()
}

  if (index > 0) {
						// This is a grid line in the centre, so drop that
  ctx.lineWidth = this.gridLineWidth
  ctx.strokeStyle = this.gridLineColor
} else {
						// This is the first line on the scale
  ctx.lineWidth = this.lineWidth
  ctx.strokeStyle = this.lineColor
}

  if (drawVerticalLine) {
  ctx.moveTo(linePos, this.endPoint)
  ctx.lineTo(linePos, this.startPoint - 3)
  ctx.stroke()
  ctx.closePath()
}

  ctx.lineWidth = this.lineWidth
  ctx.strokeStyle = this.lineColor

					// Small lines at the bottom of the base grid line
  ctx.beginPath()
  ctx.moveTo(linePos, this.endPoint)
  ctx.lineTo(linePos, this.endPoint + 5)
  ctx.stroke()
  ctx.closePath()

  ctx.save()
  ctx.translate(xPos, (isRotated) ? this.endPoint + 12 : this.endPoint + 8)
  ctx.rotate(toRadians(this.xLabelRotation) * -1)
  ctx.font = this.font
  ctx.textAlign = (isRotated) ? 'right' : 'center'
  ctx.textBaseline = (isRotated) ? 'middle' : 'top'
  ctx.fillText(label, 0, 0)
  ctx.restore()
}, this)
}
}

})

  Chart.RadialScale = Chart.Element.extend({
  initialize: function () {
  this.size = min([this.height, this.width])
  this.drawingArea = (this.display) ? (this.size / 2) - (this.fontSize / 2 + this.backdropPaddingY) : (this.size / 2)
},
  calculateCenterOffset: function (value) {
			// Take into account half font size + the yPadding of the top value
  var scalingFactor = this.drawingArea / (this.max - this.min)

  return (value - this.min) * scalingFactor
},
  update: function () {
  if (!this.lineArc) {
  this.setScaleSize()
} else {
  this.drawingArea = (this.display) ? (this.size / 2) - (this.fontSize / 2 + this.backdropPaddingY) : (this.size / 2)
}
  this.buildYLabels()
},
  buildYLabels: function () {
  this.yLabels = []

  var stepDecimalPlaces = getDecimalPlaces(this.stepValue)

  for (var i = 0; i <= this.steps; i++) {
  this.yLabels.push(template(this.templateString, { value: (this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces) }))
}
},
  getCircumference: function () {
  return ((Math.PI * 2) / this.valuesCount)
},
  setScaleSize: function () {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */

			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
  var largestPossibleRadius = min([(this.height / 2 - this.pointLabelFontSize - 5), this.width / 2]),
  pointPosition,
  i,
  textWidth,
  halfTextWidth,
  furthestRight = this.width,
  furthestRightIndex,
  furthestRightAngle,
  furthestLeft = 0,
  furthestLeftIndex,
  furthestLeftAngle,
  xProtrusionLeft,
  xProtrusionRight,
  radiusReductionRight,
  radiusReductionLeft,
  maxWidthRadius
  this.ctx.font = fontString(this.pointLabelFontSize, this.pointLabelFontStyle, this.pointLabelFontFamily)
  for (i = 0; i < this.valuesCount; i++) {
				// 5px to space the text slightly out - similar to what we do in the draw function.
  pointPosition = this.getPointPosition(i, largestPossibleRadius)
  textWidth = this.ctx.measureText(template(this.templateString, { value: this.labels[i] })).width + 5
  if (i === 0 || i === this.valuesCount / 2) {
					// If we're at index zero, or exactly the middle, we're at exactly the top/bottom
					// of the radar chart, so text will be aligned centrally, so we'll half it and compare
					// w/left and right text sizes
  halfTextWidth = textWidth / 2
  if (pointPosition.x + halfTextWidth > furthestRight) {
  furthestRight = pointPosition.x + halfTextWidth
  furthestRightIndex = i
}
  if (pointPosition.x - halfTextWidth < furthestLeft) {
  furthestLeft = pointPosition.x - halfTextWidth
  furthestLeftIndex = i
}
} else if (i < this.valuesCount / 2) {
					// Less than half the values means we'll left align the text
  if (pointPosition.x + textWidth > furthestRight) {
  furthestRight = pointPosition.x + textWidth
  furthestRightIndex = i
}
} else if (i > this.valuesCount / 2) {
					// More than half the values means we'll right align the text
  if (pointPosition.x - textWidth < furthestLeft) {
  furthestLeft = pointPosition.x - textWidth
  furthestLeftIndex = i
}
}
}

  xProtrusionLeft = furthestLeft

  xProtrusionRight = Math.ceil(furthestRight - this.width)

  furthestRightAngle = this.getIndexAngle(furthestRightIndex)

  furthestLeftAngle = this.getIndexAngle(furthestLeftIndex)

  radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI / 2)

  radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI / 2)

			// Ensure we actually need to reduce the size of the chart
  radiusReductionRight = (isNumber(radiusReductionRight)) ? radiusReductionRight : 0
  radiusReductionLeft = (isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0

  this.drawingArea = largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2

			// this.drawingArea = min([maxWidthRadius, (this.height - (2 * (this.pointLabelFontSize + 5)))/2])
  this.setCenterPoint(radiusReductionLeft, radiusReductionRight)
},
  setCenterPoint: function (leftMovement, rightMovement) {
  var maxRight = this.width - rightMovement - this.drawingArea,
  maxLeft = leftMovement + this.drawingArea

  this.xCenter = (maxLeft + maxRight) / 2
			// Always vertically in the centre as the text height doesn't change
  this.yCenter = (this.height / 2)
},

  getIndexAngle: function (index) {
  var angleMultiplier = (Math.PI * 2) / this.valuesCount
			// Start from the top instead of right, so remove a quarter of the circle

  return index * angleMultiplier - (Math.PI / 2)
},
  getPointPosition: function (index, distanceFromCenter) {
  var thisAngle = this.getIndexAngle(index)
return {
  x: (Math.cos(thisAngle) * distanceFromCenter) + this.xCenter,
  y: (Math.sin(thisAngle) * distanceFromCenter) + this.yCenter
}
},
  draw: function () {
  if (this.display) {
  var ctx = this.ctx
  each(this.yLabels, function (label, index) {
					// Don't draw a centre value
  if (index > 0) {
  var yCenterOffset = index * (this.drawingArea / this.steps),
  yHeight = this.yCenter - yCenterOffset,
  pointPosition

						// Draw circular lines around the scale
  if (this.lineWidth > 0) {
  ctx.strokeStyle = this.lineColor
  ctx.lineWidth = this.lineWidth

  if (this.lineArc) {
  ctx.beginPath()
  ctx.arc(this.xCenter, this.yCenter, yCenterOffset, 0, Math.PI * 2)
  ctx.closePath()
  ctx.stroke()
} else {
  ctx.beginPath()
  for (var i = 0; i < this.valuesCount; i++) {
  pointPosition = this.getPointPosition(i, this.calculateCenterOffset(this.min + (index * this.stepValue)))
  if (i === 0) {
  ctx.moveTo(pointPosition.x, pointPosition.y)
} else {
  ctx.lineTo(pointPosition.x, pointPosition.y)
}
}
  ctx.closePath()
  ctx.stroke()
}
}
  if (this.showLabels) {
  ctx.font = fontString(this.fontSize, this.fontStyle, this.fontFamily)
  if (this.showLabelBackdrop) {
  var labelWidth = ctx.measureText(label).width
  ctx.fillStyle = this.backdropColor
  ctx.fillRect(
									this.xCenter - labelWidth / 2 - this.backdropPaddingX,
									yHeight - this.fontSize / 2 - this.backdropPaddingY,
									labelWidth + this.backdropPaddingX * 2,
									this.fontSize + this.backdropPaddingY * 2
								)
}
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = this.fontColor
  ctx.fillText(label, this.xCenter, yHeight)
}
}
}, this)

  if (!this.lineArc) {
  ctx.lineWidth = this.angleLineWidth
  ctx.strokeStyle = this.angleLineColor
  for (var i = this.valuesCount - 1; i >= 0; i--) {
  if (this.angleLineWidth > 0) {
  var outerPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max))
  ctx.beginPath()
  ctx.moveTo(this.xCenter, this.yCenter)
  ctx.lineTo(outerPosition.x, outerPosition.y)
  ctx.stroke()
  ctx.closePath()
}
						// Extra 3px out for some label spacing
  var pointLabelPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max) + 5)
  ctx.font = fontString(this.pointLabelFontSize, this.pointLabelFontStyle, this.pointLabelFontFamily)
  ctx.fillStyle = this.pointLabelFontColor

  var labelsCount = this.labels.length,
  halfLabelsCount = this.labels.length / 2,
  quarterLabelsCount = halfLabelsCount / 2,
  upperHalf = (i < quarterLabelsCount || i > labelsCount - quarterLabelsCount),
  exactQuarter = (i === quarterLabelsCount || i === labelsCount - quarterLabelsCount)
  if (i === 0) {
  ctx.textAlign = 'center'
} else if (i === halfLabelsCount) {
  ctx.textAlign = 'center'
} else if (i < halfLabelsCount) {
  ctx.textAlign = 'left'
} else {
  ctx.textAlign = 'right'
}

						// Set the correct text baseline based on outer positioning
  if (exactQuarter) {
  ctx.textBaseline = 'middle'
} else if (upperHalf) {
  ctx.textBaseline = 'bottom'
} else {
  ctx.textBaseline = 'top'
}

  ctx.fillText(this.labels[i], pointLabelPosition.x, pointLabelPosition.y)
}
}
}
}
})

	// Attach global event to resize each chart instance when the browser resizes
  helpers.addEvent(window, 'resize', (function () {
		// Basic debounce of resize function so it doesn't hurt performance when resizing browser.
  var timeout
return function () {
  clearTimeout(timeout)
  timeout = setTimeout(function () {
  each(Chart.instances, function (instance) {
					// If the responsive flag is set in the chart instance config
					// Cascade the resize event down to the chart.
  if (instance.options.responsive) {
  instance.resize(instance.render, true)
}
})
}, 50)
}
})())

  if (amd) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
  return Chart
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
} else if (typeof module === 'object' && module.exports) {
  module.exports = Chart
}

  root.Chart = Chart

  Chart.noConflict = function () {
  root.Chart = previous
  return Chart
}
}).call(this);

(function () {
  'use strict'

  var root = this,
  Chart = root.Chart,
  helpers = Chart.helpers

  var defaultConfig = {
		// Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
  scaleBeginAtZero: true,

		// Boolean - Whether grid lines are shown across the chart
  scaleShowGridLines: true,

		// String - Colour of the grid lines
  scaleGridLineColor: 'rgba(0,0,0,.05)',

		// Number - Width of the grid lines
  scaleGridLineWidth: 1,

		// Boolean - Whether to show horizontal lines (except X axis)
  scaleShowHorizontalLines: true,

		// Boolean - Whether to show vertical lines (except Y axis)
  scaleShowVerticalLines: true,

		// Boolean - If there is a stroke on each bar
  barShowStroke: true,

		// Number - Pixel width of the bar stroke
  barStrokeWidth: 2,

		// Number - Spacing between each of the X value sets
  barValueSpacing: 5,

		// Number - Spacing between data sets within X values
  barDatasetSpacing: 1,

		// String - A legend template
  legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].fillColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'

}

  Chart.Type.extend({
  name: 'Bar',
  defaults: defaultConfig,
  initialize: function (data) {
			// Expose options as a scope variable here so we can access it in the ScaleClass
  var options = this.options

  this.ScaleClass = Chart.Scale.extend({
  offsetGridLines: true,
  calculateBarX: function (datasetCount, datasetIndex, barIndex) {
					// Reusable method for calculating the xPosition of a given bar based on datasetIndex & width of the bar
  var xWidth = this.calculateBaseWidth(),
  xAbsolute = this.calculateX(barIndex) - (xWidth / 2),
  barWidth = this.calculateBarWidth(datasetCount)

  return xAbsolute + (barWidth * datasetIndex) + (datasetIndex * options.barDatasetSpacing) + barWidth / 2
},
  calculateBaseWidth: function () {
  return (this.calculateX(1) - this.calculateX(0)) - (2 * options.barValueSpacing)
},
  calculateBarWidth: function (datasetCount) {
					// The padding between datasets is to the right of each bar, providing that there are more than 1 dataset
  var baseWidth = this.calculateBaseWidth() - ((datasetCount - 1) * options.barDatasetSpacing)

  return (baseWidth / datasetCount)
}
})

  this.datasets = []

			// Set up tooltip events on the chart
  if (this.options.showTooltips) {
  helpers.bindEvents(this, this.options.tooltipEvents, function (evt) {
  var activeBars = (evt.type !== 'mouseout') ? this.getBarsAtEvent(evt) : []

  this.eachBars(function (bar) {
  bar.restore(['fillColor', 'strokeColor'])
})
  helpers.each(activeBars, function (activeBar) {
  activeBar.fillColor = activeBar.highlightFill
  activeBar.strokeColor = activeBar.highlightStroke
})
  this.showTooltip(activeBars)
})
}

			// Declare the extension of the default point, to cater for the options passed in to the constructor
  this.BarClass = Chart.Rectangle.extend({
  strokeWidth: this.options.barStrokeWidth,
  showStroke: this.options.barShowStroke,
  ctx: this.chart.ctx
})

			// Iterate through each of the datasets, and build this into a property of the chart
  helpers.each(data.datasets, function (dataset, datasetIndex) {
  var datasetObject = {
  label: dataset.label || null,
  fillColor: dataset.fillColor,
  strokeColor: dataset.strokeColor,
  bars: []
}

  this.datasets.push(datasetObject)

  helpers.each(dataset.data, function (dataPoint, index) {
					// Add a new point for each piece of data, passing any required data to draw.
  datasetObject.bars.push(new this.BarClass({
  value: dataPoint,
  label: data.labels[index],
  datasetLabel: dataset.label,
  strokeColor: dataset.strokeColor,
  fillColor: dataset.fillColor,
  highlightFill: dataset.highlightFill || dataset.fillColor,
  highlightStroke: dataset.highlightStroke || dataset.strokeColor
}))
}, this)
}, this)

  this.buildScale(data.labels)

  this.BarClass.prototype.base = this.scale.endPoint

  this.eachBars(function (bar, index, datasetIndex) {
  helpers.extend(bar, {
  width: this.scale.calculateBarWidth(this.datasets.length),
  x: this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
  y: this.scale.endPoint
})
  bar.save()
}, this)

  this.render()
},
  update: function () {
  this.scale.update()
			// Reset any highlight colours before updating.
  helpers.each(this.activeElements, function (activeElement) {
  activeElement.restore(['fillColor', 'strokeColor'])
})

  this.eachBars(function (bar) {
  bar.save()
})
  this.render()
},
  eachBars: function (callback) {
  helpers.each(this.datasets, function (dataset, datasetIndex) {
  helpers.each(dataset.bars, callback, this, datasetIndex)
}, this)
},
  getBarsAtEvent: function (e) {
  var barsArray = [],
  eventPosition = helpers.getRelativePosition(e),
  datasetIterator = function (dataset) {
  barsArray.push(dataset.bars[barIndex])
},
  barIndex

  for (var datasetIndex = 0; datasetIndex < this.datasets.length; datasetIndex++) {
  for (barIndex = 0; barIndex < this.datasets[datasetIndex].bars.length; barIndex++) {
  if (this.datasets[datasetIndex].bars[barIndex].inRange(eventPosition.x, eventPosition.y)) {
  helpers.each(this.datasets, datasetIterator)
  return barsArray
}
}
}

  return barsArray
},
  buildScale: function (labels) {
  var self = this

  var dataTotal = function () {
  var values = []
  self.eachBars(function (bar) {
  values.push(bar.value)
})
  return values
}

  var scaleOptions = {
  templateString: this.options.scaleLabel,
  height: this.chart.height,
  width: this.chart.width,
  ctx: this.chart.ctx,
  textColor: this.options.scaleFontColor,
  fontSize: this.options.scaleFontSize,
  fontStyle: this.options.scaleFontStyle,
  fontFamily: this.options.scaleFontFamily,
  valuesCount: labels.length,
  beginAtZero: this.options.scaleBeginAtZero,
  integersOnly: this.options.scaleIntegersOnly,
  calculateYRange: function (currentHeight) {
  var updatedRanges = helpers.calculateScaleRange(
						dataTotal(),
						currentHeight,
						this.fontSize,
						this.beginAtZero,
						this.integersOnly
					)
  helpers.extend(this, updatedRanges)
},
  xLabels: labels,
  font: helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
  lineWidth: this.options.scaleLineWidth,
  lineColor: this.options.scaleLineColor,
  showHorizontalLines: this.options.scaleShowHorizontalLines,
  showVerticalLines: this.options.scaleShowVerticalLines,
  gridLineWidth: (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
  gridLineColor: (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : 'rgba(0,0,0,0)',
  padding: (this.options.showScale) ? 0 : (this.options.barShowStroke) ? this.options.barStrokeWidth : 0,
  showLabels: this.options.scaleShowLabels,
  display: this.options.showScale
}

  if (this.options.scaleOverride) {
  helpers.extend(scaleOptions, {
  calculateYRange: helpers.noop,
  steps: this.options.scaleSteps,
  stepValue: this.options.scaleStepWidth,
  min: this.options.scaleStartValue,
  max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
})
}

  this.scale = new this.ScaleClass(scaleOptions)
},
  addData: function (valuesArray, label) {
			// Map the values array for each of the datasets
  helpers.each(valuesArray, function (value, datasetIndex) {
				// Add a new point for each piece of data, passing any required data to draw.
  this.datasets[datasetIndex].bars.push(new this.BarClass({
  value: value,
  label: label,
  x: this.scale.calculateBarX(this.datasets.length, datasetIndex, this.scale.valuesCount + 1),
  y: this.scale.endPoint,
  width: this.scale.calculateBarWidth(this.datasets.length),
  base: this.scale.endPoint,
  strokeColor: this.datasets[datasetIndex].strokeColor,
  fillColor: this.datasets[datasetIndex].fillColor
}))
}, this)

  this.scale.addXLabel(label)
			// Then re-render the chart.
  this.update()
},
  removeData: function () {
  this.scale.removeXLabel()
			// Then re-render the chart.
  helpers.each(this.datasets, function (dataset) {
  dataset.bars.shift()
}, this)
  this.update()
},
  reflow: function () {
  helpers.extend(this.BarClass.prototype, {
  y: this.scale.endPoint,
  base: this.scale.endPoint
})
  var newScaleProps = helpers.extend({
  height: this.chart.height,
  width: this.chart.width
})
  this.scale.update(newScaleProps)
},
  draw: function (ease) {
  var easingDecimal = ease || 1
  this.clear()

  var ctx = this.chart.ctx

  this.scale.draw(easingDecimal)

			// Draw all the bars for each dataset
  helpers.each(this.datasets, function (dataset, datasetIndex) {
  helpers.each(dataset.bars, function (bar, index) {
  if (bar.hasValue()) {
  bar.base = this.scale.endPoint
						// Transition then draw
  bar.transition({
  x: this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
  y: this.scale.calculateY(bar.value),
  width: this.scale.calculateBarWidth(this.datasets.length)
}, easingDecimal).draw()
}
}, this)
}, this)
}
})
}).call(this);

(function () {
  'use strict'

  var root = this,
  Chart = root.Chart,
		// Cache a local reference to Chart.helpers
  helpers = Chart.helpers

  var defaultConfig = {
		// Boolean - Whether we should show a stroke on each segment
  segmentShowStroke: true,

		// String - The colour of each segment stroke
  segmentStrokeColor: '#fff',

		// Number - The width of each segment stroke
  segmentStrokeWidth: 2,

		// The percentage of the chart that we cut out of the middle.
  percentageInnerCutout: 50,

		// Number - Amount of animation steps
  animationSteps: 100,

		// String - Animation easing effect
  animationEasing: 'easeOutBounce',

		// Boolean - Whether we animate the rotation of the Doughnut
  animateRotate: true,

		// Boolean - Whether we animate scaling the Doughnut from the centre
  animateScale: false,

		// String - A legend template
  legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'

}

  Chart.Type.extend({
		// Passing in a name registers this chart in the Chart namespace
  name: 'Doughnut',
		// Providing a defaults will also register the deafults in the chart namespace
  defaults: defaultConfig,
		// Initialize is fired when the chart is initialized - Data is passed in as a parameter
		// Config is automatically merged by the core of Chart.js, and is available at this.options
  initialize: function (data) {
			// Declare segments as a static property to prevent inheriting across the Chart type prototype
  this.segments = []
  this.outerRadius = (helpers.min([this.chart.width, this.chart.height]) - this.options.segmentStrokeWidth / 2) / 2

  this.SegmentArc = Chart.Arc.extend({
  ctx: this.chart.ctx,
  x: this.chart.width / 2,
  y: this.chart.height / 2
})

			// Set up tooltip events on the chart
  if (this.options.showTooltips) {
  helpers.bindEvents(this, this.options.tooltipEvents, function (evt) {
  var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : []

  helpers.each(this.segments, function (segment) {
  segment.restore(['fillColor'])
})
  helpers.each(activeSegments, function (activeSegment) {
  activeSegment.fillColor = activeSegment.highlightColor
})
  this.showTooltip(activeSegments)
})
}
  this.calculateTotal(data)

  helpers.each(data, function (datapoint, index) {
  this.addData(datapoint, index, true)
}, this)

  this.render()
},
  getSegmentsAtEvent: function (e) {
  var segmentsArray = []

  var location = helpers.getRelativePosition(e)

  helpers.each(this.segments, function (segment) {
  if (segment.inRange(location.x, location.y)) segmentsArray.push(segment)
}, this)
  return segmentsArray
},
  addData: function (segment, atIndex, silent) {
  var index = atIndex || this.segments.length
  this.segments.splice(index, 0, new this.SegmentArc({
  value: segment.value,
  outerRadius: (this.options.animateScale) ? 0 : this.outerRadius,
  innerRadius: (this.options.animateScale) ? 0 : (this.outerRadius / 100) * this.options.percentageInnerCutout,
  fillColor: segment.color,
  highlightColor: segment.highlight || segment.color,
  showStroke: this.options.segmentShowStroke,
  strokeWidth: this.options.segmentStrokeWidth,
  strokeColor: this.options.segmentStrokeColor,
  startAngle: Math.PI * 1.5,
  circumference: (this.options.animateRotate) ? 0 : this.calculateCircumference(segment.value),
  label: segment.label
}))
  if (!silent) {
  this.reflow()
  this.update()
}
},
  calculateCircumference: function (value) {
  return (Math.PI * 2) * (Math.abs(value) / this.total)
},
  calculateTotal: function (data) {
  this.total = 0
  helpers.each(data, function (segment) {
  this.total += Math.abs(segment.value)
}, this)
},
  update: function () {
  this.calculateTotal(this.segments)

			// Reset any highlight colours before updating.
  helpers.each(this.activeElements, function (activeElement) {
  activeElement.restore(['fillColor'])
})

  helpers.each(this.segments, function (segment) {
  segment.save()
})
  this.render()
},

  removeData: function (atIndex) {
  var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length - 1
  this.segments.splice(indexToDelete, 1)
  this.reflow()
  this.update()
},

  reflow: function () {
  helpers.extend(this.SegmentArc.prototype, {
  x: this.chart.width / 2,
  y: this.chart.height / 2
})
  this.outerRadius = (helpers.min([this.chart.width, this.chart.height]) - this.options.segmentStrokeWidth / 2) / 2
  helpers.each(this.segments, function (segment) {
  segment.update({
  outerRadius: this.outerRadius,
  innerRadius: (this.outerRadius / 100) * this.options.percentageInnerCutout
})
}, this)
},
  draw: function (easeDecimal) {
  var animDecimal = (easeDecimal) || 1
  this.clear()
  helpers.each(this.segments, function (segment, index) {
  segment.transition({
  circumference: this.calculateCircumference(segment.value),
  outerRadius: this.outerRadius,
  innerRadius: (this.outerRadius / 100) * this.options.percentageInnerCutout
}, animDecimal)

  segment.endAngle = segment.startAngle + segment.circumference

  segment.draw()
  if (index === 0) {
  segment.startAngle = Math.PI * 1.5
}
				// Check to see if it's the last segment, if not get the next and update the start angle
  if (index < this.segments.length - 1) {
  this.segments[index + 1].startAngle = segment.endAngle
}
}, this)
}
})

  Chart.types.Doughnut.extend({
  name: 'Pie',
  defaults: helpers.merge(defaultConfig, { percentageInnerCutout: 0 })
})
}).call(this);
(function () {
  'use strict'

  var root = this,
  Chart = root.Chart,
  helpers = Chart.helpers

  var defaultConfig = {

		// /Boolean - Whether grid lines are shown across the chart
  scaleShowGridLines: true,

		// String - Colour of the grid lines
  scaleGridLineColor: 'rgba(0,0,0,.05)',

		// Number - Width of the grid lines
  scaleGridLineWidth: 1,

		// Boolean - Whether to show horizontal lines (except X axis)
  scaleShowHorizontalLines: true,

		// Boolean - Whether to show vertical lines (except Y axis)
  scaleShowVerticalLines: true,

		// Boolean - Whether the line is curved between points
  bezierCurve: true,

		// Number - Tension of the bezier curve between points
  bezierCurveTension: 0.4,

		// Boolean - Whether to show a dot for each point
  pointDot: true,

		// Number - Radius of each point dot in pixels
  pointDotRadius: 4,

		// Number - Pixel width of point dot stroke
  pointDotStrokeWidth: 1,

		// Number - amount extra to add to the radius to cater for hit detection outside the drawn point
  pointHitDetectionRadius: 20,

		// Boolean - Whether to show a stroke for datasets
  datasetStroke: true,

		// Number - Pixel width of dataset stroke
  datasetStrokeWidth: 2,

		// Boolean - Whether to fill the dataset with a colour
  datasetFill: true,

		// String - A legend template
  legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'

}

  Chart.Type.extend({
  name: 'Line',
  defaults: defaultConfig,
  initialize: function (data) {
			// Declare the extension of the default point, to cater for the options passed in to the constructor
  this.PointClass = Chart.Point.extend({
  strokeWidth: this.options.pointDotStrokeWidth,
  radius: this.options.pointDotRadius,
  display: this.options.pointDot,
  hitDetectionRadius: this.options.pointHitDetectionRadius,
  ctx: this.chart.ctx,
  inRange: function (mouseX) {
  return (Math.pow(mouseX - this.x, 2) < Math.pow(this.radius + this.hitDetectionRadius, 2))
}
})

  this.datasets = []

			// Set up tooltip events on the chart
  if (this.options.showTooltips) {
  helpers.bindEvents(this, this.options.tooltipEvents, function (evt) {
  var activePoints = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : []
  this.eachPoints(function (point) {
  point.restore(['fillColor', 'strokeColor'])
})
  helpers.each(activePoints, function (activePoint) {
  activePoint.fillColor = activePoint.highlightFill
  activePoint.strokeColor = activePoint.highlightStroke
})
  this.showTooltip(activePoints)
})
}

			// Iterate through each of the datasets, and build this into a property of the chart
  helpers.each(data.datasets, function (dataset) {
  var datasetObject = {
  label: dataset.label || null,
  fillColor: dataset.fillColor,
  strokeColor: dataset.strokeColor,
  pointColor: dataset.pointColor,
  pointStrokeColor: dataset.pointStrokeColor,
  points: []
}

  this.datasets.push(datasetObject)

  helpers.each(dataset.data, function (dataPoint, index) {
					// Add a new point for each piece of data, passing any required data to draw.
  datasetObject.points.push(new this.PointClass({
  value: dataPoint,
  label: data.labels[index],
  datasetLabel: dataset.label,
  strokeColor: dataset.pointStrokeColor,
  fillColor: dataset.pointColor,
  highlightFill: dataset.pointHighlightFill || dataset.pointColor,
  highlightStroke: dataset.pointHighlightStroke || dataset.pointStrokeColor
}))
}, this)

  this.buildScale(data.labels)

  this.eachPoints(function (point, index) {
  helpers.extend(point, {
  x: this.scale.calculateX(index),
  y: this.scale.endPoint
})
  point.save()
}, this)
}, this)

  this.render()
},
  update: function () {
  this.scale.update()
			// Reset any highlight colours before updating.
  helpers.each(this.activeElements, function (activeElement) {
  activeElement.restore(['fillColor', 'strokeColor'])
})
  this.eachPoints(function (point) {
  point.save()
})
  this.render()
},
  eachPoints: function (callback) {
  helpers.each(this.datasets, function (dataset) {
  helpers.each(dataset.points, callback, this)
}, this)
},
  getPointsAtEvent: function (e) {
  var pointsArray = [],
  eventPosition = helpers.getRelativePosition(e)
  helpers.each(this.datasets, function (dataset) {
  helpers.each(dataset.points, function (point) {
  if (point.inRange(eventPosition.x, eventPosition.y)) pointsArray.push(point)
})
}, this)
  return pointsArray
},
  buildScale: function (labels) {
  var self = this

  var dataTotal = function () {
  var values = []
  self.eachPoints(function (point) {
  values.push(point.value)
})

  return values
}

  var scaleOptions = {
  templateString: this.options.scaleLabel,
  height: this.chart.height,
  width: this.chart.width,
  ctx: this.chart.ctx,
  textColor: this.options.scaleFontColor,
  fontSize: this.options.scaleFontSize,
  fontStyle: this.options.scaleFontStyle,
  fontFamily: this.options.scaleFontFamily,
  valuesCount: labels.length,
  beginAtZero: this.options.scaleBeginAtZero,
  integersOnly: this.options.scaleIntegersOnly,
  calculateYRange: function (currentHeight) {
  var updatedRanges = helpers.calculateScaleRange(
						dataTotal(),
						currentHeight,
						this.fontSize,
						this.beginAtZero,
						this.integersOnly
					)
  helpers.extend(this, updatedRanges)
},
  xLabels: labels,
  font: helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
  lineWidth: this.options.scaleLineWidth,
  lineColor: this.options.scaleLineColor,
  showHorizontalLines: this.options.scaleShowHorizontalLines,
  showVerticalLines: this.options.scaleShowVerticalLines,
  gridLineWidth: (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
  gridLineColor: (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : 'rgba(0,0,0,0)',
  padding: (this.options.showScale) ? 0 : this.options.pointDotRadius + this.options.pointDotStrokeWidth,
  showLabels: this.options.scaleShowLabels,
  display: this.options.showScale
}

  if (this.options.scaleOverride) {
  helpers.extend(scaleOptions, {
  calculateYRange: helpers.noop,
  steps: this.options.scaleSteps,
  stepValue: this.options.scaleStepWidth,
  min: this.options.scaleStartValue,
  max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
})
}

  this.scale = new Chart.Scale(scaleOptions)
},
  addData: function (valuesArray, label) {
			// Map the values array for each of the datasets

  helpers.each(valuesArray, function (value, datasetIndex) {
				// Add a new point for each piece of data, passing any required data to draw.
  this.datasets[datasetIndex].points.push(new this.PointClass({
  value: value,
  label: label,
  x: this.scale.calculateX(this.scale.valuesCount + 1),
  y: this.scale.endPoint,
  strokeColor: this.datasets[datasetIndex].pointStrokeColor,
  fillColor: this.datasets[datasetIndex].pointColor
}))
}, this)

  this.scale.addXLabel(label)
			// Then re-render the chart.
  this.update()
},
  removeData: function () {
  this.scale.removeXLabel()
			// Then re-render the chart.
  helpers.each(this.datasets, function (dataset) {
  dataset.points.shift()
}, this)
  this.update()
},
  reflow: function () {
  var newScaleProps = helpers.extend({
  height: this.chart.height,
  width: this.chart.width
})
  this.scale.update(newScaleProps)
},
  draw: function (ease) {
  var easingDecimal = ease || 1
  this.clear()

  var ctx = this.chart.ctx

			// Some helper methods for getting the next/prev points
  var hasValue = function (item) {
    return item.value !== null
  },
  nextPoint = function (point, collection, index) {
  return helpers.findNextWhere(collection, hasValue, index) || point
},
  previousPoint = function (point, collection, index) {
  return helpers.findPreviousWhere(collection, hasValue, index) || point
}

  this.scale.draw(easingDecimal)

  helpers.each(this.datasets, function (dataset) {
  var pointsWithValues = helpers.where(dataset.points, hasValue)

				// Transition each point first so that the line and point drawing isn't out of sync
				// We can use this extra loop to calculate the control points of this dataset also in this loop

  helpers.each(dataset.points, function (point, index) {
  if (point.hasValue()) {
  point.transition({
  y: this.scale.calculateY(point.value),
  x: this.scale.calculateX(index)
}, easingDecimal)
}
}, this)

				// Control points need to be calculated in a seperate loop, because we need to know the current x/y of the point
				// This would cause issues when there is no animation, because the y of the next point would be 0, so beziers would be skewed
  if (this.options.bezierCurve) {
  helpers.each(pointsWithValues, function (point, index) {
  var tension = (index > 0 && index < pointsWithValues.length - 1) ? this.options.bezierCurveTension : 0
  point.controlPoints = helpers.splineCurve(
							previousPoint(point, pointsWithValues, index),
							point,
							nextPoint(point, pointsWithValues, index),
							tension
						)

						// Prevent the bezier going outside of the bounds of the graph

						// Cap puter bezier handles to the upper/lower scale bounds
  if (point.controlPoints.outer.y > this.scale.endPoint) {
  point.controlPoints.outer.y = this.scale.endPoint
} else if (point.controlPoints.outer.y < this.scale.startPoint) {
  point.controlPoints.outer.y = this.scale.startPoint
}

						// Cap inner bezier handles to the upper/lower scale bounds
  if (point.controlPoints.inner.y > this.scale.endPoint) {
  point.controlPoints.inner.y = this.scale.endPoint
} else if (point.controlPoints.inner.y < this.scale.startPoint) {
  point.controlPoints.inner.y = this.scale.startPoint
}
}, this)
}

				// Draw the line between all the points
  ctx.lineWidth = this.options.datasetStrokeWidth
  ctx.strokeStyle = dataset.strokeColor
  ctx.beginPath()

  helpers.each(pointsWithValues, function (point, index) {
  if (index === 0) {
  ctx.moveTo(point.x, point.y)
} else {
  if (this.options.bezierCurve) {
  var previous = previousPoint(point, pointsWithValues, index)

  ctx.bezierCurveTo(
								previous.controlPoints.outer.x,
								previous.controlPoints.outer.y,
								point.controlPoints.inner.x,
								point.controlPoints.inner.y,
								point.x,
								point.y
							)
} else {
  ctx.lineTo(point.x, point.y)
}
}
}, this)

  ctx.stroke()

  if (this.options.datasetFill && pointsWithValues.length > 0) {
					// Round off the line by going to the base of the chart, back to the start, then fill.
  ctx.lineTo(pointsWithValues[pointsWithValues.length - 1].x, this.scale.endPoint)
  ctx.lineTo(pointsWithValues[0].x, this.scale.endPoint)
  ctx.fillStyle = dataset.fillColor
  ctx.closePath()
  ctx.fill()
}

				// Now draw the points over the line
				// A little inefficient double looping, but better than the line
				// lagging behind the point positions
  helpers.each(pointsWithValues, function (point) {
  point.draw()
})
}, this)
}
})
}).call(this);

(function () {
  'use strict'

  var root = this,
  Chart = root.Chart,
		// Cache a local reference to Chart.helpers
  helpers = Chart.helpers

  var defaultConfig = {
		// Boolean - Show a backdrop to the scale label
  scaleShowLabelBackdrop: true,

		// String - The colour of the label backdrop
  scaleBackdropColor: 'rgba(255,255,255,0.75)',

		// Boolean - Whether the scale should begin at zero
  scaleBeginAtZero: true,

		// Number - The backdrop padding above & below the label in pixels
  scaleBackdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
  scaleBackdropPaddingX: 2,

		// Boolean - Show line for each value in the scale
  scaleShowLine: true,

		// Boolean - Stroke a line around each segment in the chart
  segmentShowStroke: true,

		// String - The colour of the stroke on each segement.
  segmentStrokeColor: '#fff',

		// Number - The width of the stroke value in pixels
  segmentStrokeWidth: 2,

		// Number - Amount of animation steps
  animationSteps: 100,

		// String - Animation easing effect.
  animationEasing: 'easeOutBounce',

		// Boolean - Whether to animate the rotation of the chart
  animateRotate: true,

		// Boolean - Whether to animate scaling the chart from the centre
  animateScale: false,

		// String - A legend template
  legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'
}

  Chart.Type.extend({
		// Passing in a name registers this chart in the Chart namespace
  name: 'PolarArea',
		// Providing a defaults will also register the deafults in the chart namespace
  defaults: defaultConfig,
		// Initialize is fired when the chart is initialized - Data is passed in as a parameter
		// Config is automatically merged by the core of Chart.js, and is available at this.options
  initialize: function (data) {
  this.segments = []
			// Declare segment class as a chart instance specific class, so it can share props for this instance
  this.SegmentArc = Chart.Arc.extend({
  showStroke: this.options.segmentShowStroke,
  strokeWidth: this.options.segmentStrokeWidth,
  strokeColor: this.options.segmentStrokeColor,
  ctx: this.chart.ctx,
  innerRadius: 0,
  x: this.chart.width / 2,
  y: this.chart.height / 2
})
  this.scale = new Chart.RadialScale({
  display: this.options.showScale,
  fontStyle: this.options.scaleFontStyle,
  fontSize: this.options.scaleFontSize,
  fontFamily: this.options.scaleFontFamily,
  fontColor: this.options.scaleFontColor,
  showLabels: this.options.scaleShowLabels,
  showLabelBackdrop: this.options.scaleShowLabelBackdrop,
  backdropColor: this.options.scaleBackdropColor,
  backdropPaddingY: this.options.scaleBackdropPaddingY,
  backdropPaddingX: this.options.scaleBackdropPaddingX,
  lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
  lineColor: this.options.scaleLineColor,
  lineArc: true,
  width: this.chart.width,
  height: this.chart.height,
  xCenter: this.chart.width / 2,
  yCenter: this.chart.height / 2,
  ctx: this.chart.ctx,
  templateString: this.options.scaleLabel,
  valuesCount: data.length
})

  this.updateScaleRange(data)

  this.scale.update()

  helpers.each(data, function (segment, index) {
  this.addData(segment, index, true)
}, this)

			// Set up tooltip events on the chart
  if (this.options.showTooltips) {
  helpers.bindEvents(this, this.options.tooltipEvents, function (evt) {
  var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : []
  helpers.each(this.segments, function (segment) {
  segment.restore(['fillColor'])
})
  helpers.each(activeSegments, function (activeSegment) {
  activeSegment.fillColor = activeSegment.highlightColor
})
  this.showTooltip(activeSegments)
})
}

  this.render()
},
  getSegmentsAtEvent: function (e) {
  var segmentsArray = []

  var location = helpers.getRelativePosition(e)

  helpers.each(this.segments, function (segment) {
  if (segment.inRange(location.x, location.y)) segmentsArray.push(segment)
}, this)
  return segmentsArray
},
  addData: function (segment, atIndex, silent) {
  var index = atIndex || this.segments.length

  this.segments.splice(index, 0, new this.SegmentArc({
  fillColor: segment.color,
  highlightColor: segment.highlight || segment.color,
  label: segment.label,
  value: segment.value,
  outerRadius: (this.options.animateScale) ? 0 : this.scale.calculateCenterOffset(segment.value),
  circumference: (this.options.animateRotate) ? 0 : this.scale.getCircumference(),
  startAngle: Math.PI * 1.5
}))
  if (!silent) {
  this.reflow()
  this.update()
}
},
  removeData: function (atIndex) {
  var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length - 1
  this.segments.splice(indexToDelete, 1)
  this.reflow()
  this.update()
},
  calculateTotal: function (data) {
  this.total = 0
  helpers.each(data, function (segment) {
  this.total += segment.value
}, this)
  this.scale.valuesCount = this.segments.length
},
  updateScaleRange: function (datapoints) {
  var valuesArray = []
  helpers.each(datapoints, function (segment) {
  valuesArray.push(segment.value)
})

  var scaleSizes = (this.options.scaleOverride)
				? {
  steps: this.options.scaleSteps,
  stepValue: this.options.scaleStepWidth,
  min: this.options.scaleStartValue,
  max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
}
				: helpers.calculateScaleRange(
					valuesArray,
					helpers.min([this.chart.width, this.chart.height]) / 2,
					this.options.scaleFontSize,
					this.options.scaleBeginAtZero,
					this.options.scaleIntegersOnly
				)

  helpers.extend(
				this.scale,
				scaleSizes,
  {
    size: helpers.min([this.chart.width, this.chart.height]),
    xCenter: this.chart.width / 2,
    yCenter: this.chart.height / 2
  }
			)
},
  update: function () {
  this.calculateTotal(this.segments)

  helpers.each(this.segments, function (segment) {
  segment.save()
})

  this.reflow()
  this.render()
},
  reflow: function () {
  helpers.extend(this.SegmentArc.prototype, {
  x: this.chart.width / 2,
  y: this.chart.height / 2
})
  this.updateScaleRange(this.segments)
  this.scale.update()

  helpers.extend(this.scale, {
  xCenter: this.chart.width / 2,
  yCenter: this.chart.height / 2
})

  helpers.each(this.segments, function (segment) {
  segment.update({
  outerRadius: this.scale.calculateCenterOffset(segment.value)
})
}, this)
},
  draw: function (ease) {
  var easingDecimal = ease || 1
			// Clear & draw the canvas
  this.clear()
  helpers.each(this.segments, function (segment, index) {
  segment.transition({
  circumference: this.scale.getCircumference(),
  outerRadius: this.scale.calculateCenterOffset(segment.value)
}, easingDecimal)

  segment.endAngle = segment.startAngle + segment.circumference

				// If we've removed the first segment we need to set the first one to
				// start at the top.
  if (index === 0) {
  segment.startAngle = Math.PI * 1.5
}

				// Check to see if it's the last segment, if not get the next and update the start angle
  if (index < this.segments.length - 1) {
  this.segments[index + 1].startAngle = segment.endAngle
}
  segment.draw()
}, this)
  this.scale.draw()
}
})
}).call(this);
(function () {
  'use strict'

  var root = this,
  Chart = root.Chart,
  helpers = Chart.helpers

  Chart.Type.extend({
  name: 'Radar',
  defaults: {
			// Boolean - Whether to show lines for each scale point
  scaleShowLine: true,

			// Boolean - Whether we show the angle lines out of the radar
  angleShowLineOut: true,

			// Boolean - Whether to show labels on the scale
  scaleShowLabels: false,

			// Boolean - Whether the scale should begin at zero
  scaleBeginAtZero: true,

			// String - Colour of the angle line
  angleLineColor: 'rgba(0,0,0,.1)',

			// Number - Pixel width of the angle line
  angleLineWidth: 1,

			// String - Point label font declaration
  pointLabelFontFamily: "'Arial'",

			// String - Point label font weight
  pointLabelFontStyle: 'normal',

			// Number - Point label font size in pixels
  pointLabelFontSize: 10,

			// String - Point label font colour
  pointLabelFontColor: '#666',

			// Boolean - Whether to show a dot for each point
  pointDot: true,

			// Number - Radius of each point dot in pixels
  pointDotRadius: 3,

			// Number - Pixel width of point dot stroke
  pointDotStrokeWidth: 1,

			// Number - amount extra to add to the radius to cater for hit detection outside the drawn point
  pointHitDetectionRadius: 20,

			// Boolean - Whether to show a stroke for datasets
  datasetStroke: true,

			// Number - Pixel width of dataset stroke
  datasetStrokeWidth: 2,

			// Boolean - Whether to fill the dataset with a colour
  datasetFill: true,

			// String - A legend template
  legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'

},

  initialize: function (data) {
  this.PointClass = Chart.Point.extend({
  strokeWidth: this.options.pointDotStrokeWidth,
  radius: this.options.pointDotRadius,
  display: this.options.pointDot,
  hitDetectionRadius: this.options.pointHitDetectionRadius,
  ctx: this.chart.ctx
})

  this.datasets = []

  this.buildScale(data)

			// Set up tooltip events on the chart
  if (this.options.showTooltips) {
  helpers.bindEvents(this, this.options.tooltipEvents, function (evt) {
  var activePointsCollection = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : []

  this.eachPoints(function (point) {
  point.restore(['fillColor', 'strokeColor'])
})
  helpers.each(activePointsCollection, function (activePoint) {
  activePoint.fillColor = activePoint.highlightFill
  activePoint.strokeColor = activePoint.highlightStroke
})

  this.showTooltip(activePointsCollection)
})
}

			// Iterate through each of the datasets, and build this into a property of the chart
  helpers.each(data.datasets, function (dataset) {
  var datasetObject = {
  label: dataset.label || null,
  fillColor: dataset.fillColor,
  strokeColor: dataset.strokeColor,
  pointColor: dataset.pointColor,
  pointStrokeColor: dataset.pointStrokeColor,
  points: []
}

  this.datasets.push(datasetObject)

  helpers.each(dataset.data, function (dataPoint, index) {
					// Add a new point for each piece of data, passing any required data to draw.
  var pointPosition
  if (!this.scale.animation) {
  pointPosition = this.scale.getPointPosition(index, this.scale.calculateCenterOffset(dataPoint))
}
  datasetObject.points.push(new this.PointClass({
  value: dataPoint,
  label: data.labels[index],
  datasetLabel: dataset.label,
  x: (this.options.animation) ? this.scale.xCenter : pointPosition.x,
  y: (this.options.animation) ? this.scale.yCenter : pointPosition.y,
  strokeColor: dataset.pointStrokeColor,
  fillColor: dataset.pointColor,
  highlightFill: dataset.pointHighlightFill || dataset.pointColor,
  highlightStroke: dataset.pointHighlightStroke || dataset.pointStrokeColor
}))
}, this)
}, this)

  this.render()
},
  eachPoints: function (callback) {
  helpers.each(this.datasets, function (dataset) {
  helpers.each(dataset.points, callback, this)
}, this)
},

  getPointsAtEvent: function (evt) {
  var mousePosition = helpers.getRelativePosition(evt),
  fromCenter = helpers.getAngleFromPoint({
  x: this.scale.xCenter,
  y: this.scale.yCenter
}, mousePosition)

  var anglePerIndex = (Math.PI * 2) / this.scale.valuesCount,
  pointIndex = Math.round((fromCenter.angle - Math.PI * 1.5) / anglePerIndex),
  activePointsCollection = []

			// If we're at the top, make the pointIndex 0 to get the first of the array.
  if (pointIndex >= this.scale.valuesCount || pointIndex < 0) {
  pointIndex = 0
}

  if (fromCenter.distance <= this.scale.drawingArea) {
  helpers.each(this.datasets, function (dataset) {
  activePointsCollection.push(dataset.points[pointIndex])
})
}

  return activePointsCollection
},

  buildScale: function (data) {
  this.scale = new Chart.RadialScale({
  display: this.options.showScale,
  fontStyle: this.options.scaleFontStyle,
  fontSize: this.options.scaleFontSize,
  fontFamily: this.options.scaleFontFamily,
  fontColor: this.options.scaleFontColor,
  showLabels: this.options.scaleShowLabels,
  showLabelBackdrop: this.options.scaleShowLabelBackdrop,
  backdropColor: this.options.scaleBackdropColor,
  backdropPaddingY: this.options.scaleBackdropPaddingY,
  backdropPaddingX: this.options.scaleBackdropPaddingX,
  lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
  lineColor: this.options.scaleLineColor,
  angleLineColor: this.options.angleLineColor,
  angleLineWidth: (this.options.angleShowLineOut) ? this.options.angleLineWidth : 0,
				// Point labels at the edge of each line
  pointLabelFontColor: this.options.pointLabelFontColor,
  pointLabelFontSize: this.options.pointLabelFontSize,
  pointLabelFontFamily: this.options.pointLabelFontFamily,
  pointLabelFontStyle: this.options.pointLabelFontStyle,
  height: this.chart.height,
  width: this.chart.width,
  xCenter: this.chart.width / 2,
  yCenter: this.chart.height / 2,
  ctx: this.chart.ctx,
  templateString: this.options.scaleLabel,
  labels: data.labels,
  valuesCount: data.datasets[0].data.length
})

  this.scale.setScaleSize()
  this.updateScaleRange(data.datasets)
  this.scale.buildYLabels()
},
  updateScaleRange: function (datasets) {
  var valuesArray = (function () {
  var totalDataArray = []
  helpers.each(datasets, function (dataset) {
  if (dataset.data) {
  totalDataArray = totalDataArray.concat(dataset.data)
} else {
  helpers.each(dataset.points, function (point) {
  totalDataArray.push(point.value)
})
}
})
  return totalDataArray
})()

  var scaleSizes = (this.options.scaleOverride)
				? {
  steps: this.options.scaleSteps,
  stepValue: this.options.scaleStepWidth,
  min: this.options.scaleStartValue,
  max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
}
				: helpers.calculateScaleRange(
					valuesArray,
					helpers.min([this.chart.width, this.chart.height]) / 2,
					this.options.scaleFontSize,
					this.options.scaleBeginAtZero,
					this.options.scaleIntegersOnly
				)

  helpers.extend(
				this.scale,
				scaleSizes
			)
},
  addData: function (valuesArray, label) {
			// Map the values array for each of the datasets
  this.scale.valuesCount++
  helpers.each(valuesArray, function (value, datasetIndex) {
  var pointPosition = this.scale.getPointPosition(this.scale.valuesCount, this.scale.calculateCenterOffset(value))
  this.datasets[datasetIndex].points.push(new this.PointClass({
  value: value,
  label: label,
  x: pointPosition.x,
  y: pointPosition.y,
  strokeColor: this.datasets[datasetIndex].pointStrokeColor,
  fillColor: this.datasets[datasetIndex].pointColor
}))
}, this)

  this.scale.labels.push(label)

  this.reflow()

  this.update()
},
  removeData: function () {
  this.scale.valuesCount--
  this.scale.labels.shift()
  helpers.each(this.datasets, function (dataset) {
  dataset.points.shift()
}, this)
  this.reflow()
  this.update()
},
  update: function () {
  this.eachPoints(function (point) {
  point.save()
})
  this.reflow()
  this.render()
},
  reflow: function () {
  helpers.extend(this.scale, {
  width: this.chart.width,
  height: this.chart.height,
  size: helpers.min([this.chart.width, this.chart.height]),
  xCenter: this.chart.width / 2,
  yCenter: this.chart.height / 2
})
  this.updateScaleRange(this.datasets)
  this.scale.setScaleSize()
  this.scale.buildYLabels()
},
  draw: function (ease) {
  var easeDecimal = ease || 1,
  ctx = this.chart.ctx
  this.clear()
  this.scale.draw()

  helpers.each(this.datasets, function (dataset) {
				// Transition each point first so that the line and point drawing isn't out of sync
  helpers.each(dataset.points, function (point, index) {
  if (point.hasValue()) {
  point.transition(this.scale.getPointPosition(index, this.scale.calculateCenterOffset(point.value)), easeDecimal)
}
}, this)

				// Draw the line between all the points
  ctx.lineWidth = this.options.datasetStrokeWidth
  ctx.strokeStyle = dataset.strokeColor
  ctx.beginPath()
  helpers.each(dataset.points, function (point, index) {
  if (index === 0) {
  ctx.moveTo(point.x, point.y)
} else {
  ctx.lineTo(point.x, point.y)
}
}, this)
  ctx.closePath()
  ctx.stroke()

  ctx.fillStyle = dataset.fillColor
  ctx.fill()

				// Now draw the points over the line
				// A little inefficient double looping, but better than the line
				// lagging behind the point positions
  helpers.each(dataset.points, function (point) {
  if (point.hasValue()) {
  point.draw()
}
})
}, this)
}

})
}).call(this)


/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Project_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Project_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Project_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Accessory_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Accessory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Accessory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Agent_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Agent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Agent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Device_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Device_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Device_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Information_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Information_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_DeviceTypes_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_DeviceTypes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_DeviceTypes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_DeviceAddon_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_DeviceAddon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_DeviceAddon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_DeviceAddonClient_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_DeviceAddonClient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_DeviceAddonClient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_ApnsRelation_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_ApnsRelation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_ApnsRelation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_OAuth2List_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_OAuth2List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_OAuth2List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Domain_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Domain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Domain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_AddApp_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_AddApp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_AddApp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_AboutDevice_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_AboutDevice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_AboutDevice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_ParameterSetting_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_ParameterSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_ParameterSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_EventList_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_EventList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_EventList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_DeviceUpgrade_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_DeviceUpgrade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_DeviceUpgrade_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_DeviceLog_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_DeviceLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_DeviceLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_ProblemDeviceList_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_ProblemDeviceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_ProblemDeviceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_DeviceUser_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_DeviceUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_DeviceUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Feedback_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_RobotList_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_RobotList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_RobotList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Master_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Master_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_Master_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Android_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Android_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_Android_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Ios_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Ios_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_Ios_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_GeneralSetting_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_GeneralSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_GeneralSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_TestDeviceAnalysis_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_TestDeviceAnalysis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_TestDeviceAnalysis_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_ConnectionAnalysis_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_ConnectionAnalysis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_ConnectionAnalysis_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_MobileClientsUpdateLogs_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_MobileClientsUpdateLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_MobileClientsUpdateLogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_MasterSlavesUpdateLogs_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_MasterSlavesUpdateLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_MasterSlavesUpdateLogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_DinNewsWeekly_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_DinNewsWeekly_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_DinNewsWeekly_vue__);



































var routes = [{
  path: "/login",
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: "project",
    alias: "",
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Project_vue___default.a,
    name: "Project",
    meta: {
      description: "Project List",
      requiresAuth: true
    }
  }, {
    path: "accessory",
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Accessory_vue___default.a,
    name: "Accessory",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "agent",
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Agent_vue___default.a,
    name: "Agent",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "device",
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Device_vue___default.a,
    name: "Device",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "aboutdevice",
    component: __WEBPACK_IMPORTED_MODULE_15__components_views_AboutDevice_vue___default.a,
    name: "AboutDevice",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "parametersetting",
    component: __WEBPACK_IMPORTED_MODULE_16__components_views_ParameterSetting_vue___default.a,
    name: "ParameterSetting",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "eventlist",
    component: __WEBPACK_IMPORTED_MODULE_17__components_views_EventList_vue___default.a,
    name: "EventList",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "deviceupgrade",
    component: __WEBPACK_IMPORTED_MODULE_18__components_views_DeviceUpgrade_vue___default.a,
    name: "DeviceUpgrade",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "devicelog",
    component: __WEBPACK_IMPORTED_MODULE_19__components_views_DeviceLog_vue___default.a,
    name: "DeviceLog",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "problemdevicelist",
    component: __WEBPACK_IMPORTED_MODULE_20__components_views_ProblemDeviceList_vue___default.a,
    name: "ProblemDeviceList",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "deviceuser",
    component: __WEBPACK_IMPORTED_MODULE_21__components_views_DeviceUser_vue___default.a,
    name: "DeviceUser",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "information/app",
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Information_vue___default.a,
    name: "Information",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "information/devicetypes",
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_DeviceTypes_vue___default.a,
    name: "DeviceTypes",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "information/deviceaddon",
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_DeviceAddon_vue___default.a,
    name: "DeviceAddon",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "information/deviceaddonclient",
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_DeviceAddonClient_vue___default.a,
    name: "DeviceAddonClient",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "information/apnsrelation",
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_ApnsRelation_vue___default.a,
    name: "ApnsRelation",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "oauth2",
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_OAuth2List_vue___default.a,
    name: "OAuth2List",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "domain",
    component: __WEBPACK_IMPORTED_MODULE_13__components_views_Domain_vue___default.a,
    name: "Domain",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "addapp",
    component: __WEBPACK_IMPORTED_MODULE_14__components_views_AddApp_vue___default.a,
    name: "AddApp",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "feedback",
    component: __WEBPACK_IMPORTED_MODULE_22__components_views_Feedback_vue___default.a,
    name: "Feedback",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/robotlist",
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_RobotList_vue___default.a,
    name: "RobotList",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/master",
    component: __WEBPACK_IMPORTED_MODULE_24__components_views_Master_vue___default.a,
    name: "Master",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/generalsetting",
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_GeneralSetting_vue___default.a,
    name: "generalsetting",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/analysis/testdeviceanalysis",
    component: __WEBPACK_IMPORTED_MODULE_28__components_views_TestDeviceAnalysis_vue___default.a,
    name: "TestDeviceAnalysis",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/analysis/connection",
    component: __WEBPACK_IMPORTED_MODULE_29__components_views_ConnectionAnalysis_vue___default.a,
    name: "connnectionAnalysis",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/mobileclientsupdatelogs",
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_MobileClientsUpdateLogs_vue___default.a,
    name: "mobileClientsUpdateLogs",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/masterslavesupdatelogs",
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_MasterSlavesUpdateLogs_vue___default.a,
    name: "masterSlavesUpdateLogs",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/android",
    component: __WEBPACK_IMPORTED_MODULE_25__components_views_Android_vue___default.a,
    name: "Android",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/compilation/ios",
    component: __WEBPACK_IMPORTED_MODULE_26__components_views_Ios_vue___default.a,
    name: "Ios",
    meta: { description: "", requiresAuth: true }
  }, {
    path: "/dinnewsweekly",
    component: __WEBPACK_IMPORTED_MODULE_32__components_views_DinNewsWeekly_vue___default.a,
    name: "Dinnewsweekly",
    meta: { description: "", requiresAuth: true }
  }]
}, {
  path: "*",
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01697276", Component.options)
  } else {
    hotAPI.reload("data-v-01697276", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === "" ? "loading" : "";
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_DEVICETOKEN: function SET_DEVICETOKEN(state, devicetoken) {
    state.devicetoken = devicetoken;
  },
  TOGGLE_FULLSCREEN_LOADING: function TOGGLE_FULLSCREEN_LOADING(state) {
    state.isLoading = !state.isLoading;
  },
  SET_FULLSCREEN_LOADING: function SET_FULLSCREEN_LOADING(state) {
    state.isLoading = true;
  },
  UNSET_FULLSCREEN_LOADING: function UNSET_FULLSCREEN_LOADING(state) {
    state.isLoading = false;
  },
  SET_ERROR: function SET_ERROR(state, message) {
    state.errorMessage = message;
  },
  UNSET_ERROR: function UNSET_ERROR(state) {
    state.errorMessage = "";
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: "",
  serverURI: "http://10.110.1.136:8080",
  user: null,
  token: null,
  isLoading: false,
  userInfo: {
    messages: [{ 1: "test", 2: "test" }],
    notifications: [],
    tasks: []
  },
  devicetoken: "",
  errorMessage: ""
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ErrorAlert_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ErrorAlert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ErrorAlert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(43);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "App",
  data: function data() {
    return {
      section: "Head"
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__Loading_vue___default.a,
    ErrorAlert: __WEBPACK_IMPORTED_MODULE_2__ErrorAlert_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(["isLoading"])),
  methods: {
    logout: function logout() {
      this.$store.commit("SET_USER", null);
      this.$store.commit("SET_TOKEN", null);

      if (window.localStorage) {
        window.localStorage.setItem("user", null);
        window.localStorage.setItem("token", null);
      }

      this.$router.push("/login");
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main__ = __webpack_require__(46);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      error: '',
      isShowDeviceName: false,
      currentIcon: '',
      user: {},
      progress: 0,
      isuploading: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['userInfo'])),
  mounted: function mounted() {
    var that = this;
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem('user') || 'null';
      this.user = JSON.parse(localUserString);
      this.currentIcon = this.user.icon;
    }

    window.jQuery('#self-agent-profile').on('hidden.bs.modal', function () {
      that.toUpdataUser();
    });
  },

  methods: {
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    toUpdataUser: function toUpdataUser() {
      if (this.isuploading) {
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].cancelUpload();
        this.isuploading = false;
      }
      this.currentIcon = this.user.icon;
      window.jQuery('#useropw').val('');
      window.jQuery('#usernpw').val('');
    },
    toLogout: function toLogout() {
      __WEBPACK_IMPORTED_MODULE_9__main__["default"].logout();
    },
    uploadfile: function uploadfile(event) {
      var that = this;
      if (!__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].isEmpty(event.target.files) && !__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].isEmpty(event.target.files[0]) && window.localStorage) {
        this.isuploading = true;
        that.toChangeInputStatus();
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].uploadFile(event.target.files[0], this.$router.app.$store.state.user.token, function (progress) {
          that.progress = progress;
        }, function (key, isOk, isCancel) {
          that.isuploading = false;
          that.toChangeInputStatus();
          if (isOk) {
            that.currentIcon = key;
          } else if (!isCancel) {
            __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].showMsg('upload fail');
          }
        });
      }
    },
    toChangeInputStatus: function toChangeInputStatus() {
      if (this.isuploading) {
        window.jQuery('input[type=\'file\']').attr('disabled', 'disabled');
      } else {
        window.jQuery('input[type=\'file\']').removeAttr('disabled');
      }
    },
    toDoUpdataUser: function toDoUpdataUser() {
      var _this = this;

      if (this.isuploading) {
        __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].showMsg('uploading');
        return;
      }
      var that = this;
      var params = new URLSearchParams();
      var jsons = {
        icon: this.currentIcon,
        opw: window.jQuery('#useropw').val().trim(),
        npw: window.jQuery('#usernpw').val().trim(),
        email: window.jQuery('#useremail').val().trim()
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_8__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/updataappuser?_type=json', params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {
          __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].showMsg('fail');
        } else {
          that.user.icon = that.currentIcon;
          _this.$store.commit('SET_USER', that.user);
          if (window.localStorage) {
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.user));
          }
          window.jQuery('#self-agent-profile').modal('hide');
        }
      });
    },
    toggleMenu: function toggleMenu() {
      var screenSizes = window.jQuery.AdminLTE.options.screenSizes;
      if (window.jQuery('body').width() > screenSizes.sm - 1) {
        if (window.jQuery('body').hasClass('sidebar-collapse')) {
          window.jQuery('body').removeClass('sidebar-collapse').trigger('expanded.pushMenu');
          this.$bus.emit('ShowBuildVersion', { isShow: true });
        } else {
          window.jQuery('body').addClass('sidebar-collapse').trigger('collapsed.pushMenu');
          this.$bus.emit('ShowBuildVersion', { isShow: false });
        }
      } else {
        if (window.jQuery('body').hasClass('sidebar-open')) {
          window.jQuery('body').removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
          this.$bus.emit('ShowBuildVersion', { isShow: false });
        } else {
          window.jQuery('body').addClass('sidebar-open').trigger('expanded.pushMenu');
          this.$bus.emit('ShowBuildVersion', { isShow: true });
        }
      }
      this.$bus.emit('ShowTreeViewFont', { key: '' });
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(37);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "error-alert",
  data: function data() {
    return {
      message: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(["errorMessage"])),
  methods: {
    hide: function hide() {
      this.jAlert.addClass("fade").removeClass("show");
    },
    show: function show() {
      this.jAlert.addClass("show").removeClass("fade");
    },
    close: function close(ev) {
      ev.preventDefault();
      this.hide();
    }
  },
  mounted: function mounted() {
    this.jAlert = window.jQuery(this.$refs.alert);
    this.timeoutId = null;
  },

  watch: {
    errorMessage: function errorMessage(message) {
      var _this = this;

      if (!message) return;

      this.message = message;
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit("UNSET_ERROR");
      if (this.timeoutId) {
        console.log(this.timeoutId);

        clearTimeout(this.timeoutId);
      }
      this.show();
      this.timeoutId = setTimeout(function () {
        _this.hide();
      }, 2000);
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var APP_SECRET = '9645c1a788e63552a6c699c28b9f77ff';
var MAC_TYPE = 'M4';
var DEVICE_TYPE = 'M5';

var PING_OK = 400;
var PING_GOOD = 200;
/* harmony default export */ __webpack_exports__["default"] = ({
  APP_SECRET: APP_SECRET,
  PING_OK: PING_OK,
  PING_GOOD: PING_GOOD,
  MAC_TYPE: MAC_TYPE,
  DEVICE_TYPE: DEVICE_TYPE
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_plugins_iCheck_icheck_min_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_plugins_iCheck_icheck_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_js_plugins_iCheck_icheck_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_plugins_iCheck_icheck_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_plugins_iCheck_icheck_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_js_plugins_iCheck_icheck_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_icheck_purple_css__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_icheck_purple_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_css_icheck_purple_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fingerprintjs2__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fingerprintjs2__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: '',
      isShowVerCode: false,
      email: '',
      emailcode: ''
    };
  },
  mounted: function mounted() {
    window.jQuery('#remember-me-checkbox').iCheck({
      checkboxClass: 'icheckbox_square-purple',
      radioClass: 'iradio_square-purple',
      increaseArea: '20%' });
  },

  methods: {
    login: function login(onlyid) {
      var _this = this;

      var username = this.username,
          password = this.password,
          emailcode = this.emailcode;


      var params = new URLSearchParams();
      var jsons = {
        uid: username,
        password: password,
        oid: onlyid,
        ecode: emailcode
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/login?_type=json', params).then(function (response) {
        _this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        _this.toggleLoading();

        var data = response.data;

        if (data.Status !== 1) {
          if (data.Status === -17) {
            _this.isShowVerCode = true;
            _this.email = data.Result;
          }
          var errorName = data.ErrorMessage;
          if (errorName) {
            _this.response = errorName === 'InvalidCredentialsError' ? 'Username/Password incorrect. Please try again.' : errorName;
          } else {
            _this.response = data.error;
          }
          return;
        }

        if (data.Result) {
          var decodeResult = _this.getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET);

          var myJson = JSON.parse(decodeResult);
          myJson.pw = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].getRC4Hex(myJson.pw, __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET);
          _this.$store.commit('SET_USER', myJson);
          _this.$store.commit('SET_TOKEN', myJson.token);

          if (window.localStorage) {
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myJson));
            window.localStorage.setItem('token', myJson.token);
          }

          window.setTimeout(function () {
            window.location.href = '/';
          }, 200);
        }
      });
    },
    togetOnlyId: function togetOnlyId() {
      var that = this;
      new __WEBPACK_IMPORTED_MODULE_8_fingerprintjs2___default.a().get(function (result, components) {
        that.login(result);
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    getRC4Hex: function getRC4Hex(message, key) {
      var keys = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8.parse(key);

      var encode = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.RC4.encrypt(message, keys);

      var base64code = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Base64.parse(encode.toString());

      var encryptedHexStr = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Hex.stringify(base64code);

      var hexsStr = encryptedHexStr.toString(__WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8);

      return hexsStr;
    },
    getDecodeRC4Hex: function getDecodeRC4Hex(encrypted, key) {
      var keys = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8.parse(key);

      var encryptedHexStr = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Hex.parse(encrypted);

      var srcs = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Base64.stringify(encryptedHexStr);

      var decrypteds = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.RC4.decrypt(srcs, keys);

      return decrypteds.toString(__WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8);
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  computed: {
    isShowSearch: function isShowSearch() {
      if (this.$route.path === '/' || this.$route.path === '/agent' || this.$route.path === '/device' || this.$route.path === '/deviceuser') {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function data() {
    return {
      searchKey: '',
      buildVersion: '1.0.0',
      buildSHA: '9999999',
      isShowVersion: true
    };
  },

  mounted: function mounted() {
    this.buildVersion = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].buildVersion;
    this.buildSHA = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].buildSHA;

    var that = this;
    window.jQuery('#search').keydown(function (event) {
      if (event.which === 13) {
        that.toDoSearch();
      }
    });
  },
  created: function created() {
    this.$bus.on('showsearchuserkey', this.setSearchKey);
    this.$bus.on('ShowBuildVersion', this.setBuildVersion);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off('showsearchuserkey', this.setSearchKey);
    this.$bus.off('ShowBuildVersion', this.setBuildVersion);
  },

  methods: {
    setBuildVersion: function setBuildVersion(datas) {
      this.isShowVersion = datas.isShow;
    },
    setSearchKey: function setSearchKey(datas) {
      this.searchKey = datas.key;
    },
    toDoSearch: function toDoSearch() {
      if (this.$route.path === '/') {
        this.toDoSearchApp();
        return;
      }

      if (this.$route.path === '/agent') {
        this.toDoSearchAgent();
        return;
      }

      if (this.$route.path === '/device') {
        this.toDoSearchDevice();
        return;
      }
      if (this.$route.path === '/deviceuser') {
        this.toDoSearchDeviceUser();
        return;
      }
    },
    toDoSearchApp: function toDoSearchApp() {
      this.$bus.emit('searchapp', { key: this.searchKey.trim() });
    },
    toDoSearchAgent: function toDoSearchAgent() {
      this.$bus.emit('searchagent', { key: this.searchKey.trim() });
    },
    toDoSearchDevice: function toDoSearchDevice() {
      this.$bus.emit('searchdevice', { key: this.searchKey.trim() });
    },
    toDoSearchDeviceUser: function toDoSearchDeviceUser() {
      this.$bus.emit('searchdeviceuser', { key: this.searchKey.trim() });
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SidebarName",
  hasAppId: true,
  isShowInformation: true,
  isShowAddApp: true,

  isShowHost: true,
  isShowAccessory: true,
  isShowFeedback: true,
  isShowUser: true,
  isShowCompilation: true,
  data: function data() {
    return {
      isShowTreeViewFont: true,
      isAgentAdmin: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAppAdmin()
    };
  },

  computed: {
    hasAppId: function hasAppId() {
      return !!this.$route.query.appid;
    },

    isShowInformation: function isShowInformation() {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowAddApp: function isShowAddApp() {
      if (this.$route.path === "/addapp") {
        return true;
      } else {
        return false;
      }
    },
    isShowAdmin: function isShowAdmin() {
      return typeof this.$route.query.appid !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAppAdmin();
    },

    isShowHost: function isShowHost() {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowAccessory: function isShowAccessory() {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowFeedback: function isShowFeedback() {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isAdminAndHasAppid: function isAdminAndHasAppid() {
      return !!this.$route.query.appid && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAdmin();
    },
    isShowUser: function isShowUser() {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowProblemDevices: function isShowProblemDevices() {
      return this.$route.query.appid;
    },
    isShowAboutDevice: function isShowAboutDevice() {
      if (typeof this.$route.query.deviceid !== "undefined") {
        window.jQuery("devicetreeview").addClass("active");
        window.jQuery("devicetreemenu").show();
        window.jQuery("devicetreemenu").addClass("active");
        return true;
      } else {
        return false;
      }
    },
    isShowAnalysis: function isShowAnalysis() {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAppAdmin() && this.$route.query.appid;
    },
    isShowTestDeviceAnalysis: function isShowTestDeviceAnalysis() {
      this.isAgentAdmin = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAppAdmin();
      if (typeof this.$route.query.appid !== "undefined" && this.isAgentAdmin !== false && this.$route.query.appid === "2d2204507cd1399283847ac3fcd7f0c8") {
        return true;
      } else {
        return false;
      }
    },
    isShowCompilation: function isShowCompilation() {
      this.isAgentAdmin = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].checkIsAppAdmin();
      return typeof this.$route.query.appid !== "undefined" && this.isAgentAdmin !== false && this.$route.query.appid !== "88d79c29c7ce1bfd07f7afb7897511a7";
    },
    isShowParamSetting: function isShowParamSetting() {
      if (typeof this.$route.query.deviceid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowLog: function isShowLog() {
      if (typeof this.$route.query.deviceid !== "undefined") {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.$bus.on("ShowTreeViewFont", this.checkShowViewFont);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off("ShowTreeViewFont", this.checkShowViewFont);
  },
  mounted: function mounted() {},

  methods: {
    toDevice: function toDevice() {
      this.$router.push("/device?appid=" + this.$route.query.appid + "&appname=" + this.$route.query.appname);
    },
    checkShowViewFont: function checkShowViewFont() {
      if (window.jQuery("body").hasClass("sidebar-collapse")) {
        this.isShowTreeViewFont = false;
      } else {
        this.isShowTreeViewFont = true;
      }
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js__);








var colors = [{
  color: "#F7464A",
  highlight: "#FF5A5E"
}, {
  color: "#46BFBD",
  highlight: "#5AD3D1"
}, {
  color: "#FDB45C",
  highlight: "#FFC870"
}, {
  color: "#00a4f2",
  highlight: "#19b2ff"
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "analysis-chart",
  props: {
    path: {
      required: true
    },
    type: {
      required: true
    },
    title: {
      required: true
    }
  },
  data: function data() {
    return {
      isFetching: true,
      barData: {
        labels: [],
        datasets: [{
          label: "Connection Info",
          fillColor: "rgba(220,220,220,0.5)",
          strokeColor: "rgba(220,220,220,0)",
          highlightFill: "rgba(220,220,220,0.75)",
          highlightStroke: "rgba(220,220,220,0)",
          data: []
        }]
      },
      pieData: []
    };
  },
  mounted: function mounted() {
    this.charType = "Bar";
    this.fetch();
  },

  methods: {
    xTypes: function xTypes(resp) {
      var type = this.type,
          barData = this.barData,
          pieData = this.pieData;
      var labels = barData.labels,
          datasets = barData.datasets;

      var dataset = datasets[0];
      var d = dataset.data;

      if (type === "monthly") {
        var color = colors[0];
        dataset.highlightFill = color.highlight;
        dataset.fillColor = color.color;
        resp.map(function (item) {
          item._date = new Date(item.date.year + "-" + item.date.month);
          return item;
        }).sort(function (a, b) {
          return a._date > b._date ? 1 : -1;
        }).forEach(function (_ref) {
          var count = _ref.count,
              _ref$date = _ref.date,
              month = _ref$date.month,
              year = _ref$date.year;

          labels.push(year + "-" + month);
          d.push(count);
        });
      } else if (type === "daily") {
        var _color = colors[1];
        dataset.highlightFill = _color.highlight;
        dataset.fillColor = _color.color;
        resp.map(function (item) {
          item._date = new Date(item.date.year + "-" + item.date.month + "-" + item.date.date);
          return item;
        }).sort(function (a, b) {
          return a._date > b._date ? 1 : -1;
        }).forEach(function (_ref2) {
          var count = _ref2.count,
              _ref2$date = _ref2.date,
              month = _ref2$date.month,
              year = _ref2$date.year,
              date = _ref2$date.date;

          labels.push(year + "-" + month + "-" + date);
          d.push(count);
        });
      } else if (type === "duration") {
        this.charType = "Pie";
        resp.sort(function (a, b) {
          return parseInt(a.duration, 10) > parseInt(b.duration, 10) ? 1 : -1;
        }).forEach(function (_ref3, index) {
          var count = _ref3.count,
              duration = _ref3.duration;

          var color = colors[index];
          pieData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, color, {
            value: count,
            label: duration.replace(/^\d+\)/, "")
          }));
        });
      } else {
        var _color2 = colors[2];
        dataset.highlightFill = _color2.highlight;
        dataset.fillColor = _color2.color;
        var max = 10;
        var total = resp.length;
        var lastIndex = Math.max(total - max, max);
        resp.sort(function (a, b) {
          return a.count > b.count ? 1 : -1;
        }).filter(function (_, index) {
          return index >= lastIndex;
        }).forEach(function (_ref4) {
          var count = _ref4.count,
              label = _ref4.label;

          labels.push(label);
          d.push(count);
        });
      }
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/analysis/" + _this.path + "?_type=json",
                  data: { appid: _this.$route.query.appid }
                });

              case 2:
                result = _context.sent;

                _this.isFetching = false;
                resp = JSON.parse(result.dataset);

                _this.xTypes(resp);
                _this.renderChart();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    renderChart: function renderChart() {
      var barData = this.barData,
          pieData = this.pieData;

      var areaChartCanvas = this.$refs.canvas.getContext("2d");
      var areaChart = new __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js___default.a(areaChartCanvas);
      areaChart[this.charType](this.charType === "Bar" ? barData : pieData, {
        legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"><%if(segments[i].label){%><%=segments[i].label%><%}%></span></li><%}%></ul>'
      });
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "apns-relation-form",
  props: {
    withInitialData: Boolean
  },
  data: function data() {
    return {
      formData: {
        appid: null,
        appsecret: null,
        fcmkey: null,
        mi: null,
        miappid: null,
        hmsid: null,
        hmskey: null
      },
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin(),
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/apnsrelation/get?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.formData = res;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _this2.formData;

                console.log("data", data);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/apnsrelation/update?_type=json",
                  data: data,
                  withLoading: true
                });

              case 4:
                res = _context2.sent;

                console.log("res", res);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);








var jsonKeys = ["smsconf", "jpushconf", "mailconf", "allowips", "notificationconf"];
var arrayKeys = ["paycontacts"];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app-data-form",
  props: {
    withInitialData: Boolean
  },
  data: function data() {
    return {
      formData: {
        appicon: "",
        appid: null,
        appname: null,
        oemname: null,
        appemail: null,
        appemailpassword: null,
        aboutme: null,
        confirmemail: null,
        helpurl: null,
        policy: null,
        contactid: null,

        description: null,
        smsconf: null,
        jpushconf: null,
        mailconf: null,
        feedbackmail: null,
        allowips: null,
        shareside: null,
        payside: null,
        paycontacts: null,
        notificationconf: null,
        rdaurl: null,
        ghome: null
      },
      progress: 0,
      isUploading: false,
      isAdmin: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsAdmin(),
      isAppAdmin: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsAppAdmin()
    };
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/getappdetailbyid?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.formData = _this._formatServerData(res);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    _save: function _save(path) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.isUploading) {
                  _context2.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].showMsg("uploading");
                return _context2.abrupt("return");

              case 3:
                formData = _this2.formData;
                data = _this2._formatFormData(formData);
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/" + path + "?_type=json",
                  data: data,
                  withLoading: true
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    update: function update() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _this3._save("updateappdetailbyid"));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    create: function create() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", _this4._save("addapp"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    uploadfile: function uploadfile(event) {
      var _this5 = this;

      if (!__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].isEmpty(event.target.files) && !__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].isEmpty(event.target.files[0]) && window.localStorage) {
        this.isUploading = true;
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadFile(event.target.files[0], this.$router.app.$store.state.user.token, function (progress) {
          _this5.progress = progress;
        }, function (key, isOk, isCancel) {
          _this5.isUploading = false;
          if (isOk) {
            _this5.formData.appicon = key;
          } else if (!isCancel) {
            __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].showMsg("upload fail");
          }
        });
      }
    },
    _formatServerData: function _formatServerData(data) {
      jsonKeys.forEach(function (key) {
        if (data[key]) {
          try {
            var stringKey = key + "String";
            var val = data[key];
            data[stringKey] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
          } catch (err) {}
        }
      });
      arrayKeys.forEach(function (key) {
        if (data[key]) {
          try {
            var stringKey = key + "String";
            var val = data[key];
            if (Array.isArray(val)) {
              data[stringKey] = val.join("\n");
            }
          } catch (err) {}
        }
      });
      return data;
    },
    _formatFormData: function _formatFormData(data) {
      jsonKeys.forEach(function (key) {
        var stringKey = key + "String";
        if (data[stringKey]) {
          try {
            var val = data[stringKey];
            data[key] = JSON.parse(val);
          } catch (err) {}
        }
      });
      arrayKeys.forEach(function (key) {
        var stringKey = key + "String";
        if (data[stringKey]) {
          try {
            var val = data[stringKey];
            data[key] = val.replace(",", "\n").split("\n").map(function (s) {
              return s.trim();
            });
          } catch (err) {}
        }
      });
      return data;
    }
  },
  mounted: function mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "device-addon-client-form",
  props: {
    withInitialData: Boolean
  },
  data: function data() {
    return {
      formData: {
        appid: null,
        description: null,
        addonversion: null,
        iosmd5: null,
        iosurl: null,
        androidmd5: null,
        androidurl: null
      },
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin(),
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/deviceaddonclient/get?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.formData = res;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _this2.formData;

                console.log("data", data);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/deviceaddonclient/update?_type=json",
                  data: data,
                  withLoading: true
                });

              case 4:
                res = _context2.sent;

                console.log("res", res);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "device-addon-form",
  props: {
    withInitialData: Boolean
  },
  data: function data() {
    return {
      formData: {
        appid: null,
        version: null,
        description: null,
        addontypeid: null,
        url: null,
        md5: null,
        addontype: null
      },
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin(),
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/deviceaddon/get?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.formData = res;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _this2.formData;

                console.log("data", data);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/deviceaddon/update?_type=json",
                  data: data,
                  withLoading: true
                });

              case 4:
                res = _context2.sent;

                console.log("res", res);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "device-type-form",
  props: {
    withInitialData: Boolean
  },
  data: function data() {
    return {
      formData: {
        appid: null,
        name: null,
        description: null,
        version: null,
        no8version: null,
        uppermd5: null,
        upperurl: null,
        lowermd5: null,
        lowerurl: null,
        lowermd5nostm8: null,
        lowerurlnostm8: null,
        logic: null
      },
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsSuperAdmin(),
      isAdmin: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/devicetypes/get?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.formData = res;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _this2.formData;

                console.log("data", data);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/devicetypes/update?_type=json",
                  data: data,
                  withLoading: true
                });

              case 4:
                res = _context2.sent;

                console.log("res", res);

                _this2.requestClearCache();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    requestClearCache: function requestClearCache() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var hosts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                hosts = [];

                if (false) {
                  hosts.push("https://api-as01.dinsafer.com");
                  hosts.push("https://api-as02.dinsafer.com");
                  hosts.push("https://api-eu01.dinsafer.com");
                  hosts.push("https://api-us01.dinsafer.com");
                } else {
                  hosts.push(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].blackholeServerURI);
                }
                hosts.map(function (host) {
                  return _this3.requestClearCacheByHost(host);
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    requestClearCacheByHost: function requestClearCacheByHost(host) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var appid, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                appid = _this4.$route.query.appid;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post_blackhole({
                  path: "/device/sendcmdadmin",
                  cmd: "CLEAN_DEVICE_VERSION_CACHE",
                  appid: appid,
                  host: host,
                  noError: true
                });

              case 3:
                res = _context4.sent;

                console.log(host, "clear cache result", res);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "domain-form-modal",
  props: {
    type: String,
    fetch: Function
  },
  data: function data() {
    return {
      title: this.$props.type === "edit" ? "Edit" : "Create",
      formData: {}
    };
  },

  computed: {
    isEdit: function isEdit() {
      return this.$props.type === "edit";
    }
  },
  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var path;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _this.$props.type === "edit" ? "update" : "create";
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/domain/" + path + "?_type=json",
                  data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.formData),
                  withLoading: true
                });

              case 3:
                _context.next = 5;
                return _this.$props.fetch();

              case 5:
                _this.hide();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/domain/delete?_type=json",
                  data: { short: _this2.formData.short },
                  withLoading: true
                });

              case 2:
                _context2.next = 4;
                return _this2.$props.fetch();

              case 4:
                _this2.hide();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    show: function show(data) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data);
      window.jQuery(this.$refs.modal).modal("show");
    },
    hide: function hide() {
      window.jQuery(this.$refs.modal).modal("hide");
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "oauth-modal",
  props: {
    type: String,
    fetch: Function
  },
  data: function data() {
    return {
      title: this.$props.type === "edit" ? "Edit" : "Create",
      formData: {}
    };
  },

  computed: {
    isEdit: function isEdit() {
      return this.$props.type === "edit";
    }
  },
  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var path, appid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _this.$props.type === "edit" ? "update" : "create";
                appid = _this.$route.query.appid;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/oauth2/" + path + "?_type=json",
                  data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.formData, { appid: appid }),
                  withLoading: true
                });

              case 4:
                _context.next = 6;
                return _this.$props.fetch();

              case 6:
                _this.hide();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/oauth2/delete?_type=json",
                  data: { id: _this2.formData.id },
                  withLoading: true
                });

              case 2:
                _context2.next = 4;
                return _this2.$props.fetch();

              case 4:
                _this2.hide();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    show: function show(data) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data);
      window.jQuery(this.$refs.modal).modal("show");
    },
    hide: function hide() {
      window.jQuery(this.$refs.modal).modal("hide");
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);






var problemDevicesPrivilege = 1;
var updateLogsPrivilege = 2;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "privilege-modal",
  data: function data() {
    return {
      uid: "",
      privileges: []
    };
  },

  computed: {
    problemDevices: {
      get: function get() {
        return this.privileges.includes(problemDevicesPrivilege);
      },
      set: function set() {
        this._toggle(problemDevicesPrivilege);
      }
    },
    updateLogs: {
      get: function get() {
        return this.privileges.includes(updateLogsPrivilege);
      },
      set: function set() {
        this._toggle(updateLogsPrivilege);
      }
    }
  },
  methods: {
    _toggle: function _toggle(val) {
      var index = this.privileges.indexOf(val);
      if (index >= 0) {
        this.privileges.splice(index, 1);
      } else {
        this.privileges.push(val);
      }
    },
    show: function show(uid) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.uid = uid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/userprivileges/getbyuid",
                  data: { appid: _this.$route.query.appid, uid: uid },
                  withLoading: true
                });

              case 3:
                res = _context.sent;

                _this.privileges = res.privileges;
                window.jQuery(_this.$refs.modal).modal("show");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSave: function handleSave() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var privileges, uid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                privileges = _this2.privileges, uid = _this2.uid;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/userprivileges/updatebyuid",
                  data: {
                    appid: _this2.$route.query.appid,
                    uid: uid,
                    privileges: privileges
                  },
                  withLoading: true
                });

              case 3:
                window.jQuery(_this2.$refs.modal).modal("hide");

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(5);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "update-logs",
  props: {
    path: {
      required: true
    },
    type: {
      required: true
    }
  },
  data: function data() {
    return {
      list: [],
      currentDeviceListHeight: 0,
      page: 1,
      isAgentAdmin: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsAppAdmin()
    };
  },

  computed: {
    isEmpty: function isEmpty() {
      return !this.list.length;
    }
  },
  methods: {
    handleScroll: function handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery(this.$refs.main).height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (this.currentDeviceListHeight < listNodeHeight && windowScrollTop + windowHeight >= listNodeHeight) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetch();
      }
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _list;

        var list, parsedList;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].post({
                  path: "/updatelogs/" + _this.path,
                  data: {
                    appid: _this.$route.query.appid,
                    limit: 20,
                    page: _this.page
                  }
                });

              case 2:
                list = _context.sent;
                parsedList = [];

                list.forEach(function (item) {
                  var platform = item.platform,
                      versionname = item.versionname,
                      date = item.date;

                  var prevItem = parsedList[parsedList.length - 1];
                  var parsedItem = function () {
                    var isClients = _this.type === "mobileclients";
                    if (!prevItem || prevItem.versionname !== versionname || prevItem.date !== date) {
                      return {
                        versionname: versionname,
                        date: date,
                        left: {
                          versionname: versionname,
                          date: date,
                          platformName: isClients ? "iOS" : "Master",
                          platform: isClients ? "IOS" : "Host machine"
                        },
                        right: {
                          versionname: versionname,
                          date: date,
                          platformName: isClients ? "Android" : "Slave",
                          platform: isClients ? "Android" : "Lower machine"
                        }
                      };
                    }
                    return prevItem;
                  }();
                  if (platform === "Lower machine" || platform === "Android") {
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(parsedItem.right, item);
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(parsedItem.left, item);
                  }
                  if (prevItem !== parsedItem) {
                    parsedList.push(parsedItem);
                  }
                });
                (_list = _this.list).push.apply(_list, parsedList);
                _this.page += 1;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    focusout: function focusout(item, ev, field) {
      var text = ev.currentTarget.innerText;
      var id = item.id,
          versionname = item.versionname,
          platform = item.platform,
          date = item.date;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].post({
        path: "/updatelogs/patch",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          appid: this.$route.query.appid,
          id: id,
          versionname: versionname,
          platform: platform,
          date: date
        }, field, text),
        noError: true
      }).catch(function (err) {
        return console.error(err);
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
    window.addEventListener("scroll", this.handleScroll, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_plugins_chartjs_Chart_min_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_plugins_chartjs_Chart_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_js_plugins_chartjs_Chart_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(11);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutDevice',
  data: function data() {
    return {
      servers: __WEBPACK_IMPORTED_MODULE_3__demo__["a" /* servers */],
      deviceData: {
        nettype: -1,
        power: -1,
        sim: -1,
        ipaddress: -1,
        version: -1
      },
      simDetail: {
        csq: -1,
        creg: -1,
        cgsn: -1,
        cimi: -1,
        cpin: -1,
        cops: -1
      },
      eventlistData: [],
      deviceCmd: '',
      offlineClass: true,
      isShowUserEmptyList: false,
      isShowPluginEmptyList: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, jsons;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = new URLSearchParams();
              jsons = {
                appid: _this.$route.query.appid,
                deviceid: _this.$route.query.deviceid
              };

              params.append('json', __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
              if (window.localStorage) {
                params.append('token', _this.$router.app.$store.state.user.token);
              }
              _this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
              _context.next = 7;
              return _this.fetchDeviceDetail(params);

            case 7:
              _this.$store.commit('TOGGLE_FULLSCREEN_LOADING');

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    toCheckSimDetail: function toCheckSimDetail() {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].checkIsAppAdmin) {
        return;
      }
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.$route.query.deviceid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/getdevicesimdata?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            _this2.simDetail = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
            console.log(_this2.simDetail);
            window.jQuery('#modal-sim-detail').modal('show');
          }
        }
      });
    },
    toSetSecurityState: function toSetSecurityState(cmd) {
      if (!this.offlineClass) {
        return;
      }
      this.deviceCmd = cmd;
      window.jQuery('#modal-security-state').modal('show');
    },
    toSendCmd: function toSendCmd() {
      var _this3 = this;

      var cmd = this.deviceCmd;
      var type = 'TASK_HOMEARM';
      if (cmd === 'Arm') {
        type = 'TASK_ARM';
        this.deviceData.deviceState = 0;
      } else if (cmd === 'Disarm') {
        type = 'TASK_DISARM';
        this.deviceData.deviceState = 2;
      } else {
        type = 'TASK_HOMEARM';
        this.deviceData.deviceState = 1;
      }

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getMessageId(),
        devtoken: this.deviceData.devicetoken,
        cmd: type,
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {
          alert('fail');
        } else {
          _this3.deviceState = cmd;
          window.jQuery('#modal-security-state').modal('hide');
        }
      });
    },
    initPingData: function initPingData(datas) {
      var lables = [];
      for (var i = 0; i < datas.length; i++) {
        lables.push('');
      }

      var areaChartCanvas = window.jQuery('#areaChart').get(0).getContext('2d');

      var areaChart = new __WEBPACK_IMPORTED_MODULE_7__static_js_plugins_chartjs_Chart_min_js___default.a(areaChartCanvas);

      var areaChartData = {
        labels: lables,
        datasets: [{
          label: 'Digital Goods',
          fillColor: 'rgba(60,141,188,0.9)',
          strokeColor: 'rgba(60,141,188,0.8)',
          pointColor: '#3b8bba',
          pointStrokeColor: 'rgba(60,141,188,1)',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(60,141,188,1)',
          data: datas
        }]
      };

      var areaChartOptions = {
        showScale: true,

        scaleShowGridLines: false,

        scaleGridLineColor: 'rgba(0,0,0,.05)',

        scaleGridLineWidth: 1,

        scaleShowHorizontalLines: true,

        scaleShowVerticalLines: true,

        bezierCurve: true,

        bezierCurveTension: 0.3,

        pointDot: false,

        pointDotRadius: 4,

        pointDotStrokeWidth: 1,

        pointHitDetectionRadius: 20,

        datasetStroke: true,

        datasetStrokeWidth: 2,

        datasetFill: true,

        legendTemplate: '<ul class=\'<%=name.toLowerCase()%>-legend\'><% for (var i=0; i<datasets.length; i++){%><li><span style=\'background-color :< %=datasets[i].lineColor%>\'></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>',

        maintainAspectRatio: true,

        responsive: true
      };

      areaChart.Line(areaChartData, areaChartOptions);
    },
    toSearchUser: function toSearchUser(uid) {
      this.$router.push('/deviceuser?appid=' + this.$route.query.appid + '&appname=' + this.$route.query.appname + '&key=' + uid);
    },
    toSearchPlugin: function toSearchPlugin(id) {
      this.$router.push('/accessory?appid=' + this.$route.query.appid + '&appname=' + this.$route.query.appname + '&key=' + id);
    },
    fetchDeviceDetail: function fetchDeviceDetail(params) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data, datas, i, j;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/getdevicesdetail?_type=json', params);

              case 2:
                response = _context2.sent;

                if (response) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                data = response.data;

                if (data.Status !== 1) {} else {
                  if (data.Result) {
                    _this4.deviceData = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
                    datas = [];

                    if (!__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].isEmpty(_this4.deviceData.pingdata)) {
                      for (i = 0; i < _this4.deviceData.pingdata.length && i < 10; i++) {
                        datas.push(_this4.deviceData.pingdata[i].pinduration / 1000000);
                      }
                    }
                    for (j = 0; j < _this4.deviceData.plugin.length; j++) {
                      if (_this4.deviceData.plugin[j].name === '') {
                        _this4.deviceData.plugin[j].prename = '( Pre-paired Accessory )';
                      } else {
                        _this4.deviceData.plugin[j].prename = _this4.deviceData.plugin[j].name;
                      }
                      _this4.deviceData.plugin[j].icon = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getPluginIconByCatAndSub(_this4.deviceData.plugin[j].cat, _this4.deviceData.plugin[j].sub);
                    }
                    if (_this4.deviceData.online === 1) {
                      _this4.offlineClass = true;
                    } else {
                      _this4.offlineClass = false;
                    }
                    if (__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].isEmpty(_this4.deviceData.users) || _this4.deviceData.users.length <= 0) {
                      _this4.isShowUserEmptyList = true;
                    } else {
                      _this4.isShowUserEmptyList = false;
                    }
                    if (_this4.deviceData.plugin.length <= 0) {
                      _this4.isShowPluginEmptyList = true;
                    } else {
                      _this4.isShowPluginEmptyList = false;
                    }
                    _this4.initPingData(datas);
                    _this4.$store.commit('SET_DEVICETOKEN', _this4.deviceData.devicetoken);
                  }
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd');
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Accessory',
  data: function data() {
    return {
      searchKey: '',
      plugins: [],
      pluginList: [],
      isShowDefault: true,
      isShowEmptyList: false,
      currentPlugin: {},
      currentAddPlugin: {},
      offlineClass: false,
      dataS: {}
    };
  },

  mounted: function mounted() {
    var that = this;
    if (this.$route.query.online === '1') {
      this.offlineClass = true;
    } else {
      this.offlineClass = false;
    }
    this.searchKey = this.$route.query.key;
    this.toSearchPlugin();

    window.jQuery('#search-plugin').keydown(function (event) {
      if (event.which === 13) {
        that.toSearchPlugin();
      }
    });
  },
  methods: {
    toSearchPlugin: function toSearchPlugin() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].isEmpty(this.searchKey)) {
        return;
      }

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        pluginname: this.searchKey
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', window.localStorage.getItem('token'));
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/searchplugin?_type=json', params).then(function (response) {
        _this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;
        if (data.Status !== 1) {
          _this.isShowEmptyList = true;
          _this.isShowDefault = false;
          var errorName = data.ErrorMessage;
          if (errorName) {
            __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].showMsg(errorName);
          } else {
            __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].showMsg('search fail');
          }
          return;
        } else {
          _this.pluginList = [];
          _this.plugins = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET));
          var p = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
          for (var i = 0; i < _this.plugins.length; i++) {
            if (_this.plugins[i].pluginname === '') {
              _this.plugins[i].isprepluginname = '( Pre-paired Accessory )';
            } else {
              _this.plugins[i].isprepluginname = _this.plugins[i].pluginname;
            }
            _this.plugins[i].typeName = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getNameByCatAndSub(_this.plugins[i].cat, _this.plugins[i].sub);
            _this.plugins[i].icon = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getPluginIconByCatAndSub(_this.plugins[i].cat, _this.plugins[i].sub);
            if (p.has(_this.plugins[i].pluginid)) {
              p.get(_this.plugins[i].pluginid).push(_this.plugins[i]);
            } else {
              var plugin = [];
              plugin.push(_this.plugins[i]);
              p.set(_this.plugins[i].pluginid, plugin);
            }
          }
          _this.pluginList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(p);
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].log(_this.pluginList);
          if (_this.pluginList.length <= 0) {
            _this.isShowEmptyList = true;
            _this.isShowDefault = false;
          } else {
            _this.isShowEmptyList = false;
            _this.isShowDefault = false;
          }
        }
      });
    },
    toSetPlugin: function toSetPlugin(i, k) {
      var _this2 = this;

      this.currentPlugin = this.pluginList[i][1][k];
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.currentPlugin.deviceid,
        pluginid: this.currentPlugin.pluginid,
        type: this.currentPlugin.cat,
        stype: this.currentPlugin.sub,
        sid: this.currentPlugin.sid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].serverURI, '/checkfactoryplugins?_type=json', params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          _this2.currentPlugin.isFactory = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET) === 'true';
          _this2.toJudgeDeviceState();
        }
      });
    },
    toJudgeDeviceState: function toJudgeDeviceState() {
      var _this3 = this;

      var params2 = new URLSearchParams();
      var jsons2 = {
        appid: this.$route.query.appid,
        deviceid: this.currentPlugin.deviceid
      };
      params2.append('json', __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons2), __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params2.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].serverURI, '/getdevicestate?_type=json', params2).then(function (response) {
        _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;
        if (data.Status !== 1) {} else {
          var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_5__Global_vue___default.a.APP_SECRET));
          _this3.offlineClass = temp.online;
          window.jQuery('#modal-set-ipc').modal('show');
        }
      });
    },
    toUnbindPlugin: function toUnbindPlugin() {
      var _this4 = this;

      var jsons = {};
      if (this.currentPlugin.cat === 10) {
        jsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'DELETE_NEWASKPLUGIN',
          stype: this.currentPlugin.sub,
          sendid: this.currentPlugin.pluginid,
          userid: ''
        };
      } else {
        jsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'DELETE_PLUGIN',
          category: this.currentPlugin.cat,
          pluginid: this.currentPlugin.pluginid,
          userid: ''
        };
      }
      var params = new URLSearchParams();

      params.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          for (var i = 0; i < _this4.pluginList.length; i++) {
            for (var j = 0; j < _this4.pluginList[i][1].length; j++) {
              if (_this4.pluginList[i][1][j].deviceid === _this4.currentPlugin.deviceid && _this4.pluginList[i][1][j].pluginid === _this4.currentPlugin.pluginid) {
                _this4.pluginList[i][1].splice(j, 1);
                if (_this4.pluginList[i][1].length <= 0) {
                  _this4.pluginList.splice(i, 1);
                  if (_this4.pluginList.length <= 0) {
                    _this4.isShowEmptyList = true;
                    _this4.isShowDefault = false;
                  } else {
                    _this4.isShowEmptyList = false;
                    _this4.isShowDefault = false;
                  }
                }
                break;
              }
            }
          }

          window.jQuery('#modal-set-ipc').modal('hide');
        }
      });
    },
    toChangePluginName: function toChangePluginName() {
      var _this5 = this;

      var jsons = {};
      if (this.currentPlugin.cat === 10) {
        jsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'SET_NEWASKPLUGINDATA',
          stype: this.currentPlugin.sub,
          sendid: this.currentPlugin.pluginid,
          name: this.currentPlugin.pluginname
        };
      } else {
        jsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'SET_PLUGINDATA',
          category: this.currentPlugin.cat,
          pluginid: this.currentPlugin.pluginid,
          plugin_item_name: this.currentPlugin.pluginname
        };
      }
      var params = new URLSearchParams();

      params.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          for (var i = 0; i < _this5.pluginList.length; i++) {
            for (var j = 0; j < _this5.pluginList[i][1].length; j++) {
              if (_this5.pluginList[i][1][j].deviceid === _this5.currentPlugin.deviceid && _this5.pluginList[i][1][j].pluginid === _this5.currentPlugin.pluginid) {
                _this5.pluginList[i][1][j].pluginname = _this5.currentPlugin.pluginname;
                break;
              }
            }
          }
          window.jQuery('#modal-set-ipc').modal('hide');
        }
      });
    },
    toAddThirdPlugin: function toAddThirdPlugin() {
      this.currentAddPlugin = { sub: '0B' };
    },
    toAddPlugin: function toAddPlugin() {
      this.currentAddPlugin = { sub: '0B', isPre: 'false' };
    },
    toSavePlugin: function toSavePlugin() {
      if (this.currentAddPlugin.isPre === 'true') {
        this.toAddPrePlugin();
      } else {
        this.toAddNoPrePlugin();
      }
    },
    toAddNoPrePlugin: function toAddNoPrePlugin() {
      var jsons = {};
      jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
        deviceid: this.currentAddPlugin.deviceid,
        cmd: 'ADD_PLUGIN',
        category: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getCategory(this.currentAddPlugin.sub),
        pluginid: this.currentAddPlugin.pluginid,
        subcategory: this.currentAddPlugin.sub,
        pluginname: this.currentAddPlugin.pluginname
      };
      var params = new URLSearchParams();
      params.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, '/device/sendcmdadmin/' + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          window.jQuery('#modal-add-offical-accessory').modal('hide');
        }
      });
    },
    toAddPrePlugin: function toAddPrePlugin() {
      var jsons = {};
      jsons = {
        deviceid: this.currentAddPlugin.deviceid,
        pluginids: this.currentAddPlugin.pluginid,
        batch: this.currentAddPlugin.batch
      };
      var params = new URLSearchParams();
      params.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, '/device/addfactorypluginlist/' + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          window.jQuery('#modal-add-offical-accessory').modal('hide');
        }
      });
    },
    toSaveThirdPlugin: function toSaveThirdPlugin() {
      var jsons = {};
      jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getMessageId(),
        deviceid: this.currentAddPlugin.deviceid,
        cmd: 'ADD_PLUGIN',
        category: 20,
        pluginid: this.currentAddPlugin.pluginid.substring(0, 4),
        decodeid: this.currentAddPlugin.pluginid,
        subcategory: this.currentAddPlugin.sub,
        pluginname: this.currentAddPlugin.pluginname
      };
      var params = new URLSearchParams();
      params.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].blackholeServerURI, '/device/sendcmdadmin/' + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          window.jQuery('#modal-add-third-party-accessory').modal('hide');
        }
      });
    },
    toSearchDevice: function toSearchDevice(devicename, deviceid) {
      this.$router.push('/aboutdevice?appid=' + this.$route.query.appid + '&appname=' + this.$route.query.appname + '&deviceid=' + deviceid + '&devicename=' + devicename + '&online=' + this.offlineClass + '&t=' + this.$store.state.devicetoken);
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd');
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddApp",
  components: {
    AppDataForm: __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm___default.a
  },
  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.create();

              case 2:
                _this.$router.push("/");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_PrivilegeModal_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_PrivilegeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_PrivilegeModal_vue__);










var pluginURL = "/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js";
var mapURL = "/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Agent",
  data: function data() {
    return {
      stats: __WEBPACK_IMPORTED_MODULE_1__demo__["b" /* stats */],
      userList: [],
      isSelectAll: false,
      currentUserPermission: "",
      isAdminInApp: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp,
      existedUser: [],
      editUser: {
        permission: "User"
      },
      newUser: {
        permission: "User"
      },
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppAdmin()
    };
  },

  components: {
    PrivilegeModal: __WEBPACK_IMPORTED_MODULE_6__modules_PrivilegeModal_vue___default.a
  },
  created: function created() {
    this.$bus.on("searchagent", this.init);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off("searchagent", this.init);
  },

  methods: {
    init: function init(key) {
      if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(key) || __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(key.key)) {
        this.toGetAllAgent();
      } else {
        this.toGetAllAgentByUid(key.key);
      }
    },

    isBurgApp: function isBurgApp() {
      return this.$route.query.appid === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].burgAppid;
    },
    toNewUser: function toNewUser() {
      if (typeof this.newUser.uid === "undefined" || typeof this.newUser.password === "undefined" || typeof this.newUser.permission === "undefined" || typeof this.newUser.email === "undefined") {
        alert("input error");
        return;
      }
      var user = {
        appid: this.$route.query.appid,
        uid: this.newUser.uid,
        password: this.newUser.password,
        email: this.newUser.email,
        permission: this.newUser.permission
      };
      var params = new URLSearchParams();
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/adduser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          var errorName = data.ErrorMessage;

          if (errorName) {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg(errorName);
          } else {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg("add fail");
          }
          return;
        } else {
          window.location.reload();
        }
      });
    },
    toDeleteUser: function toDeleteUser() {
      var user = {
        appid: this.$route.query.appid,
        uid: this.editUser.uid
      };
      var params = new URLSearchParams();
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/deleteuserbyappidanduid?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          var errorName = data.ErrorMessage;
          if (errorName) {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg(errorName);
          } else {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg("delete fail");
          }
          return;
        } else {
          window.location.reload();
        }
      });
    },
    toUpdataUser: function toUpdataUser() {
      var user = {
        appid: this.$route.query.appid,
        uid: this.editUser.uid,
        password: this.editUser.password,
        permission: this.editUser.permission,
        email: this.editUser.email
      };
      var params = new URLSearchParams();
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/updatauserbyuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          var errorName = data.ErrorMessage;

          if (errorName) {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg(errorName);
          } else {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg("updata fail");
          }
          return;
        } else {
          window.location.reload();
        }
      });
    },
    toGetExistUser: function toGetExistUser() {
      var _this = this;

      this.existedUser = [];
      this.isSelectAll = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: this.$router.app.$store.state.user.uid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/getexistuserbyappid?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < mylist.length; i++) {
              var hasAdd = false;
              for (var j = 0; j < _this.userList.length; j++) {
                if (mylist[i].uid === _this.userList[j].uid) {
                  if (_this.userList[j].permission >= 888) {
                    _this.existedUser.push({
                      uid: mylist[i].uid,
                      permission: "Admin",
                      isCheck: true,
                      hasAdd: true
                    });
                  } else {
                    _this.existedUser.push({
                      uid: mylist[i].uid,
                      permission: "User",
                      isCheck: true,
                      hasAdd: true
                    });
                  }
                  hasAdd = true;
                  break;
                }
              }
              if (hasAdd === false) {
                _this.existedUser.push({
                  uid: mylist[i].uid,
                  permission: "User",
                  isCheck: false,
                  hasAdd: false
                });
              }
            }
          }
        }
      });
    },
    toShowNewUserModal: function toShowNewUserModal(item) {
      this.newUser = {};
      this.newUser.permission = "User";
      window.jQuery("#modal-new-an-agent").modal("show");
    },
    toEditUser: function toEditUser(item) {
      var _this2 = this;

      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      this.editUser = {};
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: item.uid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/getuseremail?_type=json", params).then(function (response) {
        _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            var myUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
            _this2.$set(_this2.editUser, "uid", item.uid);
            _this2.$set(_this2.editUser, "email", myUser.email);

            if (item.permission >= 888) {
              _this2.$set(_this2.editUser, "permission", "Admin");
              _this2.editUser.permission = "Admin";
            } else {
              _this2.$set(_this2.editUser, "permission", "User");
            }
            window.jQuery("#modal-edit-agent").modal("show");
          }
        }
      });
    },
    toSelectAllExistUser: function toSelectAllExistUser() {
      this.isSelectAll = !this.isSelectAll;
      for (var i = 0; i < this.existedUser.length; i++) {
        if (!this.existedUser[i].hasAdd) {
          this.existedUser[i].isCheck = this.isSelectAll;
        }
      }
    },
    toAddExistUser: function toAddExistUser() {
      var addExistUserList = [];
      for (var i = 0; i < this.existedUser.length; i++) {
        if (this.existedUser[i].isCheck && !this.existedUser[i].hasAdd) {
          addExistUserList.push({
            uid: this.existedUser[i].uid,
            permission: this.existedUser[i].permission
          });
        }
      }
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        users: addExistUserList
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/addexistuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.location.reload();
        }
      });
    },
    toGetAllAgent: function toGetAllAgent() {
      var _this3 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/getuserbyappid?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            _this3.userList = [];
            if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppSuperAdmin()) {
              __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = true;
              _this3.isAdminInApp = true;
              var localUserString = window.localStorage.getItem("user");
              var localUser = JSON.parse(localUserString);
              _this3.currentUserPermission = localUser.pm;
            } else {
              __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = false;
              _this3.isAdminInApp = false;
            }
            var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < mylist.length; i++) {
              if (i === 0) {
                if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppSuperAdmin()) {
                  _this3.currentUserPermission = mylist[i].permission;
                }
                if (_this3.currentUserPermission >= 888) {
                  __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = true;
                  _this3.isAdminInApp = true;
                } else {
                  __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = false;
                  _this3.isAdminInApp = false;
                }
              }
              _this3.userList.push({
                uid: mylist[i].uid,
                permission: mylist[i].permission
              });
            }
          }
        }
      });
    },
    toGetAllAgentByUid: function toGetAllAgentByUid(uid) {
      var _this4 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: uid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/searchuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            _this4.userList = [];
            if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppSuperAdmin()) {
              __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = true;
              _this4.isAdminInApp = true;
            } else {
              __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].isAdminInApp = false;
              _this4.isAdminInApp = false;
            }
            var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < mylist.length; i++) {
              _this4.userList.push({
                uid: mylist[i].uid,
                permission: mylist[i].permission
              });
            }
          }
        }
      });
    },
    handleEditPrivilege: function handleEditPrivilege(user) {
      this.$refs.privilegeModal.show(user.uid);
    }
  },
  mounted: function mounted() {
    this.init();
    this.$nextTick(function () {
      window.jQuery.getScript(pluginURL, function () {
        window.jQuery.getScript(mapURL, function () {
          window.jQuery("#world-map-markers").vectorMap({
            map: "world_mill"
          });
        });
      });
    });
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(11);










var DEVELOP_STAGE = 'S1';
var API_STAGE = 'S2';
var PUBLISH_STAGE = 'S3';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Master',
  data: function data() {
    return {
      newversion_name: '',
      newversion_developlog: '',
      newversion_developshell: '',
      newversion_releaseshell: '',
      newversion_typeid: '',
      newbuild_developlog: '',
      newbuild_developshell: '',
      newbuild_stage: '',
      versionList: [],
      newbuild_robotid: '',
      sendtodevice_robotid: '',
      currentSendToStageid: '',
      currentVersoinPage: 0,
      currentLogContent: {},
      downloadLink: '',
      logDialogCurrentBuildid: '',
      logDialogCurrentContent: '',
      socket: {},
      currentBuildList: {
        'S1': [],
        'S2': [],
        'S3': []
      },
      currentStageBuild: {
        'S1': {
          'result': 1
        },
        'S2': { 'result': 1 },
        'S3': { 'result': 1 }
      },
      macRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      deviceRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      currentVersion: {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      },
      shellDialogContent: ''
    };
  },

  computed: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default.a, 'wss://testadminapi.dinsafer.com/ws', {
      reconnection: true
    });

    this.socket = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$socket;

    this.socket.onmessage = function (data) {
      return _this.onMessage(data);
    };

    this.socket.onopen = function (n) {
      console.log('onopen' + n);
      _this.toSendJoinToServer();
    };
    this.socket.onerror = function (n) {
      return console.log('onerror' + n);
    };
    this.socket.onclose = function (n) {
      return console.log('onclose' + n);
    };
  },
  mounted: function mounted() {
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
    this.toGetVersionList(0);
  },
  beforeDestroy: function beforeDestroy() {
    this.socket.close();
  },

  methods: {
    toShowVersionList: function toShowVersionList() {
      window.jQuery('#version-list-popmenu').addClass('open');
    },
    toSaveLog: function toSaveLog() {
      var _this2 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        developlog: window.jQuery('#currentVersionDevelopLog').val(),
        releaselog: window.jQuery('#currentVersionReleaseLog').val()
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifylog?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this2.currentVersion.developlog = window.jQuery('#currentVersionDevelopLog').val();
          _this2.currentVersion.releaselog = window.jQuery('#currentVersionReleaseLog').val();
        }
      });
    },
    toSendDingDing: function toSendDingDing(stageid) {
      var _this3 = this;

      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        stageid: stageid,
        buildid: this.currentStageBuild[stageid].buildid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/senddingding?_type=json', params).then(function (response) {
        _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {}
      });
    },
    toDoSendTo: function toDoSendTo() {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[this.currentSendToStageid].buildid,
        robotid: this.sendtodevice_robotid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/sendto?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.jQuery('#sendto_robotlist').modal('hide');
        }
      });
    },
    emptyToInVisibiliy: function emptyToInVisibiliy(con, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(con)) {
        return 'visibiliy ' + classString;
      } else {
        return 'invisibiliy';
      }
    },
    isHasBuildList: function isHasBuildList(stageid) {
      if (this.getBuildlistById(stageid) && this.getBuildlistById(stageid).length > 0) {
        return true;
      }
      return false;
    },
    onMessage: function onMessage(message) {
      var result = JSON.parse(message.data);
      if (result.Cmd && result.Cmd === '/task/taskstate') {
        window.location.reload();
      } else if (result.Cmd && result.Cmd === '/task/sendtasklog') {
        console.log('log result', result.Data);
        if (!this.currentLogContent[result.Data.buildID]) {
          this.currentLogContent[result.Data.buildID] = '';
        }
        var tempContent = this.currentLogContent[result.Data.buildID] + '\r\n' + '[' + result.Data.robotid + ']' + '[' + result.Data.robotname + '][' + result.Data.Time + ']' + '[' + result.Data.Level + '][' + result.Data.Msg + ']';
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(this.currentLogContent, result.Data.buildID, tempContent);
        if (this.logDialogCurrentBuildid === result.Data.buildID) {
          this.logDialogCurrentContent = this.currentLogContent[result.Data.buildID];
          console.log('log ', this.currentLogContent[result.Data.buildID]);
        }
      }
    },
    selectVersoin: function selectVersoin(index) {
      this.currentBuildList = {
        'S1': [],
        'S2': [],
        'S3': []
      };
      this.currentStageBuild = {
        'S1': {},
        'S2': {},
        'S3': {}
      };
      this.currentVersion = {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      };
      this.toDoAfterSelectVersion(index);
    },
    selectBuild: function selectBuild(stageid, index) {
      if (stageid === 'S3') {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList['S2'][index]);
      } else {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList[stageid][index]);
      }
    },
    toSendJoinToServer: function toSendJoinToServer() {
      var sd = {
        id: this.$router.app.$store.state.user.uid
      };
      var sf = {
        Cmd: '/task/login',
        Data: sd
      };
      var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sf);
      this.socket.send('iris-websocket-message:join;0;;;' + str);
    },
    toSendMessage: function toSendMessage(message) {},
    toGetLogContent: function toGetLogContent() {},
    toShowLog: function toShowLog(stageid) {
      if (this.currentStageBuild[stageid].result === -1) {
        this.logDialogCurrentBuildid = this.currentStageBuild[stageid].buildid;
        this.logDialogCurrentContent = '';

        window.jQuery('#modal-log').modal('show');
      } else {
        var win = window.open(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI + '/build/' + this.$route.query.appid + '/' + this.currentVersion.versionid + '/' + this.currentStageBuild[stageid].buildid + '/logfile.log', '_blank');
        win.focus();
      }
    },
    toShowShell: function toShowShell(stageid) {
      this.shellDialogContent = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentStageBuild[stageid].shell);
      console.log(this.currentStageBuild[stageid]);
      window.jQuery('#modal-shell').modal('show');
    },
    toDoPublishClick: function toDoPublishClick(stageid) {
      var _this4 = this;

      if (this.currentStageBuild[stageid].result !== 1 || this.currentStageBuild[stageid].buildid === this.currentVersion.PublishBuildid) {
        return;
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[stageid].buildid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifypublishid?_type=json', params).then(function (response) {
        _this4.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;
        if (data.Status !== 1) {
          alert('发布错误');
        } else {
          _this4.currentVersion.PublishBuildid = _this4.currentStageBuild[stageid].buildid;
        }
      });
    },
    getBtnText: function getBtnText(stageid) {
      if (this.currentVersion.PublishBuildid === this.currentStageBuild[stageid].buildid) {
        return '已发布';
      } else {
        return '发布';
      }
    },
    toShowDownload: function toShowDownload(stageid) {
      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.currentSendToStageid = stageid;

      var urls = this.currentStageBuild[this.currentSendToStageid].downloadkey;
      var jsons = {
        app: this.$route.query.appname,
        appid: this.$route.query.appid,
        type: this.$route.query.typeid,
        v: this.currentVersion.versionname,
        b: 'build ' + this.currentStageBuild[this.currentSendToStageid].buildnumber,
        u: urls
      };
      this.downloadLink = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI + '/appdowload?p=' + __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      window.jQuery('#modal-download').modal('show');
    },
    toDownloadLink: function toDownloadLink() {
      var win = window.open(this.downloadLink, '_blank');
      win.focus();
    },
    getBuildlistById: function getBuildlistById(stageid) {
      if (stageid === 'S3') {
        return this.currentBuildList['S2'];
      } else {
        return this.currentBuildList[stageid];
      }
    },
    getNameByTypeId: function getNameByTypeId(sid) {
      if (sid === DEVELOP_STAGE) {
        return 'TEST';
      }
      if (sid === API_STAGE) {
        return 'API';
      }
      if (sid === PUBLISH_STAGE) {
        return 'PUBLISH';
      }
    },
    getState: function getState(result) {
      if (result === -1) {
        return 'Building';
      }
      if (result === 0) {
        return 'Build Failed';
      }
      if (result === 1) {
        return 'Build Succeed';
      }
    },
    isPublishSelectSuccess: function isPublishSelectSuccess(stageid, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid]) && !__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid].buildid) && this.currentStageBuild[stageid].result === 1) {
        return 'visibiliy ' + classString;
      } else {
        return 'gone ' + classString;
      }
    },
    getBuildStageClassByTypeId: function getBuildStageClassByTypeId(result) {
      if (result === -1) {
        return 'fa fa-spinner';
      }
      if (result === 0) {
        return 'fa fa-remove (alias)';
      }
      if (result === 1) {
        return 'fa fa-check';
      }
    },
    getStageClassByTypeId: function getStageClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'box box-warning version-manage-box';
      }
      if (sid === 'S2') {
        return 'box box-info version-manage-box';
      }
      if (sid === 'S3') {
        return 'box box-success version-manage-box';
      }
    },
    getStageLogClassByTypeId: function getStageLogClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'label label-warning pull-right add-agent-choose';
      }
      if (sid === 'S2') {
        return 'label label-info pull-right add-agent-choose';
      }
      if (sid === 'S3') {
        return 'gone';
      }
    },
    toGetBuildList: function toGetBuildList(versionid, stageid, pages) {
      var _this5 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages,
        stage: stageid,
        versionid: this.currentVersion.versionid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/buildlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var buildlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          buildlist = _this5.currentBuildList[stageid].concat(buildlist);
          console.log(_this5.currentBuildList);
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(_this5.currentBuildList, stageid, buildlist);
          if (buildlist.length > 0 && _this5.currentStageBuild[stageid]) {
            _this5.currentStageBuild[stageid] = buildlist[0];
            if (stageid === 'S2') {
              _this5.currentStageBuild['S3'] = buildlist[0];
              if (stageid === 'S2') {
                _this5.currentStageBuild['S3'] = buildlist[0];
              }
            }
          }
        }
      });
    },
    toLoadMoreVersion: function toLoadMoreVersion(pages) {
      this.toGetVersionList(pages);
    },
    toLoadMoreBuild: function toLoadMoreBuild(stageid) {
      if (stageid === 'S3') {
        stageid = 'S2';
      }
      if (this.currentBuildList[stageid].length % 5 === 0) {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5);
      } else {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5 + 1);
      }
    },
    toGetVersionList: function toGetVersionList(pages) {
      var _this6 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/versionlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          if (pages === 0) {
            _this6.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          }
          if (tempList.length > 0 && _this6.currentVersion.versionname === '-') {
            _this6.versionList = tempList;
            _this6.currentVersoinPage++;
            _this6.toDoAfterSelectVersion(0);
          } else {
            _this6.currentVersoinPage++;
            _this6.versionList = _this6.versionList.concat(tempList);
          }
        }
      });
    },
    toDoAfterSelectVersion: function toDoAfterSelectVersion(index) {
      this.currentVersion = this.versionList[index];
      console.log(this.currentVersion);

      for (var i = 0; i < this.currentVersion.GeneralSetting.StageSupport.length; i++) {
        this.toGetBuildList(this.currentVersion.versionid, this.currentVersion.GeneralSetting.StageSupport[i], 0);
      }
    },
    toNewBuild: function toNewBuild(item) {
      var _this7 = this;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentVersion.PublishBuildid)) {
        alert('已经发布了，不能再新建Build');
        return;
      }

      if (item === DEVELOP_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.DevelopShell);
      } else if (item === API_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.ReleaseShell);
      }

      this.newbuild_stage = item;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/robotlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          if (data.Result) {
            _this7.macRobotList = [];
            var robotlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < robotlist.length; i++) {
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.MAC_TYPE) {
                _this7.macRobotList.push(robotlist[i]);
              }
            }
            _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
            window.jQuery('#modal-new-build').modal('show');
          }
        }
      });
    },
    toDoNewBuild: function toDoNewBuild() {
      var _this8 = this;

      var tempShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newbuild_developshell);
      if (tempShell === this.currentVersion.DevelopShell) {
        tempShell = '';
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.currentVersion.Type.id,
        versionid: this.currentVersion.versionid,
        stage: this.newbuild_stage,
        robotid: this.newbuild_robotid,
        comment: this.newbuild_developlog,
        shell: tempShell
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newbuild?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.location.reload();
        }
      });
    },
    toNewVersion: function toNewVersion() {
      var _this9 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/getshell?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          alert('获取默认脚本错误');
        } else {
          var tempResult = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          _this9.newversion_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.testShell);
          _this9.newversion_releaseshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.apiShell);
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.jQuery('#modal-new-version').modal('show');
        }
      });
    },
    toDoNewVersion: function toDoNewVersion() {
      var params = new URLSearchParams();
      var tempDevelopShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_developshell);
      var tempReleaseShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_releaseshell);
      var jsons = {
        appid: this.$route.query.appid,
        versionname: this.newversion_name,
        developlog: this.newversion_developlog,
        developshell: tempDevelopShell,
        releaseshell: tempReleaseShell,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newversion?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.location.reload();
        }
      });
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_ApnsRelationForm__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_ApnsRelationForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_ApnsRelationForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ApnsRelation",
  components: {
    ApnsRelationForm: __WEBPACK_IMPORTED_MODULE_2__modules_ApnsRelationForm___default.a
  },
  data: function data() {
    return {
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin()
    };
  },

  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.update();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AnalysisChart_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AnalysisChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_AnalysisChart_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Analysis",
  components: {
    AnalysisChart: __WEBPACK_IMPORTED_MODULE_0__modules_AnalysisChart_vue___default.a
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Device",
  data: function data() {
    return {
      devicelist: [],
      currentDeviceListHeight: 0,
      currentPage: 0,
      isSearchByName: false,
      searchName: "",
      isLoadMore: false,
      totalDevice: "-",
      onlineDevice: "-",
      as: "-",
      eu: "-",
      us: "-",
      normalsim: "-",
      noCard: "-",
      problem: "-",
      isAgentAdmin: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].checkIsAppAdmin()
    };
  },
  created: function created() {
    this.$bus.on("searchdevice", this.init);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off("searchdevice", this.init);
    this.$bus.emit("showsearchuserkey", { key: "" });
  },

  methods: {
    init: function init(key) {
      this.isLoadMore = false;
      this.currentPage = 0;
      this.currentDeviceListHeight = -1;
      window.scrollTo(0, 0);
      if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isEmpty(key) || __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isEmpty(key.key)) {
        this.toGetAllDevice(0);
      } else {
        this.toGetAllDeviceByName(key.key, 0);
      }
    },
    toGetAllDevice: function toGetAllDevice(page) {
      var _this = this;

      this.isSearchByName = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/getdevicesbyappid?_type=json", params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          if (data.Result) {
            if (!_this.isLoadMore) {
              _this.devicelist = [];
              _this.devicelist = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            } else {
              var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              _this.devicelist = _this.devicelist.concat(tempList);
            }
            _this.fixQuery();
          }
        }
      });
    },
    toGetAllDeviceByName: function toGetAllDeviceByName(key, page) {
      var _this2 = this;

      this.isSearchByName = true;
      this.searchName = key;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page,
        deviceid: key
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/getdevicesbyappid?_type=json", params).then(function (response) {
        _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
        var data = response.data;
        if (data.Status !== 1) {} else {
          if (data.Result) {
            if (!_this2.isLoadMore) {
              _this2.devicelist = [];
              _this2.devicelist = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            } else {
              var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              _this2.devicelist = _this2.devicelist.concat(tempList);
            }
            _this2.fixQuery();
          }
        }
      });
    },
    winScroll: function winScroll(e) {
      if (this.currentDeviceListHeight < window.jQuery("#devicelist").height()) {
        if (window.jQuery(window).scrollTop() + window.jQuery(window).height() >= window.jQuery("#devicelist").height()) {
          this.currentDeviceListHeight = window.jQuery(window).scrollTop() + window.jQuery(window).height();
          this.isLoadMore = true;
          this.getNextPage();
        }
      }
    },
    fixQuery: function fixQuery() {},
    getNextPage: function getNextPage() {
      this.currentPage = this.currentPage + 1;
      if (!this.isSearchByName) {
        this.toGetAllDevice(this.currentPage);
      } else {
        this.toGetAllDeviceByName(this.searchName, this.currentPage);
      }
    },
    getAggregation: function getAggregation() {
      var that = this;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request("post", "/appaggregation?_type=json", params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          if (data.Result) {
            var result = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));

            that.totalDevice = result.simnormal + result.nocard + result.problem;

            that.onlineDevice = result.as + result.eu + result.us;
            that.as = result.as;
            that.eu = result.eu;
            that.us = result.us;
            that.normalsim = result.simnormal;
            that.noCard = result.nocard;
            that.problem = result.problem;
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
    this.getAggregation();
    window.addEventListener("scroll", this.winScroll);
  },

  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].formatDate(date, "yyyy-MM-dd");
    },
    encodeURI: function encodeURI(url) {
      return encodeURIComponent(url);
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonForm__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceAddon",
  components: {
    DeviceAddonForm: __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonForm___default.a
  },
  data: function data() {
    return {
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin()
    };
  },

  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.update();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonClientForm__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonClientForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonClientForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceAddonClient",
  components: {
    DeviceAddonClientForm: __WEBPACK_IMPORTED_MODULE_2__modules_DeviceAddonClientForm___default.a
  },
  data: function data() {
    return {
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin()
    };
  },

  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.update();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);








function arrayBufferToString(buf) {
  var bytes = new Uint8Array(buf);
  var i = 0;
  var s = '';
  while (i < bytes.length) {
    var c = bytes[i++];
    if (c > 127) {
      if (c > 191 && c < 224) {
        if (i >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 2-byte sequence');
        }
        c = (c & 31) << 6 | bytes[i++] & 63;
      } else if (c > 223 && c < 240) {
        if (i + 1 >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 3-byte sequence');
        }
        c = (c & 15) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
      } else if (c > 239 && c < 248) {
        if (i + 2 >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 4-byte sequence');
        }
        c = (c & 7) << 18 | (bytes[i++] & 63) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
      } else {
        throw new Error('UTF-8 decode: unknown multibyte start 0x' + c.toString(16) + ' at index ' + (i - 1));
      }
    }
    if (c <= 0xffff) {
      s += String.fromCharCode(c);
    } else if (c <= 0x10ffff) {
      c -= 0x10000;
      s += String.fromCharCode(c >> 10 | 0xd800);
      s += String.fromCharCode(c & 0x3FF | 0xdc00);
    } else {
      throw new Error('UTF-8 decode: code point 0x' + c.toString(16) + ' exceeds UTF-16 reach');
    }
  }
  return s;
}

function getWsURL() {
  var url = new URL(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI);
  var protocol = url.protocol === "http:" ? "ws:" : "wss:";
  var room = Math.random().toString(36).slice(2);
  return protocol + "//" + url.host + "/ws-log/" + room;
}

function stdout(target, data) {
  var win = target.contentWindow;
  var document = win.document;
  var body = document.body;

  var isBottom = Math.abs(document.body.offsetHeight - win.innerHeight - win.scrollY) <= 30;
  var line = document.createElement("div");

  line.innerHTML = data;
  body.append(line);

  var lines = document.querySelectorAll("div");
  for (var n = lines.length; n >= 2000; n--) {
    body.firstElementChild.remove();
  }

  if (isBottom) {
    setTimeout(function () {
      return win.scrollTo(0, document.body.scrollHeight);
    }, 2);
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceLog",
  data: function data() {
    return {
      isAdmin: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].checkIsAdmin()
    };
  },
  beforeDestroy: function beforeDestroy() {
    console.log("unmount");
    if (this.ws) {
      this.handleDismiss();
    }
  },
  mounted: function mounted() {
    var style = this.$refs.console.contentWindow.document.body.style;

    style.fontFamily = "Consolas,'Courier New',Courier,FreeMono,monospace";
    style.fontWeight = "bold";
    style.fontSize = "14px";
    style.color = "rgb(0, 168, 0)";
    style.wordBreak = "break-all";
  },

  methods: {
    handleClear: function handleClear() {
      this.$refs.console.contentWindow.document.body.innerHTML = "";
    },
    handleShow: function handleShow() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _$route$query, appid, deviceid, url, res;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _$route$query = _this.$route.query, appid = _$route$query.appid, deviceid = _$route$query.deviceid;
                url = getWsURL();

                console.log(url);
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post_blackhole({
                  path: "/device/sendcmdadmin",
                  cmd: "UPLOAD_LOG_WS",
                  withLoading: true,
                  appid: appid,
                  data: {
                    deviceid: deviceid,
                    ws: url
                  }
                });

              case 5:
                res = _context.sent;

                console.log("handle show", res);
                _this.runWs(url);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleDismiss: function handleDismiss() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _$route$query2, appid, deviceid, res;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.ws) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:

                console.log("dismiss ws");
                _this2.ws.removeEventListener("message", _this2.wsMessageListener);
                _this2.ws.close();

                _$route$query2 = _this2.$route.query, appid = _$route$query2.appid, deviceid = _$route$query2.deviceid;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post_blackhole({
                  path: "/device/sendcmdadmin",
                  cmd: "UPLOAD_LOG_WS",
                  withLoading: true,
                  appid: appid,
                  data: {
                    deviceid: deviceid,
                    ws: ""
                  }
                });

              case 8:
                res = _context2.sent;

                console.log("handle dismiss", res);

                _this2.ws = null;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    runWs: function runWs(url) {
      var target = this.$refs.console;

      var ansiUp = new AnsiUp();

      var ws = new WebSocket(url);
      ws.binaryType = "arraybuffer";
      this.wsMessageListener = function (event) {
        try {
          var data = arrayBufferToString(event.data);
          console.log("ws <=", data);
          stdout(target, ansiUp.ansi_to_html(data));
        } catch (err) {
          console.error("ws <=r", err);
        }
      };
      ws.addEventListener("message", this.wsMessageListener);
      ws.addEventListener("error", function (err) {
        console.error("ws <=", err);
      });
      this.ws = ws;
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceTypesForm__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DeviceTypesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_DeviceTypesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceTypes",
  components: {
    DeviceTypesForm: __WEBPACK_IMPORTED_MODULE_2__modules_DeviceTypesForm___default.a
  },
  data: function data() {
    return {
      isSuperAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsSuperAdmin()
    };
  },

  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.update();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceUpgrade",
  data: function data() {
    return {
      formData: {
        url: "",
        uppermd5: ""
      },
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    handleUpgrade: function handleUpgrade() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _$route$query, appid, deviceid, url, data, res;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _$route$query = _this.$route.query, appid = _$route$query.appid, deviceid = _$route$query.deviceid;
                url = _this.formData.url;

                if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsURL(url)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", alert("\"" + url + "\" is not a valid url"));

              case 4:
                data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.formData, {
                  deviceid: deviceid
                });
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post_blackhole({
                  path: "/device/sendcmdadmin",
                  cmd: "SYSTEM_UPDATEVERSION",
                  withLoading: true,
                  appid: appid,
                  data: data
                });

              case 7:
                res = _context.sent;

                console.log("send result", res);
                alert("OK");

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DeviceUser",
  data: function data() {
    return {
      userList: [],
      currentProfileUser: {},
      currentUserDeviceSetting: {},
      currentAddDevice: {},
      currentAddDeviceUser: {},
      currentIndex: -1,
      phonezonaname: ["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burma (Myanmar)", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Republic of the Congo", "Democratic Republic of the Congo", "Cook Islands", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Timor-Leste", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "Gabon", "Gambia", "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "North Korea", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda", "Saint Barthelemy", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "Spain", "Sri Lanka", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "United Arab Emirates", "Uganda", "United Kingdom", "Ukraine", "Uruguay", "United States", "Uzbekistan", "Vanuatu", "Holy See (Vatican City)", "Venezuela", "Vietnam", "US Virgin Islands", "Wallis and Futuna", "West Bank", "Yemen", "Zambia", "Zimbabwe"],
      phonezonelist: ["+93", "+355", "+213", "+1684", "+376", "+244", "+1264", "+672", "+1268", "+54", "+374", "+297", "+61", "+43", "+994", "+1242", "+973", "+880", "+1246", "+375", "+32", "+501", "+229", "+1441", "+975", "+591", "+387", "+267", "+55", "+1284", "+673", "+359", "+226", "+95", "+257", "+855", "+237", "+1", "+238", "+1345", "+236", "+235", "+56", "+86", "+61", "+61", "+57", "+269", "+242", "+243", "+682", "+506", "+385", "+53", "+357", "+420", "+45", "+253", "+1767", "+1809", "+670", "+593", "+20", "+503", "+240", "+291", "+372", "+251", "+500", "+298", "+679", "+358", "+33", "+689", "+241", "+220", "+970", "+995", "+49", "+233", "+350", "+30", "+299", "+1473", "+1671", "+502", "+224", "+245", "+592", "+509", "+504", "+852", "+36", "+354", "+91", "+62", "+98", "+964", "+353", "+44", "+972", "+39", "+225", "+1876", "+81", "+962", "+7", "+254", "+686", "+381", "+965", "+996", "+856", "+371", "+961", "+266", "+231", "+218", "+423", "+370", "+352", "+853", "+389", "+261", "+265", "+60", "+960", "+223", "+356", "+692", "+222", "+230", "+262", "+52", "+691", "+373", "+377", "+976", "+382", "+1664", "+212", "+258", "+264", "+674", "+977", "+31", "+599", "+687", "+64", "+505", "+227", "+234", "+683", "+672", "+1670", "+850", "+47", "+968", "+92", "+680", "+507", "+675", "+595", "+51", "+63", "+870", "+48", "+351", "+1", "+974", "+40", "+7", "+250", "+590", "+685", "+378", "+239", "+966", "+221", "+381", "+248", "+232", "+65", "+421", "+386", "+677", "+252", "+27", "+82", "+34", "+94", "+290", "+1869", "+1758", "+1599", "+508", "+1784", "+249", "+597", "+268", "+46", "+41", "+963", "+886", "+992", "+255", "+66", "+228", "+690", "+676", "+1868", "+216", "+90", "+993", "+1649", "+688", "+971", "+256", "+44", "+380", "+598", "+1", "+998", "+678", "+39", "+58", "+84", "+1340", "+681", "+970", "+967", "+260", "+263"],
      currentDeviceListHeight: 0,
      currentPage: 0,
      isSearchByName: false,
      searchName: "",
      isLoadMore: false,
      isShowEmptyList: false
    };
  },
  created: function created() {
    this.$bus.on("searchdeviceuser", this.init);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off("searchdeviceuser", this.init);
    this.toShowSearchUserKey("");
  },

  methods: {
    init: function init(key) {
      this.isLoadMore = false;
      this.currentPage = 0;
      this.currentDeviceListHeight = -1;
      window.scrollTo(0, 0);
      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(key) || __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(key.key)) {
        this.toGetAllUser();
      } else {
        this.toGetAllUserByUid(key.key, 0);
      }
    },
    toGetAllUser: function toGetAllUser(page) {
      var _this = this;

      this.isSearchByName = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/getdeviceuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            if (!_this.isLoadMore) {
              _this.userList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              for (var i = 0; i < _this.userList.length; i++) {
                _this.userList[i].isShowDevice = false;
                _this.userList[i].isShowNone = false;
              }
            } else {
              var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              _this.userList = _this.userList.concat(tempList);
              for (var j = 0; j < _this.userList.length; j++) {
                _this.userList[j].isShowDevice = false;
                _this.userList[j].isShowNone = false;
              }
            }
          }
          if (_this.userList.length <= 0) {
            _this.isShowEmptyList = true;
          } else {
            _this.isShowEmptyList = false;
          }
        }
      });
    },
    toGetAllUserByUid: function toGetAllUserByUid(key, page) {
      var _this2 = this;

      this.isSearchByName = true;
      this.searchName = key;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: key,
        page: page
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/getdeviceuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            if (!_this2.isLoadMore) {
              _this2.userList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              for (var i = 0; i < _this2.userList.length; i++) {
                _this2.userList[i].isShowDevice = false;
                _this2.userList[i].isShowNone = false;
              }
            } else {
              var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              _this2.userList = _this2.userList.concat(tempList);
              for (var j = 0; j < _this2.userList.length; j++) {
                _this2.userList[j].isShowDevice = false;
                _this2.userList[j].isShowNone = false;
              }
            }
          }
          if (_this2.userList.length <= 0) {
            _this2.isShowEmptyList = true;
          } else {
            _this2.isShowEmptyList = false;
          }
        }
      });
    },
    toAddUser: function toAddUser() {
      this.currentAddDeviceUser = {};
    },
    toDoAddUser: function toDoAddUser() {
      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentAddDeviceUser.mail)) {
        this.currentAddDeviceUser.mail = "";
      }
      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentAddDeviceUser.phone)) {
        this.currentAddDeviceUser.phone = "";
      }
      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentAddDeviceUser.password)) {
        this.currentAddDeviceUser.password = "123456";
      }

      var params = new URLSearchParams();
      var jsons = {
        regfrom: this.$route.query.appid,
        password: this.currentAddDeviceUser.password,
        uid: this.currentAddDeviceUser.uid,
        mail: this.currentAddDeviceUser.mail,
        phone: this.currentAddDeviceUser.phone,
        system: "admin"
      };
      this.currentAddDeviceUser.password = "";
      params.append("json", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl("post", __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].blackholeServerURI, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].addDeviceuser, params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].showMsg("fail");
        } else {
          if (data.Result) {
            window.location.reload();
          }
        }
      });
    },
    toProfile: function toProfile(item, index) {
      this.currentIndex = index;
      this.currentProfileUser = {};
      this.currentProfileUser = item;
    },
    getPhone: function getPhone(phone) {
      if (typeof phone === "undefined") {
        return;
      }
      return phone.split(" ")[1];
    },
    getPhoneZone: function getPhoneZone(phone) {
      if (typeof phone === "undefined") {
        return;
      }

      if (phone.split(" ")[0] === "") {
        return "+86";
      }
      return phone.split(" ")[0];
    },
    toUnbindUser: function toUnbindUser() {
      var _this3 = this;

      var params = new URLSearchParams();
      var jsons = {
        deviceid: this.currentUserDeviceSetting.deviceid,
        unbinduid: this.currentUserDeviceSetting.username
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl("post", __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].blackholeServerURI, "/device/unbinduser/" + this.$route.query.appid, params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          for (var i = 0; i < _this3.userList.length; i++) {
            if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(_this3.userList[i].devices) && _this3.userList[i].uid === _this3.currentUserDeviceSetting.username) {
              for (var j = 0; j < _this3.userList[i].devices.length; j++) {
                if (_this3.userList[i].devices[j].deviceid === _this3.currentUserDeviceSetting.deviceid) {
                  var temp = _this3.userList[i];
                  temp.devices.splice(j, 1);
                  if (temp.devices.length <= 0) {
                    temp.isShowNone = true;
                  }

                  _this3.userList.splice(i, 1, temp);
                  window.jQuery("#device-user-list-set-device").modal("hide");
                  return;
                }
              }
            }
          }
        }
      });
    },
    toChangPermission: function toChangPermission() {
      var _this4 = this;

      if (this.currentUserDeviceSetting.permission !== window.jQuery("#change_device_permission").val()) {
        var params = new URLSearchParams();
        var jsons = {
          deviceid: this.currentUserDeviceSetting.deviceid,
          uid: this.currentUserDeviceSetting.username,
          newpermission: parseInt(window.jQuery("#change_device_permission").val())
        };
        params.append("json", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
        if (window.localStorage) {
          params.append("token", this.$router.app.$store.state.user.token);
        }
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl("post", __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].blackholeServerURI, "/device/modifydevicecontact/v2/" + this.$route.query.appid, params).then(function (response) {
          var data = response.data;
          if (data.Status !== 1) {} else {
            for (var i = 0; i < _this4.userList.length; i++) {
              if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(_this4.userList[i].devices) && _this4.userList[i].uid === _this4.currentUserDeviceSetting.username) {
                for (var j = 0; j < _this4.userList[i].devices.length; j++) {
                  if (_this4.userList[i].devices[j].deviceid === _this4.currentUserDeviceSetting.deviceid) {
                    var temp = _this4.userList[i];
                    temp.devices[j].permission = window.jQuery("#change_device_permission").val();
                    _this4.userList.splice(i, 1, temp);
                    window.jQuery("#device-user-list-set-device").modal("hide");
                    return;
                  }
                }
              }
            }
          }
        });
      }
    },
    toLoadMoreDevice: function toLoadMoreDevice(uid, index) {
      var _this5 = this;

      window.jQuery("#" + uid + "showdevicebtn").hide(200);
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: uid
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/getdevicesbyuser?_type=json", params).then(function (response) {
        var data = response.data;
        if (data.Status !== 1) {} else {
          var temp = _this5.userList[index];
          temp.devices = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          temp.isShowDevice = true;
          if (temp.devices.length <= 0) {
            temp.isShowNone = true;
          }
          _this5.userList.splice(index, 1, temp);
        }
      });
    },
    toGetDevice: function toGetDevice(index) {
      if (this.userList[index].devices.length > 0) {
        return true;
      }
      return false;
    },
    toAddDevice: function toAddDevice(userid) {
      this.$set(this.currentAddDevice, "uid", userid);
      this.$set(this.currentAddDevice, "deviceid", "");
      this.$set(this.currentAddDevice, "permission", 30);
    },
    toDoAddDevice: function toDoAddDevice() {
      var _this6 = this;

      var params = new URLSearchParams();
      var jsons = {
        deviceid: this.currentAddDevice.deviceid.trim(),
        uid: this.currentAddDevice.uid,
        permission: parseInt(this.currentAddDevice.permission)
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl("post", __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].blackholeServerURI, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userAddDevice + this.$route.query.appid, params).then(function (response) {
        _this6.$store.commit("TOGGLE_FULLSCREEN_LOADING");
        var data = response.data;

        if (data.Status !== 1) {} else {
          for (var i = 0; i < _this6.userList.length; i++) {
            if (_this6.userList[i].uid === _this6.currentAddDevice.uid && _this6.userList[i].isShowDevice) {
              var temp;
              if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(_this6.userList[i].devices)) {
                temp = _this6.userList[i];
                temp.devices.push({
                  deviceid: _this6.currentAddDevice.deviceid,
                  devicename: data.Result.devicename,
                  permission: _this6.currentAddDevice.permission
                });
                _this6.userList.splice(i, 1, temp);
              } else {
                temp = _this6.userList[i];
                temp.devices = [];
                temp.devices.push({
                  deviceid: _this6.currentAddDevice.deviceid,
                  devicename: data.Result.devicename,
                  permission: _this6.currentAddDevice.permission
                });
                _this6.userList.splice(i, 1, temp);
              }
              window.jQuery("#" + _this6.currentAddDevice.uid + "emptydevice").hide();
              window.jQuery("#modal-user-add-device").modal("hide");
              return;
            }
          }
          window.jQuery("#modal-user-add-device").modal("hide");
        }
      });
    },
    toShowDevicePermission: function toShowDevicePermission(device, index) {
      this.currentUserDeviceSetting.username = this.userList[index].uid;
      this.currentUserDeviceSetting = {
        username: this.userList[index].uid,
        devicename: device.devicename,
        deviceid: device.deviceid,
        permission: device.permission
      };
    },
    toDoUpdataUser: function toDoUpdataUser() {
      var _this7 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: this.currentProfileUser.uid,
        pw: window.jQuery("#current_password").val(),
        email: window.jQuery("#current_email").val(),
        phone: this.phonezonelist[window.jQuery("#current_phone_zone").get(0).selectedIndex] + " " + window.jQuery("#current_phone").val()
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/updatadeviceuser?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].showMsg(data.ErrorMessage);
        } else {
          _this7.$set(_this7.userList[_this7.currentIndex], "mail", window.jQuery("#current_email").val());
          _this7.$set(_this7.userList[_this7.currentIndex], "phone", _this7.phonezonelist[window.jQuery("#current_phone_zone").get(0).selectedIndex] + " " + window.jQuery("#current_phone").val());

          window.jQuery("#modal-user-profile").modal("hide");
        }
      });
    },
    winScroll: function winScroll(e) {
      if (this.currentDeviceListHeight < window.jQuery("#deviceuserlist").height()) {
        if (window.jQuery(window).scrollTop() + window.jQuery(window).height() >= window.jQuery("#deviceuserlist").height()) {
          this.currentDeviceListHeight = window.jQuery(window).scrollTop() + window.jQuery(window).height();
          this.isLoadMore = true;
          this.getNextPage();
        }
      }
    },
    getNextPage: function getNextPage() {
      this.currentPage = this.currentPage + 1;
      if (!this.isSearchByName) {
        this.toGetAllUser(this.currentPage);
      } else {
        this.toGetAllUserByUid(this.searchName, this.currentPage);
      }
    },
    toSearchDevice: function toSearchDevice(devicename, deviceid) {
      this.$router.push("/aboutdevice?appid=" + this.$route.query.appid + "&appname=" + this.$route.query.appname + "&deviceid=" + deviceid + "&devicename=" + devicename + "&online=1" + "&t=" + this.$store.state.devicetoken);
    },
    toShowSearchUserKey: function toShowSearchUserKey(userkey) {
      this.$bus.emit("showsearchuserkey", { key: userkey.trim() });
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.$route.query.key)) {
      this.init();
    } else {
      this.toShowSearchUserKey(this.$route.query.key);
      this.init({ key: this.$route.query.key });
    }
    window.addEventListener("scroll", this.winScroll, false);
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(37);









var genMarkdownFile = function genMarkdownFile(data) {
  var title = data.title,
      date = data.date,
      todoList = data.todoList,
      doneList = data.doneList,
      fixedList = data.fixedList,
      styleHrefs = data.styleHrefs;

  var table = function table(caption, list) {
    var defaultDue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "待定";
    return "\n    <h2 style=\"font-size: 24px; margin: 40px 0 20px;\">" + caption + "</h2>\n    <table class=\"table\">\n      <thead style=\"background: #f7f7f7;\">\n        <tr>\n          <th>\u6807\u9898</th>\n          <th style=\"width: 100px;\">\u5B8C\u6210\u65F6\u95F4</th>\n        </tr>\n      </thead>\n      <tbody>\n        " + list.map(function (issue) {
      return "\n            <tr>\n              <td>" + issue.title + "</td>\n              <td style=\"width: 100px;\">" + (issue.due_date || defaultDue) + "</td>\n            </tr>\n          ";
    }).join("\n") + "\n      </tbody>\n    </table>\n  ";
  };

  var content = "\n    <!DOCTYPE html>\n    <html>\n      <head>\n        <meta charset=\"utf-8\" />\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />\n        <title>" + title + "</title>\n        " + styleHrefs.map(function (href) {
    return "<link rel=\"stylesheet\" href=\"" + href + "\" />";
  }).join("\n") + "\n      </head>\n      <body style=\"background: ghostwhite;\">\n        <div\n          style=\"max-width: 960px; margin: auto; padding: 2em; background: white; box-shadow: 0 0 3px rgba(0,0,0,0.2);\"\n        >\n          <h1 style=\"margin-bottom: 1em;\">" + title + "</h1>\n          " + table("进行中", todoList) + "\n          <hr class=\"hr\" />\n          " + table("正在验证", doneList) + "\n          <hr class=\"hr\" />\n          " + table("已完成", fixedList, date) + "\n        </div>\n      </body>\n    </html>\n  ";

  var fragment = document.createElement("a");
  var blob = new Blob([content]);
  fragment.href = URL.createObjectURL(blob);
  fragment.target = "_blank";
  fragment.download = title + ".html";
  fragment.click();
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "din-news-weekly",
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    isAdminInApp: function isAdminInApp() {
      return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].checkIsAppAdmin();
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/dinnewsweekly/get?_type=json",
                  withLoading: true
                });

              case 2:
                list = _context.sent;

                _this.list = list;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, ok;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/dinnewsweekly/create?_type=json",
                  withLoading: true
                });

              case 2:
                _ref = _context2.sent;
                ok = _ref.ok;

                if (ok) {
                  _context2.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("SET_ERROR", "Create News Weekly failed.");
                _context2.next = 10;
                break;

              case 8:
                _context2.next = 10;
                return _this2.fetch();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownload: function handleDownload(_ref2) {
      var _this3 = this;

      var id = _ref2.id;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, date, doneList, fixedList, title, todoList, _location, origin, bootstrapCSSHref;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post({
                  path: "/dinnewsweekly/getone?_type=json",
                  data: { id: id },
                  withLoading: true
                });

              case 2:
                data = _context3.sent;

                console.log("data", data);
                date = data.date, doneList = data.doneList, fixedList = data.fixedList;
                title = date + " \u5468\u62A5";
                todoList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.todoList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.doingList));
                _location = location, origin = _location.origin;
                bootstrapCSSHref = origin + "/static/css/bootstrap.min.css";

                genMarkdownFile({
                  title: title,
                  date: date,
                  todoList: todoList,
                  doneList: doneList,
                  fixedList: fixedList,
                  styleHrefs: [bootstrapCSSHref]
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_DomainFormModal__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_DomainFormModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_DomainFormModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "domain",
  components: {
    DomainFormModal: __WEBPACK_IMPORTED_MODULE_4__modules_DomainFormModal___default.a
  },
  data: function data() {
    return {
      short: "",
      list: []
    };
  },

  computed: {
    isAdminInApp: function isAdminInApp() {
      return __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppAdmin();
    },
    isShowEmptyList: function isShowEmptyList() {
      return !this.list.length;
    }
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var short, list;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                short = _this.short.trim();

                if (short) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/domain/get?_type=json",
                  data: { short: short },
                  withLoading: true
                });

              case 5:
                list = _context.sent;

                _this.list = list || [];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleCreate: function handleCreate() {
      this.$refs.modalCreate.show();
    },
    handleEdit: function handleEdit(item) {
      this.$refs.modalEdit.show(item);
    },
    preventDefault: function preventDefault(ev) {
      ev.preventDefault();
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Global_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EventList",
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    isShowEmptyList: function isShowEmptyList() {
      return this.list.length < 1;
    }
  },
  filters: {
    formatTime: function formatTime(time) {
      return __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].formatDate(new Date(time / 1000000), "yyyy-MM-dd hh:mm:ss");
    },
    capitalize: function capitalize(cmdname) {
      return __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].capitalize(cmdname);
    }
  },
  methods: {
    fetchEventList: function fetchEventList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, time, jsons, response, data, Result, _list, list;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = new URLSearchParams();
                time = _this.list.length ? _this.list[_this.list.length - 1].time : Date.now() * 1000000;
                jsons = {
                  appid: _this.$route.query.appid,
                  deviceid: _this.$route.query.deviceid,
                  devicename: _this.$route.query.devicename,
                  time: time
                };

                params.append("json", __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
                if (window.localStorage) {
                  params.append("token", _this.$router.app.$store.state.user.token);
                }
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request("post", "/getdeviceeventlistdata?_type=json", params);

              case 7:
                response = _context.sent;

                if (response) {
                  data = response.data;
                  Result = data.Result;

                  if (Result) {
                    list = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getDecodeRC4Hex(Result, __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));

                    (_list = _this.list).push.apply(_list, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(list.filter(function (item) {
                      return +item.result;
                    })));
                  }
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleScroll: function handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery("#eventlist").height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (this.currentDeviceListHeight < listNodeHeight && windowScrollTop + windowHeight >= listNodeHeight) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetchEventList();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var params, query, appid, deviceid, jsons;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = new URLSearchParams();
              query = _this2.$route.query;
              appid = query.appid, deviceid = query.deviceid;
              jsons = { appid: appid, deviceid: deviceid };

              params.append("json", __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_6__Global_vue___default.a.APP_SECRET));
              if (window.localStorage) {
                params.append("token", _this2.$router.app.$store.state.user.token);
              }
              _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
              _context2.next = 9;
              return _this2.fetchEventList(params);

            case 9:
              _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
              _this2.currentDeviceListHeight = 0;
              window.addEventListener("scroll", _this2.handleScroll, false);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Feedback',
  data: function data() {
    return {
      feedbackList: [],
      currentPage: 0,
      currentDeviceListHeight: 0,
      filterMarker: 2,
      isClear: true,
      isShowNoMoreData: false,
      feedbackListIndex: '',
      feedbackListFid: '',
      feedbackListState: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.toGetFeedbackList(0, true);
    window.addEventListener('scroll', this.winScroll, false);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    getNextPage: function getNextPage() {
      this.currentPage = this.currentPage + 1;
      if (this.filterMarker === 2) {
        this.toGetFeedbackList(this.currentPage, false);
      } else {
        this.toFilterFeedbackList(this.currentPage, this.filterMarker, false);
      }
    },
    toGetFeedbackList: function toGetFeedbackList(page, isClear) {
      var _this = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/feedback?_type=json', params).then(function (response) {
        _this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            if (isClear) {
              _this.isShowNoMoreData = false;
              _this.currentDeviceListHeight = 0;
              _this.currentPage = 0;
              _this.feedbackList = [];
              _this.feedbackList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              if (_this.feedbackList.length === 0) {
                _this.isShowNoMoreData = true;
              }
            } else {
              var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
              _this.feedbackList = _this.feedbackList.concat(tempList);
              if (data.Status === 1) {
                _this.isShowNoMoreData = true;
              }
            }
            _this.filterMarker = 2;
          }
        }
      });
    },
    toFilterFeedbackList: function toFilterFeedbackList(page, state, isClear) {
      var _this2 = this;

      if (state === 1) {
        this.filterMarker = 1;
      } else {
        this.filterMarker = 0;
      }
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page,
        state: state
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/feedback?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (isClear) {
            _this2.isShowNoMoreData = false;
            _this2.currentDeviceListHeight = 0;
            _this2.currentPage = 0;
            _this2.feedbackList = [];
            _this2.feedbackList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            if (_this2.feedbackList.length === 0) {
              _this2.isShowNoMoreData = true;
            }
          } else {
            var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            _this2.feedbackList = _this2.feedbackList.concat(tempList);
            if (data.Status === 1) {
              _this2.isShowNoMoreData = true;
            }
          }
        }
      });
    },
    toConfirmChangeStatus: function toConfirmChangeStatus(i, fid, state) {
      this.feedbackListIndex = i;
      this.feedbackListFid = fid;
      this.feedbackListState = state;
      window.jQuery('#modal-confirm-change-status').modal('show');
    },
    toChangeFeedbackStatus: function toChangeFeedbackStatus() {
      var _this3 = this;

      var i = this.feedbackListIndex;
      var fid = this.feedbackListFid;
      var state = this.feedbackListState;
      if (state === 1) {
        state = 0;
      } else {
        state = 1;
      }
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        fid: fid,
        state: state
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/updatafeedback?_type=json', params).then(function (response) {
          _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          var data = response.data;

          if (data.Status !== 1) {} else {
            _this3.feedbackList[i].state = state;
            window.jQuery('#modal-confirm-change-status').modal('hide');
          }
        });
      }
    },
    winScroll: function winScroll(e) {
      if (this.currentDeviceListHeight < window.jQuery('#feedbackdiv').height()) {
        if (window.jQuery(window).scrollTop() + window.jQuery(window).height() >= window.jQuery('#feedbackdiv').height()) {
          this.currentDeviceListHeight = window.jQuery(window).scrollTop() + window.jQuery(window).height();
          this.getNextPage();
        }
      }
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd');
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GeneralSetting',
  data: function data() {
    return {
      taskStartSetting: '',
      taskEndSetting: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].asServerURI, '/compilation/generalsetting?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var setting = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          if (setting) {
            _this.taskStartSetting = setting.taskstart;
            _this.taskEndSetting = setting.taskend;
          }
        }
      });
    },
    modifySetting: function modifySetting() {
      var _this2 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        taskstart: this.taskStartSetting,
        taskend: this.taskEndSetting
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].asServerURI, '/compilation/modifygeneralsetting?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {}
      });
    }
  },
  filters: {}
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Information",
  components: {
    AppDataForm: __WEBPACK_IMPORTED_MODULE_2__modules_AppDataForm___default.a
  },
  data: function data() {
    return {
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAdmin()
    };
  },

  methods: {
    handleSave: function handleSave() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.update();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goBack: function goBack() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(11);










var DEVELOP_STAGE = 'S1';
var API_STAGE = 'S2';
var PUBLISH_STAGE = 'S3';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Master',
  data: function data() {
    return {
      newversion_name: '',
      newversion_developlog: '',
      newversion_developshell: '',
      newversion_releaseshell: '',
      newversion_typeid: '',
      newbuild_developlog: '',
      newbuild_developshell: '',
      newbuild_stage: '',
      versionList: [],
      newbuild_robotid: '',
      sendtodevice_robotid: '',
      currentSendToStageid: '',
      currentVersoinPage: 0,
      currentLogContent: {},
      downloadLink: '',
      logDialogCurrentBuildid: '',
      logDialogCurrentContent: '',
      socket: {},
      currentBuildList: {
        'S1': [],
        'S2': [],
        'S3': []
      },
      currentStageBuild: {
        'S1': {
          'result': 1
        },
        'S2': { 'result': 1 },
        'S3': { 'result': 1 }
      },
      macRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      deviceRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      currentVersion: {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      },
      shellDialogContent: ''
    };
  },

  computed: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default.a, 'wss://testadminapi.dinsafer.com/ws', {
      reconnection: true
    });

    this.socket = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$socket;

    this.socket.onmessage = function (data) {
      return _this.onMessage(data);
    };

    this.socket.onopen = function (n) {
      console.log('onopen' + n);
      _this.toSendJoinToServer();
    };
    this.socket.onerror = function (n) {
      return console.log('onerror' + n);
    };
    this.socket.onclose = function (n) {
      return console.log('onclose' + n);
    };
  },
  mounted: function mounted() {
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
    this.toGetVersionList(0);
  },
  beforeDestroy: function beforeDestroy() {
    this.socket.close();
  },

  methods: {
    toShowVersionList: function toShowVersionList() {
      window.jQuery('#version-list-popmenu').addClass('open');
    },
    toSaveLog: function toSaveLog() {
      var _this2 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        developlog: window.jQuery('#currentVersionDevelopLog').val(),
        releaselog: window.jQuery('#currentVersionReleaseLog').val()
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifylog?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this2.currentVersion.developlog = window.jQuery('#currentVersionDevelopLog').val();
          _this2.currentVersion.releaselog = window.jQuery('#currentVersionReleaseLog').val();
        }
      });
    },
    toSendDingDing: function toSendDingDing(stageid) {
      var _this3 = this;

      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        stageid: stageid,
        buildid: this.currentStageBuild[stageid].buildid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/senddingding?_type=json', params).then(function (response) {
        _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {}
      });
    },
    toDoSendTo: function toDoSendTo() {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[this.currentSendToStageid].buildid,
        robotid: this.sendtodevice_robotid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/sendto?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.jQuery('#sendto_robotlist').modal('hide');
        }
      });
    },
    emptyToInVisibiliy: function emptyToInVisibiliy(con, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(con)) {
        return 'visibiliy ' + classString;
      } else {
        return 'invisibiliy';
      }
    },
    isHasBuildList: function isHasBuildList(stageid) {
      if (this.getBuildlistById(stageid) && this.getBuildlistById(stageid).length > 0) {
        return true;
      }
      return false;
    },
    onMessage: function onMessage(message) {
      var result = JSON.parse(message.data);
      if (result.Cmd && result.Cmd === '/task/taskstate') {
        window.location.reload();
      } else if (result.Cmd && result.Cmd === '/task/sendtasklog') {
        console.log('log result', result.Data);
        if (!this.currentLogContent[result.Data.buildID]) {
          this.currentLogContent[result.Data.buildID] = '';
        }
        var tempContent = this.currentLogContent[result.Data.buildID] + '\r\n' + '[' + result.Data.robotid + ']' + '[' + result.Data.robotname + '][' + result.Data.Time + ']' + '[' + result.Data.Level + '][' + result.Data.Msg + ']';
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(this.currentLogContent, result.Data.buildID, tempContent);
        if (this.logDialogCurrentBuildid === result.Data.buildID) {
          this.logDialogCurrentContent = this.currentLogContent[result.Data.buildID];
          console.log('log ', this.currentLogContent[result.Data.buildID]);
        }
      }
    },
    selectVersoin: function selectVersoin(index) {
      this.currentBuildList = {
        'S1': [],
        'S2': [],
        'S3': []
      };
      this.currentStageBuild = {
        'S1': {},
        'S2': {},
        'S3': {}
      };
      this.currentVersion = {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      };
      this.toDoAfterSelectVersion(index);
    },
    selectBuild: function selectBuild(stageid, index) {
      if (stageid === 'S3') {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList['S2'][index]);
      } else {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList[stageid][index]);
      }
    },
    toSendJoinToServer: function toSendJoinToServer() {
      var sd = {
        id: this.$router.app.$store.state.user.uid
      };
      var sf = {
        Cmd: '/task/login',
        Data: sd
      };
      var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sf);
      this.socket.send('iris-websocket-message:join;0;;;' + str);
    },
    toSendMessage: function toSendMessage(message) {},
    toGetLogContent: function toGetLogContent() {},
    toShowLog: function toShowLog(stageid) {
      if (this.currentStageBuild[stageid].result === -1) {
        this.logDialogCurrentBuildid = this.currentStageBuild[stageid].buildid;
        this.logDialogCurrentContent = '';

        window.jQuery('#modal-log').modal('show');
      } else {
        var win = window.open(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI + '/build/' + this.$route.query.appid + '/' + this.currentVersion.versionid + '/' + this.currentStageBuild[stageid].buildid + '/logfile.log', '_blank');
        win.focus();
      }
    },
    toShowShell: function toShowShell(stageid) {
      this.shellDialogContent = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentStageBuild[stageid].shell);
      console.log(this.currentStageBuild[stageid]);
      window.jQuery('#modal-shell').modal('show');
    },
    toDoPublishClick: function toDoPublishClick(stageid) {
      var _this4 = this;

      if (this.currentStageBuild[stageid].result !== 1 || this.currentStageBuild[stageid].buildid === this.currentVersion.PublishBuildid) {
        return;
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[stageid].buildid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifypublishid?_type=json', params).then(function (response) {
        _this4.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;
        if (data.Status !== 1) {
          alert('发布错误');
        } else {
          _this4.currentVersion.PublishBuildid = _this4.currentStageBuild[stageid].buildid;
        }
      });
    },
    getBtnText: function getBtnText(stageid) {
      if (this.currentVersion.PublishBuildid === this.currentStageBuild[stageid].buildid) {
        return '已发布';
      } else {
        return '发布';
      }
    },
    toShowDownload: function toShowDownload(stageid) {
      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.currentSendToStageid = stageid;

      var urls = this.currentStageBuild[this.currentSendToStageid].downloadkey;
      var jsons = {
        app: this.$route.query.appname,
        appid: this.$route.query.appid,
        type: this.$route.query.typeid,
        v: this.currentVersion.versionname,
        b: 'build ' + this.currentStageBuild[this.currentSendToStageid].buildnumber,
        u: urls
      };
      console.log(jsons);
      this.downloadLink = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI + '/appdowload?p=' + __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      window.jQuery('#modal-download').modal('show');
    },
    toDownloadLink: function toDownloadLink() {
      var win = window.open(this.downloadLink, '_blank');
      win.focus();
    },
    getBuildlistById: function getBuildlistById(stageid) {
      if (stageid === 'S3') {
        return this.currentBuildList['S2'];
      } else {
        return this.currentBuildList[stageid];
      }
    },
    getNameByTypeId: function getNameByTypeId(sid) {
      if (sid === DEVELOP_STAGE) {
        return 'TEST';
      }
      if (sid === API_STAGE) {
        return 'API';
      }
      if (sid === PUBLISH_STAGE) {
        return 'PUBLISH';
      }
    },
    getState: function getState(result) {
      if (result === -1) {
        return 'Building';
      }
      if (result === 0) {
        return 'Build Failed';
      }
      if (result === 1) {
        return 'Build Succeed';
      }
    },
    isPublishSelectSuccess: function isPublishSelectSuccess(stageid, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid]) && !__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid].buildid) && this.currentStageBuild[stageid].result === 1) {
        return 'visibiliy ' + classString;
      } else {
        return 'gone ' + classString;
      }
    },
    getBuildStageClassByTypeId: function getBuildStageClassByTypeId(result) {
      if (result === -1) {
        return 'fa fa-spinner';
      }
      if (result === 0) {
        return 'fa fa-remove (alias)';
      }
      if (result === 1) {
        return 'fa fa-check';
      }
    },
    getStageClassByTypeId: function getStageClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'box box-warning version-manage-box';
      }
      if (sid === 'S2') {
        return 'box box-info version-manage-box';
      }
      if (sid === 'S3') {
        return 'box box-success version-manage-box';
      }
    },
    getStageLogClassByTypeId: function getStageLogClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'label label-warning pull-right add-agent-choose';
      }
      if (sid === 'S2') {
        return 'label label-info pull-right add-agent-choose';
      }
      if (sid === 'S3') {
        return 'gone';
      }
    },
    toGetBuildList: function toGetBuildList(versionid, stageid, pages) {
      var _this5 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages,
        stage: stageid,
        versionid: this.currentVersion.versionid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/buildlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var buildlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          buildlist = _this5.currentBuildList[stageid].concat(buildlist);
          console.log(_this5.currentBuildList);
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(_this5.currentBuildList, stageid, buildlist);
          if (buildlist.length > 0 && _this5.currentStageBuild[stageid]) {
            _this5.currentStageBuild[stageid] = buildlist[0];
            if (stageid === 'S2') {
              _this5.currentStageBuild['S3'] = buildlist[0];
            }
          }
        }
      });
    },
    toLoadMoreVersion: function toLoadMoreVersion(pages) {
      this.toGetVersionList(pages);
    },
    toLoadMoreBuild: function toLoadMoreBuild(stageid) {
      if (stageid === 'S3') {
        stageid = 'S2';
      }
      if (this.currentBuildList[stageid].length % 5 === 0) {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5);
      } else {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5 + 1);
      }
    },
    toGetVersionList: function toGetVersionList(pages) {
      var _this6 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/versionlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          if (pages === 0) {
            _this6.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          }
          if (tempList.length > 0 && _this6.currentVersion.versionname === '-') {
            _this6.versionList = tempList;
            _this6.currentVersoinPage++;
            _this6.toDoAfterSelectVersion(0);
          } else {
            _this6.currentVersoinPage++;
            _this6.versionList = _this6.versionList.concat(tempList);
          }
        }
      });
    },
    toDoAfterSelectVersion: function toDoAfterSelectVersion(index) {
      this.currentVersion = this.versionList[index];
      console.log(this.currentVersion);

      for (var i = 0; i < this.currentVersion.GeneralSetting.StageSupport.length; i++) {
        this.toGetBuildList(this.currentVersion.versionid, this.currentVersion.GeneralSetting.StageSupport[i], 0);
      }
    },
    toNewBuild: function toNewBuild(item) {
      var _this7 = this;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentVersion.PublishBuildid)) {
        alert('已经发布了，不能再新建Build');
        return;
      }

      if (item === DEVELOP_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.DevelopShell);
      } else if (item === API_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.ReleaseShell);
      }

      this.newbuild_stage = item;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/robotlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          if (data.Result) {
            _this7.macRobotList = [];
            var robotlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < robotlist.length; i++) {
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.MAC_TYPE) {
                _this7.macRobotList.push(robotlist[i]);
              }
            }
            _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
            window.jQuery('#modal-new-build').modal('show');
          }
        }
      });
    },
    toDoNewBuild: function toDoNewBuild() {
      var _this8 = this;

      var tempShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newbuild_developshell);
      if (tempShell === this.currentVersion.DevelopShell) {
        tempShell = '';
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.currentVersion.Type.id,
        versionid: this.currentVersion.versionid,
        stage: this.newbuild_stage,
        robotid: this.newbuild_robotid,
        comment: this.newbuild_developlog,
        shell: tempShell
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newbuild?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.location.reload();
        }
      });
    },
    toNewVersion: function toNewVersion() {
      var _this9 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/getshell?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          alert('获取默认脚本错误');
        } else {
          var tempResult = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          _this9.newversion_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.testShell);
          _this9.newversion_releaseshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.apiShell);
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.jQuery('#modal-new-version').modal('show');
        }
      });
    },
    toDoNewVersion: function toDoNewVersion() {
      var params = new URLSearchParams();
      var tempDevelopShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_developshell);
      var tempReleaseShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_releaseshell);
      var jsons = {
        appid: this.$route.query.appid,
        versionname: this.newversion_name,
        developlog: this.newversion_developlog,
        developshell: tempDevelopShell,
        releaseshell: tempReleaseShell,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newversion?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.location.reload();
        }
      });
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(11);










var DEVELOP_STAGE = 'S1';
var API_STAGE = 'S2';
var PUBLISH_STAGE = 'S3';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Master',
  data: function data() {
    return {
      newversion_name: '',
      newversion_developlog: '',
      newversion_developshell: '',
      newversion_releaseshell: '',
      newversion_typeid: '',
      newbuild_developlog: '',
      newbuild_developshell: '',
      newbuild_stage: '',
      versionList: [],
      newbuild_robotid: '',
      sendtodevice_robotid: '',
      currentSendToStageid: '',
      currentVersoinPage: 0,
      currentLogContent: {},
      logDialogCurrentBuildid: '',
      logDialogCurrentContent: '',
      downloadLink: '',
      socket: {},
      currentBuildList: {
        'S1': [],
        'S2': [],
        'S3': []
      },
      currentStageBuild: {
        'S1': {
          'result': 1
        },
        'S2': { 'result': 1 },
        'S3': { 'result': 1 }
      },
      macRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      deviceRobotList: [{
        name: '',
        id: '',
        task: 0
      }],
      currentVersion: {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      },
      shellDialogContent: ''
    };
  },

  computed: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_native_websocket___default.a, 'wss://testadminapi.dinsafer.com/ws', {
      reconnection: true
    });

    this.socket = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$socket;

    this.socket.onmessage = function (data) {
      return _this.onMessage(data);
    };

    this.socket.onopen = function (n) {
      console.log('onopen' + n);
      _this.toSendJoinToServer();
    };
    this.socket.onerror = function (n) {
      return console.log('onerror' + n);
    };
    this.socket.onclose = function (n) {
      return console.log('onclose' + n);
    };
  },
  mounted: function mounted() {
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
    this.toGetVersionList(0);
  },
  beforeDestroy: function beforeDestroy() {
    this.socket.close();
  },

  methods: {
    toShowVersionList: function toShowVersionList() {
      window.jQuery('#version-list-popmenu').addClass('open');
    },
    toSaveLog: function toSaveLog() {
      var _this2 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        developlog: window.jQuery('#currentVersionDevelopLog').val(),
        releaselog: window.jQuery('#currentVersionReleaseLog').val()
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifylog?_type=json', params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this2.currentVersion.developlog = window.jQuery('#currentVersionDevelopLog').val();
          _this2.currentVersion.releaselog = window.jQuery('#currentVersionReleaseLog').val();
        }
      });
    },
    getBtnText: function getBtnText(stageid) {
      if (this.currentVersion.PublishBuildid === this.currentStageBuild[stageid].buildid) {
        return '查看下载链接';
      } else {
        return '生成下载链接';
      }
    },
    toDoPublishClick: function toDoPublishClick(stageid) {
      var _this3 = this;

      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }

      var urls = 'https://d.din.bz/' + this.currentStageBuild[stageid].downloadkey;
      this.downloadLink = urls;
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentVersion.PublishBuildid) && this.currentVersion.PublishBuildid === this.currentStageBuild[stageid].buildid) {
        window.jQuery('#modal-download').modal('show');
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentVersion.PublishBuildid) || this.currentVersion.PublishBuildid !== this.currentStageBuild[stageid].buildid) {
        this.currentVersion.PublishBuildid = this.currentStageBuild[stageid].buildid;
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var params = new URLSearchParams();
        var jsons = {
          versionid: this.currentVersion.versionid,
          buildid: this.currentVersion.PublishBuildid
        };
        params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token);
        }
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/modifypublishid?_type=json', params).then(function (response) {
          _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          var data = response.data;
          if (data.Status !== 1) {
            alert('生成下载链接错误');
          } else {
            window.jQuery('#modal-download').modal('show');
          }
        });
        return;
      }
    },
    toSendDingDing: function toSendDingDing(stageid) {
      var _this4 = this;

      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        stageid: stageid,
        buildid: this.currentStageBuild[stageid].buildid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/senddingding?_type=json', params).then(function (response) {
        _this4.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {}
      });
    },
    toDownloadLink: function toDownloadLink() {
      var win = window.open(this.downloadLink, '_blank');
      win.focus();
    },
    toSendToRobot: function toSendToRobot(stageid) {
      var _this5 = this;

      if (this.currentStageBuild[stageid].result !== 1) {
        return;
      }
      this.currentSendToStageid = stageid;
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/robotlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this5.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          if (data.Result) {
            _this5.deviceRobotList = [];
            var robotlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < robotlist.length; i++) {
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.DEVICE_TYPE) {
                _this5.deviceRobotList.push(robotlist[i]);
              }
            }
            _this5.$store.commit('TOGGLE_FULLSCREEN_LOADING');
            window.jQuery('#sendto_robotlist').modal('show');
          }
        }
      });
    },
    toDoSendTo: function toDoSendTo() {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[this.currentSendToStageid].buildid,
        robotid: this.sendtodevice_robotid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/sendto?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.jQuery('#sendto_robotlist').modal('hide');
        }
      });
    },
    emptyToInVisibiliy: function emptyToInVisibiliy(con, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(con)) {
        return 'visibiliy ' + classString;
      } else {
        return 'invisibiliy';
      }
    },
    isPublishSelectEmpty: function isPublishSelectEmpty(stageid, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid]) && !__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid].buildid)) {
        return 'visibiliy ' + classString;
      } else {
        return 'invisibiliy';
      }
    },
    isPublishSelectSuccess: function isPublishSelectSuccess(stageid, classString) {
      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid]) && !__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentStageBuild[stageid].buildid) && this.currentStageBuild[stageid].result === 1) {
        return 'visibiliy ' + classString;
      } else {
        return 'gone ' + classString;
      }
    },
    isHasBuildList: function isHasBuildList(stageid) {
      if (this.getBuildlistById(stageid) && this.getBuildlistById(stageid).length > 0) {
        return true;
      }
      return false;
    },
    onMessage: function onMessage(message) {
      var result = JSON.parse(message.data);
      if (result.Cmd && result.Cmd === '/task/taskstate') {
        window.location.reload();
      } else if (result.Cmd && result.Cmd === '/task/sendtasklog') {
        console.log('log result', result.Data);
        if (!this.currentLogContent[result.Data.buildID]) {
          this.currentLogContent[result.Data.buildID] = '';
        }
        var tempContent = this.currentLogContent[result.Data.buildID] + '\r\n' + '[' + result.Data.robotid + ']' + '[' + result.Data.robotname + '][' + result.Data.Time + ']' + '[' + result.Data.Level + '][' + result.Data.Msg + ']';
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(this.currentLogContent, result.Data.buildID, tempContent);
        if (this.logDialogCurrentBuildid === result.Data.buildID) {
          this.logDialogCurrentContent = this.currentLogContent[result.Data.buildID];
          console.log('log ', this.currentLogContent[result.Data.buildID]);
        }
      }
    },
    selectVersoin: function selectVersoin(index) {
      this.currentBuildList = {
        'S1': [],
        'S2': [],
        'S3': []
      };
      this.currentStageBuild = {
        'S1': {},
        'S2': {},
        'S3': {}
      };
      this.currentVersion = {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      };
      this.toDoAfterSelectVersion(index);
    },
    selectBuild: function selectBuild(stageid, index) {
      console.log(stageid);
      if (stageid === 'S3') {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList['S2'][index]);
      } else {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList[stageid][index]);
      }
    },
    toSendJoinToServer: function toSendJoinToServer() {
      var sd = {
        id: this.$router.app.$store.state.user.uid
      };
      var sf = {
        Cmd: '/task/login',
        Data: sd
      };
      var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sf);
      this.socket.send('iris-websocket-message:join;0;;;' + str);
    },
    toSendMessage: function toSendMessage(message) {},
    toGetLogContent: function toGetLogContent() {},
    toShowLog: function toShowLog(stageid) {
      if (this.currentStageBuild[stageid].result === -1) {
        this.logDialogCurrentBuildid = this.currentStageBuild[stageid].buildid;
        this.logDialogCurrentContent = '';

        window.jQuery('#modal-log').modal('show');
      } else {
        var win = window.open(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI + '/build/' + this.$route.query.appid + '/' + this.currentVersion.versionid + '/' + this.currentStageBuild[stageid].buildid + '/logfile.log', '_blank');
        win.focus();
      }
    },
    toShowShell: function toShowShell(stageid) {
      this.shellDialogContent = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentStageBuild[stageid].shell);
      console.log(this.currentStageBuild[stageid]);
      window.jQuery('#modal-shell').modal('show');
    },
    getBuildlistById: function getBuildlistById(stageid) {
      if (stageid === 'S3') {
        return this.currentBuildList['S2'];
      } else {
        return this.currentBuildList[stageid];
      }
    },
    getNameByTypeId: function getNameByTypeId(sid) {
      if (sid === DEVELOP_STAGE) {
        return 'TEST';
      }
      if (sid === API_STAGE) {
        return 'API';
      }
      if (sid === PUBLISH_STAGE) {
        return 'PUBLISH';
      }
    },
    getState: function getState(result) {
      if (result === -1) {
        return 'Building';
      }
      if (result === 0) {
        return 'Build Failed';
      }
      if (result === 1) {
        return 'Build Succeed';
      }
    },
    getBuildStageClassByTypeId: function getBuildStageClassByTypeId(result) {
      if (result === -1) {
        return 'fa fa-spinner';
      }
      if (result === 0) {
        return 'fa fa-remove (alias)';
      }
      if (result === 1) {
        return 'fa fa-check';
      }
    },
    getStageClassByTypeId: function getStageClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'box box-warning version-manage-box';
      }
      if (sid === 'S2') {
        return 'box box-info version-manage-box';
      }
      if (sid === 'S3') {
        return 'box box-success version-manage-box';
      }
    },
    getStageLogClassByTypeId: function getStageLogClassByTypeId(sid) {
      if (sid === 'S1') {
        return 'label label-warning pull-right add-agent-choose';
      }
      if (sid === 'S2') {
        return 'label label-info pull-right add-agent-choose';
      }
      if (sid === 'S3') {
        return 'gone';
      }
    },
    toGetBuildList: function toGetBuildList(versionid, stageid, pages) {
      var _this6 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages,
        stage: stageid,
        versionid: this.currentVersion.versionid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/buildlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var buildlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          buildlist = _this6.currentBuildList[stageid].concat(buildlist);
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(_this6.currentBuildList, stageid, buildlist);
          if (buildlist.length > 0 && _this6.currentStageBuild[stageid]) {
            _this6.currentStageBuild[stageid] = buildlist[0];
            if (stageid === 'S2') {
              _this6.currentStageBuild['S3'] = buildlist[0];
            }
          }
        }
      });
    },
    toLoadMoreVersion: function toLoadMoreVersion(pages) {
      this.toGetVersionList(pages);
    },
    toLoadMoreBuild: function toLoadMoreBuild(stageid) {
      if (stageid === 'S3') {
        stageid = 'S2';
      }
      if (this.currentBuildList[stageid].length % 5 === 0) {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5);
      } else {
        this.toGetBuildList(this.currentVersion.versionid, stageid, this.currentBuildList[stageid].length / 5 + 1);
      }
    },
    toGetVersionList: function toGetVersionList(pages) {
      var _this7 = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/versionlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          var tempList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          if (pages === 0) {
            _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          }
          if (tempList.length > 0 && _this7.currentVersion.versionname === '-') {
            _this7.versionList = tempList;
            _this7.currentVersoinPage++;
            _this7.toDoAfterSelectVersion(0);
          } else {
            _this7.currentVersoinPage++;
            _this7.versionList = _this7.versionList.concat(tempList);
          }
        }
      });
    },
    toDoAfterSelectVersion: function toDoAfterSelectVersion(index) {
      this.currentVersion = this.versionList[index];
      console.log(this.currentVersion);
      for (var i = 0; i < this.currentVersion.GeneralSetting.StageSupport.length; i++) {
        this.toGetBuildList(this.currentVersion.versionid, this.currentVersion.GeneralSetting.StageSupport[i], 0);
      }
    },
    toNewBuild: function toNewBuild(item) {
      var _this8 = this;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(this.currentVersion.PublishBuildid)) {
        alert('已经发布了，不能再新建Build');
        return;
      }

      if (item === DEVELOP_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.DevelopShell);
      } else if (item === API_STAGE) {
        this.newbuild_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(this.currentVersion.ReleaseShell);
      }

      this.newbuild_stage = item;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/robotlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          if (data.Result) {
            _this8.macRobotList = [];
            var robotlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < robotlist.length; i++) {
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.MAC_TYPE) {
                _this8.macRobotList.push(robotlist[i]);
              }
            }
            _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
            window.jQuery('#modal-new-build').modal('show');
          }
        }
      });
    },
    toDoNewBuild: function toDoNewBuild() {
      var _this9 = this;

      var tempShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newbuild_developshell);
      if (tempShell === this.currentVersion.DevelopShell) {
        tempShell = '';
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.currentVersion.Type.id,
        versionid: this.currentVersion.versionid,
        stage: this.newbuild_stage,
        robotid: this.newbuild_robotid,
        comment: this.newbuild_developlog,
        shell: tempShell
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newbuild?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        } else {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.location.reload();
        }
      });
    },
    toNewVersion: function toNewVersion() {
      var _this10 = this;

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/getshell?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {
          _this10.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          alert('获取默认脚本错误');
        } else {
          var tempResult = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
          _this10.newversion_developshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.testShell);
          _this10.newversion_releaseshell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].hextoString(tempResult.apiShell);
          _this10.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          window.jQuery('#modal-new-version').modal('show');
        }
      });
    },
    toDoNewVersion: function toDoNewVersion() {
      var params = new URLSearchParams();
      var tempDevelopShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_developshell);
      var tempReleaseShell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].stringtoHex(this.newversion_releaseshell);
      var jsons = {
        appid: this.$route.query.appid,
        versionname: this.newversion_name,
        developlog: this.newversion_developlog,
        developshell: tempDevelopShell,
        releaseshell: tempReleaseShell,
        typeid: this.$route.query.typeid
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].asServerURI, '/compilation/newversion?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.location.reload();
        }
      });
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MasterSlavesUpdateLogs",
  components: {
    UpdateLogs: __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue___default.a
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MobileClientsUpdateLogs",
  components: {
    UpdateLogs: __WEBPACK_IMPORTED_MODULE_0__modules_UpdateLogs_vue___default.a
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_OauthModal__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_OauthModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_OauthModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "oauth2-list",
  components: {
    OauthModal: __WEBPACK_IMPORTED_MODULE_4__modules_OauthModal___default.a
  },
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    isAdminInApp: function isAdminInApp() {
      return __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].checkIsAppAdmin();
    }
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appid, list;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appid = _this.$route.query.appid;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post({
                  path: "/oauth2/get?_type=json",
                  data: { appid: appid },
                  withLoading: true
                });

              case 3:
                list = _context.sent;

                _this.list = list;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleCreate: function handleCreate() {
      this.$refs.modalCreate.show();
    },
    handleEdit: function handleEdit(item) {
      this.$refs.modalEdit.show(item);
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(11);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParameterSetting',
  data: function data() {
    return {
      servers: __WEBPACK_IMPORTED_MODULE_1__demo__["a" /* servers */],
      settingData: {
        alarmsetting: {
          isOpen: false,
          text: ''
        },
        pirData: [],
        otherpirData: [],
        doorData: [],
        otherdoorData: []
      },
      pirNameList: '',
      doorNameList: '',
      entrypirNameList: '',
      entrydoorNameList: '',
      offlineSetting: false,
      pirData: [],
      otherpirData: [],
      doorData: [],
      otherdoorData: [],
      deviceState: 'Disarm',
      isShowSos: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.appid !== '2d2204507cd1399283847ac3fcd7f0c8') {
      this.isShowSos = true;
    }
    window.jQuery('.switch-checkbox').bootstrapSwitch();
    if (this.$route.query.online === '1') {
      this.offlineSetting = true;
    } else {
      this.offlineSetting = false;
    }
    var params = new URLSearchParams();
    var jsons = {
      appid: this.$route.query.appid,
      deviceid: this.$route.query.deviceid
    };
    params.append('json', __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
    if (window.localStorage) {
      params.append('token', this.$router.app.$store.state.user.token);
    }
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/getdevicesetting?_type=json', params).then(function (response) {
      var data = response.data;

      if (data.Status !== 1) {} else {
        if (data.Result) {
          _this.settingData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_4__Global_vue___default.a.APP_SECRET));
          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isHasKey(_this.settingData, 'otherpirData')) {
            _this.settingData.otherpirData = [];
          }
          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isHasKey(_this.settingData, 'otherdoorData')) {
            _this.settingData.otherdoorData = [];
          }

          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.pirData)) {
            for (var j = 0; j < _this.settingData.pirData.length; j++) {
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.pirData[j].isHomeArmOn)) {
                if (_this.pirNameList.length === 0) {
                  _this.pirNameList = _this.settingData.pirData[j].name;
                } else {
                  _this.pirNameList = _this.pirNameList + ',' + _this.settingData.pirData[j].name;
                }
              }
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.pirData[j].isEntryDelayOn)) {
                if (_this.entrypirNameList.length === 0) {
                  _this.entrypirNameList = _this.settingData.pirData[j].name;
                } else {
                  _this.entrypirNameList = _this.entrypirNameList + ',' + _this.settingData.pirData[j].name;
                }
              }
            }
          }

          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.doorData)) {
            for (var i = 0; i < _this.settingData.doorData.length; i++) {
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.doorData[i].isHomeArmOn)) {
                if (_this.doorNameList.length === 0) {
                  _this.doorNameList = _this.settingData.doorData[i].name;
                } else {
                  _this.doorNameList = _this.doorNameList + ',' + _this.settingData.doorData[i].name;
                }
              }
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.doorData[i].isEntryDelayOn)) {
                if (_this.entrydoorNameList.length === 0) {
                  _this.entrydoorNameList = _this.settingData.doorData[i].name;
                } else {
                  _this.entrydoorNameList = _this.entrydoorNameList + ',' + _this.settingData.doorData[i].name;
                }
              }
            }
          }

          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherpirData)) {
            for (var o = 0; o < _this.settingData.otherpirData.length; o++) {
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherpirData[o].isHomeArmOn)) {
                if (_this.pirNameList.length === 0) {
                  _this.pirNameList = _this.settingData.otherpirData[o].name;
                } else {
                  _this.pirNameList = _this.pirNameList + ',' + _this.settingData.otherpirData[o].name;
                }
              }
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherpirData[o].isEntryDelayOn)) {
                if (_this.entrypirNameList.length === 0) {
                  _this.entrypirNameList = _this.settingData.otherpirData[o].name;
                } else {
                  _this.entrypirNameList = _this.entrypirNameList + ',' + _this.settingData.otherpirData[o].name;
                }
              }
            }
          }

          if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherdoorData)) {
            for (var p = 0; p < _this.settingData.otherdoorData.length; p++) {
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherdoorData[p].isHomeArmOn)) {
                if (_this.doorNameList.length === 0) {
                  _this.doorNameList = _this.settingData.otherdoorData[p].name;
                } else {
                  _this.doorNameList = _this.doorNameList + ',' + _this.settingData.otherdoorData[p].name;
                }
              }
              if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(_this.settingData.otherdoorData[p].isEntryDelayOn)) {
                if (_this.entrydoorNameList.length === 0) {
                  _this.entrydoorNameList = _this.settingData.otherdoorData[p].name;
                } else {
                  _this.entrydoorNameList = _this.entrydoorNameList + ',' + _this.settingData.otherdoorData[p].name;
                }
              }
            }
          }
          if (_this.settingData.deviceState === 0) {
            _this.deviceState = 'Arm';
          } else if (_this.settingData.deviceState === 1) {
            _this.deviceState = 'Home Arm';
          } else {
            _this.deviceState = 'Disarm';
          }

          _this.pirData = _this.settingData.pirData;
          _this.otherpirData = _this.settingData.otherpirData;
          _this.doorData = _this.settingData.doorData;
          _this.otherdoorData = _this.settingData.otherdoorData;
        }
      }
    });
  },

  methods: {
    toSetDuressAlarmSetting: function toSetDuressAlarmSetting() {
      if (!this.offlineSetting) {
        return;
      }
      window.jQuery('#modal-duress-alarm-setting').modal('show');
      if (this.settingData.alarmsetting.isOpen) {
        window.jQuery('#alarm_setting_switch').bootstrapSwitch('state', true);
      } else {
        window.jQuery('#alarm_setting_switch').bootstrapSwitch('state', false);
      }
      var tempText = this.settingData.alarmsetting.text;
      this.settingData.alarmsetting.text = '';
      this.settingData.alarmsetting.text = tempText;
      this.settingData.alarmsetting.password = '';
    },
    toSetHomeArmFunction: function toSetHomeArmFunction() {
      if (!this.offlineSetting) {
        return;
      }
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-customize-homearm').modal('show');
    },
    toSetEntryDelay: function toSetEntryDelay() {
      if (!this.offlineSetting) {
        return;
      }
      var tempTime = this.settingData.entrydelaytime;
      this.settingData.entrydelaytime = -1;
      this.settingData.entrydelaytime = tempTime;
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-entry-delay').modal('show');
    },
    toSetExitDelay: function toSetExitDelay() {
      if (!this.offlineSetting) {
        return;
      }
      var tempTime = this.settingData.exitdelaytime;
      this.settingData.exitdelaytime = -1;
      this.settingData.exitdelaytime = tempTime;
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-exit-delay').modal('show');
    },
    toSetSirenDuration: function toSetSirenDuration() {
      if (!this.offlineSetting) {
        return;
      }
      var tempTime = this.settingData.sirentime;
      this.settingData.sirentime = -1;
      this.settingData.sirentime = tempTime;
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-siren-duration').modal('show');
    },
    toSetSelectTimezon: function toSetSelectTimezon() {
      if (!this.offlineSetting) {
        return;
      }
      var tempZone = this.settingData.timezone;
      this.settingData.timezone = '';
      this.settingData.timezone = tempZone;
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-select-timezone').modal('show');
    },
    toSetRestartDevice: function toSetRestartDevice() {
      if (!this.offlineSetting) {
        return;
      }
      window.jQuery('#modal-restart-device').modal('show');
    },
    toSetResetDevice: function toSetResetDevice() {
      if (!this.offlineSetting) {
        return;
      }
      window.jQuery('.switch-checkbox').bootstrapSwitch();
      this.toInitData();
      window.jQuery('#modal-reset-device').modal('show');
    },
    getDelayTime: function getDelayTime(time) {
      if (time <= 0) {
        return 'No Delay';
      }
      return time + 's';
    },
    getSirenTime: function getSirenTime(time) {
      if (time <= 0) {
        return 'Silent';
      }
      return time + 'min';
    },
    toDoResetDevice: function toDoResetDevice() {
      var _this2 = this;

      var resetAll = window.jQuery('#reset_device').get(0).selectedIndex;
      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'RESET_DEVICE',
        retainplugins: resetAll === 1,
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this2.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          window.jQuery('#modal-reset-device').modal('hide');
        }
      });
    },
    toDoSetTimeZone: function toDoSetTimeZone() {
      var _this3 = this;

      var timezone = window.jQuery('#select_timezone').val();
      if (timezone === this.settingData.timezone) {
        window.jQuery('#modal-select-timezone').modal('hide');
        return;
      }
      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SET_DEVICE_TIMEZONE',
        timezone: parseInt(timezone),
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this3.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this3.settingData.exitdelaytime = timezone;
          window.jQuery('#modal-select-timezone').modal('hide');
        }
      });
    },
    toDoSetExitDelay: function toDoSetExitDelay() {
      var _this4 = this;

      var time = 0;
      var times = window.jQuery('#exit_delay_time').val();
      if (times === 'No Delay') {
        time = 0;
      } else {
        time = times.replace('s', '');
      }

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SET_EXITDELAY',
        time: parseInt(time),
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this4.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this4.settingData.exitdelaytime = time;
          window.jQuery('#modal-exit-delay').modal('hide');
        }
      });
    },
    toDoSetEntryDelay: function toDoSetEntryDelay() {
      var _this5 = this;

      var datas = [];
      var third = [];
      var newask = [];
      for (var j = 0; j < this.pirData.length; j++) {
        this.pirData[j].isEntryDelayOn = window.jQuery('#' + j + '_pir_entry_switch').bootstrapSwitch('state');
        if (!this.pirData[j].isAsk) {
          datas.push({ id: this.pirData[j].id, entrydelayenable: this.pirData[j].isEntryDelayOn });
        } else {
          newask.push({ id: this.pirData[j].id, entrydelayenable: this.pirData[j].isEntryDelayOn });
        }
      }
      for (j = 0; j < this.doorData.length; j++) {
        this.doorData[j].isEntryDelayOn = window.jQuery('#' + j + '_door_entry_switch').bootstrapSwitch('state');
        if (!this.doorData[j].isAsk) {
          datas.push({ id: this.doorData[j].id, entrydelayenable: this.doorData[j].isEntryDelayOn });
        } else {
          newask.push({ id: this.doorData[j].id, entrydelayenable: this.doorData[j].isEntryDelayOn });
        }
      }
      for (j = 0; j < this.otherpirData.length; j++) {
        this.otherpirData[j].isEntryDelayOn = window.jQuery('#' + j + '_other_pir_entry_switch').bootstrapSwitch('state');
        if (!this.otherpirData[j].isAsk) {
          third.push({ id: this.otherpirData[j].id, entrydelayenable: this.otherpirData[j].isEntryDelayOn });
        } else {
          newask.push({ id: this.otherpirData[j].id, entrydelayenable: this.otherpirData[j].isEntryDelayOn });
        }
      }
      for (j = 0; j < this.otherdoorData.length; j++) {
        this.otherdoorData[j].isEntryDelayOn = window.jQuery('#' + j + '_other_door_entry_switch').bootstrapSwitch('state');
        if (!this.otherdoorData[j].isAsk) {
          third.push({ id: this.otherdoorData[j].id, entrydelayenable: this.otherdoorData[j].isEntryDelayOn });
        } else {
          newask.push({ id: this.otherdoorData[j].id, entrydelayenable: this.otherdoorData[j].isEntryDelayOn });
        }
      }
      var time = 0;
      var times = window.jQuery('#entry_delay_time').val();
      if (times === 'No Delay') {
        time = 0;
      } else {
        time = times.replace('s', '');
      }

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SET_ENTRYDELAY',
        datas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(datas),
        thirdpartydatas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(third),
        newaskdatas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newask),
        time: parseInt(time),
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this5.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this5.settingData.pirData = _this5.pirData;
          _this5.settingData.otherpirData = _this5.otherpirData;
          _this5.settingData.doorData = _this5.doorData;
          _this5.settingData.otherdoorData = _this5.otherdoorData;
          _this5.settingData.entrydelaytime = time;

          window.location.reload();
        }
      });
    },
    toDoSetSirenTime: function toDoSetSirenTime() {
      var _this6 = this;

      var time = 0;
      var times = window.jQuery('#siren_time').val();
      if (times === 'Silent') {
        time = 0;
      } else {
        time = times.replace('min', '');
      }

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SET_SIRENTIME',
        time: parseInt(time),
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this6.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this6.settingData.sirentime = time;
          window.jQuery('#modal-siren-duration').modal('hide');
        }
      });
    },
    toSetHomeAlarm: function toSetHomeAlarm() {
      var _this7 = this;

      var datas = [];
      var third = [];
      var newask = [];
      for (var j = 0; j < this.pirData.length; j++) {
        this.pirData[j].isHomeArmOn = window.jQuery('#' + j + '_pir_home_switch').bootstrapSwitch('state');
        if (!this.pirData[j].isAsk) {
          datas.push({ id: this.pirData[j].id, homearmenable: this.pirData[j].isHomeArmOn });
        } else {
          newask.push({ sendid: this.pirData[j].sid, stype: this.pirData[j].stype, homearmenable: this.pirData[j].isHomeArmOn });
        }
      }
      for (j = 0; j < this.doorData.length; j++) {
        this.doorData[j].isHomeArmOn = window.jQuery('#' + j + '_door_home_switch').bootstrapSwitch('state');
        if (!this.doorData[j].isAsk) {
          datas.push({ id: this.doorData[j].id, homearmenable: this.doorData[j].isHomeArmOn });
        } else {
          newask.push({ sendid: this.doorData[j].sid, stype: this.doorData[j].stype, homearmenable: this.doorData[j].isHomeArmOn });
        }
      }
      for (j = 0; j < this.otherpirData.length; j++) {
        this.otherpirData[j].isHomeArmOn = window.jQuery('#' + j + '_other_pir_home_switch').bootstrapSwitch('state');
        if (!this.otherpirData[j].isAsk) {
          third.push({ id: this.otherpirData[j].id, homearmenable: this.otherpirData[j].isHomeArmOn });
        } else {
          newask.push({ sendid: this.otherpirData[j].sid, stype: this.otherpirData[j].stype, homearmenable: this.otherpirData[j].isHomeArmOn });
        }
      }
      for (j = 0; j < this.otherdoorData.length; j++) {
        this.otherdoorData[j].isHomeArmOn = window.jQuery('#' + j + '_other_door_home_switch').bootstrapSwitch('state');
        if (!this.otherdoorData[j].isAsk) {
          third.push({ id: this.otherdoorData[j].id, homearmenable: this.otherdoorData[j].isHomeArmOn });
        } else {
          newask.push({ sendid: this.otherdoorData[j].sid, stype: this.otherdoorData[j].stype, homearmenable: this.otherdoorData[j].isHomeArmOn });
        }
      }

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SET_HOMEARM',
        datas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(datas),
        thirdpartydatas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(third),
        newaskdatas: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newask),
        userid: ''
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this7.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          _this7.settingData.pirData = _this7.pirData;
          _this7.settingData.otherpirData = _this7.otherpirData;
          _this7.settingData.doorData = _this7.doorData;
          _this7.settingData.otherdoorData = _this7.otherdoorData;
          window.jQuery('#modal-customize-homearm').modal('hide');
          window.location.reload();
        }
      });
    },
    toInitData: function toInitData() {
      this.pirData = this.settingData.pirData;
      this.otherpirData = this.settingData.otherpirData;
      this.doorData = this.settingData.doorData;
      this.otherdoorData = this.settingData.otherdoorData;
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(this.pirData)) {
        for (var j = 0; j < this.pirData.length; j++) {
          window.jQuery('#' + j + '_pir_home_switch').bootstrapSwitch('state', this.pirData[j].isHomeArmOn);
          window.jQuery('#' + j + '_pir_entry_switch').bootstrapSwitch('state', this.pirData[j].isEntryDelayOn);
        }
      }
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(this.doorData)) {
        for (j = 0; j < this.doorData.length; j++) {
          window.jQuery('#' + j + '_door_home_switch').bootstrapSwitch('state', this.doorData[j].isHomeArmOn);
          window.jQuery('#' + j + '_door_entry_switch').bootstrapSwitch('state', this.doorData[j].isEntryDelayOn);
        }
      }
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(this.otherpirData)) {
        for (j = 0; j < this.otherpirData.length; j++) {
          window.jQuery('#' + j + '_other_pir_home_switch').bootstrapSwitch('state', this.otherpirData[j].isHomeArmOn);
          window.jQuery('#' + j + '_other_pir_entry_switch').bootstrapSwitch('state', this.otherpirData[j].isEntryDelayOn);
        }
      }
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isEmpty(this.otherpirData)) {
        for (j = 0; j < this.otherdoorData.length; j++) {
          window.jQuery('#' + j + '_other_door_home_switch').bootstrapSwitch('state', this.otherdoorData[j].isHomeArmOn);
          window.jQuery('#' + j + '_other_door_entry_switch').bootstrapSwitch('state', this.otherdoorData[j].isEntryDelayOn);
        }
      }
    },
    toRestartDevice: function toRestartDevice() {
      var _this8 = this;

      var params = new URLSearchParams();
      var jsons = {
        messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
        devtoken: this.$route.query.t,
        cmd: 'SYSTEM_REBOOT'
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
        _this8.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].showMsg('Restart success');
          }
        }
      });
    },
    toSetDuressAlarm: function toSetDuressAlarm() {
      var _this9 = this;

      if (window.jQuery('#alarm_setting_switch').bootstrapSwitch('state') !== this.settingData.alarmsetting.isOpen) {
        var params = new URLSearchParams();
        var jsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_INTIMIDATIONALARM_ENABLE',
          enable: window.jQuery('#alarm_setting_switch').bootstrapSwitch('state'),
          userid: ''
        };
        params.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons));
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token);
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params).then(function (response) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          var data = response.data;

          if (data.Status !== 1) {} else {
            if (data.Result) {
              _this9.settingData.alarmsetting.isOpen = !_this9.settingData.alarmsetting.isOpen;
              window.jQuery('#modal-duress-alarm-setting').modal('hide');
            }
          }
        });
      }

      if (window.jQuery('#alarm_setting_password').val() !== '') {
        var passwordParams = new URLSearchParams();
        var passwordJsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_INTIMIDATIONALARM_PASSWORD',
          password: window.jQuery('#alarm_setting_password').val(),
          userid: ''
        };
        passwordParams.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordJsons));
        if (window.localStorage) {
          passwordParams.append('token', this.$router.app.$store.state.user.token);
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, passwordParams).then(function (response) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          var data = response.data;

          if (data.Status !== 1) {} else {
            if (data.Result) {
              window.jQuery('#alarm_setting_password').val('');
            }
          }
        });
      }

      if (window.jQuery('#alarm_setting_text').val() !== this.settingData.alarmsetting.text) {
        var textParams = new URLSearchParams();
        var textJsons = {
          messageid: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getMessageId(),
          devtoken: this.$route.query.t,
          cmd: 'SET_INTIMIDATIONALARM_PUSH_TXT',
          pushliterary: window.jQuery('#alarm_setting_text').val(),
          userid: ''
        };
        textParams.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(textJsons));
        if (window.localStorage) {
          textParams.append('token', this.$router.app.$store.state.user.token);
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING');
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, textParams).then(function (response) {
          _this9.$store.commit('TOGGLE_FULLSCREEN_LOADING');
          var data = response.data;

          if (data.Status !== 1) {} else {
            if (data.Result) {
              _this9.settingData.alarmsetting.text = window.jQuery('#alarm_setting_text').val();
              window.jQuery('#modal-duress-alarm-setting').modal('hide');
            }
          }
        });
      } else {
        window.jQuery('#modal-duress-alarm-setting').modal('hide');
      }
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);












var formatList = function formatList(arr) {
  return arr.map(function (item) {
    var deviceid = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(item)[0];
    var itemData = item[deviceid];
    var online = !!itemData.online;
    var onlineText = online ? "online" : "offline";
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, itemData, { deviceid: deviceid, online: online, onlineText: onlineText });
  });
};

var limit = 20;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProblemDevicesList",
  data: function data() {
    return {
      list: [],
      isLoadMore: false
    };
  },

  computed: {
    isShowEmptyList: function isShowEmptyList() {
      return this.list.length < 1;
    }
  },
  filters: {
    formatTime: function formatTime(time) {
      return __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].formatDate(new Date(time / 1000000), "yyyy-MM-dd hh:mm:ss");
    },
    capitalize: function capitalize(cmdname) {
      return __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].capitalize(cmdname);
    }
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _list;

        var list;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].post({
                  path: "/getsimdatalist?_type=json",
                  data: {
                    appid: _this.$route.query.appid,
                    skip: _this.list.length,
                    limit: limit,
                    sim: 2
                  },
                  withLoading: true
                });

              case 2:
                list = _context.sent;

                (_list = _this.list).push.apply(_list, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(formatList(list)));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleScroll: function handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery("#problemDeviceList").height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (this.currentDeviceListHeight < listNodeHeight && windowScrollTop + windowHeight >= listNodeHeight) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetch();
      }
    },
    downloadCSV: function downloadCSV() {
      var titles = ["AT+CSQ", "AT+CREG", "AT+CGSN", "AT+CIMI", "AT+CPIN", "AT+COPS"].sort();
      titles.unshift("ID");
      var join = function join(dataset) {
        return dataset.join(",");
      };
      var csv = this.list.reduce(function (arr, item) {
        var deviceid = item.deviceid,
            rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(item, ["deviceid"]);

        arr.push(join([deviceid].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(rest).sort().map(function (key) {
          return rest[key];
        })))));
        return arr;
      }, [join(titles)]).join("\n");
      var fragment = document.createElement("a");
      fragment.href = "data:text/csvcharset=utf-8," + encodeURI(csv);
      fragment.target = "_blank";
      fragment.download = "problem_devices.csv";
      fragment.click();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
              _context2.next = 3;
              return _this2.fetch();

            case 3:
              _this2.$store.commit("TOGGLE_FULLSCREEN_LOADING");
              _this2.currentDeviceListHeight = 0;
              window.addEventListener("scroll", _this2.handleScroll, false);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Project",
  data: function data() {
    return {
      applists: [],
      isAdmin: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].checkIsSuperAdmin()
    };
  },

  computed: {},
  created: function created() {
    this.$bus.on("searchapp", this.init);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off("searchapp", this.init);
  },

  methods: {
    toGetAllApp: function toGetAllApp() {
      var _this = this;

      var params = new URLSearchParams();
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/searchbyidapp?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status === 1) {
          if (data.Result) {
            _this.applists = [];
            var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < mylist.length; i++) {
              _this.applists.push({
                appid: mylist[i].appid,
                appname: mylist[i].appname,
                appicon: mylist[i].appicon,
                UidPermission: mylist[i].UidPermission
              });
            }
          }
        }
      });
    },
    toSearchApp: function toSearchApp(key) {
      var _this2 = this;

      var params = new URLSearchParams();
      var appname = {
        appname: key
      };
      params.append("json", __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(appname), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append("token", window.localStorage.getItem("token"));
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request("post", "/searchapp?_type=json", params).then(function (response) {
        var data = response.data;

        if (data.Status === 1) {
          if (data.Result) {
            _this2.applists = [];
            var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < mylist.length; i++) {
              _this2.applists.push({
                appid: mylist[i].appid,
                appname: mylist[i].appname,
                appicon: mylist[i].appicon,
                UidPermission: mylist[i].UidPermission
              });
            }
          }
        }
      });
    },
    goToApp: function goToApp(appid, appname, appper) {
      if (window.localStorage) {
        window.localStorage.setItem("appper", appper);
      }
      this.$router.push("/information/app?" + "appid=" + appid + "&appname=" + appname);
    },
    init: function init(key) {
      if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(key) || __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isEmpty(key.key)) {
        this.toGetAllApp();
      } else {
        this.toSearchApp(key.key);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RobotList',
  data: function data() {
    return {
      robotStatus: 1,
      deviceRobotList: [],
      macRobotList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      var params = new URLSearchParams();
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestWithServerUrl('post', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].asServerURI, '/compilation/robotlist?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            _this.deviceRobotList = [];
            _this.macRobotList = [];
            var robotlist = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            for (var i = 0; i < robotlist.length; i++) {
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.DEVICE_TYPE) {
                _this.deviceRobotList.push(robotlist[i]);
              }
              if (robotlist[i].type === __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.MAC_TYPE) {
                _this.macRobotList.push(robotlist[i]);
              }
            }
          }
        }
      });
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].formatDate(date, 'yyyy.MM.dd');
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TestDeviceAnalysis',
  data: function data() {
    return {
      testDeviceList: [],
      online: 0,
      offline: 0,
      nocoap: 0,
      unregister: 0,
      normal: 0,
      problem: 0,
      nocard: 0,
      pieData: [{
        value: 0,
        color: '#4AC0C0',
        highlight: '#41A6A6',
        label: 'online'
      }, {
        value: 0,
        color: '#FF6483',
        highlight: '#E65A76',
        label: 'offline'
      }, {
        value: 0,
        color: '#36A2EB',
        highlight: '#3091D1',
        label: 'no coap connection'
      }, {
        value: 0,
        color: '#FFCD56',
        highlight: '#E6B84E',
        label: 'unregistered'
      }],
      simCardChartData: [{
        value: 0,
        color: '#4AC0C0',
        highlight: '#41A6A6',
        label: 'normal'
      }, {
        value: 0,
        color: '#FF6483',
        highlight: '#E65A76',
        label: 'something wrong'
      }, {
        value: 0,
        color: '#36A2EB',
        highlight: '#3091D1',
        label: 'have no card'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.testDeviceList = ['Deviceid_SikkertHjem_1e89f85acA', 'Deviceid_SikkertHjem_40E1411f23', 'Deviceid_SikkertHjem_682fad066a', 'Deviceid_SikkertHjem_32f2AfB98f', 'Deviceid_SikkertHjem_25677466Af', 'Deviceid_SikkertHjem_FD6bE31Cc4', 'Deviceid_SikkertHjem_F0f122179e', 'Deviceid_SikkertHjem_7b79969114', 'Deviceid_SikkertHjem_c81D46d605', 'Deviceid_SikkertHjem_5a8Cb8ef96', 'Deviceid_SikkertHjem_0719f41ff9', 'Deviceid_SikkertHjem_42e188Ccdf', 'Deviceid_SikkertHjem_4Db6D369F5', 'Deviceid_SikkertHjem_735d9e9DEa', 'Deviceid_SikkertHjem_Fdc11Cf718', 'Deviceid_SikkertHjem_1149E7991B', 'Deviceid_SikkertHjem_27dd508921', 'Deviceid_SikkertHjem_89a5AC6E62', 'Deviceid_SikkertHjem_136E4FdDC0', 'Deviceid_SikkertHjem_Dde04225d2', 'Deviceid_SikkertHjem_fFA51BD7d0', 'Deviceid_SikkertHjem_028fFCD962', 'Deviceid_SikkertHjem_3680E4D027', 'Deviceid_SikkertHjem_C0B8896452', 'Deviceid_SikkertHjem_e56CB6Cb7B', 'Deviceid_SikkertHjem_c7984CE3B7', 'Deviceid_SikkertHjem_59Ca9a4a89', 'Deviceid_SikkertHjem_74dF06038B', 'Deviceid_SikkertHjem_Ff9fC9eDF6', 'Deviceid_SikkertHjem_5100bD56d5', 'Deviceid_SikkertHjem_B8702f89C1', 'Deviceid_SikkertHjem_536Ac2db2e', 'Deviceid_SikkertHjem_e51447A6A7', 'Deviceid_SikkertHjem_33d095A524', 'Deviceid_SikkertHjem_dE4c280554', 'Deviceid_SikkertHjem_06B77B1a1c', 'Deviceid_SikkertHjem_4865de9b5d', 'Deviceid_SikkertHjem_96550cB152', 'Deviceid_SikkertHjem_2E32148875', 'Deviceid_SikkertHjem_5A61C1E2E8', 'Deviceid_SikkertHjem_292BE0F32e', 'Deviceid_SikkertHjem_2dA4Ec1Fe2', 'Deviceid_SikkertHjem_1aA302cE26', 'Deviceid_SikkertHjem_8952beA672', 'Deviceid_SikkertHjem_2c5FD5e74A', 'Deviceid_SikkertHjem_66ae9b3DFd', 'Deviceid_SikkertHjem_8A70Fc2D57', 'Deviceid_SikkertHjem_CD5e0a2C3D', 'Deviceid_SikkertHjem_a1cf0736b4', 'Deviceid_SikkertHjem_eF87f6D42B', 'Deviceid_SikkertHjem_976b59F201', 'Deviceid_SikkertHjem_64CE84bE70', 'Deviceid_SikkertHjem_81B8136822', 'Deviceid_SikkertHjem_a7A1b5b569', 'Deviceid_SikkertHjem_16AB30AC3d', 'Deviceid_SikkertHjem_836d5Dd121', 'Deviceid_SikkertHjem_44A02a24f5', 'Deviceid_SikkertHjem_08CaB3C5dE', 'Deviceid_SikkertHjem_83a8c50652', 'Deviceid_SikkertHjem_624587c666'];
    this.init();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        devices: this.testDeviceList
      };
      params.append('json', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getRC4Hex(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsons), __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token);
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/analysis/deviceanalysis?_type=json', params).then(function (response) {
        var data = response.data;

        if (data.Status !== 1) {} else {
          if (data.Result) {
            var result = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getDecodeRC4Hex(data.Result, __WEBPACK_IMPORTED_MODULE_3__Global_vue___default.a.APP_SECRET));
            _this.online = result.online;
            _this.offline = result.offline;
            _this.nocoap = result.uncoap;
            _this.unregister = result.unregister;
            _this.normal = result.simnormal;
            _this.problem = result.problem;
            _this.nocard = result.nocard;
            _this.initPieData();
          }
        }
      });
    },
    initPieData: function initPieData() {
      var areaChartOptions = {
        tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= value %>%'
      };
      var areaChartCanvas = window.jQuery('#areaChart').get(0).getContext('2d');
      var areaChart = new __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js___default.a(areaChartCanvas);
      if (this.online > 0) {
        this.pieData[0].value = this.online / this.testDeviceList.length * 100;
      }
      if (this.offline > 0) {
        this.pieData[1].value = this.offline / this.testDeviceList.length * 100;
      }
      if (this.nocoap > 0) {
        this.pieData[2].value = this.nocoap / this.testDeviceList.length * 100;
      }
      if (this.unregister > 0) {
        this.pieData[3].value = this.unregister / this.testDeviceList.length * 100;
      }
      areaChart.Pie(this.pieData, areaChartOptions);
      var simCardChartCanvas = window.jQuery('#simCardChart').get(0).getContext('2d');
      var simCardChart = new __WEBPACK_IMPORTED_MODULE_4__static_js_plugins_chartjs_Chart_js___default.a(simCardChartCanvas);
      if (this.normal > 0) {
        this.simCardChartData[0].value = this.normal / this.testDeviceList.length * 100;
      }
      if (this.problem > 0) {
        this.simCardChartData[1].value = this.problem / this.testDeviceList.length * 100;
      }
      if (this.nocard > 0) {
        this.simCardChartData[2].value = this.nocard / this.testDeviceList.length * 100;
      }
      simCardChart.Pie(this.simCardChartData, areaChartOptions);
    }
  }
});

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.loading-full-screen {\n  z-index: 999999999999;\n}\n", ""]);

// exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.bootstrap-switch-info {\n  background-color: #00c0ef !important;\n}\n", ""]);

// exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.skin-purple .wrapper {\n  background-color: #ecf0f5;\n}\n", ""]);

// exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.info-box {\n  /*cursor: pointer;*/\n}\n.info-box-content {\n  vertical-align: middle;\n  display: inherit;\n}\n.fullCanvas {\n  width: 100%;\n}\n.info-box-text {\n  margin-bottom: 12px;\n}\n", ""]);

// exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.erroralert[data-v-4021f7ef] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 233333;\n}\n.erroralert.fade[data-v-4021f7ef] {\n  pointer-events: none;\n}\n", ""]);

// exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.wrapper.fixed_layout .main-header {\n  position: fixed;\n  width: 100%;\n}\n.wrapper.fixed_layout .main-sidebar {\n  position: fixed;\n  height: 100vh;\n}\n@media (max-width: 767px) {\n.wrapper.hide_logo .main-header .logo {\n    display: none;\n}\n}\n.logo-mini,\n.logo-lg {\n  text-align: center;\n}\n.logo-mini img,\n.logo-lg img {\n  padding: 0.4em !important;\n}\n.logo-lg img {\n  display: -webkit-inline-box;\n  width: 25%;\n}\n.user-panel {\n  height: 4em;\n}\nhr.visible-xs-block {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.17);\n  height: 1px;\n  border-color: transparent;\n}\n.messages-margin {\n  margin-right: 13px;\n}\n.user-menu {\n  margin-right: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.user-panel .image img {\n  border-radius: 50%;\n}\n", ""]);

// exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.search-form[data-v-5dfe1a00] {\n  height: 64px;\n  float: none;\n}\n.domain-section dd[data-v-5dfe1a00] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  color: #8a2be2;\n}\n.domain-section dt[data-v-5dfe1a00] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n", ""]);

// exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.loading[data-v-61766d91]{\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding-top: 190px;\n  background:rgba(0,0,0,0.5);\n  color: #fff;\n}\n.spinner[data-v-61766d91] {\n  margin-bottom: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 150px;\n  text-align: center;\n}\n.spinner > div[data-v-61766d91] {\n  width: 14px;\n  height: 14px;\n  background-color: #fff;\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;\n  animation: bouncedelay 1.4s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.spinner .bounce1[data-v-61766d91] {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.spinner .bounce2[data-v-61766d91] {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n@-webkit-keyframes bouncedelay {\n0%, 80%, 100% { -webkit-transform: scale(0.0)\n}\n40% { -webkit-transform: scale(1.0)\n}\n}\n@keyframes bouncedelay {\n0%, 80%, 100% {\n    transform: scale(0.0);\n    -webkit-transform: scale(0.0);\n}\n40% {\n      transform: scale(1.0);\n      -webkit-transform: scale(1.0);\n}\n}\n", ""]);

// exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.example-modal .modal {\n  position: fixed;\n  display: block;\n  z-index: 999999;\n}\n.example-modal .modal {\n  /*background: transparent !important;*/\n  background: #000000 0.3 !important;\n}\n.form-horizontal .form-group {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n", ""]);

// exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.newsweekly .center-box[data-v-62bc1d91] {\n  margin: auto;\n  float: none;\n}\n.newsweekly th[data-v-62bc1d91],\n.newsweekly td[data-v-62bc1d91] {\n  padding-left: 2em;\n  padding-right: 2em;\n}\n.newsweekly .td-right[data-v-62bc1d91] {\n  text-align: right;\n}\n", ""]);

// exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\nhtml,\nbody,\n.container-table {\n  background-color: #ecf0f5;\n}\n.login-bg {\n  background-color: #d2d6de;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n.container-table {\n  display: table;\n  color: white;\n}\n.vertical-center-row {\n  display: table-cell;\n  vertical-align: middle;\n}\n.vertical-20p {\n  padding-top: 20%;\n}\n.vertical-10p {\n  padding-top: 5%;\n}\n.logo {\n  width: 10em;\n  padding: 3em;\n}\n.loginForm .input-group {\n  padding-bottom: 1em;\n  height: 4em;\n}\n", ""]);

// exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.fake {\n  color: \"red\";\n}\n#world-map-markers svg {\n  height: 355px;\n}\n.row.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.row.no-gutters > [class^=\"col-\"],\n.row.no-gutters > [class*=\" col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.fa-star {\n  color: #605ca8;\n}\n.fa-star-o {\n  color: #605ca8;\n}\n.example-modal .modal {\n  position: fixed;\n  display: block;\n  z-index: 999999;\n}\n.example-modal .modal {\n  /*background: transparent !important;*/\n  background: #000000 0.3 !important;\n}\n.form-horizontal .form-group {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n", ""]);

// exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.information-content em[data-v-968f34c8] {\n  color: #de4444;\n}\n", ""]);

// exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* override default */\n.sidebar-menu > li > a {\n  padding: 12px 15px 12px 15px;\n}\n.sidebar-menu li.active > a > .fa-angle-left,\n.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {\n  animation-name: rotate;\n  animation-duration: 0.2s;\n  animation-fill-mode: forwards;\n}\n@keyframes rotate {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(-90deg);\n}\n}\n", ""]);

// exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n.logs-header {\n  padding: 30px;\n}\n.logs-date {\n  float: left;\n  margin: 0;\n  font-weight: bold;\n  font-size: 16px;\n}\n.logs-version {\n  float: left;\n  margin: 0 0 0 15px;\n  font-size: 16px;\n}\n.logs-table {\n  width: 100%;\n  margin: 0 15px 30px;\n}\n.logs-table th {\n  padding-bottom: 10px;\n}\n.logs-table td {\n  padding: 0;\n}\n.logs-content {\n  width: 100%;\n  min-height: 2em;\n  display: block;\n  margin: 0;\n  border-color: white;\n  background-color: white;\n  font-size: 16px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.logs-note {\n  color: #787878;\n}\n.logs-body {\n  clear: both;\n}\n", ""]);

// exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 89,
	"./af.js": 89,
	"./ar": 96,
	"./ar-dz": 90,
	"./ar-dz.js": 90,
	"./ar-kw": 91,
	"./ar-kw.js": 91,
	"./ar-ly": 92,
	"./ar-ly.js": 92,
	"./ar-ma": 93,
	"./ar-ma.js": 93,
	"./ar-sa": 94,
	"./ar-sa.js": 94,
	"./ar-tn": 95,
	"./ar-tn.js": 95,
	"./ar.js": 96,
	"./az": 97,
	"./az.js": 97,
	"./be": 98,
	"./be.js": 98,
	"./bg": 99,
	"./bg.js": 99,
	"./bn": 100,
	"./bn.js": 100,
	"./bo": 101,
	"./bo.js": 101,
	"./br": 102,
	"./br.js": 102,
	"./bs": 103,
	"./bs.js": 103,
	"./ca": 104,
	"./ca.js": 104,
	"./cs": 105,
	"./cs.js": 105,
	"./cv": 106,
	"./cv.js": 106,
	"./cy": 107,
	"./cy.js": 107,
	"./da": 108,
	"./da.js": 108,
	"./de": 111,
	"./de-at": 109,
	"./de-at.js": 109,
	"./de-ch": 110,
	"./de-ch.js": 110,
	"./de.js": 111,
	"./dv": 112,
	"./dv.js": 112,
	"./el": 113,
	"./el.js": 113,
	"./en-au": 114,
	"./en-au.js": 114,
	"./en-ca": 115,
	"./en-ca.js": 115,
	"./en-gb": 116,
	"./en-gb.js": 116,
	"./en-ie": 117,
	"./en-ie.js": 117,
	"./en-nz": 118,
	"./en-nz.js": 118,
	"./eo": 119,
	"./eo.js": 119,
	"./es": 121,
	"./es-do": 120,
	"./es-do.js": 120,
	"./es.js": 121,
	"./et": 122,
	"./et.js": 122,
	"./eu": 123,
	"./eu.js": 123,
	"./fa": 124,
	"./fa.js": 124,
	"./fi": 125,
	"./fi.js": 125,
	"./fo": 126,
	"./fo.js": 126,
	"./fr": 129,
	"./fr-ca": 127,
	"./fr-ca.js": 127,
	"./fr-ch": 128,
	"./fr-ch.js": 128,
	"./fr.js": 129,
	"./fy": 130,
	"./fy.js": 130,
	"./gd": 131,
	"./gd.js": 131,
	"./gl": 132,
	"./gl.js": 132,
	"./gom-latn": 133,
	"./gom-latn.js": 133,
	"./he": 134,
	"./he.js": 134,
	"./hi": 135,
	"./hi.js": 135,
	"./hr": 136,
	"./hr.js": 136,
	"./hu": 137,
	"./hu.js": 137,
	"./hy-am": 138,
	"./hy-am.js": 138,
	"./id": 139,
	"./id.js": 139,
	"./is": 140,
	"./is.js": 140,
	"./it": 141,
	"./it.js": 141,
	"./ja": 142,
	"./ja.js": 142,
	"./jv": 143,
	"./jv.js": 143,
	"./ka": 144,
	"./ka.js": 144,
	"./kk": 145,
	"./kk.js": 145,
	"./km": 146,
	"./km.js": 146,
	"./kn": 147,
	"./kn.js": 147,
	"./ko": 148,
	"./ko.js": 148,
	"./ky": 149,
	"./ky.js": 149,
	"./lb": 150,
	"./lb.js": 150,
	"./lo": 151,
	"./lo.js": 151,
	"./lt": 152,
	"./lt.js": 152,
	"./lv": 153,
	"./lv.js": 153,
	"./me": 154,
	"./me.js": 154,
	"./mi": 155,
	"./mi.js": 155,
	"./mk": 156,
	"./mk.js": 156,
	"./ml": 157,
	"./ml.js": 157,
	"./mr": 158,
	"./mr.js": 158,
	"./ms": 160,
	"./ms-my": 159,
	"./ms-my.js": 159,
	"./ms.js": 160,
	"./my": 161,
	"./my.js": 161,
	"./nb": 162,
	"./nb.js": 162,
	"./ne": 163,
	"./ne.js": 163,
	"./nl": 165,
	"./nl-be": 164,
	"./nl-be.js": 164,
	"./nl.js": 165,
	"./nn": 166,
	"./nn.js": 166,
	"./pa-in": 167,
	"./pa-in.js": 167,
	"./pl": 168,
	"./pl.js": 168,
	"./pt": 170,
	"./pt-br": 169,
	"./pt-br.js": 169,
	"./pt.js": 170,
	"./ro": 171,
	"./ro.js": 171,
	"./ru": 172,
	"./ru.js": 172,
	"./sd": 173,
	"./sd.js": 173,
	"./se": 174,
	"./se.js": 174,
	"./si": 175,
	"./si.js": 175,
	"./sk": 176,
	"./sk.js": 176,
	"./sl": 177,
	"./sl.js": 177,
	"./sq": 178,
	"./sq.js": 178,
	"./sr": 180,
	"./sr-cyrl": 179,
	"./sr-cyrl.js": 179,
	"./sr.js": 180,
	"./ss": 181,
	"./ss.js": 181,
	"./sv": 182,
	"./sv.js": 182,
	"./sw": 183,
	"./sw.js": 183,
	"./ta": 184,
	"./ta.js": 184,
	"./te": 185,
	"./te.js": 185,
	"./tet": 186,
	"./tet.js": 186,
	"./th": 187,
	"./th.js": 187,
	"./tl-ph": 188,
	"./tl-ph.js": 188,
	"./tlh": 189,
	"./tlh.js": 189,
	"./tr": 190,
	"./tr.js": 190,
	"./tzl": 191,
	"./tzl.js": 191,
	"./tzm": 193,
	"./tzm-latn": 192,
	"./tzm-latn.js": 192,
	"./tzm.js": 193,
	"./uk": 194,
	"./uk.js": 194,
	"./ur": 195,
	"./ur.js": 195,
	"./uz": 197,
	"./uz-latn": 196,
	"./uz-latn.js": 196,
	"./uz.js": 197,
	"./vi": 198,
	"./vi.js": 198,
	"./x-pseudo": 199,
	"./x-pseudo.js": 199,
	"./yo": 200,
	"./yo.js": 200,
	"./zh-cn": 201,
	"./zh-cn.js": 201,
	"./zh-hk": 202,
	"./zh-hk.js": 202,
	"./zh-tw": 203,
	"./zh-tw.js": 203
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/404.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] 404.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d9673a6", Component.options)
  } else {
    hotAPI.reload("data-v-3d9673a6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/Dash.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dash.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-521a128d", Component.options)
  } else {
    hotAPI.reload("data-v-521a128d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-4021f7ef",
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/ErrorAlert.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ErrorAlert.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4021f7ef", Component.options)
  } else {
    hotAPI.reload("data-v-4021f7ef", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-61766d91",
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/Loading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Loading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61766d91", Component.options)
  } else {
    hotAPI.reload("data-v-61766d91", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/Login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-68292f04", Component.options)
  } else {
    hotAPI.reload("data-v-68292f04", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56cd87b1", Component.options)
  } else {
    hotAPI.reload("data-v-56cd87b1", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/SidebarMenu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarMenu.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b31df5a0", Component.options)
  } else {
    hotAPI.reload("data-v-b31df5a0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/AnalysisChart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AnalysisChart.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06f7306f", Component.options)
  } else {
    hotAPI.reload("data-v-06f7306f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/ApnsRelationForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ApnsRelationForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c955592", Component.options)
  } else {
    hotAPI.reload("data-v-5c955592", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/DeviceAddonClientForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceAddonClientForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4449e1e6", Component.options)
  } else {
    hotAPI.reload("data-v-4449e1e6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/DeviceAddonForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceAddonForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69552f8a", Component.options)
  } else {
    hotAPI.reload("data-v-69552f8a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/DeviceTypesForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceTypesForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75d19574", Component.options)
  } else {
    hotAPI.reload("data-v-75d19574", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/DomainFormModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DomainFormModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-024be19c", Component.options)
  } else {
    hotAPI.reload("data-v-024be19c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/OauthModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OauthModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70f49599", Component.options)
  } else {
    hotAPI.reload("data-v-70f49599", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/modules/PrivilegeModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PrivilegeModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-271b4582", Component.options)
  } else {
    hotAPI.reload("data-v-271b4582", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/AboutDevice.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AboutDevice.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-987fc992", Component.options)
  } else {
    hotAPI.reload("data-v-987fc992", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Accessory.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Accessory.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1742a186", Component.options)
  } else {
    hotAPI.reload("data-v-1742a186", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/AddApp.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddApp.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ae5be08", Component.options)
  } else {
    hotAPI.reload("data-v-2ae5be08", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Agent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Agent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7dff9c0e", Component.options)
  } else {
    hotAPI.reload("data-v-7dff9c0e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Android.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Android.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d3e1cd3a", Component.options)
  } else {
    hotAPI.reload("data-v-d3e1cd3a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/ApnsRelation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ApnsRelation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-682f488c", Component.options)
  } else {
    hotAPI.reload("data-v-682f488c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/ConnectionAnalysis.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConnectionAnalysis.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-80fb67d4", Component.options)
  } else {
    hotAPI.reload("data-v-80fb67d4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Device.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Device.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-529b6adc", Component.options)
  } else {
    hotAPI.reload("data-v-529b6adc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceAddon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceAddon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f79e8fe", Component.options)
  } else {
    hotAPI.reload("data-v-0f79e8fe", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceAddonClient.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceAddonClient.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15d4f6e9", Component.options)
  } else {
    hotAPI.reload("data-v-15d4f6e9", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceLog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceLog.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c7bf4cfc", Component.options)
  } else {
    hotAPI.reload("data-v-c7bf4cfc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceTypes.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceTypes.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00079ab7", Component.options)
  } else {
    hotAPI.reload("data-v-00079ab7", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceUpgrade.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceUpgrade.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-646e3d4c", Component.options)
  } else {
    hotAPI.reload("data-v-646e3d4c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DeviceUser.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeviceUser.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62a22ffd", Component.options)
  } else {
    hotAPI.reload("data-v-62a22ffd", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-62bc1d91",
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/DinNewsWeekly.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DinNewsWeekly.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62bc1d91", Component.options)
  } else {
    hotAPI.reload("data-v-62bc1d91", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  "data-v-5dfe1a00",
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Domain.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Domain.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5dfe1a00", Component.options)
  } else {
    hotAPI.reload("data-v-5dfe1a00", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/EventList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae480c68", Component.options)
  } else {
    hotAPI.reload("data-v-ae480c68", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Feedback.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Feedback.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02b24f41", Component.options)
  } else {
    hotAPI.reload("data-v-02b24f41", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/GeneralSetting.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GeneralSetting.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a964784", Component.options)
  } else {
    hotAPI.reload("data-v-2a964784", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Information.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Information.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-725a63a0", Component.options)
  } else {
    hotAPI.reload("data-v-725a63a0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Ios.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Ios.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88566bfe", Component.options)
  } else {
    hotAPI.reload("data-v-88566bfe", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Master.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Master.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e97709e", Component.options)
  } else {
    hotAPI.reload("data-v-2e97709e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/MasterSlavesUpdateLogs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MasterSlavesUpdateLogs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-796f8f72", Component.options)
  } else {
    hotAPI.reload("data-v-796f8f72", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/MobileClientsUpdateLogs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MobileClientsUpdateLogs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6312dd9c", Component.options)
  } else {
    hotAPI.reload("data-v-6312dd9c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/OAuth2List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OAuth2List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f2799756", Component.options)
  } else {
    hotAPI.reload("data-v-f2799756", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/ParameterSetting.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ParameterSetting.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13f31dba", Component.options)
  } else {
    hotAPI.reload("data-v-13f31dba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/ProblemDeviceList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ProblemDeviceList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b5d9a07", Component.options)
  } else {
    hotAPI.reload("data-v-4b5d9a07", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/Project.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Project.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2628c90d", Component.options)
  } else {
    hotAPI.reload("data-v-2628c90d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/RobotList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RobotList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7579bcc8", Component.options)
  } else {
    hotAPI.reload("data-v-7579bcc8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/Users/webber/www/golang/blackholeAdmin/res/adminlte/src/components/views/TestDeviceAnalysis.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TestDeviceAnalysis.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c58b9080", Component.options)
  } else {
    hotAPI.reload("data-v-c58b9080", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuperAdmin),
      expression: "isSuperAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('device-types-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00079ab7", module.exports)
  }
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    staticClass: "loading-full-screen fixed"
  }) : _vm._e(), _vm._v(" "), _c('error-alert')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01697276", module.exports)
  }
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade in"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title) + " Domain")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Short")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.short),
      expression: "formData.short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Short",
      "disabled": _vm.isEdit
    },
    domProps: {
      "value": (_vm.formData.short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "short", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Content Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.contenttype),
      expression: "formData.contenttype"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Content Type"
    },
    domProps: {
      "value": (_vm.formData.contenttype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "contenttype", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.content),
      expression: "formData.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Content"
    },
    domProps: {
      "value": (_vm.formData.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "content", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Delete Domain")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to delete ?\n          ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-024be19c", module.exports)
  }
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "feedbackdiv"
    }
  }, [_c('div', {
    staticClass: "feedback-filter"
  }, [_c('span', {
    class: _vm.filterMarker == 2 ? 'feedback-filter-active feedback-filter-active-current' : 'feedback-filter-active',
    on: {
      "click": function($event) {
        _vm.toGetFeedbackList(0, true)
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', {
    staticClass: "feedback-filter-symbol"
  }, [_vm._v("   >   ")]), _vm._v(" "), _c('span', {
    class: _vm.filterMarker == 1 ? 'feedback-filter-active feedback-filter-active-current' : 'feedback-filter-active',
    on: {
      "click": function($event) {
        _vm.toFilterFeedbackList(0, 1, true)
      }
    }
  }, [_vm._v("Read")]), _vm._v(" "), _c('span', {
    staticClass: "feedback-filter-symbol"
  }, [_vm._v("   |   ")]), _vm._v(" "), _c('span', {
    class: _vm.filterMarker == 0 ? 'feedback-filter-active feedback-filter-active-current' : 'feedback-filter-active',
    on: {
      "click": function($event) {
        _vm.toFilterFeedbackList(0, 0, true)
      }
    }
  }, [_vm._v("Unread")])]), _vm._v(" "), _c('div', {
    staticClass: "feedback-content"
  }, [_vm._l((_vm.feedbackList), function(item, index) {
    return _c('div', {
      staticClass: "box-footer box-comments feedback-content-group"
    }, [_c('div', {
      staticClass: "modal fade in",
      attrs: {
        "id": "modal-confirm-change-status"
      }
    }, [_c('div', {
      staticClass: "modal-dialog"
    }, [_c('div', {
      staticClass: "modal-content"
    }, [_vm._m(0, true), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "modal-footer"
    }, [_c('button', {
      staticClass: "btn btn-default pull-left",
      attrs: {
        "type": "button",
        "data-dismiss": "modal",
        "aria-label": "Cancel"
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toChangeFeedbackStatus()
        }
      }
    }, [_vm._v("Yes, I do.")])])])])]), _vm._v(" "), (item.state) ? _c('img', {
      staticClass: "img-md feedback-content-user-img",
      attrs: {
        "src": __webpack_require__(404)
      },
      on: {
        "click": function($event) {
          _vm.toConfirmChangeStatus(index, item.fid, item.state)
        }
      }
    }) : _c('img', {
      staticClass: "img-md feedback-content-user-img",
      attrs: {
        "src": __webpack_require__(405)
      },
      on: {
        "click": function($event) {
          _vm.toConfirmChangeStatus(index, item.fid, item.state)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment-text feedback-content-user-comment"
    }, [_c('span', {
      staticClass: "username"
    }, [_vm._v("\n        " + _vm._s(item.uid) + "\n        "), _c('span', {
      staticClass: "text-muted pull-right"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.time / 1000000)))])]), _vm._v("\n      " + _vm._s(item.contents) + "\n      "), _c('div', {
      staticClass: "feedback-content-user-information"
    }, [_c('div', {
      staticClass: "feedback-content-user-email"
    }, [_c('i', {
      staticClass: "fa fa-envelope-o feedback-content-user-email-icon"
    }), _vm._v(_vm._s(item.email))]), _vm._v(" "), _c('div', {
      staticClass: "feedback-content-user-email"
    }, [_c('i', {
      staticClass: "fa fa-desktop feedback-content-user-email-icon"
    }), _vm._v(_vm._s(item.deviceid))])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNoMoreData),
      expression: "isShowNoMoreData"
    }],
    staticClass: "no-more-data"
  }, [_c('p', {
    staticClass: "no-more-data-content"
  }, [_vm._v("There's no more data.")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("To Confirm Change Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('p', [_vm._v("Do you really want to change this feedback's status ?")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02b24f41", module.exports)
  }
}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "test-device-analysis-chart"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06f7306f", module.exports)
  }
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuperAdmin),
      expression: "isSuperAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('device-addon-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f79e8fe", module.exports)
  }
}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.offlineSetting),
      expression: "!offlineSetting"
    }],
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Device Offline !")]), _vm._v(" "), _c('p', [_vm._v("The parameters of the device could not be set.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSos),
      expression: "isShowSos"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Duress Alarm Setting")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-duress-alarm-setting"
    },
    on: {
      "click": _vm.toSetDuressAlarmSetting
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Status:  ")]), _vm._v(_vm._s(_vm.settingData.alarmsetting.isOpen ? 'On' : 'Off'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("SOS Code:  ")]), _vm._v("7890")]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("SOS Message Content:  ")]), _vm._v(_vm._s(_vm.settingData.alarmsetting.text ? _vm.settingData.alarmsetting.text : '(empty)'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Customize Home Arm function")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-customize-homearm"
    },
    on: {
      "click": _vm.toSetHomeArmFunction
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("PIR Sensor:  ")]), _vm._v(_vm._s(this.pirNameList))]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("Door/Window Sensor:  ")]), _vm._v(_vm._s(this.doorNameList))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entry Delay")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(3), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-entry-delay"
    },
    on: {
      "click": _vm.toSetEntryDelay
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Delay Time:  ")]), _vm._v(_vm._s(this.settingData.entrydelaytime > 0 ? this.settingData.entrydelaytime + 's' : 'No delay'))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("PIR Sensor:  ")]), _vm._v(_vm._s(this.entrypirNameList))]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("Door/Window Sensor:  ")]), _vm._v(_vm._s(this.entrydoorNameList))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exit Delay")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(5), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-exit-delay"
    },
    on: {
      "click": _vm.toSetExitDelay
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Delay Time:  ")]), _vm._v(_vm._s(this.settingData.exitdelaytime > 0 ? this.settingData.exitdelaytime + 's' : 'No delay'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Siren Duration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(6), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-siren-duration"
    },
    on: {
      "click": _vm.toSetSirenDuration
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Time:  ")]), _vm._v(_vm._s(this.settingData.sirentime > 0 ? this.settingData.sirentime + 'min' : 'Silent'))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Select Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(7), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-select-timezone"
    },
    on: {
      "click": _vm.toSetSelectTimezon
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Timezone:  ")]), _vm._v(_vm._s(this.settingData.timezone))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "parameter-setting-advanced-title"
  }, [_vm._v("Advanced Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Restart the Device")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-restart-device"
    },
    on: {
      "click": _vm.toSetRestartDevice
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-duress-alarm-setting"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password for Duress Alarm")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "alarm_setting_password",
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": _vm.settingData.alarmsetting.password
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Custom the SOS message")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "id": "alarm_setting_text",
      "placeholder": "Content sent when duress alarm activated"
    },
    domProps: {
      "value": _vm.settingData.alarmsetting.text
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetDuressAlarm
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-customize-homearm"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("The official accessory")]), _vm._v(" "), _c('div', [_vm._m(11), _vm._v(" "), (_vm.pirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_pir_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(12), _vm._v(" "), (_vm.doorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.doorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_door_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("Third party accessory")]), _vm._v(" "), _c('div', [_vm._m(13), _vm._v(" "), (_vm.otherpirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherpirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_other_pir_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(14), _vm._v(" "), (_vm.otherdoorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherdoorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_other_door_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetHomeAlarm
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-entry-delay"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Delay Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "entry_delay_time"
    },
    domProps: {
      "value": _vm.getDelayTime(_vm.settingData.entrydelaytime)
    }
  }, [_c('option', [_vm._v("No Delay")]), _vm._v(" "), _c('option', [_vm._v("10s")]), _vm._v(" "), _c('option', [_vm._v("20s")]), _vm._v(" "), _c('option', [_vm._v("30s")]), _vm._v(" "), _c('option', [_vm._v("40s")]), _vm._v(" "), _c('option', [_vm._v("50s")]), _vm._v(" "), _c('option', [_vm._v("60s")]), _vm._v(" "), _c('option', [_vm._v("70s")]), _vm._v(" "), _c('option', [_vm._v("80s")]), _vm._v(" "), _c('option', [_vm._v("90s")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("The official accessory")]), _vm._v(" "), _c('div', [_vm._m(16), _vm._v(" "), (_vm.pirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_pir_entry_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(17), _vm._v(" "), (_vm.doorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.doorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_door_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("Third party accessory")]), _vm._v(" "), _c('div', [_vm._m(18), _vm._v(" "), (_vm.otherpirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherpirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_other_pir_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(19), _vm._v(" "), (_vm.otherdoorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherdoorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_other_door_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetEntryDelay
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-exit-delay"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Delay Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "exit_delay_time"
    },
    domProps: {
      "value": _vm.getDelayTime(_vm.settingData.exitdelaytime)
    }
  }, [_c('option', [_vm._v("No Delay")]), _vm._v(" "), _c('option', [_vm._v("10s")]), _vm._v(" "), _c('option', [_vm._v("20s")]), _vm._v(" "), _c('option', [_vm._v("30s")]), _vm._v(" "), _c('option', [_vm._v("40s")]), _vm._v(" "), _c('option', [_vm._v("50s")]), _vm._v(" "), _c('option', [_vm._v("60s")]), _vm._v(" "), _c('option', [_vm._v("70s")]), _vm._v(" "), _c('option', [_vm._v("80s")]), _vm._v(" "), _c('option', [_vm._v("90s")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetExitDelay
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-siren-duration"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Ringing Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "siren_time"
    },
    domProps: {
      "value": _vm.getSirenTime(_vm.settingData.sirentime)
    }
  }, [_c('option', [_vm._v("Silent")]), _vm._v(" "), _c('option', [_vm._v("1min")]), _vm._v(" "), _c('option', [_vm._v("2min")]), _vm._v(" "), _c('option', [_vm._v("3min")]), _vm._v(" "), _c('option', [_vm._v("4min")]), _vm._v(" "), _c('option', [_vm._v("5min")]), _vm._v(" "), _c('option', [_vm._v("10min")]), _vm._v(" "), _c('option', [_vm._v("15min")]), _vm._v(" "), _c('option', [_vm._v("20min")]), _vm._v(" "), _c('option', [_vm._v("25min")]), _vm._v(" "), _c('option', [_vm._v("30min")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetSirenTime
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-select-timezone"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Time Zone:")]), _vm._v(" "), _c('select', {
    staticClass: "device-setting-select",
    attrs: {
      "id": "select_timezone"
    },
    domProps: {
      "value": _vm.settingData.timezone
    }
  }, [_c('option', [_vm._v("Europe/London")]), _vm._v(" "), _c('option', [_vm._v("Europe/Lisbon")]), _vm._v(" "), _c('option', [_vm._v("Europe/Madrid")]), _vm._v(" "), _c('option', [_vm._v("Europe/Amsterdam")]), _vm._v(" "), _c('option', [_vm._v("Europe/Helsinki")]), _vm._v(" "), _c('option', [_vm._v("Europe/Mariehamn")]), _vm._v(" "), _c('option', [_vm._v("Europe/Oslo")]), _vm._v(" "), _c('option', [_vm._v("Europe/Copenhagen")]), _vm._v(" "), _c('option', [_vm._v("Europe/Paris")]), _vm._v(" "), _c('option', [_vm._v("Europe/Stockholm")]), _vm._v(" "), _c('option', [_vm._v("Europe/Zurich")]), _vm._v(" "), _c('option', [_vm._v("Europe/Berlin")]), _vm._v(" "), _c('option', [_vm._v("Europe/Busingen")]), _vm._v(" "), _c('option', [_vm._v("Europe/Vienna")]), _vm._v(" "), _c('option', [_vm._v("Europe/Rome")]), _vm._v(" "), _c('option', [_vm._v("Europe/Vatican")]), _vm._v(" "), _c('option', [_vm._v("Europe/Athens")]), _vm._v(" "), _c('option', [_vm._v("Europe/Warsaw")]), _vm._v(" "), _c('option', [_vm._v("Europe/Kiev")]), _vm._v(" "), _c('option', [_vm._v("Europe/Moscow")]), _vm._v(" "), _c('option', [_vm._v("Europe/Prague")]), _vm._v(" "), _c('option', [_vm._v("Europe/Bratislava")]), _vm._v(" "), _c('option', [_vm._v("Europe/Ljubljana")]), _vm._v(" "), _c('option', [_vm._v("Europe/Istanbul")]), _vm._v(" "), _c('option', [_vm._v("Africa/Cairo")]), _vm._v(" "), _c('option', [_vm._v("Africa/Johannesburg")]), _vm._v(" "), _c('option', [_vm._v("Asia/Jerusalem")]), _vm._v(" "), _c('option', [_vm._v("Asia/Riyadh")]), _vm._v(" "), _c('option', [_vm._v("Asia/Dubai")]), _vm._v(" "), _c('option', [_vm._v("Asia/Tehran")]), _vm._v(" "), _c('option', [_vm._v("Asia/Karachi")]), _vm._v(" "), _c('option', [_vm._v("Asia/Kolkata")]), _vm._v(" "), _c('option', [_vm._v("Asia/Bangkok")]), _vm._v(" "), _c('option', [_vm._v("Asia/Shanghai")]), _vm._v(" "), _c('option', [_vm._v("Asia/Kuala_Lumpur")]), _vm._v(" "), _c('option', [_vm._v("Asia/Ho_Chi_Minh")]), _vm._v(" "), _c('option', [_vm._v("Asia/Seoul")]), _vm._v(" "), _c('option', [_vm._v("Asia/Tokyo")]), _vm._v(" "), _c('option', [_vm._v("Australia/Hobart")]), _vm._v(" "), _c('option', [_vm._v("Australia/Sydney")]), _vm._v(" "), _c('option', [_vm._v("Australia/Brisbane")]), _vm._v(" "), _c('option', [_vm._v("Australia/Perth")]), _vm._v(" "), _c('option', [_vm._v("America/New_York")]), _vm._v(" "), _c('option', [_vm._v("America/Monterrey")]), _vm._v(" "), _c('option', [_vm._v("America/Halifax")]), _vm._v(" "), _c('option', [_vm._v("America/Argentina/Cordoba")]), _vm._v(" "), _c('option', [_vm._v("America/Fortaleza")]), _vm._v(" "), _c('option', [_vm._v("America/Sao_Paulo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetTimeZone
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-restart-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Restart")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right alert-del"
  }, [_vm._m(25), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toRestartDevice
    }
  }, [_vm._v("Restart")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Active Accessories:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Active Accessories:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Duress Alarm Setting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Duress Alarm")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-parameter-setting-switch"
  }, [_c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "alarm_setting_switch",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Customize Home Arm function")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Entry Delay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Exit Delay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Siren Duration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Siren Duration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Restart the Device")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('p', [_vm._v("After RESTART, the local data and configure of the device will be updated to the Server. It may take several minutes.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to Restart ?")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13f31dba", module.exports)
  }
}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuperAdmin),
      expression: "isSuperAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('device-addon-client-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15d4f6e9", module.exports)
  }
}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-xs-12 accessory-search-form"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "form-control accessory-search-input",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search Accessory ID or Device ID...",
      "id": "search-plugin"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat accessory-search-btn",
    on: {
      "click": _vm.toSearchPlugin
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDefault),
      expression: "isShowDefault"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-default-img",
    attrs: {
      "src": __webpack_require__(403)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._l((_vm.pluginList), function(item, index) {
    return _c('div', {
      staticClass: "accessory-list-overall"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('div', {
      staticClass: "accessory-list-overall"
    }, [_c('div', {
      staticClass: "col-xs-12 accessory-list-header"
    }, [(!item[1][0].icon) ? _c('img', {
      staticClass: "accessory-list-type",
      attrs: {
        "src": __webpack_require__(65)
      }
    }) : _c('img', {
      staticClass: "accessory-list-type",
      attrs: {
        "src": item[1][0].icon
      }
    }), _vm._v(" "), (!item[1][0].typeName) ? _c('span', {
      staticClass: "accessory-list-type-name"
    }, [_vm._v("Accessory")]) : _c('span', {
      staticClass: "accessory-list-type-name"
    }, [_vm._v(_vm._s(item[1][0].typeName))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right accessory-list-type-name"
    }, [_vm._v("\n                Accessory ID:  \n                "), _c('span', [_vm._v(_vm._s(item[0]))])])]), _vm._v(" "), _vm._l((item[1]), function(pluginItem, pIndex) {
      return _c('div', {
        staticClass: "col-xs-12 accessory-list-body"
      }, [_c('div', {
        staticClass: "accessory-list-rect row",
        attrs: {
          "data-toggle": "modal"
        },
        on: {
          "click": function($event) {
            _vm.toSetPlugin(index, pIndex)
          }
        }
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-11 accessory-list-information"
      }, [_c('h5', [_vm._v("\n                    Accessory Name:  \n                    "), _c('span', [_vm._v(_vm._s(pluginItem.isprepluginname))])]), _vm._v(" "), _c('h5', [_vm._v("\n                    Binding Device:  \n                    "), _c('span', [_vm._v(_vm._s(pluginItem.devicename))]), _vm._v(" "), _c('span', {
        staticClass: "accessory-list-device-id"
      }, [_vm._v("\n                      (\n                      "), _c('span', [_vm._v(_vm._s(pluginItem.deviceid))]), _vm._v(" )\n                    ")])])]), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('i', {
        staticClass: "fa fa-circle accessory-list-label"
      })])
    })], 2)])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "add-app-bgcolor dropup"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right add-btn-dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-offical-accessory"
    },
    on: {
      "click": _vm.toAddPlugin
    }
  }, [_vm._v("Add Offical Accessory")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-third-party-accessory"
    },
    on: {
      "click": _vm.toAddThirdPlugin
    }
  }, [_vm._v("Add Third Party Accessory")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-offical-accessory"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Accessory ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginid),
      expression: "currentAddPlugin.pluginid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Accessory ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.sub),
      expression: "currentAddPlugin.sub"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "sub", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0B"
    }
  }, [_vm._v("Door/Window Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("PIR Motion Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Smoke Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Vibration Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Emergency Button")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Remote Controller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("SmartPlugs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Wireless Sirens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1B"
    }
  }, [_vm._v("SmartPad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0E"
    }
  }, [_vm._v("Water Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "37"
    }
  }, [_vm._v("Key Tag")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Binding Device ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.deviceid),
      expression: "currentAddPlugin.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Device ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "deviceid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.isPre),
      expression: "currentAddPlugin.isPre"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "isPre", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Pre-paired Accessory")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Non Pre-paired Accessory")])])])]), _vm._v(" "), (_vm.currentAddPlugin.isPre === 'true') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Production Batch")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.batch),
      expression: "currentAddPlugin.batch"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Text"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.batch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "batch", $event.target.value)
      }
    }
  })])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginname),
      expression: "currentAddPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name the Accessory"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginname", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSavePlugin
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-third-party-accessory"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Accessory ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginid),
      expression: "currentAddPlugin.pluginid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Accessory ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.sub),
      expression: "currentAddPlugin.sub"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "sub", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0B"
    }
  }, [_vm._v("Door/Window Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("PIR Motion Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Smoke Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Emergency Button")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Remote Controller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Wireless Sirens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1B"
    }
  }, [_vm._v("SmartPad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0E"
    }
  }, [_vm._v("Water Sensor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Binding Device ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.deviceid),
      expression: "currentAddPlugin.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Device ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "deviceid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginname),
      expression: "currentAddPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name the Accessory"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginname", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveThirdPlugin
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-set-ipc"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), (!_vm.currentPlugin.typeName) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Set Accessory")]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Set " + _vm._s(_vm.currentPlugin.typeName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_vm._m(7), _vm._v(" "), (!_vm.currentPlugin.icon) ? _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": __webpack_require__(65)
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": _vm.currentPlugin.icon
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n                Accessory ID:  \n                "), _c('span', [_vm._v(_vm._s(_vm.currentPlugin.pluginid))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group accessory-modal-set-binding-device"
  }, [_c('label', {
    staticClass: "col-sm-12 control-label agent-edit-modal-name"
  }, [_c('i', {
    staticClass: "fa fa-desktop accessory-modal-set-title-desktop"
  }), _vm._v("\n                Binding Device:  \n                "), _c('p', {
    staticClass: "accessory-modal-set-title-device set-accessory-dia-device-name",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.toSearchDevice(_vm.currentPlugin.devicename, _vm.currentPlugin.deviceid)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.currentPlugin.devicename) + "\n                  (\n                  "), _c('span', [_vm._v(_vm._s(_vm.currentPlugin.deviceid))]), _vm._v(")\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accessory-modal-set-data-group"
  }, [_c('hr'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 accessory-modal-set-info"
  }, [_c('h5', [_c('label', [_vm._v("Binding Time:  ")]), _vm._v("\n                  " + _vm._s(_vm._f("formatDate")(_vm.currentPlugin.time / 1000000)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 accessory-modal-set-info"
  }, [_c('h5', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Type:")]), _vm._v("  \n                  "), (_vm.currentPlugin.isFactory) ? _c('span', [_vm._v("Pre-paired Accessory")]) : _c('span', [_vm._v("Non Pre-paired Accessory")]), _vm._v(" ; \n                  "), (_vm.currentPlugin.cat != 20) ? _c('span', [_vm._v("Offical Accessory")]) : _vm._e(), _vm._v(" "), (_vm.currentPlugin.cat == 20) ? _c('span', [_vm._v("Third Party Accessory")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [(!_vm.offlineClass) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPlugin.pluginname),
      expression: "currentPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPlugin, "pluginname", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPlugin.pluginname),
      expression: "currentPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.currentPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPlugin, "pluginname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "accessory-modal-set-data-group"
  }, [_c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "accessory-modal-set-title"
  }, [_c('i', {
    staticClass: "fa fa-sliders accessory-modal-set-title-icon"
  }), _vm._v("\n                Setting\n                "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.offlineClass),
      expression: "!offlineClass"
    }],
    staticClass: "label accessory-modal-offline-lable"
  }, [_vm._v("Device Offline")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlugin.typeName == 'Smart Plug'),
      expression: "currentPlugin.typeName == 'Smart Plug'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name"
  }, [_vm._v("Status:  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 modal-parameter-setting-switch"
  }, [(_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox pull-right",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox pull-right",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlugin.typeName == 'Wireless Siren'),
      expression: "currentPlugin.typeName == 'Wireless Siren'"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prompt Tone:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n                    Disarm\n                    "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "pull-v"
  }, [_vm._v("\n                      Home Arm\n                      "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Arm\n                      "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Light Mode:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Disarm\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Home Arm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row accessory-modal-set-siren-row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Arm\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Alarm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Volume:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Prompt Tone\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Alarm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Siren Time (Min)")]), _vm._v(" "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer dropup"
  }, [(_vm.offlineClass == true) ? _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Unbind Device")]) : _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Unbind Device")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del accessory-list-alert"
  }, [_vm._m(9), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toUnbindPlugin
    }
  }, [_vm._v("Unbind")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toChangePluginName
    }
  }, [_vm._v("Save changes")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("Find your accessory and its binding device.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("Sorry, no matching results.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-chevron-right accessory-list-right-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Offical Accessory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Third Party Accessory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-self-profile-upload-head modal-user-profile-head-input"
  }, [_c('input')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "accessory-modal-set-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o accessory-modal-set-title-icon"
  }), _vm._v("Information\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to unbind?\n            ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1742a186", module.exports)
  }
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.applists), function(item) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box",
      on: {
        "click": function($event) {
          _vm.goToApp(item.appid, item.appname, item.UidPermission)
        }
      }
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [(item.appicon == '') ? _c('img', {
      staticClass: "app-list-img",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "app-list-img",
      attrs: {
        "src": 'https://d.din.bz/' + item.appicon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(item.appname))]), _vm._v(" "), _vm._m(0, true)])])])
  }), 0)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: 'addapp',
        query: {
          appname: 'Add App'
        }
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "add-app-bgcolor"
  }, [_c('span', {
    staticClass: "btn add-app pull-right"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-app"
  }, [_vm._v("\n              Go To\n              "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2628c90d", module.exports)
  }
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade in"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.problemDevices),
      expression: "problemDevices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "problemDevices"
    },
    domProps: {
      "checked": Array.isArray(_vm.problemDevices) ? _vm._i(_vm.problemDevices, null) > -1 : (_vm.problemDevices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.problemDevices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.problemDevices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.problemDevices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.problemDevices = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "problemDevices"
    }
  }, [_vm._v("Problem Devices")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateLogs),
      expression: "updateLogs"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "appsUpdateLogs"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateLogs) ? _vm._i(_vm.updateLogs, null) > -1 : (_vm.updateLogs)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.updateLogs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.updateLogs = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.updateLogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateLogs = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "appsUpdateLogs"
    }
  }, [_vm._v("Update Logs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Privileges")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-271b4582", module.exports)
  }
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-info btn-robot-setting-save pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifySetting
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "robot-setting-content"
  }, [_vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskStartSetting),
      expression: "taskStartSetting"
    }],
    staticClass: "form-control robot-setting-input",
    attrs: {
      "placeholder": "Task starts..."
    },
    domProps: {
      "value": (_vm.taskStartSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskStartSetting = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "robot-setting-content"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskEndSetting),
      expression: "taskEndSetting"
    }],
    staticClass: "form-control robot-setting-input",
    attrs: {
      "placeholder": "Task completed..."
    },
    domProps: {
      "value": (_vm.taskEndSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskEndSetting = $event.target.value
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v("   Notification of  "), _c('strong', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("TASK START")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v("   Notification of  "), _c('strong', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("TASK COMPLETION")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a964784", module.exports)
  }
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('app-data-form', {
    ref: "form"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ae5be08", module.exports)
  }
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "btn-group version-manage-dropdown-btn",
    attrs: {
      "id": "version-list-popmenu"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle version-manage-dropdown",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.currentVersion.versionname))]), _vm._v(" "), _c('span', {
    staticClass: "caret pull-right version-manage-dropdown-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu version-manage-dropdown",
    attrs: {
      "id": "version-list-pop-menu"
    }
  }, [_c('li', {
    attrs: {
      "data-target": "#modal-new-version"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._l((_vm.versionList), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectVersoin(index)
        }
      }
    }, [_vm._v(_vm._s(item.versionname))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "version-manage-dropdown-more",
    on: {
      "click": function($event) {
        _vm.toLoadMoreVersion(_vm.currentVersoinPage)
      }
    }
  }, [_vm._v("\n            More   \n            "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length > 0),
      expression: "versionList.length>0"
    }],
    staticClass: "version-manage-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.currentVersion.GeneralSetting.StageSupport), function(item) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 version-manage-stage-margin"
    }, [_c('div', {
      class: _vm.getStageClassByTypeId(item)
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('span', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(_vm.getNameByTypeId(item)))]), _vm._v(" "), _c('span', {
      class: _vm.getStageLogClassByTypeId(item),
      on: {
        "click": function($event) {
          _vm.toShowLog(item)
        }
      }
    }, [_vm._v("Log")])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "btn-group version-manage-box-body-dropdown"
    }, [(item !== 'S3') ? _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "caret pull-right version-manage-dropdown-icon"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu version-manage-dropdown version-manage-box-body-dropdown-btn"
    }, [_c('li', {
      attrs: {
        "data-target": "#modal-new-version"
      },
      on: {
        "click": function($event) {
          _vm.toNewBuild(item)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _vm._l((_vm.getBuildlistById(item)), function(b, index) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.selectBuild(item, index)
          }
        }
      }, [_vm._v("build " + _vm._s(b.buildnumber) + " (" + _vm._s(_vm._f("formatDate")(b.time / 1000000)) + ")")])])
    }), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "version-manage-dropdown-more",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreBuild(item)
        }
      }
    }, [_vm._v("\n                        More   \n                        "), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])])], 2)]) : _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
      staticClass: "version-manage-comment"
    }, [_c('div', {
      class: _vm.currentStageBuild[item].result === 1 ? 'version-manage-build-state gone' : 'version-manage-build-state'
    }, [_c('p', [_c('i', {
      class: _vm.getBuildStageClassByTypeId(_vm.currentStageBuild[item].result)
    }), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.getState(_vm.currentStageBuild[item].result)) + "\n                  ")])]), _vm._v(" "), _c('p', {
      class: _vm.emptyToInVisibiliy(_vm.currentStageBuild[item].comment, 'version-manage-stage-comment')
    }, [_vm._v(_vm._s(_vm.currentStageBuild[item].comment))])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "version-manage-button"
    }, [(item !== 'S3') ? _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toSendToRobot(item)
        }
      }
    }, [_vm._v("SEND TO")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentBuildList[item].length > 0 ?
            _vm.toSendDingDing(item) : _vm.toNewBuild(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.currentBuildList[item].length > 0 ?
      '发送钉钉通知' : 'New Build') + "\n                  ")])]) : _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toDoPublishClick(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnText(item)))]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toSendDingDing(item)
        }
      }
    }, [_vm._v("发送钉钉通知")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "version-manage-log"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionDevelopLog",
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": _vm.currentVersion.developlog
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Publish Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionReleaseLog",
      "placeholder": "Publish log..."
    },
    domProps: {
      "value": _vm.currentVersion.releaselog
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length <= 0),
      expression: "versionList.length<=0"
    }]
  }, [_c('p', {
    staticClass: "large_title"
  }, [_vm._v("There's no version!")]), _vm._v(" "), _c('div', {
    staticClass: "version-manage-new-version"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   New Version\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-version"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Version Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_name),
      expression: "newversion_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "version number"
    },
    domProps: {
      "value": (_vm.newversion_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developlog),
      expression: "newversion_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "develop log..."
    },
    domProps: {
      "value": (_vm.newversion_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developshell),
      expression: "newversion_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developshell = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("API")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_releaseshell),
      expression: "newversion_releaseshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_releaseshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_releaseshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoNewVersion
    }
  }, [_vm._v("New Version")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-build"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newbuild_robotid),
        expression: "newbuild_robotid"
      }],
      staticClass: "modal-dialog-sendto-robotpick-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.newbuild_robotid, item.id)
      },
      on: {
        "change": function($event) {
          _vm.newbuild_robotid = item.id
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-3"
    }, [(!item.icon) ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developlog),
      expression: "newbuild_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "Coment..."
    },
    domProps: {
      "value": (_vm.newbuild_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Shell")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developshell),
      expression: "newbuild_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newbuild_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoNewBuild
    }
  }, [_vm._v("New Build")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-shell"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.shellDialogContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-download"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), (_vm.downloadLink) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('qrcode', {
    staticStyle: {
      "margin-left": "31%"
    },
    attrs: {
      "value": _vm.downloadLink,
      "options": {
        width: 200
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p add-agent-choose"
  }, [_c('a', {
    on: {
      "click": _vm.toDownloadLink
    }
  }, [_vm._v(_vm._s(_vm.downloadLink))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "sendto_robotlist"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.deviceRobotList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.sendtodevice_robotid),
        expression: "sendtodevice_robotid"
      }],
      staticClass: "modal-dialog-sendto-robotpick-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.sendtodevice_robotid, item.id)
      },
      on: {
        "change": function($event) {
          _vm.sendtodevice_robotid = item.id
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-3"
    }, [(!item.icon) ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSendTo
    }
  }, [_vm._v("Send")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-log"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.logDialogCurrentContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Version\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Build\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-manage-stage-more invisibiliy"
  }, [_vm._v("\n                more   \n                "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Build")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Download Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', [_vm._v("Send To")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RealTime LogCat")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e97709e", module.exports)
  }
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo_blk.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', {
    staticClass: "page-404-tips"
  }, [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d9673a6", module.exports)
  }
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "alert",
    staticClass: "erroralert alert alert-warning alert-dismissible fade"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4021f7ef", module.exports)
  }
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Addonversion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.addonversion),
      expression: "formData.addonversion"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Addonversion",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.addonversion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "addonversion", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Iosmd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.iosmd5),
      expression: "formData.iosmd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Iosmd5",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.iosmd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "iosmd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Iosurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.iosurl),
      expression: "formData.iosurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Iosurl",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.iosurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "iosurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Androidmd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.androidmd5),
      expression: "formData.androidmd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Androidmd5",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.androidmd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "androidmd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Androidurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.androidurl),
      expression: "formData.androidurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Androidurl",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.androidurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "androidurl", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4449e1e6", module.exports)
  }
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "problemDeviceList"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowEmptyList),
      expression: "!isShowEmptyList"
    }],
    staticClass: "row box problem-device-header"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._v("Download CSV File")])]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      class: ['box', {
        'box-info': item.online
      }, {
        'box-warning': !item.online
      }]
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title device-list-name"
    }, [_vm._v(_vm._s(item.deviceid))]), _vm._v(" "), _c('span', {
      staticClass: "agent-list-id device-list-id"
    }, [_vm._v("\n        (\n        "), _c('span', [_vm._v(_vm._s(item.onlineText))]), _vm._v(" )\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "device-list-table"
    }, [_c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+CSQ: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.csq))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+CREG: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.creg))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-right"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+CGSN: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.cgsn))])])]), _vm._v(" "), _c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+CIMI: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.cimi))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+CPIN: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.cpin))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-right"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("AT+COPS: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.cops))])])])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("No problem devices found.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b5d9a07", module.exports)
  }
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("D")]), _vm._v("Ad\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Dinsafer")]), _vm._v("Admin\n      ")])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "sidebar-toggle toggle-menu-icon",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [(_vm.user.icon == '') ? _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": __webpack_require__(23),
      "alt": "User Image"
    }
  }) : _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.user.icon,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [(_vm.user.icon == '') ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": __webpack_require__(23),
      "alt": "User Image"
    }
  }) : _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.user.icon,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    on: {
      "click": _vm.toLogout
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Logout")])])])])])])])])], 1), _vm._v(" "), (_vm.user.icon == '') ? _c('sidebar', {
    attrs: {
      "display-name": _vm.user.uid,
      "picture-url": "../../static/img/img_device_user_default.png"
    }
  }) : _c('sidebar', {
    attrs: {
      "display-name": _vm.user.uid,
      "picture-url": 'https://d.din.bz/' + _vm.user.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(typeof(_vm.$route.query.devicename) !== 'undefined') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.query.devicename) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]) : _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.query.appname) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.query.appname))]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.query.devicename))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "self-agent-profile"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_c('div', {
    staticClass: "modal-self-profile-upload-head",
    attrs: {
      "title": "Edit"
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadfile($event)
      }
    }
  })]), _vm._v(" "), (_vm.currentIcon == '') ? _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": __webpack_require__(23)
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.currentIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-profile-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progress > 0),
      expression: "progress > 0"
    }],
    staticClass: "progress progress-xxs active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% Complete")])])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "useremail",
      "placeholder": "E-mail Address..."
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#self-agent-profile"
    }
  }, [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("My Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Original Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "useropw",
      "placeholder": "password"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "usernpw",
      "placeholder": "password"
    }
  })])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-521a128d", module.exports)
  }
}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "devicelist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentAdmin),
      expression: "isAgentAdmin"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_c('div', {
    staticClass: "row data_aggregation_table_margin"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    online device\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    " + _vm._s(_vm.onlineDevice) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    total device\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    " + _vm._s(_vm.totalDevice) + "\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row data_aggregation_table_margin"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_as\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.as) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_eu\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.eu) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_us\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.us) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    normal\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.normalsim) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    have no card\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.noCard) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    with problem\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.problem) + "\n                  ")])])])])])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _vm._l((_vm.devicelist), function(item) {
    return _c('div', {
      staticClass: "box box-default device-list-box"
    }, [_c('router-link', {
      staticClass: "device-list-hover",
      attrs: {
        "to": {
          path: '/aboutdevice?appname=' +
            _vm.$route.query.appname +
            '&appid=' +
            _vm.$route.query.appid +
            '&devicename=' +
            encodeURIComponent(item.devicename) +
            '&deviceid=' +
            item.deviceid +
            '&online=' +
            item.online +
            '&t=' +
            item.devicetoken
        }
      }
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title device-list-name"
    }, [_vm._v(_vm._s(item.devicename))]), _vm._v(" "), _c('span', {
      staticClass: "agent-list-id device-list-id"
    }, [_vm._v("( "), _c('span', [_vm._v(_vm._s(item.deviceid))]), _vm._v(" )\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right device-list-go-to"
    }, [_c('span', [_vm._v("More  \n            "), _c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "device-list-table"
    }, [_c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("country/region: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ipaddress))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("network status: ")]), _vm._v(" "), (item.online != 1) ? _c('span', [_vm._v(" -")]) : (item.network / 1000000 < 200) ? _c('span', {
      staticClass: "device-network-status-excellent"
    }, [_vm._v("excellent \n                "), _c('i', {
      staticClass: "fa fa-thumbs-o-up"
    })]) : (item.network / 1000000 < 400) ? _c('span', {
      staticClass: "device-network-status-good"
    }, [_vm._v("good \n                "), _c('i', {
      staticClass: "fa fa-hand-peace-o"
    })]) : _c('span', {
      staticClass: "device-network-status-poor"
    }, [_vm._v("poor \n                "), _c('i', {
      staticClass: "fa fa-thumbs-o-down"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-right"
    }, [(item.online == 1) ? _c('span', {
      staticClass: "device-list-table-content device-online-status"
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" online\n              ")]) : _c('span', {
      staticClass: "device-list-table-content device-offline-status"
    }, [_c('i', {
      staticClass: "fa fa-times-circle"
    }), _vm._v(" offline\n              ")])])]), _vm._v(" "), _c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("firmware version: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.version))])]), _vm._v(" "), (item.activetime > 0) ? _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("activation time: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")((item.activetime / 1000000))))])]) : _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("activation time: ")]), _vm._v(" "), _c('span', [_vm._v(" -")])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "col-xs-4 device-list-right"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("production batch: ")]), _vm._v(" "), _c('span', [_vm._v("1862443")])])])])])])], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    server\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    number of device\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    sim card status\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    number of device\n                  ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-529b6adc", module.exports)
  }
}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSearch),
      expression: "isShowSearch"
    }],
    staticClass: "sidebar-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "name": "search",
      "id": "search-btn"
    },
    on: {
      "click": _vm.toDoSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('sidebar-menu'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVersion),
      expression: "isShowVersion"
    }],
    staticClass: "version-data"
  }, [_vm._v(_vm._s(_vm.buildVersion + ' (' + _vm.buildSHA + ')'))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-56cd87b1", module.exports)
  }
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Appsecret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appsecret),
      expression: "formData.appsecret"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Appsecret",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appsecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appsecret", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fcmkey")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.fcmkey),
      expression: "formData.fcmkey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Fcmkey",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.fcmkey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "fcmkey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mi),
      expression: "formData.mi"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Mi",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.mi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mi", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Miappid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.miappid),
      expression: "formData.miappid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Miappid",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.miappid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "miappid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hmsid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.hmsid),
      expression: "formData.hmsid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hmsid",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.hmsid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "hmsid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hmskey")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.hmskey),
      expression: "formData.hmskey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hmskey",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.hmskey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "hmskey", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c955592", module.exports)
  }
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content domain-section"
  }, [_c('div', {
    staticClass: "col-xs-12 accessory-search-form search-form"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('form', {
    staticClass: "input-group",
    on: {
      "submit": _vm.preventDefault
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.short),
      expression: "short"
    }],
    staticClass: "form-control accessory-search-input",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search short...",
      "id": "search-plugin"
    },
    domProps: {
      "value": (_vm.short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.short = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat accessory-search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "accessory-list-overall"
    }, [_c('div', [_c('div', {
      staticClass: "box box-solid"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('dl', {
      staticClass: "dl-horizontal"
    }, [_c('dt', [_vm._v("Short")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.short))]), _vm._v(" "), _c('dt', [_vm._v("Content Type")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.contenttype))]), _vm._v(" "), _c('dt', [_vm._v("Content")]), _vm._v(" "), _c('dd', [_c('pre', [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('dt', [_vm._v("Action")]), _vm._v(" "), _c('dd', [_c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleEdit(item)
        }
      }
    }, [_vm._v("Edit")])])])])])])])
  })], 2)]), _vm._v(" "), _c('domain-form-modal', {
    ref: "modalEdit",
    attrs: {
      "type": "edit",
      "fetch": _vm.fetch
    }
  }), _vm._v(" "), _c('domain-form-modal', {
    ref: "modalCreate",
    attrs: {
      "type": "create",
      "fetch": _vm.fetch
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminInApp),
      expression: "isAdminInApp"
    }],
    staticClass: "add-app-bgcolor dropup"
  }, [_c('button', {
    staticClass: "add-app-btn",
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._m(2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("Sorry, no matching results.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Domain")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dfe1a00", module.exports)
  }
}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })]), _vm._v(" "), _c('h4', [_vm._v("Loading")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61766d91", module.exports)
  }
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "deviceuserlist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.userList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "agent-list",
      attrs: {
        "value": _vm.userList
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.photo == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(23)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.photo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('span', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.uid))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isShowDevice),
        expression: "!item.isShowDevice"
      }],
      staticClass: "device-user-list-devicename",
      attrs: {
        "id": item.uid + 'showdevicebtn'
      }
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreDevice(item.uid, index)
        }
      }
    }, [_vm._v("show the binding device")])]), _vm._v(" "), _vm._l((item.devices), function(device) {
      return _c('div', {
        key: device.deviceid,
        staticClass: "row",
        attrs: {
          "id": item.uid
        }
      }, [_c('p', {
        staticClass: "col-sm-11 col-xs-10 device-user-list-show-device-name-mar device-user-list-show-device-name-go-to",
        attrs: {
          "id": item.uid + 'devicelist'
        },
        on: {
          "click": function($event) {
            _vm.toSearchDevice(device.devicename, device.deviceid)
          }
        }
      }, [_vm._v("\n            " + _vm._s(device.devicename) + "\n            "), _c('span', {
        staticClass: "device-user-list-show-device-id"
      }, [_vm._v("\n              (\n              "), _c('span', [_vm._v(_vm._s(device.deviceid))]), _vm._v(" )\n            ")])]), _vm._v(" "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.toGetDevice(index)),
          expression: "toGetDevice(index)"
        }],
        staticClass: "btn btn-xs btn-default pull-right col-sm-1 col-xs-2 device-user-list-show-device-name-mar",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#device-user-list-set-device"
        },
        on: {
          "click": function($event) {
            _vm.toShowDevicePermission(device, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit (alias)"
      })])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isShowNone),
        expression: "item.isShowNone"
      }],
      staticClass: "row",
      attrs: {
        "id": item.uid + 'emptydevice'
      }
    }, [_vm._m(1, true)])], 2), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
    }, [_c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modal-user-add-device"
      },
      on: {
        "click": function($event) {
          _vm.toAddDevice(item.uid)
        }
      }
    }, [_vm._v("Add Device")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm btn-device-user-list-setting pull-right",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modal-user-profile"
      },
      on: {
        "click": function($event) {
          _vm.toProfile(item, index)
        }
      }
    }, [_vm._v("Profile")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-app-bgcolor",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-new-a-device-user"
    },
    on: {
      "click": _vm.toAddUser
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-user-profile"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_vm._m(4), _vm._v(" "), (_vm.currentProfileUser.photo == '') ? _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": __webpack_require__(23)
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.currentProfileUser.photo
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.currentProfileUser.uid))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_password",
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": _vm.currentProfileUser.password
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": _vm.currentProfileUser.mail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_phone",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": _vm.getPhone(_vm.currentProfileUser.phone)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('select', {
    staticClass: "btn btn-warning modal-user-profile-area-code",
    attrs: {
      "id": "current_phone_zone"
    },
    domProps: {
      "value": _vm.getPhoneZone(_vm.currentProfileUser.phone)
    }
  }, _vm._l((_vm.phonezonelist), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": _vm.phonezonelist[index]
      }
    }, [_vm._v(_vm._s(_vm.phonezonelist[index] + ' ' + _vm.phonezonaname[index]))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-user-add-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(8), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n            Add Device\n            "), _c('i', {
    staticClass: "fa fa-angle-right modal-device-user-title-name"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentAddDevice.uid))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row modal-user-setting-add-device-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 modal-user-setting-table-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDevice.deviceid),
      expression: "currentAddDevice.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input the Device ID"
    },
    domProps: {
      "value": (_vm.currentAddDevice.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDevice, "deviceid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-user-setting-auth-add"
  }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDevice.permission),
      expression: "currentAddDevice.permission"
    }],
    staticClass: "choose-existing-agent-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddDevice, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Guest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoAddDevice
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "device-user-list-set-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(10), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n            Authority Management\n            "), _c('i', {
    staticClass: "fa fa-angle-right modal-device-user-title-name"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentUserDeviceSetting.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row modal-user-setting-add-device-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 modal-user-setting-table-input"
  }, [_c('p', {
    staticClass: "device-user-list-show-device-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentUserDeviceSetting.devicename) + "\n                  "), _c('span', {
    staticClass: "device-user-list-show-device-id"
  }, [_vm._v("(" + _vm._s(_vm.currentUserDeviceSetting.deviceid) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-user-setting-auth-add modal-user-setting-auth-sel"
  }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
    staticClass: "choose-existing-agent-select",
    attrs: {
      "id": "change_device_permission"
    },
    domProps: {
      "value": _vm.currentUserDeviceSetting.permission
    }
  }, [_c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Guest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Unbind")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(12), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toUnbindUser
    }
  }, [_vm._v("Unbind")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toChangPermission
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-a-device-user"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.uid),
      expression: "currentAddDeviceUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "User ID"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.password),
      expression: "currentAddDeviceUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Keep the default password(123456)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.mail),
      expression: "currentAddDeviceUser.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "(Optional)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "mail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Mobile Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.phone),
      expression: "currentAddDeviceUser.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "(Optional)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-device-user-area-code"
  }, [_c('select', {
    staticClass: "btn btn-warning modal-user-profile-area-code",
    attrs: {
      "id": ""
    },
    domProps: {
      "value": _vm.getPhoneZone(_vm.currentProfileUser.phone)
    }
  }, _vm._l((_vm.phonezonelist), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": _vm.phonezonelist[index]
      }
    }, [_vm._v(_vm._s(_vm.phonezonelist[index] + ' ' + _vm.phonezonaname[index]))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoAddUser
    }
  }, [_vm._v("Save changes")])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("This user is maybe not registered on this platform.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-xs-11 device-user-list-show-device-name"
  }, [_c('span', {
    staticClass: "device-user-list-show-device-id"
  }, [_vm._v("none")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn"
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("User Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-self-profile-upload-head modal-user-profile-head-input"
  }, [_c('input')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon modal-user-profile-content-icon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-desktop modal-user-setting-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to unbind?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New a Device User")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62a22ffd", module.exports)
  }
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content newsweekly"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 center-box"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleDownload(item)
        }
      }
    }, [_vm._v("Download")])])])
  })], 2)])])])])])]), _vm._v(" "), (_vm.isAdminInApp) ? _c('div', {
    staticClass: "add-app-bgcolor dropup"
  }, [_c('button', {
    staticClass: "add-app-btn",
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._m(2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("News Weekly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "td-right"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62bc1d91", module.exports)
  }
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('update-logs', {
    attrs: {
      "path": "getmobileclients",
      "type": "mobileclients"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6312dd9c", module.exports)
  }
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleUpgrade
    }
  }, [_vm._v("Upgrade")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$route.query.appid),
      expression: "$route.query.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.$route.query.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$route.query, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Device ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$route.query.deviceid),
      expression: "$route.query.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.$route.query.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$route.query, "deviceid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.url),
      expression: "formData.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "url",
      "placeholder": "url"
    },
    domProps: {
      "value": (_vm.formData.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Upper MD5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.uppermd5),
      expression: "formData.uppermd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "uppermd5",
      "placeholder": "uppermd5"
    },
    domProps: {
      "value": (_vm.formData.uppermd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "uppermd5", $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-646e3d4c", module.exports)
  }
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "login-page hold-transition"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Login to start your session")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.togetOnlyId($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-user form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-lock form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVerCode),
      expression: "isShowVerCode"
    }],
    staticClass: "form-group has-feedback"
  }, [_c('p', {
    staticClass: "verification-code-tips"
  }, [_vm._v("\n              The verification code has been sent to\n              "), _c('strong', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailcode),
      expression: "emailcode"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "emailcode",
      "placeholder": "Verification Code"
    },
    domProps: {
      "value": (_vm.emailcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-purple login-response-word"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('b', [_vm._v("Dinsafer")]), _vm._v("Admin\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat btn-login-purple",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68292f04", module.exports)
  }
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuperAdmin),
      expression: "isSuperAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('apns-relation-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-682f488c", module.exports)
  }
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.version),
      expression: "formData.version"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Version",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Addontypeid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.addontypeid),
      expression: "formData.addontypeid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Addontypeid",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.addontypeid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "addontypeid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.url),
      expression: "formData.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Url",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Md5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.md5),
      expression: "formData.md5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Md5",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.md5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "md5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Addontype")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.addontype),
      expression: "formData.addontype"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Addontype",
      "disabled": !_vm.isSuperAdmin
    },
    domProps: {
      "value": (_vm.formData.addontype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "addontype", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-69552f8a", module.exports)
  }
}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade in"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title) + " OAuth2")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.isEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "ID",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Secret")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.secret),
      expression: "formData.secret"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Secret",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.secret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "secret", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("App Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appname),
      expression: "formData.appname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "App Name"
    },
    domProps: {
      "value": (_vm.formData.appname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Domain")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.domain),
      expression: "formData.domain"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Domain"
    },
    domProps: {
      "value": (_vm.formData.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "domain", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Delete OAuth2")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to delete ?\n          ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70f49599", module.exports)
  }
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('app-data-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-725a63a0", module.exports)
  }
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.macRobotList.length > 0),
      expression: "macRobotList.length>0"
    }],
    staticClass: "robot-list-type"
  }, [_vm._v("Mac Robot")]), _vm._v(" "), _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      staticClass: "agent-list"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.icon == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()]), _vm._v(" "), (item.task > 0) ? _c('div', {
      staticClass: "col-lg-10 col-md-9 col-sm-9 col-xs-8"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$route.query.appname) + " - v" + _vm._s(item.currentVersion) + " build " + _vm._s(item.currentBuild) + " (" + _vm._s(_vm._f("formatDate")(item.currentTime / 1000000)) + ")")]), _vm._v(" "), _c('p', {
      staticClass: "robot-list-task-wait"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack"
    }), _vm._v("  "), _c('span', {
      staticClass: "robot-list-task-num"
    }, [_vm._v(_vm._s(item.task - 1))]), _vm._v(" task waiting...")])]) : _vm._e()])])])
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deviceRobotList.length > 0),
      expression: "deviceRobotList.length>0"
    }],
    staticClass: "robot-list-type"
  }, [_vm._v("Device Robot")]), _vm._v(" "), _vm._l((_vm.deviceRobotList), function(item) {
    return _c('div', {
      staticClass: "agent-list"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.icon == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()]), _vm._v(" "), (item.task > 0) ? _c('div', {
      staticClass: "col-lg-10 col-md-9 col-sm-9 col-xs-8"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$route.query.appname) + " - v" + _vm._s(item.currentVersion) + " build " + _vm._s(item.currentBuild) + " (" + _vm._s(_vm._f("formatDate")(item.currentTime / 1000000)) + ")")]), _vm._v(" "), _c('p', {
      staticClass: "robot-list-task-wait"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack"
    }), _vm._v("  "), _c('span', {
      staticClass: "robot-list-task-num"
    }, [_vm._v(_vm._s(item.task - 1))]), _vm._v(" task waiting...")])]) : _vm._e()])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7579bcc8", module.exports)
  }
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "name",
      "placeholder": "name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "description",
      "placeholder": "description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.version),
      expression: "formData.version"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "version",
      "placeholder": "version"
    },
    domProps: {
      "value": (_vm.formData.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("No8version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.no8version),
      expression: "formData.no8version"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "no8version",
      "placeholder": "no8version"
    },
    domProps: {
      "value": (_vm.formData.no8version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "no8version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Uppermd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.uppermd5),
      expression: "formData.uppermd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "uppermd5",
      "placeholder": "uppermd5"
    },
    domProps: {
      "value": (_vm.formData.uppermd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "uppermd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Upperurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.upperurl),
      expression: "formData.upperurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "upperurl",
      "placeholder": "upperurl"
    },
    domProps: {
      "value": (_vm.formData.upperurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "upperurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowermd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowermd5),
      expression: "formData.lowermd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowermd5",
      "placeholder": "lowermd5"
    },
    domProps: {
      "value": (_vm.formData.lowermd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowermd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowerurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowerurl),
      expression: "formData.lowerurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowerurl",
      "placeholder": "lowerurl"
    },
    domProps: {
      "value": (_vm.formData.lowerurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowerurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowermd5nostm8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowermd5nostm8),
      expression: "formData.lowermd5nostm8"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowermd5nostm8",
      "placeholder": "lowermd5nostm8"
    },
    domProps: {
      "value": (_vm.formData.lowermd5nostm8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowermd5nostm8", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowerurlnostm8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowerurlnostm8),
      expression: "formData.lowerurlnostm8"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowerurlnostm8",
      "placeholder": "lowerurlnostm8"
    },
    domProps: {
      "value": (_vm.formData.lowerurlnostm8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowerurlnostm8", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logic")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.logic),
      expression: "formData.logic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "logic",
      "placeholder": "logic"
    },
    domProps: {
      "value": (_vm.formData.logic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "logic", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75d19574", module.exports)
  }
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('update-logs', {
    attrs: {
      "path": "getmasterslaves",
      "type": "masterslaves"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-796f8f72", module.exports)
  }
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, _vm._l((_vm.userList), function(item) {
    return _c('div', {
      key: item.uid,
      staticClass: "agent-list"
    }, [_c('h4', [_vm._v("\n        " + _vm._s(item.uid) + "\n        "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "agent-list-id"
    }, [_vm._v("\n          ( id_\n          "), _c('span', [_vm._v("xjioa355bhhd")]), _vm._v(" )\n        ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.uid == _vm.$router.app.$store.state.user.uid),
        expression: "item.uid == $router.app.$store.state.user.uid "
      }],
      staticClass: "badge agent-list-badge"
    }, [_vm._v("Me")]), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
      staticClass: "btn btn-warning btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleEditPrivilege(item)
        }
      }
    }, [_vm._v("Privileges")]) : _vm._e(), _vm._v(" "), (item.permission < _vm.currentUserPermission || _vm.$router.app.$store.state.user.pm > 888) ? _c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.toEditUser(item)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e()]), _vm._v(" "), (item.permission >= 888) ? _c('span', [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" Admin\n      ")]) : _c('span', [_c('i', {
      staticClass: "fa fa-star-o"
    }), _vm._v(" User\n      ")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminInApp),
      expression: "isAdminInApp"
    }],
    staticClass: "add-app-bgcolor dropup"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right add-btn-dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-existing-agent"
    },
    on: {
      "click": _vm.toGetExistUser
    }
  }, [_vm._v("Add Existing Agents")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.toShowNewUserModal
    }
  }, [_vm._v("New An Agent")])])])]), _vm._v(" "), _c('privilege-modal', {
    ref: "privilegeModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-edit-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Agent ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.uid),
      expression: "editUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Agent uid",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.password),
      expression: "editUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": (_vm.editUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.email),
      expression: "editUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "E-mail Address..."
    },
    domProps: {
      "value": (_vm.editUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), (_vm.$router.app.$store.state.user.pm > 888) ? _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.permission),
      expression: "editUser.permission"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])]) : _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.permission),
      expression: "editUser.permission"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Delete Agent")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toDeleteUser
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-an-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Agent ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.uid),
      expression: "newUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.currentUserPermission > 888) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-existing-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "choose-existing-agent-table table-striped"
  }, _vm._l((_vm.existedUser), function(item) {
    return _c('tbody', {
      key: item.uid
    }, [_c('tr', {
      staticClass: "choose-existing-agent-row",
      attrs: {
        "role": "row"
      }
    }, [(item.hasAdd == true) ? _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox",
        "checked": "",
        "disabled": ""
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]) : (item.isCheck == true) ? _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]) : _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', [_vm._v("Agent ID: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.uid))])]), _vm._v(" "), (_vm.$router.app.$store.state.user.pm > 888 && item.hasAdd != true) ? _c('td', {
      staticClass: "col-xs-5"
    }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.permission),
        expression: "item.permission"
      }],
      staticClass: "choose-existing-agent-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])]) : _c('td', {
      staticClass: "col-xs-5"
    }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.permission),
        expression: "item.permission"
      }],
      staticClass: "choose-existing-agent-select",
      attrs: {
        "disabled": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSelectAll),
      expression: "!isSelectAll"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSelectAllExistUser
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelectAll),
      expression: "isSelectAll"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSelectAllExistUser
    }
  }, [_vm._v("DeSelect All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toAddExistUser
    }
  }, [_vm._v("Save changes")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Agent's Authority")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to delete ?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Agent's Authority")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Existing Agents")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dff9c0e", module.exports)
  }
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('analysis-chart', {
    attrs: {
      "type": "monthly",
      "path": "connectionanalysis",
      "title": "Device Connection Counts (Last Year)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "deviceid",
      "path": "deviceconnectcountsanalysis",
      "title": "Device Connection Counts"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "daily",
      "path": "dailyactivationanalysis",
      "title": "Device Daily Activation Counts (Last 30 Days)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "monthly",
      "path": "monthlyactivationanalysis",
      "title": "Device Monthly Activation Counts (Last Year)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "duration",
      "path": "disconnectdurationanalysis",
      "title": "Device Disconnect Durations"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Analysis")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80fb67d4", module.exports)
  }
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "btn-group version-manage-dropdown-btn",
    attrs: {
      "id": "version-list-popmenu"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle version-manage-dropdown",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.currentVersion.versionname))]), _vm._v(" "), _c('span', {
    staticClass: "caret pull-right version-manage-dropdown-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu version-manage-dropdown",
    attrs: {
      "id": "version-list-pop-menu"
    }
  }, [_c('li', {
    attrs: {
      "data-target": "#modal-new-version"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._l((_vm.versionList), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectVersoin(index)
        }
      }
    }, [_vm._v(_vm._s(item.versionname))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "version-manage-dropdown-more",
    on: {
      "click": function($event) {
        _vm.toLoadMoreVersion(_vm.currentVersoinPage)
      }
    }
  }, [_vm._v("\n            More   \n            "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length > 0),
      expression: "versionList.length>0"
    }],
    staticClass: "version-manage-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.currentVersion.GeneralSetting.StageSupport), function(item) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 version-manage-stage-margin"
    }, [_c('div', {
      class: _vm.getStageClassByTypeId(item)
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('span', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(_vm.getNameByTypeId(item)))]), _vm._v(" "), _c('span', {
      class: _vm.getStageLogClassByTypeId(item),
      on: {
        "click": function($event) {
          _vm.toShowLog(item)
        }
      }
    }, [_vm._v("Log")])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "btn-group version-manage-box-body-dropdown"
    }, [(item !== 'S3') ? _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "caret pull-right version-manage-dropdown-icon"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu version-manage-dropdown version-manage-box-body-dropdown-btn"
    }, [_c('li', {
      attrs: {
        "data-target": "#modal-new-version"
      },
      on: {
        "click": function($event) {
          _vm.toNewBuild(item)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _vm._l((_vm.getBuildlistById(item)), function(b, index) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.selectBuild(item, index)
          }
        }
      }, [_vm._v("build " + _vm._s(b.buildnumber) + " (" + _vm._s(_vm._f("formatDate")(b.time / 1000000)) + ")")])])
    }), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "version-manage-dropdown-more",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreBuild(item)
        }
      }
    }, [_vm._v("\n                        More   \n                        "), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])])], 2)]) : _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
      staticClass: "version-manage-comment"
    }, [_c('div', {
      class: _vm.currentStageBuild[item].result === 1 ? 'version-manage-build-state gone' : 'version-manage-build-state'
    }, [_c('p', [_c('i', {
      class: _vm.getBuildStageClassByTypeId(_vm.currentStageBuild[item].result)
    }), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.getState(_vm.currentStageBuild[item].result)) + "\n                  ")])]), _vm._v(" "), _c('p', {
      class: _vm.emptyToInVisibiliy(_vm.currentStageBuild[item].comment, 'version-manage-stage-comment')
    }, [_vm._v(_vm._s(_vm.currentStageBuild[item].comment))])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "version-manage-button"
    }, [(item !== 'S3') ? _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowDownload(item)
        }
      }
    }, [_vm._v("Download App")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentBuildList[item].length > 0 ?
            _vm.toSendDingDing(item) : _vm.toNewBuild(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.currentBuildList[item].length > 0 ?
      '发送钉钉通知' : 'New Build') + "\n                  ")])]) : _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toDoPublishClick(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnText(item)))]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toSendDingDing(item)
        }
      }
    }, [_vm._v("发送钉钉通知")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "version-manage-log"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionDevelopLog",
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": _vm.currentVersion.developlog
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Publish Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionReleaseLog",
      "placeholder": "Publish log..."
    },
    domProps: {
      "value": _vm.currentVersion.releaselog
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length <= 0),
      expression: "versionList.length<=0"
    }]
  }, [_c('p', {
    staticClass: "large_title"
  }, [_vm._v("There's no version!")]), _vm._v(" "), _c('div', {
    staticClass: "version-manage-new-version"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   New Version\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-version"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Version Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_name),
      expression: "newversion_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "version number"
    },
    domProps: {
      "value": (_vm.newversion_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developlog),
      expression: "newversion_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "develop log..."
    },
    domProps: {
      "value": (_vm.newversion_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developshell),
      expression: "newversion_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developshell = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("API")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_releaseshell),
      expression: "newversion_releaseshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_releaseshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_releaseshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("New Version")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu alert-del pull-right"
  }, [_vm._m(5), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default pull-left"
  }, [_vm._v("Not Sure")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right",
    on: {
      "click": _vm.toDoNewVersion
    }
  }, [_vm._v("Confirm")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-build"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newbuild_robotid),
        expression: "newbuild_robotid"
      }],
      staticClass: "modal-dialog-sendto-robotpick-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.newbuild_robotid, item.id)
      },
      on: {
        "change": function($event) {
          _vm.newbuild_robotid = item.id
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-3"
    }, [(!item.icon) ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developlog),
      expression: "newbuild_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "develop log..."
    },
    domProps: {
      "value": (_vm.newbuild_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Shell")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developshell),
      expression: "newbuild_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newbuild_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoNewBuild
    }
  }, [_vm._v("New Build")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-shell"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.shellDialogContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-download"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), (_vm.downloadLink) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('qrcode', {
    staticStyle: {
      "margin-left": "31%"
    },
    attrs: {
      "value": _vm.downloadLink,
      "options": {
        width: 200
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p add-agent-choose"
  }, [_c('a', {
    on: {
      "click": _vm.toDownloadLink
    }
  }, [_vm._v(_vm._s(_vm.downloadLink))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-log"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.logDialogCurrentContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Version\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Build\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-manage-stage-more invisibiliy"
  }, [_vm._v("\n                more   \n                "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("\n                Please confirm that the datas below in\n                "), _c('strong', [_vm._v("Shell Configuration")]), _vm._v(" are filled in correctly :\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm"
  }, [_vm._v("development branch")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("Application id")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm-down"
  }, [_vm._v("jPush key")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Build")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Download App")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RealTime LogCat")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88566bfe", module.exports)
  }
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "upload-appicon upload-appicon-information-noicon",
    attrs: {
      "title": _vm.formData.appicon ? 'Upload app icon' : 'Edit'
    }
  }, [(!_vm.formData.appicon) ? _c('i', {
    staticClass: "fa fa-plus"
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.isUploading
    },
    on: {
      "change": function($event) {
        _vm.uploadfile($event)
      }
    }
  })]), _vm._v(" "), (_vm.formData.appicon) ? _c('img', {
    staticClass: "information-appicon",
    attrs: {
      "title": "APP icon",
      "name": "appicon",
      "src": 'https://d.din.bz/' + _vm.formData.appicon
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progress > 0),
      expression: "progress > 0"
    }],
    staticClass: "upload-progress-bar"
  }, [_c('div', {
    staticClass: "progress progress-xxs active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% Complete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "information-content"
  }, [(_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP Keys")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appkeys),
      expression: "formData.appkeys"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "App Keys",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appkeys)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appkeys", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP Secret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appsecret),
      expression: "formData.appsecret"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "App Secret",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appsecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appsecret", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appname),
      expression: "formData.appname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appname",
      "placeholder": "Suggest fill out the client app name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.appname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.oemname),
      expression: "formData.oemname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "oemname",
      "placeholder": "OEM name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.oemname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "oemname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Description",
      "name": "description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Auto-reply email account")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appemail),
      expression: "formData.appemail"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appemail",
      "placeholder": "Email Account"
    },
    domProps: {
      "value": (_vm.formData.appemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appemail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appemailpassword),
      expression: "formData.appemailpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appemailpassword",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.formData.appemailpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appemailpassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("About us")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.aboutme),
      expression: "formData.aboutme"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "aboutme",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.aboutme)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "aboutme", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("A website for jumping to after verifying the verification email to show the binding process is successful")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.confirmemail),
      expression: "formData.confirmemail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.confirmemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "confirmemail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Help")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.helpurl),
      expression: "formData.helpurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "helpurl",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.helpurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "helpurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("User privacy policy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.policy),
      expression: "formData.policy"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "policy",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contact ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.contactid),
      expression: "formData.contactid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "contactid",
      "placeholder": "Contact ID Key"
    },
    domProps: {
      "value": (_vm.formData.contactid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "contactid", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("SMS Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.smsconfString),
      expression: "formData.smsconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "smsconf"
    },
    domProps: {
      "value": (_vm.formData.smsconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "smsconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("jPush Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.jpushconfString),
      expression: "formData.jpushconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isAdmin,
      "name": "jpushconf",
      "placeholder": "{}"
    },
    domProps: {
      "value": (_vm.formData.jpushconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "jpushconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mail Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mailconfString),
      expression: "formData.mailconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "mailconf"
    },
    domProps: {
      "value": (_vm.formData.mailconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mailconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.feedbackmail),
      expression: "formData.feedbackmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Feedbackmail",
      "name": "feedbackmail",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.feedbackmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "feedbackmail", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Allowips")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.allowipsString),
      expression: "formData.allowipsString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Allowips",
      "name": "allowips"
    },
    domProps: {
      "value": (_vm.formData.allowipsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "allowipsString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Shareside")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.shareside),
      expression: "formData.shareside"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Shareside",
      "name": "shareside"
    },
    domProps: {
      "value": (_vm.formData.shareside)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "shareside", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Payside")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.payside),
      expression: "formData.payside"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Payside",
      "name": "payside"
    },
    domProps: {
      "value": (_vm.formData.payside)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "payside", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pay Contacts (using multiple lines for multiple contacts)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.paycontactsString),
      expression: "formData.paycontactsString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Pay Contact",
      "name": "paycontacts"
    },
    domProps: {
      "value": (_vm.formData.paycontactsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "paycontactsString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.notificationconfString),
      expression: "formData.notificationconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "notificationconf",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.notificationconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "notificationconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RDA URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.rdaurl),
      expression: "formData.rdaurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "RDA URL",
      "name": "rdaurl"
    },
    domProps: {
      "value": (_vm.formData.rdaurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "rdaurl", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ghome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.ghome),
      expression: "formData.ghome"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.isAdmin,
      "placeholder": "Ghome",
      "name": "ghome"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.formData.ghome) ? _vm._i(_vm.formData.ghome, 1) > -1 : (_vm.formData.ghome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formData.ghome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formData, "ghome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formData, "ghome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formData, "ghome", $$c)
        }
      }
    }
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        APP Name\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        OEM Name\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        Feedback Mail\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        Notification Conf\n        "), _c('em', [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-968f34c8", module.exports)
  }
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.offlineClass),
      expression: "!offlineClass"
    }],
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Device Offline !")]), _vm._v(" "), _c('p', [_vm._v("Some data of the device could not be set or query.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.offlineClass ? 'col-xs-12' : 'col-xs-12 device-offline-class'
  }, [_vm._m(0)])]), _vm._v(" "), (_vm.offlineClass) ? _c('div', {
    staticClass: "row security-state-row"
  }, [_c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 0 ? 'btn btn-default security-state-btn1-active' : 'btn btn-default security-state-btn1',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toSetSecurityState('Arm')
      }
    }
  }, [_vm._v("Arm")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 2 ? 'btn btn-default security-state-btn2-active' : 'btn btn-default security-state-btn2',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toSetSecurityState('Disarm')
      }
    }
  }, [_vm._v("Disarm")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 1 ? 'btn btn-default security-state-btn3-active' : 'btn btn-default security-state-btn3',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toSetSecurityState('Home Arm')
      }
    }
  }, [_vm._v("Home Arm")])])]) : _c('div', {
    staticClass: "row security-state-row device-offline-class"
  }, [_c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 0 ? 'btn btn-default security-state-btn1-active security-state-btn-disabled' : 'btn btn-default security-state-btn1 security-state-btn-disabled',
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Arm")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 2 ? 'btn btn-default security-state-btn2-active security-state-btn-disabled' : 'btn btn-default security-state-btn2 security-state-btn-disabled',
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Disarm")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 security-state-div"
  }, [_c('button', {
    class: _vm.deviceData.deviceState == 1 ? 'btn btn-default security-state-btn3-active security-state-btn-disabled' : 'btn btn-default security-state-btn3 security-state-btn-disabled',
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Home Arm")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-security-state"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('p', [_vm._v("\n                Do you really want to set the security state as \n                "), _c('span', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v(_vm._s(_vm.deviceCmd))]), _vm._v(" ?\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toSendCmd()
      }
    }
  }, [_vm._v("Yes, I do.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.offlineClass ? 'col-md-6 col-xs-12' : 'col-md-6 col-xs-12 device-offline-class'
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tr', [_vm._m(2), _vm._v(" "), (_vm.deviceData.nettype === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [(_vm.deviceData.nettype === 0) ? _c('span', [_vm._v("LAN")]) : _c('span', [_vm._v("Wifi")])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), (_vm.deviceData.power === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [_vm._v("\n              " + _vm._s(_vm.deviceData.power) + "\n              "), (_vm.deviceData.ischarge) ? _c('span', [_vm._v("- charging")]) : _c('span', [_vm._v("- battery")])])]), _vm._v(" "), (_vm.offlineClass) ? _c('tr', [_vm._m(4), _vm._v(" "), (_vm.deviceData.sim === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : (_vm.deviceData.sim === 0) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("have no card")])]) : (_vm.deviceData.sim === 1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("normal")])]) : _c('td', {
    staticClass: "device-information-table-content sim-data-wrong",
    on: {
      "click": _vm.toCheckSimDetail
    }
  }, [_vm._m(5)])]) : _c('tr', [_vm._m(6), _vm._v(" "), (_vm.deviceData.sim === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : (_vm.deviceData.sim === 0) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("have no card")])]) : (_vm.deviceData.sim === 1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("normal")])]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("something wrong")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-sim-detail"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('table', {
    staticClass: "center sim-card-detail-table"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+CSQ 信号质量:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.csq))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+CREG 网络注册信息:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.creg))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+CGSN imei:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.cgsn))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+CIMI imsi:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.cimi))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+CPIN cpin:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.cpin))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AT+COPS 运营商:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.simDetail.cops))])])])])]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tr', [_vm._m(9), _vm._v(" "), (_vm.deviceData.ipaddress === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [_vm._v(_vm._s(_vm.deviceData.ipaddress))])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), (_vm.deviceData.activetime > 0) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.deviceData.activetime / 1000000)))]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), (_vm.deviceData.version === -1) ? _c('td', {
    staticClass: "device-information-table-content"
  }, [_c('span', [_vm._v("-")])]) : _c('td', {
    staticClass: "device-information-table-content"
  }, [_vm._v(_vm._s(_vm.deviceData.version))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-danger"
  }, [_c('table', {
    staticClass: "device-information-table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title",
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-group (alias) device-information-table-icon"
  }), _vm._v("member\n                "), (_vm.isShowUserEmptyList) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("total: 0")]) : _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("total: " + _vm._s(_vm.deviceData.totaluses))])])])]), _vm._v(" "), _c('tbody', [(_vm.isShowUserEmptyList) ? _c('tr', [_vm._m(12)]) : _vm._l((_vm.deviceData.users), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "aboutdevice-user-list",
      attrs: {
        "colspan": "4"
      },
      on: {
        "click": function($event) {
          _vm.toSearchUser(item.uid)
        }
      }
    }, [(item.photo == '') ? _c('img', {
      staticClass: "aboutdevice-user-list-img",
      attrs: {
        "src": __webpack_require__(23)
      }
    }) : _c('img', {
      staticClass: "aboutdevice-user-list-img",
      attrs: {
        "src": 'https://d.din.bz/' + item.photo
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "aboutdevice-user-list-username"
    }, [_vm._v(_vm._s(item.uid))]), _vm._v(" "), (item.permission === 30) ? _c('span', {
      staticClass: "aboutdevice-user-list-authority pull-right"
    }, [_vm._v("admin")]) : (item.permission === 20) ? _c('span', {
      staticClass: "aboutdevice-user-list-authority pull-right"
    }, [_vm._v("user")]) : _c('span', {
      staticClass: "aboutdevice-user-list-authority pull-right"
    }, [_vm._v("guest")])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('table', {
    staticClass: "device-information-table table-hover"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [(_vm.isShowPluginEmptyList) ? _c('tr', [_vm._m(14)]) : _vm._l((_vm.deviceData.plugin), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "aboutdevice-user-list",
      attrs: {
        "colspan": "4"
      },
      on: {
        "click": function($event) {
          _vm.toSearchPlugin(item.id)
        }
      }
    }, [(!item.icon) ? _c('img', {
      staticClass: "aboutdevice-user-list-img",
      attrs: {
        "src": __webpack_require__(65)
      }
    }) : _c('img', {
      staticClass: "aboutdevice-user-list-img",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "aboutdevice-user-list-username"
    }, [_vm._v(_vm._s(item.prename))]), _vm._v(" "), _c('span', {
      staticClass: "aboutdevice-user-list-authority pull-right"
    }, [_vm._v(_vm._s(item.id))])])])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "box-title"
  }, [_vm._v("Network Status of Device")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('canvas', {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "id": "areaChart"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Set Security State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-at device-information-table-icon"
  }), _vm._v("\n              internet connection\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-battery-three-quarters device-information-table-icon"
  }), _vm._v("\n              power situation\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-signal device-information-table-icon"
  }), _vm._v("\n              sim card status\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n                something wrong\n                "), _c('i', {
    staticClass: "fa fa-question-circle pull-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-signal device-information-table-icon"
  }), _vm._v("\n              sim card status\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Sim Card Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Got it"
    }
  }, [_vm._v("Got it")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-globe device-information-table-icon"
  }), _vm._v("\n              country/region\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-calendar device-information-table-icon"
  }), _vm._v("\n              activation time\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "device-information-table-title"
  }, [_c('i', {
    staticClass: "fa fa-gears (alias) device-information-table-icon"
  }), _vm._v("\n              firmware version\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "aboutdevice-user-list",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "aboutdevice-user-list-username"
  }, [_vm._v("There is no member in this device.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title",
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes device-information-table-icon"
  }), _vm._v("accessory\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "aboutdevice-user-list",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "aboutdevice-user-list-username"
  }, [_vm._v("There is no plugin in this device.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-987fc992", module.exports)
  }
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "eventlist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "agent-list",
      attrs: {
        "value": _vm.list
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.photo == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(23)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.photo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.user))]), _vm._v(" "), _c('p', {
      staticClass: "device-user-list-devicename"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.time)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(item.cmdname)))])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("No event found.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae480c68", module.exports)
  }
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    on: {
      "mouseenter": _vm.checkShowViewFont
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path == '/'),
      expression: "$route.path == '/'"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Project")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInformation),
      expression: "isShowInformation"
    }],
    class: _vm.$route.path === '/information' ? 'treeview active' : 'treeview'
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Information")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInformation),
      expression: "isShowInformation"
    }],
    class: _vm.$route.path === '/information' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/app?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-adn"
  }), _vm._v(" App\n        ")])], 1), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/devicetypes' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/devicetypes',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v(" DeviceTypes\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/deviceaddon' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/deviceaddon',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece"
  }), _vm._v(" DeviceAddon\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/deviceaddonclient' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/deviceaddonclient',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" DeviceAddonClient\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/apnsrelation' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/apnsrelation',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Apns Relation\n        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAddApp),
      expression: "isShowAddApp"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/addapp"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Add App")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAdmin),
      expression: "isShowAdmin"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/agent?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Administrator")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowAboutDevice && _vm.$route.path != '/' && !_vm.isShowAddApp),
      expression: "!isShowAboutDevice&&$route.path!='/'&&!isShowAddApp"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/device?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Device")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAboutDevice),
      expression: "isShowAboutDevice"
    }],
    staticClass: "treeview active",
    attrs: {
      "id": "devicetreeview"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toDevice
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Device")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu active",
    attrs: {
      "id": "devicetreemenu"
    }
  }, [_c('li', {
    class: _vm.$route.path === '/aboutdevice' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/aboutdevice?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database active"
  }), _vm._v(" About Device\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/parametersetting' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/parametersetting?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Parameter Setting\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentAdmin),
      expression: "isAgentAdmin"
    }],
    class: _vm.$route.path === '/eventlist' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/eventlist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" Event List\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminAndHasAppid),
      expression: "isAdminAndHasAppid"
    }],
    class: _vm.$route.path === '/deviceupgrade' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/deviceupgrade?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upgrade\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminAndHasAppid),
      expression: "isAdminAndHasAppid"
    }],
    class: _vm.$route.path === '/devicelog' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/devicelog?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" Log\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/device?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" Log\n        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowProblemDevices),
      expression: "isShowProblemDevices"
    }],
    class: _vm.$route.path === '/problemdevicelist' ? 'active' : '',
    attrs: {
      "to": {
        path: '/problemdevicelist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Problem Devices")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUser),
      expression: "isShowUser"
    }],
    class: _vm.$route.path === '/deviceuser' ? 'active pageLink' : 'pageLink',
    attrs: {
      "tag": "li",
      "to": {
        path: '/deviceuser?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Device's Member")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccessory),
      expression: "isShowAccessory"
    }],
    class: _vm.$route.path === '/accessory' ? 'active pageLink' : 'pageLink',
    attrs: {
      "tag": "li",
      "to": {
        path: '/accessory?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Accessory")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFeedback),
      expression: "isShowFeedback"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/feedback?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Feedback")])])]), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/oauth2',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-shield"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("OAuth2")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/domain',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Domain")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAnalysis),
      expression: "isShowAnalysis"
    }],
    class: _vm.$route.path === '/analysis' ? 'treeview active' : 'treeview'
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Data Analysis")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTestDeviceAnalysis),
      expression: "isShowTestDeviceAnalysis"
    }],
    class: _vm.$route.path === '/analysis/testdeviceanalysis' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/analysis/testdeviceanalysis?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Test Device Analysis\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/analysis/connection' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/analysis/connection',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Connection Analysis\n        ")])], 1)])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasAppId),
      expression: "hasAppId"
    }],
    class: _vm.$route.path === '/compilation' ? 'treeview active' : 'treeview',
    attrs: {
      "id": "roboottreeview"
    }
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-vimeo"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Version Management")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    attrs: {
      "id": "robottreemenu"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/master' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/master?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up"
  }), _vm._v(" Master\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/android' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/android?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M3'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-android"
  }), _vm._v(" Android\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/ios' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/ios?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M2'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-apple"
  }), _vm._v(" IOS\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/robotlist' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/robotlist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-simplybuilt"
  }), _vm._v(" Robot List\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/compilation/mobileclientsupdatelogs' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/mobileclientsupdatelogs?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Mobile Clients Update Logs\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/compilation/masterslavesupdatelogs' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/masterslavesupdatelogs?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Master / Slave Update Logs\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/generalsetting' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/generalsetting?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Notification Settings\n        ")])], 1)])]), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/dinnewsweekly',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("News Weekly")])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b31df5a0", module.exports)
  }
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("统计目标主机总量："), _c('span', [_vm._v(_vm._s(_vm.testDeviceList.length))]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("因为数据同步的问题，可能在一段时间内，各个统计部分的总量与目标主机总量不相等。")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.online))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.offline))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.nocoap))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.unregister))])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.online + _vm.offline + _vm.nocoap + _vm.unregister))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(6), _vm._v(" "), ((_vm.normal + _vm.problem + _vm.nocard) !== 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('canvas', {
    staticClass: "test-device-analysis-chart",
    attrs: {
      "id": "simCardChart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_vm._m(7), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.normal))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.problem))])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.nocard))])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.normal + _vm.problem + _vm.nocard))])])])])]) : _c('div', {
    staticClass: "box-body"
  }, [_c('p', {
    staticClass: "test-device-analysis-chart-empty"
  }, [_vm._v("There is no data now.")]), _vm._v(" "), _vm._m(10)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Online Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('canvas', {
    staticClass: "test-device-analysis-chart",
    attrs: {
      "id": "areaChart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("online")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-offline"
  }), _vm._v("offline")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("no coap connection")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-minus-circle test-device-analysis-table-icon-unregistered"
  }), _vm._v("unregistered")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Sim Card Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("normal")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-offline"
  }), _vm._v("something wrong")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("have no card")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("normal")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-offline"
  }), _vm._v("something wrong")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("have no card")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c58b9080", module.exports)
  }
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "main",
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box box-warning"
    }, [_c('div', {
      staticClass: "logs-header"
    }, [_c('h1', {
      staticClass: "logs-date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('h2', {
      staticClass: "logs-version"
    }, [_vm._v("\n            (\n            "), _c('strong', [_vm._v(_vm._s(item.platform))]), _vm._v("\n            " + _vm._s(item.versionname) + ")\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "row logs-body data_aggregation_table_margin"
    }, [_c('table', {
      staticClass: "logs-table"
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(item.left.platformName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.right.platformName))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.left, $event, 'developlog')
        }
      }
    }, [_vm._v(_vm._s(item.left.developlog))])]), _vm._v(" "), _c('td', {
      staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.right, $event, 'developlog')
        }
      }
    }, [_vm._v(_vm._s(item.right.developlog))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content logs-note",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.left, $event, 'releaselog')
        }
      }
    }, [_vm._v(_vm._s(item.left.releaselog))])]), _vm._v(" "), _c('td', {
      staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content logs-note",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.right, $event, 'releaselog')
        }
      }
    }, [_vm._v(_vm._s(item.right.releaselog))])])])])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("No update logs found.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c6b36f4a", module.exports)
  }
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleShow
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.handleDismiss
    }
  }, [_vm._v("Dismiss")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "device-log-console-container"
  }, [_c('iframe', {
    ref: "console",
    staticClass: "device-log-console",
    attrs: {
      "frameborder": "0",
      "border": "0",
      "cellspacing": "0"
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c7bf4cfc", module.exports)
  }
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "btn-group version-manage-dropdown-btn",
    attrs: {
      "id": "version-list-popmenu"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle version-manage-dropdown",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.currentVersion.versionname))]), _vm._v(" "), _c('span', {
    staticClass: "caret pull-right version-manage-dropdown-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu version-manage-dropdown",
    attrs: {
      "id": "version-list-pop-menu"
    }
  }, [_c('li', {
    attrs: {
      "data-target": "#modal-new-version"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._l((_vm.versionList), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectVersoin(index)
        }
      }
    }, [_vm._v(_vm._s(item.versionname))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "version-manage-dropdown-more",
    on: {
      "click": function($event) {
        _vm.toLoadMoreVersion(_vm.currentVersoinPage)
      }
    }
  }, [_vm._v("\n            More   \n            "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length > 0),
      expression: "versionList.length>0"
    }],
    staticClass: "version-manage-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.currentVersion.GeneralSetting.StageSupport), function(item) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 version-manage-stage-margin"
    }, [_c('div', {
      class: _vm.getStageClassByTypeId(item)
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('span', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(_vm.getNameByTypeId(item)))]), _vm._v(" "), _c('span', {
      class: _vm.getStageLogClassByTypeId(item),
      on: {
        "click": function($event) {
          _vm.toShowLog(item)
        }
      }
    }, [_vm._v("Log")])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "btn-group version-manage-box-body-dropdown"
    }, [(item !== 'S3') ? _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "caret pull-right version-manage-dropdown-icon"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu version-manage-dropdown version-manage-box-body-dropdown-btn"
    }, [_c('li', {
      attrs: {
        "data-target": "#modal-new-version"
      },
      on: {
        "click": function($event) {
          _vm.toNewBuild(item)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _vm._l((_vm.getBuildlistById(item)), function(b, index) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.selectBuild(item, index)
          }
        }
      }, [_vm._v("build " + _vm._s(b.buildnumber) + " (" + _vm._s(_vm._f("formatDate")(b.time / 1000000)) + ")")])])
    }), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "version-manage-dropdown-more",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreBuild(item)
        }
      }
    }, [_vm._v("\n                        More   \n                        "), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])])], 2)]) : _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
      staticClass: "version-manage-comment"
    }, [_c('div', {
      class: _vm.currentStageBuild[item].result === 1 ? 'version-manage-build-state gone' : 'version-manage-build-state'
    }, [_c('p', [_c('i', {
      class: _vm.getBuildStageClassByTypeId(_vm.currentStageBuild[item].result)
    }), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.getState(_vm.currentStageBuild[item].result)) + "\n                  ")])]), _vm._v(" "), _c('p', {
      class: _vm.emptyToInVisibiliy(_vm.currentStageBuild[item].comment, 'version-manage-stage-comment')
    }, [_vm._v(_vm._s(_vm.currentStageBuild[item].comment))])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "version-manage-button"
    }, [(item !== 'S3') ? _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowDownload(item)
        }
      }
    }, [_vm._v("Download App")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentBuildList[item].length > 0 ?
            _vm.toSendDingDing(item) : _vm.toNewBuild(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.currentBuildList[item].length > 0 ?
      '发送钉钉通知' : 'New Build') + "\n                  ")])]) : _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toDoPublishClick(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnText(item)))]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toSendDingDing(item)
        }
      }
    }, [_vm._v("发送钉钉通知")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "version-manage-log"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionDevelopLog",
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": _vm.currentVersion.developlog
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Publish Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionReleaseLog",
      "placeholder": "Publish log..."
    },
    domProps: {
      "value": _vm.currentVersion.releaselog
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length <= 0),
      expression: "versionList.length<=0"
    }]
  }, [_c('p', {
    staticClass: "large_title"
  }, [_vm._v("There's no version!")]), _vm._v(" "), _c('div', {
    staticClass: "version-manage-new-version"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   New Version\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-version"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Version Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_name),
      expression: "newversion_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "version number"
    },
    domProps: {
      "value": (_vm.newversion_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Develop log")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developlog),
      expression: "newversion_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": (_vm.newversion_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developshell),
      expression: "newversion_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developshell = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("API")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_releaseshell),
      expression: "newversion_releaseshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_releaseshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_releaseshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("New Version")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu alert-del pull-right"
  }, [_vm._m(5), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default pull-left"
  }, [_vm._v("Not Sure")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right",
    on: {
      "click": _vm.toDoNewVersion
    }
  }, [_vm._v("Confirm")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-build"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newbuild_robotid),
        expression: "newbuild_robotid"
      }],
      staticClass: "modal-dialog-sendto-robotpick-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.newbuild_robotid, item.id)
      },
      on: {
        "change": function($event) {
          _vm.newbuild_robotid = item.id
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-3"
    }, [(!item.icon) ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": __webpack_require__(22)
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developlog),
      expression: "newbuild_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "Comment..."
    },
    domProps: {
      "value": (_vm.newbuild_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Shell")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developshell),
      expression: "newbuild_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newbuild_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoNewBuild
    }
  }, [_vm._v("New Build")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-shell"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.shellDialogContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-download"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), (_vm.downloadLink) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('qrcode', {
    staticStyle: {
      "margin-left": "31%"
    },
    attrs: {
      "value": _vm.downloadLink,
      "options": {
        width: 200
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p add-agent-choose"
  }, [_c('a', {
    on: {
      "click": _vm.toDownloadLink
    }
  }, [_vm._v(_vm._s(_vm.downloadLink))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-log"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.logDialogCurrentContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Version\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Build\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-manage-stage-more invisibiliy"
  }, [_vm._v("\n                more   \n                "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("\n                Please confirm that the datas below in\n                "), _c('strong', [_vm._v("Shell Configuration")]), _vm._v(" are filled in correctly :\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm"
  }, [_vm._v("development branch")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("Application id")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm-down"
  }, [_vm._v("jPush key")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Build")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Download App")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RealTime LogCat")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d3e1cd3a", module.exports)
  }
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.appname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.domain))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleEdit(item)
        }
      }
    }, [_vm._v("Edit")])])])
  })], 2)])])])])])]), _vm._v(" "), _c('oauth-modal', {
    ref: "modalEdit",
    attrs: {
      "type": "edit",
      "fetch": _vm.fetch
    }
  }), _vm._v(" "), _c('oauth-modal', {
    ref: "modalCreate",
    attrs: {
      "type": "create",
      "fetch": _vm.fetch
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminInApp),
      expression: "isAdminInApp"
    }],
    staticClass: "add-app-bgcolor dropup"
  }, [_c('button', {
    staticClass: "add-app-btn",
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._m(2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("OAuth2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("App Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Domain")]), _vm._v(" "), _c('th', [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f2799756", module.exports)
  }
}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(354);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5de3434b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00079ab7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceTypes.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00079ab7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceTypes.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f6fd9084", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01697276\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01697276\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(356);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1619dcf8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02b24f41\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Feedback.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02b24f41\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Feedback.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(357);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("74a4f668", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-06f7306f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AnalysisChart.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-06f7306f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AnalysisChart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("168fab8a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f79e8fe\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddon.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f79e8fe\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(359);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7bb424bc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13f31dba\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ParameterSetting.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13f31dba\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ParameterSetting.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(360);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6ae591ed", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-15d4f6e9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonClient.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-15d4f6e9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonClient.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(361);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("512a5d8a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1742a186\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Accessory.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1742a186\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Accessory.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(362);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("30db8576", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2628c90d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Project.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2628c90d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Project.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("76212152", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2a964784\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GeneralSetting.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2a964784\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GeneralSetting.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cf494dc0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2ae5be08\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddApp.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2ae5be08\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddApp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(365);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("59e61032", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2e97709e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Master.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2e97709e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Master.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(366);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4dde9586", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3d9673a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./404.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3d9673a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./404.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("682a9101", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4021f7ef\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ErrorAlert.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4021f7ef\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ErrorAlert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(368);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("16b87df3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4449e1e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonClientForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4449e1e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonClientForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(369);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7f87eee3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b5d9a07\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProblemDeviceList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b5d9a07\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProblemDeviceList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(370);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("42ed05a8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-521a128d\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dash.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-521a128d\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dash.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("402eb838", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-529b6adc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Device.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-529b6adc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Device.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6bd6c9de", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-56cd87b1\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-56cd87b1\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("23bf69da", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5c955592\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApnsRelationForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5c955592\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApnsRelationForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3c6199f6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5dfe1a00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Domain.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5dfe1a00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Domain.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("518b6876", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-61766d91\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loading.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-61766d91\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6d0b37ac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-62a22ffd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceUser.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-62a22ffd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceUser.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("26dd03b8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-62bc1d91\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DinNewsWeekly.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-62bc1d91\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DinNewsWeekly.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("038b3ad1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-646e3d4c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceUpgrade.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-646e3d4c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceUpgrade.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("fbdb51da", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-68292f04\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-68292f04\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(380);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2bf96b16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-682f488c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApnsRelation.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-682f488c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApnsRelation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(381);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f4d8cd48", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-69552f8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-69552f8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceAddonForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b42959e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-725a63a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Information.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-725a63a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Information.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(383);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("14c0c898", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7579bcc8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RobotList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7579bcc8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RobotList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(384);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e6e2f8b2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-75d19574\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceTypesForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-75d19574\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceTypesForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(385);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("de06c91e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dff9c0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Agent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dff9c0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Agent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(386);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9114c66a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-80fb67d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConnectionAnalysis.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-80fb67d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConnectionAnalysis.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(387);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1cfb39ae", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-88566bfe\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Ios.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-88566bfe\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Ios.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5c2496d9", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-968f34c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AppDataForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-968f34c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AppDataForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(389);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("64e0c364", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-987fc992\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AboutDevice.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-987fc992\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AboutDevice.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6ffe924f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ae480c68\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ae480c68\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(391);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("25b98060", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b31df5a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarMenu.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b31df5a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("747f817b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c58b9080\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestDeviceAnalysis.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c58b9080\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestDeviceAnalysis.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(393);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4ab7ad31", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c6b36f4a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UpdateLogs.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c6b36f4a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UpdateLogs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("79f76f20", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c7bf4cfc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceLog.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c7bf4cfc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeviceLog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(395);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7326f8e5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d3e1cd3a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Android.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d3e1cd3a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Android.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(396);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3e464f44", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f2799756\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OAuth2List.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f2799756\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OAuth2List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 1.0.2
 *
 * Copyright 2015 Nick Downie
 * Released under the MIT license
 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
 */
(function(){"use strict";var t=this,i=t.Chart,e=function(t){this.canvas=t.canvas,this.ctx=t;var i=function(t,i){return t["offset"+i]?t["offset"+i]:document.defaultView.getComputedStyle(t).getPropertyValue(i)},e=this.width=i(t.canvas,"Width"),n=this.height=i(t.canvas,"Height");t.canvas.width=e,t.canvas.height=n;var e=this.width=t.canvas.width,n=this.height=t.canvas.height;return this.aspectRatio=this.width/this.height,s.retinaScale(this),this};e.defaults={global:{animation:!0,animationSteps:60,animationEasing:"easeOutQuart",showScale:!0,scaleOverride:!1,scaleSteps:null,scaleStepWidth:null,scaleStartValue:null,scaleLineColor:"rgba(0,0,0,.1)",scaleLineWidth:1,scaleShowLabels:!0,scaleLabel:"<%=value%>",scaleIntegersOnly:!0,scaleBeginAtZero:!1,scaleFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",scaleFontSize:12,scaleFontStyle:"normal",scaleFontColor:"#666",responsive:!1,maintainAspectRatio:!0,showTooltips:!0,customTooltips:!1,tooltipEvents:["mousemove","touchstart","touchmove","mouseout"],tooltipFillColor:"rgba(0,0,0,0.8)",tooltipFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",tooltipFontSize:14,tooltipFontStyle:"normal",tooltipFontColor:"#fff",tooltipTitleFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",tooltipTitleFontSize:14,tooltipTitleFontStyle:"bold",tooltipTitleFontColor:"#fff",tooltipYPadding:6,tooltipXPadding:6,tooltipCaretSize:8,tooltipCornerRadius:6,tooltipXOffset:10,tooltipTemplate:"<%if (label){%><%=label%>: <%}%><%= value %>",multiTooltipTemplate:"<%= value %>",multiTooltipKeyBackground:"#fff",onAnimationProgress:function(){},onAnimationComplete:function(){}}},e.types={};var s=e.helpers={},n=s.each=function(t,i,e){var s=Array.prototype.slice.call(arguments,3);if(t)if(t.length===+t.length){var n;for(n=0;n<t.length;n++)i.apply(e,[t[n],n].concat(s))}else for(var o in t)i.apply(e,[t[o],o].concat(s))},o=s.clone=function(t){var i={};return n(t,function(e,s){t.hasOwnProperty(s)&&(i[s]=e)}),i},a=s.extend=function(t){return n(Array.prototype.slice.call(arguments,1),function(i){n(i,function(e,s){i.hasOwnProperty(s)&&(t[s]=e)})}),t},h=s.merge=function(){var t=Array.prototype.slice.call(arguments,0);return t.unshift({}),a.apply(null,t)},l=s.indexOf=function(t,i){if(Array.prototype.indexOf)return t.indexOf(i);for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1},r=(s.where=function(t,i){var e=[];return s.each(t,function(t){i(t)&&e.push(t)}),e},s.findNextWhere=function(t,i,e){e||(e=-1);for(var s=e+1;s<t.length;s++){var n=t[s];if(i(n))return n}},s.findPreviousWhere=function(t,i,e){e||(e=t.length);for(var s=e-1;s>=0;s--){var n=t[s];if(i(n))return n}},s.inherits=function(t){var i=this,e=t&&t.hasOwnProperty("constructor")?t.constructor:function(){return i.apply(this,arguments)},s=function(){this.constructor=e};return s.prototype=i.prototype,e.prototype=new s,e.extend=r,t&&a(e.prototype,t),e.__super__=i.prototype,e}),c=s.noop=function(){},u=s.uid=function(){var t=0;return function(){return"chart-"+t++}}(),d=s.warn=function(t){window.console&&"function"==typeof window.console.warn&&console.warn(t)},p=s.amd="function"=="function"&&__webpack_require__(206),f=s.isNumber=function(t){return!isNaN(parseFloat(t))&&isFinite(t)},g=s.max=function(t){return Math.max.apply(Math,t)},m=s.min=function(t){return Math.min.apply(Math,t)},v=(s.cap=function(t,i,e){if(f(i)){if(t>i)return i}else if(f(e)&&e>t)return e;return t},s.getDecimalPlaces=function(t){return t%1!==0&&f(t)?t.toString().split(".")[1].length:0}),S=s.radians=function(t){return t*(Math.PI/180)},x=(s.getAngleFromPoint=function(t,i){var e=i.x-t.x,s=i.y-t.y,n=Math.sqrt(e*e+s*s),o=2*Math.PI+Math.atan2(s,e);return 0>e&&0>s&&(o+=2*Math.PI),{angle:o,distance:n}},s.aliasPixel=function(t){return t%2===0?0:.5}),y=(s.splineCurve=function(t,i,e,s){var n=Math.sqrt(Math.pow(i.x-t.x,2)+Math.pow(i.y-t.y,2)),o=Math.sqrt(Math.pow(e.x-i.x,2)+Math.pow(e.y-i.y,2)),a=s*n/(n+o),h=s*o/(n+o);return{inner:{x:i.x-a*(e.x-t.x),y:i.y-a*(e.y-t.y)},outer:{x:i.x+h*(e.x-t.x),y:i.y+h*(e.y-t.y)}}},s.calculateOrderOfMagnitude=function(t){return Math.floor(Math.log(t)/Math.LN10)}),C=(s.calculateScaleRange=function(t,i,e,s,n){var o=2,a=Math.floor(i/(1.5*e)),h=o>=a,l=g(t),r=m(t);l===r&&(l+=.5,r>=.5&&!s?r-=.5:l+=.5);for(var c=Math.abs(l-r),u=y(c),d=Math.ceil(l/(1*Math.pow(10,u)))*Math.pow(10,u),p=s?0:Math.floor(r/(1*Math.pow(10,u)))*Math.pow(10,u),f=d-p,v=Math.pow(10,u),S=Math.round(f/v);(S>a||a>2*S)&&!h;)if(S>a)v*=2,S=Math.round(f/v),S%1!==0&&(h=!0);else if(n&&u>=0){if(v/2%1!==0)break;v/=2,S=Math.round(f/v)}else v/=2,S=Math.round(f/v);return h&&(S=o,v=f/S),{steps:S,stepValue:v,min:p,max:p+S*v}},s.template=function(t,i){function e(t,i){var e=/\W/.test(t)?new Function("obj","var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('"+t.replace(/[\r\t\n]/g," ").split("<%").join("	").replace(/((^|%>)[^\t]*)'/g,"$1\r").replace(/\t=(.*?)%>/g,"',$1,'").split("	").join("');").split("%>").join("p.push('").split("\r").join("\\'")+"');}return p.join('');"):s[t]=s[t];return i?e(i):e}if(t instanceof Function)return t(i);var s={};return e(t,i)}),w=(s.generateLabels=function(t,i,e,s){var o=new Array(i);return labelTemplateString&&n(o,function(i,n){o[n]=C(t,{value:e+s*(n+1)})}),o},s.easingEffects={linear:function(t){return t},easeInQuad:function(t){return t*t},easeOutQuad:function(t){return-1*t*(t-2)},easeInOutQuad:function(t){return(t/=.5)<1?.5*t*t:-0.5*(--t*(t-2)-1)},easeInCubic:function(t){return t*t*t},easeOutCubic:function(t){return 1*((t=t/1-1)*t*t+1)},easeInOutCubic:function(t){return(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2)},easeInQuart:function(t){return t*t*t*t},easeOutQuart:function(t){return-1*((t=t/1-1)*t*t*t-1)},easeInOutQuart:function(t){return(t/=.5)<1?.5*t*t*t*t:-0.5*((t-=2)*t*t*t-2)},easeInQuint:function(t){return 1*(t/=1)*t*t*t*t},easeOutQuint:function(t){return 1*((t=t/1-1)*t*t*t*t+1)},easeInOutQuint:function(t){return(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)},easeInSine:function(t){return-1*Math.cos(t/1*(Math.PI/2))+1},easeOutSine:function(t){return 1*Math.sin(t/1*(Math.PI/2))},easeInOutSine:function(t){return-0.5*(Math.cos(Math.PI*t/1)-1)},easeInExpo:function(t){return 0===t?1:1*Math.pow(2,10*(t/1-1))},easeOutExpo:function(t){return 1===t?1:1*(-Math.pow(2,-10*t/1)+1)},easeInOutExpo:function(t){return 0===t?0:1===t?1:(t/=.5)<1?.5*Math.pow(2,10*(t-1)):.5*(-Math.pow(2,-10*--t)+2)},easeInCirc:function(t){return t>=1?t:-1*(Math.sqrt(1-(t/=1)*t)-1)},easeOutCirc:function(t){return 1*Math.sqrt(1-(t=t/1-1)*t)},easeInOutCirc:function(t){return(t/=.5)<1?-0.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)},easeInElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:1==(t/=1)?1:(e||(e=.3),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),-(s*Math.pow(2,10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e)))},easeOutElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:1==(t/=1)?1:(e||(e=.3),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),s*Math.pow(2,-10*t)*Math.sin(2*(1*t-i)*Math.PI/e)+1)},easeInOutElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:2==(t/=.5)?1:(e||(e=.3*1.5),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),1>t?-.5*s*Math.pow(2,10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e):s*Math.pow(2,-10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e)*.5+1)},easeInBack:function(t){var i=1.70158;return 1*(t/=1)*t*((i+1)*t-i)},easeOutBack:function(t){var i=1.70158;return 1*((t=t/1-1)*t*((i+1)*t+i)+1)},easeInOutBack:function(t){var i=1.70158;return(t/=.5)<1?.5*t*t*(((i*=1.525)+1)*t-i):.5*((t-=2)*t*(((i*=1.525)+1)*t+i)+2)},easeInBounce:function(t){return 1-w.easeOutBounce(1-t)},easeOutBounce:function(t){return(t/=1)<1/2.75?7.5625*t*t:2/2.75>t?1*(7.5625*(t-=1.5/2.75)*t+.75):2.5/2.75>t?1*(7.5625*(t-=2.25/2.75)*t+.9375):1*(7.5625*(t-=2.625/2.75)*t+.984375)},easeInOutBounce:function(t){return.5>t?.5*w.easeInBounce(2*t):.5*w.easeOutBounce(2*t-1)+.5}}),b=s.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){return window.setTimeout(t,1e3/60)}}(),P=s.cancelAnimFrame=function(){return window.cancelAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||window.oCancelAnimationFrame||window.msCancelAnimationFrame||function(t){return window.clearTimeout(t,1e3/60)}}(),L=(s.animationLoop=function(t,i,e,s,n,o){var a=0,h=w[e]||w.linear,l=function(){a++;var e=a/i,r=h(e);t.call(o,r,e,a),s.call(o,r,e),i>a?o.animationFrame=b(l):n.apply(o)};b(l)},s.getRelativePosition=function(t){var i,e,s=t.originalEvent||t,n=t.currentTarget||t.srcElement,o=n.getBoundingClientRect();return s.touches?(i=s.touches[0].clientX-o.left,e=s.touches[0].clientY-o.top):(i=s.clientX-o.left,e=s.clientY-o.top),{x:i,y:e}},s.addEvent=function(t,i,e){t.addEventListener?t.addEventListener(i,e):t.attachEvent?t.attachEvent("on"+i,e):t["on"+i]=e}),k=s.removeEvent=function(t,i,e){t.removeEventListener?t.removeEventListener(i,e,!1):t.detachEvent?t.detachEvent("on"+i,e):t["on"+i]=c},F=(s.bindEvents=function(t,i,e){t.events||(t.events={}),n(i,function(i){t.events[i]=function(){e.apply(t,arguments)},L(t.chart.canvas,i,t.events[i])})},s.unbindEvents=function(t,i){n(i,function(i,e){k(t.chart.canvas,e,i)})}),R=s.getMaximumWidth=function(t){var i=t.parentNode;return i.clientWidth},T=s.getMaximumHeight=function(t){var i=t.parentNode;return i.clientHeight},A=(s.getMaximumSize=s.getMaximumWidth,s.retinaScale=function(t){var i=t.ctx,e=t.canvas.width,s=t.canvas.height;window.devicePixelRatio&&(i.canvas.style.width=e+"px",i.canvas.style.height=s+"px",i.canvas.height=s*window.devicePixelRatio,i.canvas.width=e*window.devicePixelRatio,i.scale(window.devicePixelRatio,window.devicePixelRatio))}),M=s.clear=function(t){t.ctx.clearRect(0,0,t.width,t.height)},W=s.fontString=function(t,i,e){return i+" "+t+"px "+e},z=s.longestText=function(t,i,e){t.font=i;var s=0;return n(e,function(i){var e=t.measureText(i).width;s=e>s?e:s}),s},B=s.drawRoundedRectangle=function(t,i,e,s,n,o){t.beginPath(),t.moveTo(i+o,e),t.lineTo(i+s-o,e),t.quadraticCurveTo(i+s,e,i+s,e+o),t.lineTo(i+s,e+n-o),t.quadraticCurveTo(i+s,e+n,i+s-o,e+n),t.lineTo(i+o,e+n),t.quadraticCurveTo(i,e+n,i,e+n-o),t.lineTo(i,e+o),t.quadraticCurveTo(i,e,i+o,e),t.closePath()};e.instances={},e.Type=function(t,i,s){this.options=i,this.chart=s,this.id=u(),e.instances[this.id]=this,i.responsive&&this.resize(),this.initialize.call(this,t)},a(e.Type.prototype,{initialize:function(){return this},clear:function(){return M(this.chart),this},stop:function(){return P(this.animationFrame),this},resize:function(t){this.stop();var i=this.chart.canvas,e=R(this.chart.canvas),s=this.options.maintainAspectRatio?e/this.chart.aspectRatio:T(this.chart.canvas);return i.width=this.chart.width=e,i.height=this.chart.height=s,A(this.chart),"function"==typeof t&&t.apply(this,Array.prototype.slice.call(arguments,1)),this},reflow:c,render:function(t){return t&&this.reflow(),this.options.animation&&!t?s.animationLoop(this.draw,this.options.animationSteps,this.options.animationEasing,this.options.onAnimationProgress,this.options.onAnimationComplete,this):(this.draw(),this.options.onAnimationComplete.call(this)),this},generateLegend:function(){return C(this.options.legendTemplate,this)},destroy:function(){this.clear(),F(this,this.events);var t=this.chart.canvas;t.width=this.chart.width,t.height=this.chart.height,t.style.removeProperty?(t.style.removeProperty("width"),t.style.removeProperty("height")):(t.style.removeAttribute("width"),t.style.removeAttribute("height")),delete e.instances[this.id]},showTooltip:function(t,i){"undefined"==typeof this.activeElements&&(this.activeElements=[]);var o=function(t){var i=!1;return t.length!==this.activeElements.length?i=!0:(n(t,function(t,e){t!==this.activeElements[e]&&(i=!0)},this),i)}.call(this,t);if(o||i){if(this.activeElements=t,this.draw(),this.options.customTooltips&&this.options.customTooltips(!1),t.length>0)if(this.datasets&&this.datasets.length>1){for(var a,h,r=this.datasets.length-1;r>=0&&(a=this.datasets[r].points||this.datasets[r].bars||this.datasets[r].segments,h=l(a,t[0]),-1===h);r--);var c=[],u=[],d=function(){var t,i,e,n,o,a=[],l=[],r=[];return s.each(this.datasets,function(i){t=i.points||i.bars||i.segments,t[h]&&t[h].hasValue()&&a.push(t[h])}),s.each(a,function(t){l.push(t.x),r.push(t.y),c.push(s.template(this.options.multiTooltipTemplate,t)),u.push({fill:t._saved.fillColor||t.fillColor,stroke:t._saved.strokeColor||t.strokeColor})},this),o=m(r),e=g(r),n=m(l),i=g(l),{x:n>this.chart.width/2?n:i,y:(o+e)/2}}.call(this,h);new e.MultiTooltip({x:d.x,y:d.y,xPadding:this.options.tooltipXPadding,yPadding:this.options.tooltipYPadding,xOffset:this.options.tooltipXOffset,fillColor:this.options.tooltipFillColor,textColor:this.options.tooltipFontColor,fontFamily:this.options.tooltipFontFamily,fontStyle:this.options.tooltipFontStyle,fontSize:this.options.tooltipFontSize,titleTextColor:this.options.tooltipTitleFontColor,titleFontFamily:this.options.tooltipTitleFontFamily,titleFontStyle:this.options.tooltipTitleFontStyle,titleFontSize:this.options.tooltipTitleFontSize,cornerRadius:this.options.tooltipCornerRadius,labels:c,legendColors:u,legendColorBackground:this.options.multiTooltipKeyBackground,title:t[0].label,chart:this.chart,ctx:this.chart.ctx,custom:this.options.customTooltips}).draw()}else n(t,function(t){var i=t.tooltipPosition();new e.Tooltip({x:Math.round(i.x),y:Math.round(i.y),xPadding:this.options.tooltipXPadding,yPadding:this.options.tooltipYPadding,fillColor:this.options.tooltipFillColor,textColor:this.options.tooltipFontColor,fontFamily:this.options.tooltipFontFamily,fontStyle:this.options.tooltipFontStyle,fontSize:this.options.tooltipFontSize,caretHeight:this.options.tooltipCaretSize,cornerRadius:this.options.tooltipCornerRadius,text:C(this.options.tooltipTemplate,t),chart:this.chart,custom:this.options.customTooltips}).draw()},this);return this}},toBase64Image:function(){return this.chart.canvas.toDataURL.apply(this.chart.canvas,arguments)}}),e.Type.extend=function(t){var i=this,s=function(){return i.apply(this,arguments)};if(s.prototype=o(i.prototype),a(s.prototype,t),s.extend=e.Type.extend,t.name||i.prototype.name){var n=t.name||i.prototype.name,l=e.defaults[i.prototype.name]?o(e.defaults[i.prototype.name]):{};e.defaults[n]=a(l,t.defaults),e.types[n]=s,e.prototype[n]=function(t,i){var o=h(e.defaults.global,e.defaults[n],i||{});return new s(t,o,this)}}else d("Name not provided for this chart, so it hasn't been registered");return i},e.Element=function(t){a(this,t),this.initialize.apply(this,arguments),this.save()},a(e.Element.prototype,{initialize:function(){},restore:function(t){return t?n(t,function(t){this[t]=this._saved[t]},this):a(this,this._saved),this},save:function(){return this._saved=o(this),delete this._saved._saved,this},update:function(t){return n(t,function(t,i){this._saved[i]=this[i],this[i]=t},this),this},transition:function(t,i){return n(t,function(t,e){this[e]=(t-this._saved[e])*i+this._saved[e]},this),this},tooltipPosition:function(){return{x:this.x,y:this.y}},hasValue:function(){return f(this.value)}}),e.Element.extend=r,e.Point=e.Element.extend({display:!0,inRange:function(t,i){var e=this.hitDetectionRadius+this.radius;return Math.pow(t-this.x,2)+Math.pow(i-this.y,2)<Math.pow(e,2)},draw:function(){if(this.display){var t=this.ctx;t.beginPath(),t.arc(this.x,this.y,this.radius,0,2*Math.PI),t.closePath(),t.strokeStyle=this.strokeColor,t.lineWidth=this.strokeWidth,t.fillStyle=this.fillColor,t.fill(),t.stroke()}}}),e.Arc=e.Element.extend({inRange:function(t,i){var e=s.getAngleFromPoint(this,{x:t,y:i}),n=e.angle>=this.startAngle&&e.angle<=this.endAngle,o=e.distance>=this.innerRadius&&e.distance<=this.outerRadius;return n&&o},tooltipPosition:function(){var t=this.startAngle+(this.endAngle-this.startAngle)/2,i=(this.outerRadius-this.innerRadius)/2+this.innerRadius;return{x:this.x+Math.cos(t)*i,y:this.y+Math.sin(t)*i}},draw:function(t){var i=this.ctx;i.beginPath(),i.arc(this.x,this.y,this.outerRadius,this.startAngle,this.endAngle),i.arc(this.x,this.y,this.innerRadius,this.endAngle,this.startAngle,!0),i.closePath(),i.strokeStyle=this.strokeColor,i.lineWidth=this.strokeWidth,i.fillStyle=this.fillColor,i.fill(),i.lineJoin="bevel",this.showStroke&&i.stroke()}}),e.Rectangle=e.Element.extend({draw:function(){var t=this.ctx,i=this.width/2,e=this.x-i,s=this.x+i,n=this.base-(this.base-this.y),o=this.strokeWidth/2;this.showStroke&&(e+=o,s-=o,n+=o),t.beginPath(),t.fillStyle=this.fillColor,t.strokeStyle=this.strokeColor,t.lineWidth=this.strokeWidth,t.moveTo(e,this.base),t.lineTo(e,n),t.lineTo(s,n),t.lineTo(s,this.base),t.fill(),this.showStroke&&t.stroke()},height:function(){return this.base-this.y},inRange:function(t,i){return t>=this.x-this.width/2&&t<=this.x+this.width/2&&i>=this.y&&i<=this.base}}),e.Tooltip=e.Element.extend({draw:function(){var t=this.chart.ctx;t.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.xAlign="center",this.yAlign="above";var i=this.caretPadding=2,e=t.measureText(this.text).width+2*this.xPadding,s=this.fontSize+2*this.yPadding,n=s+this.caretHeight+i;this.x+e/2>this.chart.width?this.xAlign="left":this.x-e/2<0&&(this.xAlign="right"),this.y-n<0&&(this.yAlign="below");var o=this.x-e/2,a=this.y-n;if(t.fillStyle=this.fillColor,this.custom)this.custom(this);else{switch(this.yAlign){case"above":t.beginPath(),t.moveTo(this.x,this.y-i),t.lineTo(this.x+this.caretHeight,this.y-(i+this.caretHeight)),t.lineTo(this.x-this.caretHeight,this.y-(i+this.caretHeight)),t.closePath(),t.fill();break;case"below":a=this.y+i+this.caretHeight,t.beginPath(),t.moveTo(this.x,this.y+i),t.lineTo(this.x+this.caretHeight,this.y+i+this.caretHeight),t.lineTo(this.x-this.caretHeight,this.y+i+this.caretHeight),t.closePath(),t.fill()}switch(this.xAlign){case"left":o=this.x-e+(this.cornerRadius+this.caretHeight);break;case"right":o=this.x-(this.cornerRadius+this.caretHeight)}B(t,o,a,e,s,this.cornerRadius),t.fill(),t.fillStyle=this.textColor,t.textAlign="center",t.textBaseline="middle",t.fillText(this.text,o+e/2,a+s/2)}}}),e.MultiTooltip=e.Element.extend({initialize:function(){this.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.titleFont=W(this.titleFontSize,this.titleFontStyle,this.titleFontFamily),this.height=this.labels.length*this.fontSize+(this.labels.length-1)*(this.fontSize/2)+2*this.yPadding+1.5*this.titleFontSize,this.ctx.font=this.titleFont;var t=this.ctx.measureText(this.title).width,i=z(this.ctx,this.font,this.labels)+this.fontSize+3,e=g([i,t]);this.width=e+2*this.xPadding;var s=this.height/2;this.y-s<0?this.y=s:this.y+s>this.chart.height&&(this.y=this.chart.height-s),this.x>this.chart.width/2?this.x-=this.xOffset+this.width:this.x+=this.xOffset},getLineHeight:function(t){var i=this.y-this.height/2+this.yPadding,e=t-1;return 0===t?i+this.titleFontSize/2:i+(1.5*this.fontSize*e+this.fontSize/2)+1.5*this.titleFontSize},draw:function(){if(this.custom)this.custom(this);else{B(this.ctx,this.x,this.y-this.height/2,this.width,this.height,this.cornerRadius);var t=this.ctx;t.fillStyle=this.fillColor,t.fill(),t.closePath(),t.textAlign="left",t.textBaseline="middle",t.fillStyle=this.titleTextColor,t.font=this.titleFont,t.fillText(this.title,this.x+this.xPadding,this.getLineHeight(0)),t.font=this.font,s.each(this.labels,function(i,e){t.fillStyle=this.textColor,t.fillText(i,this.x+this.xPadding+this.fontSize+3,this.getLineHeight(e+1)),t.fillStyle=this.legendColorBackground,t.fillRect(this.x+this.xPadding,this.getLineHeight(e+1)-this.fontSize/2,this.fontSize,this.fontSize),t.fillStyle=this.legendColors[e].fill,t.fillRect(this.x+this.xPadding,this.getLineHeight(e+1)-this.fontSize/2,this.fontSize,this.fontSize)},this)}}}),e.Scale=e.Element.extend({initialize:function(){this.fit()},buildYLabels:function(){this.yLabels=[];for(var t=v(this.stepValue),i=0;i<=this.steps;i++)this.yLabels.push(C(this.templateString,{value:(this.min+i*this.stepValue).toFixed(t)}));this.yLabelWidth=this.display&&this.showLabels?z(this.ctx,this.font,this.yLabels):0},addXLabel:function(t){this.xLabels.push(t),this.valuesCount++,this.fit()},removeXLabel:function(){this.xLabels.shift(),this.valuesCount--,this.fit()},fit:function(){this.startPoint=this.display?this.fontSize:0,this.endPoint=this.display?this.height-1.5*this.fontSize-5:this.height,this.startPoint+=this.padding,this.endPoint-=this.padding;var t,i=this.endPoint-this.startPoint;for(this.calculateYRange(i),this.buildYLabels(),this.calculateXLabelRotation();i>this.endPoint-this.startPoint;)i=this.endPoint-this.startPoint,t=this.yLabelWidth,this.calculateYRange(i),this.buildYLabels(),t<this.yLabelWidth&&this.calculateXLabelRotation()},calculateXLabelRotation:function(){this.ctx.font=this.font;var t,i,e=this.ctx.measureText(this.xLabels[0]).width,s=this.ctx.measureText(this.xLabels[this.xLabels.length-1]).width;if(this.xScalePaddingRight=s/2+3,this.xScalePaddingLeft=e/2>this.yLabelWidth+10?e/2:this.yLabelWidth+10,this.xLabelRotation=0,this.display){var n,o=z(this.ctx,this.font,this.xLabels);this.xLabelWidth=o;for(var a=Math.floor(this.calculateX(1)-this.calculateX(0))-6;this.xLabelWidth>a&&0===this.xLabelRotation||this.xLabelWidth>a&&this.xLabelRotation<=90&&this.xLabelRotation>0;)n=Math.cos(S(this.xLabelRotation)),t=n*e,i=n*s,t+this.fontSize/2>this.yLabelWidth+8&&(this.xScalePaddingLeft=t+this.fontSize/2),this.xScalePaddingRight=this.fontSize/2,this.xLabelRotation++,this.xLabelWidth=n*o;this.xLabelRotation>0&&(this.endPoint-=Math.sin(S(this.xLabelRotation))*o+3)}else this.xLabelWidth=0,this.xScalePaddingRight=this.padding,this.xScalePaddingLeft=this.padding},calculateYRange:c,drawingArea:function(){return this.startPoint-this.endPoint},calculateY:function(t){var i=this.drawingArea()/(this.min-this.max);return this.endPoint-i*(t-this.min)},calculateX:function(t){var i=(this.xLabelRotation>0,this.width-(this.xScalePaddingLeft+this.xScalePaddingRight)),e=i/Math.max(this.valuesCount-(this.offsetGridLines?0:1),1),s=e*t+this.xScalePaddingLeft;return this.offsetGridLines&&(s+=e/2),Math.round(s)},update:function(t){s.extend(this,t),this.fit()},draw:function(){var t=this.ctx,i=(this.endPoint-this.startPoint)/this.steps,e=Math.round(this.xScalePaddingLeft);this.display&&(t.fillStyle=this.textColor,t.font=this.font,n(this.yLabels,function(n,o){var a=this.endPoint-i*o,h=Math.round(a),l=this.showHorizontalLines;t.textAlign="right",t.textBaseline="middle",this.showLabels&&t.fillText(n,e-10,a),0!==o||l||(l=!0),l&&t.beginPath(),o>0?(t.lineWidth=this.gridLineWidth,t.strokeStyle=this.gridLineColor):(t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor),h+=s.aliasPixel(t.lineWidth),l&&(t.moveTo(e,h),t.lineTo(this.width,h),t.stroke(),t.closePath()),t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor,t.beginPath(),t.moveTo(e-5,h),t.lineTo(e,h),t.stroke(),t.closePath()},this),n(this.xLabels,function(i,e){var s=this.calculateX(e)+x(this.lineWidth),n=this.calculateX(e-(this.offsetGridLines?.5:0))+x(this.lineWidth),o=this.xLabelRotation>0,a=this.showVerticalLines;0!==e||a||(a=!0),a&&t.beginPath(),e>0?(t.lineWidth=this.gridLineWidth,t.strokeStyle=this.gridLineColor):(t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor),a&&(t.moveTo(n,this.endPoint),t.lineTo(n,this.startPoint-3),t.stroke(),t.closePath()),t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor,t.beginPath(),t.moveTo(n,this.endPoint),t.lineTo(n,this.endPoint+5),t.stroke(),t.closePath(),t.save(),t.translate(s,o?this.endPoint+12:this.endPoint+8),t.rotate(-1*S(this.xLabelRotation)),t.font=this.font,t.textAlign=o?"right":"center",t.textBaseline=o?"middle":"top",t.fillText(i,0,0),t.restore()},this))}}),e.RadialScale=e.Element.extend({initialize:function(){this.size=m([this.height,this.width]),this.drawingArea=this.display?this.size/2-(this.fontSize/2+this.backdropPaddingY):this.size/2},calculateCenterOffset:function(t){var i=this.drawingArea/(this.max-this.min);return(t-this.min)*i},update:function(){this.lineArc?this.drawingArea=this.display?this.size/2-(this.fontSize/2+this.backdropPaddingY):this.size/2:this.setScaleSize(),this.buildYLabels()},buildYLabels:function(){this.yLabels=[];for(var t=v(this.stepValue),i=0;i<=this.steps;i++)this.yLabels.push(C(this.templateString,{value:(this.min+i*this.stepValue).toFixed(t)}))},getCircumference:function(){return 2*Math.PI/this.valuesCount},setScaleSize:function(){var t,i,e,s,n,o,a,h,l,r,c,u,d=m([this.height/2-this.pointLabelFontSize-5,this.width/2]),p=this.width,g=0;for(this.ctx.font=W(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily),i=0;i<this.valuesCount;i++)t=this.getPointPosition(i,d),e=this.ctx.measureText(C(this.templateString,{value:this.labels[i]})).width+5,0===i||i===this.valuesCount/2?(s=e/2,t.x+s>p&&(p=t.x+s,n=i),t.x-s<g&&(g=t.x-s,a=i)):i<this.valuesCount/2?t.x+e>p&&(p=t.x+e,n=i):i>this.valuesCount/2&&t.x-e<g&&(g=t.x-e,a=i);l=g,r=Math.ceil(p-this.width),o=this.getIndexAngle(n),h=this.getIndexAngle(a),c=r/Math.sin(o+Math.PI/2),u=l/Math.sin(h+Math.PI/2),c=f(c)?c:0,u=f(u)?u:0,this.drawingArea=d-(u+c)/2,this.setCenterPoint(u,c)},setCenterPoint:function(t,i){var e=this.width-i-this.drawingArea,s=t+this.drawingArea;this.xCenter=(s+e)/2,this.yCenter=this.height/2},getIndexAngle:function(t){var i=2*Math.PI/this.valuesCount;return t*i-Math.PI/2},getPointPosition:function(t,i){var e=this.getIndexAngle(t);return{x:Math.cos(e)*i+this.xCenter,y:Math.sin(e)*i+this.yCenter}},draw:function(){if(this.display){var t=this.ctx;if(n(this.yLabels,function(i,e){if(e>0){var s,n=e*(this.drawingArea/this.steps),o=this.yCenter-n;if(this.lineWidth>0)if(t.strokeStyle=this.lineColor,t.lineWidth=this.lineWidth,this.lineArc)t.beginPath(),t.arc(this.xCenter,this.yCenter,n,0,2*Math.PI),t.closePath(),t.stroke();else{t.beginPath();for(var a=0;a<this.valuesCount;a++)s=this.getPointPosition(a,this.calculateCenterOffset(this.min+e*this.stepValue)),0===a?t.moveTo(s.x,s.y):t.lineTo(s.x,s.y);t.closePath(),t.stroke()}if(this.showLabels){if(t.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.showLabelBackdrop){var h=t.measureText(i).width;t.fillStyle=this.backdropColor,t.fillRect(this.xCenter-h/2-this.backdropPaddingX,o-this.fontSize/2-this.backdropPaddingY,h+2*this.backdropPaddingX,this.fontSize+2*this.backdropPaddingY)}t.textAlign="center",t.textBaseline="middle",t.fillStyle=this.fontColor,t.fillText(i,this.xCenter,o)}}},this),!this.lineArc){t.lineWidth=this.angleLineWidth,t.strokeStyle=this.angleLineColor;for(var i=this.valuesCount-1;i>=0;i--){if(this.angleLineWidth>0){var e=this.getPointPosition(i,this.calculateCenterOffset(this.max));t.beginPath(),t.moveTo(this.xCenter,this.yCenter),t.lineTo(e.x,e.y),t.stroke(),t.closePath()}var s=this.getPointPosition(i,this.calculateCenterOffset(this.max)+5);t.font=W(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily),t.fillStyle=this.pointLabelFontColor;var o=this.labels.length,a=this.labels.length/2,h=a/2,l=h>i||i>o-h,r=i===h||i===o-h;t.textAlign=0===i?"center":i===a?"center":a>i?"left":"right",t.textBaseline=r?"middle":l?"bottom":"top",t.fillText(this.labels[i],s.x,s.y)}}}}}),s.addEvent(window,"resize",function(){var t;return function(){clearTimeout(t),t=setTimeout(function(){n(e.instances,function(t){t.options.responsive&&t.resize(t.render,!0)})},50)}}()),p?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return e}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports&&(module.exports=e),t.Chart=e,e.noConflict=function(){return t.Chart=i,e}}).call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleBeginAtZero:!0,scaleShowGridLines:!0,scaleGridLineColor:"rgba(0,0,0,.05)",scaleGridLineWidth:1,scaleShowHorizontalLines:!0,scaleShowVerticalLines:!0,barShowStroke:!0,barStrokeWidth:2,barValueSpacing:5,barDatasetSpacing:1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].fillColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Bar",defaults:s,initialize:function(t){var s=this.options;this.ScaleClass=i.Scale.extend({offsetGridLines:!0,calculateBarX:function(t,i,e){var n=this.calculateBaseWidth(),o=this.calculateX(e)-n/2,a=this.calculateBarWidth(t);return o+a*i+i*s.barDatasetSpacing+a/2},calculateBaseWidth:function(){return this.calculateX(1)-this.calculateX(0)-2*s.barValueSpacing},calculateBarWidth:function(t){var i=this.calculateBaseWidth()-(t-1)*s.barDatasetSpacing;return i/t}}),this.datasets=[],this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getBarsAtEvent(t):[];this.eachBars(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),this.BarClass=i.Rectangle.extend({strokeWidth:this.options.barStrokeWidth,showStroke:this.options.barShowStroke,ctx:this.chart.ctx}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,bars:[]};this.datasets.push(s),e.each(i.data,function(e,n){s.bars.push(new this.BarClass({value:e,label:t.labels[n],datasetLabel:i.label,strokeColor:i.strokeColor,fillColor:i.fillColor,highlightFill:i.highlightFill||i.fillColor,highlightStroke:i.highlightStroke||i.strokeColor}))},this)},this),this.buildScale(t.labels),this.BarClass.prototype.base=this.scale.endPoint,this.eachBars(function(t,i,s){e.extend(t,{width:this.scale.calculateBarWidth(this.datasets.length),x:this.scale.calculateBarX(this.datasets.length,s,i),y:this.scale.endPoint}),t.save()},this),this.render()},update:function(){this.scale.update(),e.each(this.activeElements,function(t){t.restore(["fillColor","strokeColor"])}),this.eachBars(function(t){t.save()}),this.render()},eachBars:function(t){e.each(this.datasets,function(i,s){e.each(i.bars,t,this,s)},this)},getBarsAtEvent:function(t){for(var i,s=[],n=e.getRelativePosition(t),o=function(t){s.push(t.bars[i])},a=0;a<this.datasets.length;a++)for(i=0;i<this.datasets[a].bars.length;i++)if(this.datasets[a].bars[i].inRange(n.x,n.y))return e.each(this.datasets,o),s;return s},buildScale:function(t){var i=this,s=function(){var t=[];return i.eachBars(function(i){t.push(i.value)}),t},n={templateString:this.options.scaleLabel,height:this.chart.height,width:this.chart.width,ctx:this.chart.ctx,textColor:this.options.scaleFontColor,fontSize:this.options.scaleFontSize,fontStyle:this.options.scaleFontStyle,fontFamily:this.options.scaleFontFamily,valuesCount:t.length,beginAtZero:this.options.scaleBeginAtZero,integersOnly:this.options.scaleIntegersOnly,calculateYRange:function(t){var i=e.calculateScaleRange(s(),t,this.fontSize,this.beginAtZero,this.integersOnly);e.extend(this,i)},xLabels:t,font:e.fontString(this.options.scaleFontSize,this.options.scaleFontStyle,this.options.scaleFontFamily),lineWidth:this.options.scaleLineWidth,lineColor:this.options.scaleLineColor,showHorizontalLines:this.options.scaleShowHorizontalLines,showVerticalLines:this.options.scaleShowVerticalLines,gridLineWidth:this.options.scaleShowGridLines?this.options.scaleGridLineWidth:0,gridLineColor:this.options.scaleShowGridLines?this.options.scaleGridLineColor:"rgba(0,0,0,0)",padding:this.options.showScale?0:this.options.barShowStroke?this.options.barStrokeWidth:0,showLabels:this.options.scaleShowLabels,display:this.options.showScale};this.options.scaleOverride&&e.extend(n,{calculateYRange:e.noop,steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}),this.scale=new this.ScaleClass(n)},addData:function(t,i){e.each(t,function(t,e){this.datasets[e].bars.push(new this.BarClass({value:t,label:i,x:this.scale.calculateBarX(this.datasets.length,e,this.scale.valuesCount+1),y:this.scale.endPoint,width:this.scale.calculateBarWidth(this.datasets.length),base:this.scale.endPoint,strokeColor:this.datasets[e].strokeColor,fillColor:this.datasets[e].fillColor}))
},this),this.scale.addXLabel(i),this.update()},removeData:function(){this.scale.removeXLabel(),e.each(this.datasets,function(t){t.bars.shift()},this),this.update()},reflow:function(){e.extend(this.BarClass.prototype,{y:this.scale.endPoint,base:this.scale.endPoint});var t=e.extend({height:this.chart.height,width:this.chart.width});this.scale.update(t)},draw:function(t){var i=t||1;this.clear();this.chart.ctx;this.scale.draw(i),e.each(this.datasets,function(t,s){e.each(t.bars,function(t,e){t.hasValue()&&(t.base=this.scale.endPoint,t.transition({x:this.scale.calculateBarX(this.datasets.length,s,e),y:this.scale.calculateY(t.value),width:this.scale.calculateBarWidth(this.datasets.length)},i).draw())},this)},this)}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={segmentShowStroke:!0,segmentStrokeColor:"#fff",segmentStrokeWidth:2,percentageInnerCutout:50,animationSteps:100,animationEasing:"easeOutBounce",animateRotate:!0,animateScale:!1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Doughnut",defaults:s,initialize:function(t){this.segments=[],this.outerRadius=(e.min([this.chart.width,this.chart.height])-this.options.segmentStrokeWidth/2)/2,this.SegmentArc=i.Arc.extend({ctx:this.chart.ctx,x:this.chart.width/2,y:this.chart.height/2}),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getSegmentsAtEvent(t):[];e.each(this.segments,function(t){t.restore(["fillColor"])}),e.each(i,function(t){t.fillColor=t.highlightColor}),this.showTooltip(i)}),this.calculateTotal(t),e.each(t,function(t,i){this.addData(t,i,!0)},this),this.render()},getSegmentsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.segments,function(t){t.inRange(s.x,s.y)&&i.push(t)},this),i},addData:function(t,i,e){var s=i||this.segments.length;this.segments.splice(s,0,new this.SegmentArc({value:t.value,outerRadius:this.options.animateScale?0:this.outerRadius,innerRadius:this.options.animateScale?0:this.outerRadius/100*this.options.percentageInnerCutout,fillColor:t.color,highlightColor:t.highlight||t.color,showStroke:this.options.segmentShowStroke,strokeWidth:this.options.segmentStrokeWidth,strokeColor:this.options.segmentStrokeColor,startAngle:1.5*Math.PI,circumference:this.options.animateRotate?0:this.calculateCircumference(t.value),label:t.label})),e||(this.reflow(),this.update())},calculateCircumference:function(t){return 2*Math.PI*(Math.abs(t)/this.total)},calculateTotal:function(t){this.total=0,e.each(t,function(t){this.total+=Math.abs(t.value)},this)},update:function(){this.calculateTotal(this.segments),e.each(this.activeElements,function(t){t.restore(["fillColor"])}),e.each(this.segments,function(t){t.save()}),this.render()},removeData:function(t){var i=e.isNumber(t)?t:this.segments.length-1;this.segments.splice(i,1),this.reflow(),this.update()},reflow:function(){e.extend(this.SegmentArc.prototype,{x:this.chart.width/2,y:this.chart.height/2}),this.outerRadius=(e.min([this.chart.width,this.chart.height])-this.options.segmentStrokeWidth/2)/2,e.each(this.segments,function(t){t.update({outerRadius:this.outerRadius,innerRadius:this.outerRadius/100*this.options.percentageInnerCutout})},this)},draw:function(t){var i=t?t:1;this.clear(),e.each(this.segments,function(t,e){t.transition({circumference:this.calculateCircumference(t.value),outerRadius:this.outerRadius,innerRadius:this.outerRadius/100*this.options.percentageInnerCutout},i),t.endAngle=t.startAngle+t.circumference,t.draw(),0===e&&(t.startAngle=1.5*Math.PI),e<this.segments.length-1&&(this.segments[e+1].startAngle=t.endAngle)},this)}}),i.types.Doughnut.extend({name:"Pie",defaults:e.merge(s,{percentageInnerCutout:0})})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleShowGridLines:!0,scaleGridLineColor:"rgba(0,0,0,.05)",scaleGridLineWidth:1,scaleShowHorizontalLines:!0,scaleShowVerticalLines:!0,bezierCurve:!0,bezierCurveTension:.4,pointDot:!0,pointDotRadius:4,pointDotStrokeWidth:1,pointHitDetectionRadius:20,datasetStroke:!0,datasetStrokeWidth:2,datasetFill:!0,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Line",defaults:s,initialize:function(t){this.PointClass=i.Point.extend({strokeWidth:this.options.pointDotStrokeWidth,radius:this.options.pointDotRadius,display:this.options.pointDot,hitDetectionRadius:this.options.pointHitDetectionRadius,ctx:this.chart.ctx,inRange:function(t){return Math.pow(t-this.x,2)<Math.pow(this.radius+this.hitDetectionRadius,2)}}),this.datasets=[],this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getPointsAtEvent(t):[];this.eachPoints(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,pointColor:i.pointColor,pointStrokeColor:i.pointStrokeColor,points:[]};this.datasets.push(s),e.each(i.data,function(e,n){s.points.push(new this.PointClass({value:e,label:t.labels[n],datasetLabel:i.label,strokeColor:i.pointStrokeColor,fillColor:i.pointColor,highlightFill:i.pointHighlightFill||i.pointColor,highlightStroke:i.pointHighlightStroke||i.pointStrokeColor}))},this),this.buildScale(t.labels),this.eachPoints(function(t,i){e.extend(t,{x:this.scale.calculateX(i),y:this.scale.endPoint}),t.save()},this)},this),this.render()},update:function(){this.scale.update(),e.each(this.activeElements,function(t){t.restore(["fillColor","strokeColor"])}),this.eachPoints(function(t){t.save()}),this.render()},eachPoints:function(t){e.each(this.datasets,function(i){e.each(i.points,t,this)},this)},getPointsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.datasets,function(t){e.each(t.points,function(t){t.inRange(s.x,s.y)&&i.push(t)})},this),i},buildScale:function(t){var s=this,n=function(){var t=[];return s.eachPoints(function(i){t.push(i.value)}),t},o={templateString:this.options.scaleLabel,height:this.chart.height,width:this.chart.width,ctx:this.chart.ctx,textColor:this.options.scaleFontColor,fontSize:this.options.scaleFontSize,fontStyle:this.options.scaleFontStyle,fontFamily:this.options.scaleFontFamily,valuesCount:t.length,beginAtZero:this.options.scaleBeginAtZero,integersOnly:this.options.scaleIntegersOnly,calculateYRange:function(t){var i=e.calculateScaleRange(n(),t,this.fontSize,this.beginAtZero,this.integersOnly);e.extend(this,i)},xLabels:t,font:e.fontString(this.options.scaleFontSize,this.options.scaleFontStyle,this.options.scaleFontFamily),lineWidth:this.options.scaleLineWidth,lineColor:this.options.scaleLineColor,showHorizontalLines:this.options.scaleShowHorizontalLines,showVerticalLines:this.options.scaleShowVerticalLines,gridLineWidth:this.options.scaleShowGridLines?this.options.scaleGridLineWidth:0,gridLineColor:this.options.scaleShowGridLines?this.options.scaleGridLineColor:"rgba(0,0,0,0)",padding:this.options.showScale?0:this.options.pointDotRadius+this.options.pointDotStrokeWidth,showLabels:this.options.scaleShowLabels,display:this.options.showScale};this.options.scaleOverride&&e.extend(o,{calculateYRange:e.noop,steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}),this.scale=new i.Scale(o)},addData:function(t,i){e.each(t,function(t,e){this.datasets[e].points.push(new this.PointClass({value:t,label:i,x:this.scale.calculateX(this.scale.valuesCount+1),y:this.scale.endPoint,strokeColor:this.datasets[e].pointStrokeColor,fillColor:this.datasets[e].pointColor}))},this),this.scale.addXLabel(i),this.update()},removeData:function(){this.scale.removeXLabel(),e.each(this.datasets,function(t){t.points.shift()},this),this.update()},reflow:function(){var t=e.extend({height:this.chart.height,width:this.chart.width});this.scale.update(t)},draw:function(t){var i=t||1;this.clear();var s=this.chart.ctx,n=function(t){return null!==t.value},o=function(t,i,s){return e.findNextWhere(i,n,s)||t},a=function(t,i,s){return e.findPreviousWhere(i,n,s)||t};this.scale.draw(i),e.each(this.datasets,function(t){var h=e.where(t.points,n);e.each(t.points,function(t,e){t.hasValue()&&t.transition({y:this.scale.calculateY(t.value),x:this.scale.calculateX(e)},i)},this),this.options.bezierCurve&&e.each(h,function(t,i){var s=i>0&&i<h.length-1?this.options.bezierCurveTension:0;t.controlPoints=e.splineCurve(a(t,h,i),t,o(t,h,i),s),t.controlPoints.outer.y>this.scale.endPoint?t.controlPoints.outer.y=this.scale.endPoint:t.controlPoints.outer.y<this.scale.startPoint&&(t.controlPoints.outer.y=this.scale.startPoint),t.controlPoints.inner.y>this.scale.endPoint?t.controlPoints.inner.y=this.scale.endPoint:t.controlPoints.inner.y<this.scale.startPoint&&(t.controlPoints.inner.y=this.scale.startPoint)},this),s.lineWidth=this.options.datasetStrokeWidth,s.strokeStyle=t.strokeColor,s.beginPath(),e.each(h,function(t,i){if(0===i)s.moveTo(t.x,t.y);else if(this.options.bezierCurve){var e=a(t,h,i);s.bezierCurveTo(e.controlPoints.outer.x,e.controlPoints.outer.y,t.controlPoints.inner.x,t.controlPoints.inner.y,t.x,t.y)}else s.lineTo(t.x,t.y)},this),s.stroke(),this.options.datasetFill&&h.length>0&&(s.lineTo(h[h.length-1].x,this.scale.endPoint),s.lineTo(h[0].x,this.scale.endPoint),s.fillStyle=t.fillColor,s.closePath(),s.fill()),e.each(h,function(t){t.draw()})},this)}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleShowLabelBackdrop:!0,scaleBackdropColor:"rgba(255,255,255,0.75)",scaleBeginAtZero:!0,scaleBackdropPaddingY:2,scaleBackdropPaddingX:2,scaleShowLine:!0,segmentShowStroke:!0,segmentStrokeColor:"#fff",segmentStrokeWidth:2,animationSteps:100,animationEasing:"easeOutBounce",animateRotate:!0,animateScale:!1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"PolarArea",defaults:s,initialize:function(t){this.segments=[],this.SegmentArc=i.Arc.extend({showStroke:this.options.segmentShowStroke,strokeWidth:this.options.segmentStrokeWidth,strokeColor:this.options.segmentStrokeColor,ctx:this.chart.ctx,innerRadius:0,x:this.chart.width/2,y:this.chart.height/2}),this.scale=new i.RadialScale({display:this.options.showScale,fontStyle:this.options.scaleFontStyle,fontSize:this.options.scaleFontSize,fontFamily:this.options.scaleFontFamily,fontColor:this.options.scaleFontColor,showLabels:this.options.scaleShowLabels,showLabelBackdrop:this.options.scaleShowLabelBackdrop,backdropColor:this.options.scaleBackdropColor,backdropPaddingY:this.options.scaleBackdropPaddingY,backdropPaddingX:this.options.scaleBackdropPaddingX,lineWidth:this.options.scaleShowLine?this.options.scaleLineWidth:0,lineColor:this.options.scaleLineColor,lineArc:!0,width:this.chart.width,height:this.chart.height,xCenter:this.chart.width/2,yCenter:this.chart.height/2,ctx:this.chart.ctx,templateString:this.options.scaleLabel,valuesCount:t.length}),this.updateScaleRange(t),this.scale.update(),e.each(t,function(t,i){this.addData(t,i,!0)},this),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getSegmentsAtEvent(t):[];e.each(this.segments,function(t){t.restore(["fillColor"])}),e.each(i,function(t){t.fillColor=t.highlightColor}),this.showTooltip(i)}),this.render()},getSegmentsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.segments,function(t){t.inRange(s.x,s.y)&&i.push(t)},this),i},addData:function(t,i,e){var s=i||this.segments.length;this.segments.splice(s,0,new this.SegmentArc({fillColor:t.color,highlightColor:t.highlight||t.color,label:t.label,value:t.value,outerRadius:this.options.animateScale?0:this.scale.calculateCenterOffset(t.value),circumference:this.options.animateRotate?0:this.scale.getCircumference(),startAngle:1.5*Math.PI})),e||(this.reflow(),this.update())},removeData:function(t){var i=e.isNumber(t)?t:this.segments.length-1;this.segments.splice(i,1),this.reflow(),this.update()},calculateTotal:function(t){this.total=0,e.each(t,function(t){this.total+=t.value},this),this.scale.valuesCount=this.segments.length},updateScaleRange:function(t){var i=[];e.each(t,function(t){i.push(t.value)});var s=this.options.scaleOverride?{steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}:e.calculateScaleRange(i,e.min([this.chart.width,this.chart.height])/2,this.options.scaleFontSize,this.options.scaleBeginAtZero,this.options.scaleIntegersOnly);e.extend(this.scale,s,{size:e.min([this.chart.width,this.chart.height]),xCenter:this.chart.width/2,yCenter:this.chart.height/2})},update:function(){this.calculateTotal(this.segments),e.each(this.segments,function(t){t.save()}),this.reflow(),this.render()},reflow:function(){e.extend(this.SegmentArc.prototype,{x:this.chart.width/2,y:this.chart.height/2}),this.updateScaleRange(this.segments),this.scale.update(),e.extend(this.scale,{xCenter:this.chart.width/2,yCenter:this.chart.height/2}),e.each(this.segments,function(t){t.update({outerRadius:this.scale.calculateCenterOffset(t.value)})},this)},draw:function(t){var i=t||1;this.clear(),e.each(this.segments,function(t,e){t.transition({circumference:this.scale.getCircumference(),outerRadius:this.scale.calculateCenterOffset(t.value)},i),t.endAngle=t.startAngle+t.circumference,0===e&&(t.startAngle=1.5*Math.PI),e<this.segments.length-1&&(this.segments[e+1].startAngle=t.endAngle),t.draw()},this),this.scale.draw()}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers;i.Type.extend({name:"Radar",defaults:{scaleShowLine:!0,angleShowLineOut:!0,scaleShowLabels:!1,scaleBeginAtZero:!0,angleLineColor:"rgba(0,0,0,.1)",angleLineWidth:1,pointLabelFontFamily:"'Arial'",pointLabelFontStyle:"normal",pointLabelFontSize:10,pointLabelFontColor:"#666",pointDot:!0,pointDotRadius:3,pointDotStrokeWidth:1,pointHitDetectionRadius:20,datasetStroke:!0,datasetStrokeWidth:2,datasetFill:!0,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'},initialize:function(t){this.PointClass=i.Point.extend({strokeWidth:this.options.pointDotStrokeWidth,radius:this.options.pointDotRadius,display:this.options.pointDot,hitDetectionRadius:this.options.pointHitDetectionRadius,ctx:this.chart.ctx}),this.datasets=[],this.buildScale(t),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getPointsAtEvent(t):[];this.eachPoints(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,pointColor:i.pointColor,pointStrokeColor:i.pointStrokeColor,points:[]};this.datasets.push(s),e.each(i.data,function(e,n){var o;this.scale.animation||(o=this.scale.getPointPosition(n,this.scale.calculateCenterOffset(e))),s.points.push(new this.PointClass({value:e,label:t.labels[n],datasetLabel:i.label,x:this.options.animation?this.scale.xCenter:o.x,y:this.options.animation?this.scale.yCenter:o.y,strokeColor:i.pointStrokeColor,fillColor:i.pointColor,highlightFill:i.pointHighlightFill||i.pointColor,highlightStroke:i.pointHighlightStroke||i.pointStrokeColor}))},this)},this),this.render()},eachPoints:function(t){e.each(this.datasets,function(i){e.each(i.points,t,this)},this)},getPointsAtEvent:function(t){var i=e.getRelativePosition(t),s=e.getAngleFromPoint({x:this.scale.xCenter,y:this.scale.yCenter},i),n=2*Math.PI/this.scale.valuesCount,o=Math.round((s.angle-1.5*Math.PI)/n),a=[];return(o>=this.scale.valuesCount||0>o)&&(o=0),s.distance<=this.scale.drawingArea&&e.each(this.datasets,function(t){a.push(t.points[o])}),a},buildScale:function(t){this.scale=new i.RadialScale({display:this.options.showScale,fontStyle:this.options.scaleFontStyle,fontSize:this.options.scaleFontSize,fontFamily:this.options.scaleFontFamily,fontColor:this.options.scaleFontColor,showLabels:this.options.scaleShowLabels,showLabelBackdrop:this.options.scaleShowLabelBackdrop,backdropColor:this.options.scaleBackdropColor,backdropPaddingY:this.options.scaleBackdropPaddingY,backdropPaddingX:this.options.scaleBackdropPaddingX,lineWidth:this.options.scaleShowLine?this.options.scaleLineWidth:0,lineColor:this.options.scaleLineColor,angleLineColor:this.options.angleLineColor,angleLineWidth:this.options.angleShowLineOut?this.options.angleLineWidth:0,pointLabelFontColor:this.options.pointLabelFontColor,pointLabelFontSize:this.options.pointLabelFontSize,pointLabelFontFamily:this.options.pointLabelFontFamily,pointLabelFontStyle:this.options.pointLabelFontStyle,height:this.chart.height,width:this.chart.width,xCenter:this.chart.width/2,yCenter:this.chart.height/2,ctx:this.chart.ctx,templateString:this.options.scaleLabel,labels:t.labels,valuesCount:t.datasets[0].data.length}),this.scale.setScaleSize(),this.updateScaleRange(t.datasets),this.scale.buildYLabels()},updateScaleRange:function(t){var i=function(){var i=[];return e.each(t,function(t){t.data?i=i.concat(t.data):e.each(t.points,function(t){i.push(t.value)})}),i}(),s=this.options.scaleOverride?{steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}:e.calculateScaleRange(i,e.min([this.chart.width,this.chart.height])/2,this.options.scaleFontSize,this.options.scaleBeginAtZero,this.options.scaleIntegersOnly);e.extend(this.scale,s)},addData:function(t,i){this.scale.valuesCount++,e.each(t,function(t,e){var s=this.scale.getPointPosition(this.scale.valuesCount,this.scale.calculateCenterOffset(t));this.datasets[e].points.push(new this.PointClass({value:t,label:i,x:s.x,y:s.y,strokeColor:this.datasets[e].pointStrokeColor,fillColor:this.datasets[e].pointColor}))},this),this.scale.labels.push(i),this.reflow(),this.update()},removeData:function(){this.scale.valuesCount--,this.scale.labels.shift(),e.each(this.datasets,function(t){t.points.shift()},this),this.reflow(),this.update()},update:function(){this.eachPoints(function(t){t.save()}),this.reflow(),this.render()},reflow:function(){e.extend(this.scale,{width:this.chart.width,height:this.chart.height,size:e.min([this.chart.width,this.chart.height]),xCenter:this.chart.width/2,yCenter:this.chart.height/2}),this.updateScaleRange(this.datasets),this.scale.setScaleSize(),this.scale.buildYLabels()},draw:function(t){var i=t||1,s=this.chart.ctx;this.clear(),this.scale.draw(),e.each(this.datasets,function(t){e.each(t.points,function(t,e){t.hasValue()&&t.transition(this.scale.getPointPosition(e,this.scale.calculateCenterOffset(t.value)),i)},this),s.lineWidth=this.options.datasetStrokeWidth,s.strokeStyle=t.strokeColor,s.beginPath(),e.each(t.points,function(t,i){0===i?s.moveTo(t.x,t.y):s.lineTo(t.x,t.y)},this),s.closePath(),s.stroke(),s.fillStyle=t.fillColor,s.fill(),e.each(t.points,function(t){t.hasValue()&&t.draw()})},this)}})}.call(this);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/*!
 * iCheck v1.0.1, http://git.io/arlzeA
 * =================================
 * Powerful jQuery and Zepto plugin for checkboxes and radio buttons customization
 *
 * (c) 2013 Damir Sultanov, http://fronteed.com
 * MIT Licensed
 */

(function($) {

  // Cached vars
  var _iCheck = 'iCheck',
    _iCheckHelper = _iCheck + '-helper',
    _checkbox = 'checkbox',
    _radio = 'radio',
    _checked = 'checked',
    _unchecked = 'un' + _checked,
    _disabled = 'disabled',
    _determinate = 'determinate',
    _indeterminate = 'in' + _determinate,
    _update = 'update',
    _type = 'type',
    _click = 'click',
    _touch = 'touchbegin.i touchend.i',
    _add = 'addClass',
    _remove = 'removeClass',
    _callback = 'trigger',
    _label = 'label',
    _cursor = 'cursor',
    _mobile = /ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);

  // Plugin init
  $.fn[_iCheck] = function(options, fire) {

    // Walker
    var handle = 'input[type="' + _checkbox + '"], input[type="' + _radio + '"]',
      stack = $(),
      walker = function(object) {
        object.each(function() {
          var self = $(this);

          if (self.is(handle)) {
            stack = stack.add(self);
          } else {
            stack = stack.add(self.find(handle));
          }
        });
      };

    // Check if we should operate with some method
    if (/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(options)) {

      // Normalize method's name
      options = options.toLowerCase();

      // Find checkboxes and radio buttons
      walker(this);

      return stack.each(function() {
        var self = $(this);

        if (options == 'destroy') {
          tidy(self, 'ifDestroyed');
        } else {
          operate(self, true, options);
        }
          // Fire method's callback
        if ($.isFunction(fire)) {
          fire();
        }
      });

    // Customization
    } else if (typeof options == 'object' || !options) {

      // Check if any options were passed
      var settings = $.extend({
          checkedClass: _checked,
          disabledClass: _disabled,
          indeterminateClass: _indeterminate,
          labelHover: true,
          aria: false
        }, options),

        selector = settings.handle,
        hoverClass = settings.hoverClass || 'hover',
        focusClass = settings.focusClass || 'focus',
        activeClass = settings.activeClass || 'active',
        labelHover = !!settings.labelHover,
        labelHoverClass = settings.labelHoverClass || 'hover',

        // Setup clickable area
        area = ('' + settings.increaseArea).replace('%', '') | 0;

      // Selector limit
      if (selector == _checkbox || selector == _radio) {
        handle = 'input[type="' + selector + '"]';
      }
        // Clickable area limit
      if (area < -50) {
        area = -50;
      }
        // Walk around the selector
      walker(this);

      return stack.each(function() {
        var self = $(this);

        // If already customized
        tidy(self);

        var node = this,
          id = node.id,

          // Layer styles
          offset = -area + '%',
          size = 100 + (area * 2) + '%',
          layer = {
            position: 'absolute',
            top: offset,
            left: offset,
            display: 'block',
            width: size,
            height: size,
            margin: 0,
            padding: 0,
            background: '#fff',
            border: 0,
            opacity: 0
          },

          // Choose how to hide input
          hide = _mobile ? {
            position: 'absolute',
            visibility: 'hidden'
          } : area ? layer : {
            position: 'absolute',
            opacity: 0
          },

          // Get proper class
          className = node[_type] == _checkbox ? settings.checkboxClass || 'i' + _checkbox : settings.radioClass || 'i' + _radio,

          // Find assigned labels
          label = $(_label + '[for="' + id + '"]').add(self.closest(_label)),

          // Check ARIA option
          aria = !!settings.aria,

          // Set ARIA placeholder
          ariaID = _iCheck + '-' + Math.random().toString(36).replace('0.', ''),

          // Parent & helper
          parent = '<div class="' + className + '" ' + (aria ? 'role="' + node[_type] + '" ' : ''),
          helper;

        // Set ARIA "labelledby"
        if (label.length && aria) {
          label.each(function() {
            parent += 'aria-labelledby="';

            if (this.id) {
              parent += this.id;
            } else {
              this.id = ariaID;
              parent += ariaID;
            }

            parent += '"';
          });
        }
          // Wrap input
        parent = self.wrap(parent + '/>')[_callback]('ifCreated').parent().append(settings.insert);

        // Layer addition
        helper = $('<ins class="' + _iCheckHelper + '"/>').css(layer).appendTo(parent);

        // Finalize customization
        self.data(_iCheck, {o: settings, s: self.attr('style')}).css(hide);
        !!settings.inheritClass && parent[_add](node.className || '');
        !!settings.inheritID && id && parent.attr('id', _iCheck + '-' + id);
        parent.css('position') == 'static' && parent.css('position', 'relative');
        operate(self, true, _update);

        // Label events
        if (label.length) {
          label.on(_click + '.i mouseover.i mouseout.i ' + _touch, function(event) {
            var type = event[_type],
              item = $(this);

            // Do nothing if input is disabled
            if (!node[_disabled]) {

              // Click
              if (type == _click) {
                if ($(event.target).is('a')) {
                  return;
                }
                operate(self, false, true);

              // Hover state
              } else if (labelHover) {

                // mouseout|touchend
                if (/ut|nd/.test(type)) {
                  parent[_remove](hoverClass);
                  item[_remove](labelHoverClass);
                } else {
                  parent[_add](hoverClass);
                  item[_add](labelHoverClass);
                }
              }
                if (_mobile) {
                event.stopPropagation();
              } else {
                return false;
              }
            }
          });
        }
          // Input events
        self.on(_click + '.i focus.i blur.i keyup.i keydown.i keypress.i', function(event) {
          var type = event[_type],
            key = event.keyCode;

          // Click
          if (type == _click) {
            return false;

          // Keydown
          } else if (type == 'keydown' && key == 32) {
            if (!(node[_type] == _radio && node[_checked])) {
              if (node[_checked]) {
                off(self, _checked);
              } else {
                on(self, _checked);
              }
            }
              return false;

          // Keyup
          } else if (type == 'keyup' && node[_type] == _radio) {
            !node[_checked] && on(self, _checked);

          // Focus/blur
          } else if (/us|ur/.test(type)) {
            parent[type == 'blur' ? _remove : _add](focusClass);
          }
        });

        // Helper events
        helper.on(_click + ' mousedown mouseup mouseover mouseout ' + _touch, function(event) {
          var type = event[_type],

            // mousedown|mouseup
            toggle = /wn|up/.test(type) ? activeClass : hoverClass;

          // Do nothing if input is disabled
          if (!node[_disabled]) {

            // Click
            if (type == _click) {
              operate(self, false, true);

            // Active and hover states
            } else {

              // State is on
              if (/wn|er|in/.test(type)) {

                // mousedown|mouseover|touchbegin
                parent[_add](toggle);

              // State is off
              } else {
                parent[_remove](toggle + ' ' + activeClass);
              }
                // Label hover
              if (label.length && labelHover && toggle == hoverClass) {

                // mouseout|touchend
                label[/ut|nd/.test(type) ? _remove : _add](labelHoverClass);
              }
            }
              if (_mobile) {
              event.stopPropagation();
            } else {
              return false;
            }
          }
        });
      });
    } else {
      return this;
    }
  };

  // Do something with inputs
  function operate(input, direct, method) {
    var node = input[0],
      state = /er/.test(method) ? _indeterminate : /bl/.test(method) ? _disabled : _checked,
      active = method == _update ? {
        checked: node[_checked],
        disabled: node[_disabled],
        indeterminate: input.attr(_indeterminate) == 'true' || input.attr(_determinate) == 'false'
      } : node[state];

    // Check, disable or indeterminate
    if (/^(ch|di|in)/.test(method) && !active) {
      on(input, state);

    // Uncheck, enable or determinate
    } else if (/^(un|en|de)/.test(method) && active) {
      off(input, state);

    // Update
    } else if (method == _update) {

      // Handle states
      for (var state in active) {
        if (active[state]) {
          on(input, state, true);
        } else {
          off(input, state, true);
        }
      }
    } else if (!direct || method == 'toggle') {

      // Helper or label was clicked
      if (!direct) {
        input[_callback]('ifClicked');
      }
        // Toggle checked state
      if (active) {
        if (node[_type] !== _radio) {
          off(input, state);
        }
      } else {
        on(input, state);
      }
    }
  }
    // Add checked, disabled or indeterminate state
  function on(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== true) {

      // Toggle assigned radio buttons
      if (!keep && state == _checked && node[_type] == _radio && node.name) {
        var form = input.closest('form'),
          inputs = 'input[name="' + node.name + '"]';

        inputs = form.length ? form.find(inputs) : $(inputs);

        inputs.each(function() {
          if (this !== node && $(this).data(_iCheck)) {
            off($(this), state);
          }
        });
      }
        // Indeterminate state
      if (indeterminate) {

        // Add indeterminate state
        node[state] = true;

        // Remove checked state
        if (node[_checked]) {
          off(input, _checked, 'force');
        }
          // Checked or disabled state
      } else {

        // Add checked or disabled state
        if (!keep) {
          node[state] = true;
        }
          // Remove indeterminate state
        if (checked && node[_indeterminate]) {
          off(input, _indeterminate, false);
        }
      }
        // Trigger callbacks
      callbacks(input, checked, state, keep);
    }
      // Add proper cursor
    if (node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'default');
    }
      // Add state class
    parent[_add](specific || option(input, state) || '');

    // Set ARIA attribute
    disabled ? parent.attr('aria-disabled', 'true') : parent.attr('aria-checked', indeterminate ? 'mixed' : 'true');

    // Remove regular state class
    parent[_remove](regular || option(input, callback) || '');
  }
    // Remove checked, disabled or indeterminate state
  function off(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== false) {

      // Toggle state
      if (indeterminate || !keep || keep == 'force') {
        node[state] = false;
      }
        // Trigger callbacks
      callbacks(input, checked, callback, keep);
    }
      // Add proper cursor
    if (!node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'pointer');
    }
      // Remove state class
    parent[_remove](specific || option(input, state) || '');

    // Set ARIA attribute
    disabled ? parent.attr('aria-disabled', 'false') : parent.attr('aria-checked', 'false');

    // Add regular state class
    parent[_add](regular || option(input, callback) || '');
  }
    // Remove all traces
  function tidy(input, callback) {
    if (input.data(_iCheck)) {

      // Remove everything except input
      input.parent().html(input.attr('style', input.data(_iCheck).s || ''));

      // Callback
      if (callback) {
        input[_callback](callback);
      }
        // Unbind events
      input.off('.i').unwrap();
      $(_label + '[for="' + input[0].id + '"]').add(input.closest(_label)).off('.i');
    }
  }
    // Get some option
  function option(input, state, regular) {
    if (input.data(_iCheck)) {
      return input.data(_iCheck).o[state + (regular ? '' : 'Class')];
    }
  }
    // Capitalize some string
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
    // Executable handlers
  function callbacks(input, checked, callback, keep) {
    if (!keep) {
      if (checked) {
        input[_callback]('ifToggled');
      }
        input[_callback]('ifChanged')[_callback]('if' + capitalize(callback));
    }
  }
})(window.jQuery || window.Zepto);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/*! iCheck v1.0.1 by Damir Sultanov, http://git.io/arlzeA, MIT Licensed */
(function(h){function F(a,b,d){var c=a[0],e=/er/.test(d)?m:/bl/.test(d)?s:l,f=d==H?{checked:c[l],disabled:c[s],indeterminate:"true"==a.attr(m)||"false"==a.attr(w)}:c[e];if(/^(ch|di|in)/.test(d)&&!f)D(a,e);else if(/^(un|en|de)/.test(d)&&f)t(a,e);else if(d==H)for(e in f)f[e]?D(a,e,!0):t(a,e,!0);else if(!b||"toggle"==d){if(!b)a[p]("ifClicked");f?c[n]!==u&&t(a,e):D(a,e)}}function D(a,b,d){var c=a[0],e=a.parent(),f=b==l,A=b==m,B=b==s,K=A?w:f?E:"enabled",p=k(a,K+x(c[n])),N=k(a,b+x(c[n]));if(!0!==c[b]){if(!d&&
b==l&&c[n]==u&&c.name){var C=a.closest("form"),r='input[name="'+c.name+'"]',r=C.length?C.find(r):h(r);r.each(function(){this!==c&&h(this).data(q)&&t(h(this),b)})}A?(c[b]=!0,c[l]&&t(a,l,"force")):(d||(c[b]=!0),f&&c[m]&&t(a,m,!1));L(a,f,b,d)}c[s]&&k(a,y,!0)&&e.find("."+I).css(y,"default");e[v](N||k(a,b)||"");B?e.attr("aria-disabled","true"):e.attr("aria-checked",A?"mixed":"true");e[z](p||k(a,K)||"")}function t(a,b,d){var c=a[0],e=a.parent(),f=b==l,h=b==m,q=b==s,p=h?w:f?E:"enabled",t=k(a,p+x(c[n])),
u=k(a,b+x(c[n]));if(!1!==c[b]){if(h||!d||"force"==d)c[b]=!1;L(a,f,p,d)}!c[s]&&k(a,y,!0)&&e.find("."+I).css(y,"pointer");e[z](u||k(a,b)||"");q?e.attr("aria-disabled","false"):e.attr("aria-checked","false");e[v](t||k(a,p)||"")}function M(a,b){if(a.data(q)){a.parent().html(a.attr("style",a.data(q).s||""));if(b)a[p](b);a.off(".i").unwrap();h(G+'[for="'+a[0].id+'"]').add(a.closest(G)).off(".i")}}function k(a,b,d){if(a.data(q))return a.data(q).o[b+(d?"":"Class")]}function x(a){return a.charAt(0).toUpperCase()+
a.slice(1)}function L(a,b,d,c){if(!c){if(b)a[p]("ifToggled");a[p]("ifChanged")[p]("if"+x(d))}}var q="iCheck",I=q+"-helper",u="radio",l="checked",E="un"+l,s="disabled",w="determinate",m="in"+w,H="update",n="type",v="addClass",z="removeClass",p="trigger",G="label",y="cursor",J=/ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);h.fn[q]=function(a,b){var d='input[type="checkbox"], input[type="'+u+'"]',c=h(),e=function(a){a.each(function(){var a=h(this);c=a.is(d)?
c.add(a):c.add(a.find(d))})};if(/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(a))return a=a.toLowerCase(),e(this),c.each(function(){var c=h(this);"destroy"==a?M(c,"ifDestroyed"):F(c,!0,a);h.isFunction(b)&&b()});if("object"!=typeof a&&a)return this;var f=h.extend({checkedClass:l,disabledClass:s,indeterminateClass:m,labelHover:!0,aria:!1},a),k=f.handle,B=f.hoverClass||"hover",x=f.focusClass||"focus",w=f.activeClass||"active",y=!!f.labelHover,C=f.labelHoverClass||
"hover",r=(""+f.increaseArea).replace("%","")|0;if("checkbox"==k||k==u)d='input[type="'+k+'"]';-50>r&&(r=-50);e(this);return c.each(function(){var a=h(this);M(a);var c=this,b=c.id,e=-r+"%",d=100+2*r+"%",d={position:"absolute",top:e,left:e,display:"block",width:d,height:d,margin:0,padding:0,background:"#fff",border:0,opacity:0},e=J?{position:"absolute",visibility:"hidden"}:r?d:{position:"absolute",opacity:0},k="checkbox"==c[n]?f.checkboxClass||"icheckbox":f.radioClass||"i"+u,m=h(G+'[for="'+b+'"]').add(a.closest(G)),
A=!!f.aria,E=q+"-"+Math.random().toString(36).replace("0.",""),g='<div class="'+k+'" '+(A?'role="'+c[n]+'" ':"");m.length&&A&&m.each(function(){g+='aria-labelledby="';this.id?g+=this.id:(this.id=E,g+=E);g+='"'});g=a.wrap(g+"/>")[p]("ifCreated").parent().append(f.insert);d=h('<ins class="'+I+'"/>').css(d).appendTo(g);a.data(q,{o:f,s:a.attr("style")}).css(e);f.inheritClass&&g[v](c.className||"");f.inheritID&&b&&g.attr("id",q+"-"+b);"static"==g.css("position")&&g.css("position","relative");F(a,!0,H);
if(m.length)m.on("click.i mouseover.i mouseout.i touchbegin.i touchend.i",function(b){var d=b[n],e=h(this);if(!c[s]){if("click"==d){if(h(b.target).is("a"))return;F(a,!1,!0)}else y&&(/ut|nd/.test(d)?(g[z](B),e[z](C)):(g[v](B),e[v](C)));if(J)b.stopPropagation();else return!1}});a.on("click.i focus.i blur.i keyup.i keydown.i keypress.i",function(b){var d=b[n];b=b.keyCode;if("click"==d)return!1;if("keydown"==d&&32==b)return c[n]==u&&c[l]||(c[l]?t(a,l):D(a,l)),!1;if("keyup"==d&&c[n]==u)!c[l]&&D(a,l);else if(/us|ur/.test(d))g["blur"==
d?z:v](x)});d.on("click mousedown mouseup mouseover mouseout touchbegin.i touchend.i",function(b){var d=b[n],e=/wn|up/.test(d)?w:B;if(!c[s]){if("click"==d)F(a,!1,!0);else{if(/wn|er|in/.test(d))g[v](e);else g[z](e+" "+w);if(m.length&&y&&e==B)m[/ut|nd/.test(d)?z:v](C)}if(J)b.stopPropagation();else return!1}})})}})(window.jQuery||window.Zepto);


/***/ })
],[46]);


// WEBPACK FOOTER //
// static/js/app.2fdbf901eb6566d2b83a.js